import gql from 'graphql-tag';
import * as Urql from 'urql';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /**
   * Represents non-fractional signed whole numeric values. Since the value may
   * exceed the size of a 32-bit integer, it's encoded as a string.
   */
  BigInt: { input: any; output: any; }
  /** A boolean that can be casted-to from multiple types */
  CastableBoolean: { input: any; output: any; }
  /**
   * Handle conversion from comma-separated string to array. Intended for input
   * convenience, to avoid having to map HTML input values into arrays.
   */
  CommaSeparatedString: { input: any; output: any; }
  /** An ISO 8601-encoded date */
  ISO8601Date: { input: any; output: any; }
  /** An ISO 8601-encoded datetime */
  ISO8601DateTime: { input: any; output: any; }
  /** An ISO 8601-encoded duration */
  ISO8601Duration: { input: any; output: any; }
  /** Represents untyped JSON */
  JSON: { input: any; output: any; }
  /** Convenience type to handle Decimals that are passed as Strings */
  ToDecimal: { input: any; output: any; }
};

/** A single account object */
export type Account = ClassTypeInterface & {
  __typename?: 'Account';
  /** The class type of the field */
  classType: Scalars['String']['output'];
  /** Object creation date */
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** If applicable, date and time user was disabled at */
  disabledAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** ID of object */
  id: Scalars['ID']['output'];
  /** Name of the account user */
  name?: Maybe<Scalars['String']['output']>;
  /** Associated Organization */
  organization?: Maybe<Organization>;
  /** ID of the associated organization */
  organizationId: Scalars['String']['output'];
  /** URL of the organization logo */
  organizationLogoUrl?: Maybe<Scalars['String']['output']>;
  /** Name of the associated organization */
  organizationName: Scalars['String']['output'];
  /** Account role */
  role: RoleEnum;
  /** Object last updated date */
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Associated User */
  user?: Maybe<User>;
  /** ID of the associated user */
  userId: Scalars['String']['output'];
};

/** Autogenerated input type of AccountDelete */
export type AccountDeleteInput = {
  /** Account to delete */
  accountId: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of AccountDelete. */
export type AccountDeletePayload = ClassTypeInterface & {
  __typename?: 'AccountDeletePayload';
  /** The class type of the field */
  classType: Scalars['String']['output'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** CRUD operation wrapper */
  crudOperation: TypesAccountTypeGraphqlCrudOperation;
  /** Array of Errors */
  errors: Array<Error>;
};

/** Autogenerated input type of AccountSwitch */
export type AccountSwitchInput = {
  /** Account to switch to */
  accountId: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of AccountSwitch. */
export type AccountSwitchPayload = ClassTypeInterface & {
  __typename?: 'AccountSwitchPayload';
  /** Updated account */
  account?: Maybe<Account>;
  /** The class type of the field */
  classType: Scalars['String']['output'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Array of Errors */
  errors: Array<Error>;
  /** Updated User */
  user?: Maybe<User>;
};

/** Autogenerated input type of AccountUpdate */
export type AccountUpdateInput = {
  /** Account to update */
  accountId: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Set a users disabled flag */
  disabled?: InputMaybe<Scalars['CastableBoolean']['input']>;
  /** Set a users role */
  role?: InputMaybe<RoleEnum>;
};

/** Autogenerated return type of AccountUpdate. */
export type AccountUpdatePayload = ClassTypeInterface & {
  __typename?: 'AccountUpdatePayload';
  /** Updated account */
  account?: Maybe<Account>;
  /** The class type of the field */
  classType: Scalars['String']['output'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Array of Errors */
  errors: Array<Error>;
  /** Updated User */
  user?: Maybe<User>;
};

/** AI Assistant */
export type AiAssistant = ClassTypeInterface & {
  __typename?: 'AiAssistant';
  /** The class type of the field */
  classType: Scalars['String']['output'];
  /** ID of the assistant */
  id: Scalars['ID']['output'];
  /** Name of the assistant */
  name: Scalars['String']['output'];
};

/** AI Assistant Eval */
export type AiAssistantEval = ClassTypeInterface & {
  __typename?: 'AiAssistantEval';
  /** The class type of the field */
  classType: Scalars['String']['output'];
  /** ID of the eval */
  id: Scalars['ID']['output'];
  /** Whether this eval is currently live */
  live: Scalars['Boolean']['output'];
  /** Name of the eval */
  name: Scalars['String']['output'];
  /** Score threshold below which to trigger retry */
  retryBelow?: Maybe<Scalars['Int']['output']>;
};

/** AI Assistant Eval Result */
export type AiAssistantEvalResult = ClassTypeInterface & {
  __typename?: 'AiAssistantEvalResult';
  /** Fingerprint of the assistant */
  assistantFingerprint?: Maybe<Scalars['String']['output']>;
  /** Name of the assistant */
  assistantName?: Maybe<Scalars['String']['output']>;
  /** The class type of the field */
  classType: Scalars['String']['output'];
  /** Context snapshot of the eval result */
  contextSnapshot?: Maybe<Scalars['String']['output']>;
  /** The eval this result is for */
  eval: AiAssistantEval;
  /** ID of the eval result */
  id: Scalars['ID']['output'];
  /** Model used for this eval */
  model: Scalars['String']['output'];
  /** Current state of the eval result */
  processedState: Scalars['String']['output'];
  /** Score for this eval result */
  score?: Maybe<Scalars['Int']['output']>;
};

/** AI Assistant File */
export type AiAssistantFile = ClassTypeInterface & {
  __typename?: 'AiAssistantFile';
  /** ID of the file cacheable */
  cacheableId: Scalars['ID']['output'];
  /** Type of the file cacheable */
  cacheableType: Scalars['String']['output'];
  /** The class type of the field */
  classType: Scalars['String']['output'];
  /** Our local ID for the file */
  id: Scalars['ID']['output'];
  /** Name of the file */
  name: Scalars['String']['output'];
  /** OpenAI remote ID */
  remoteId: Scalars['String']['output'];
};

/** Autogenerated input type of AiAssistantFileCacheFilesAdd */
export type AiAssistantFileCacheFilesAddInput = {
  /** cacheable ID */
  cacheableId: Scalars['ID']['input'];
  /** cacheable type */
  cacheableType: Scalars['String']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** OpenAI remote IDs to add */
  fileIds: Array<Scalars['ID']['input']>;
};

/** Autogenerated return type of AiAssistantFileCacheFilesAdd. */
export type AiAssistantFileCacheFilesAddPayload = ClassTypeInterface & {
  __typename?: 'AiAssistantFileCacheFilesAddPayload';
  /** The class type of the field */
  classType: Scalars['String']['output'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Whether the operation was successful or not (in practice, always true, as failures mean exceptions) */
  success?: Maybe<Scalars['Boolean']['output']>;
};

/** Autogenerated input type of AiAssistantFileCacheFilesRemove */
export type AiAssistantFileCacheFilesRemoveInput = {
  /** cacheable ID */
  cacheableId: Scalars['ID']['input'];
  /** cacheable type */
  cacheableType: Scalars['String']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Files IDs to remove */
  fileIds: Array<Scalars['ID']['input']>;
};

/** Autogenerated return type of AiAssistantFileCacheFilesRemove. */
export type AiAssistantFileCacheFilesRemovePayload = ClassTypeInterface & {
  __typename?: 'AiAssistantFileCacheFilesRemovePayload';
  /** The class type of the field */
  classType: Scalars['String']['output'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Whether the operation was successful or not (in practice, always true, as failures mean exceptions) */
  success?: Maybe<Scalars['Boolean']['output']>;
};

/** List of possible Role values on User */
export enum AiAssistantRoleEnum {
  /** Assistant - The User is an AI Assistant */
  Assistant = 'assistant',
  /** System role */
  System = 'system',
  /** User - The User is a regular User */
  User = 'user'
}

/** An AI conversation */
export type AiConversation = ClassTypeInterface & {
  __typename?: 'AiConversation';
  /** The messages in the conversation */
  aiConversationMessages: Array<AiConversationMessage>;
  /** The class type of the field */
  classType: Scalars['String']['output'];
  /** The ID */
  id: Scalars['ID']['output'];
  /** The strategy for this conversation */
  strategy: Strategy;
};

/** A request & response pair, in an AI conversation */
export type AiConversationMessage = ClassTypeInterface & {
  __typename?: 'AiConversationMessage';
  /** The class type of the field */
  classType: Scalars['String']['output'];
  /** The ID */
  id: Scalars['ID']['output'];
  /** The content of the request */
  requestContent: Scalars['String']['output'];
  /** The speaker's role for this message */
  requestRole: Scalars['String']['output'];
  /** The response content for the request */
  responseContent: Scalars['String']['output'];
  /** The responder's role for this message */
  responseRole: Scalars['String']['output'];
  /** Whether the response was successful */
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of AiNodesGenerate */
export type AiNodesGenerateInput = {
  /** Additional instructions for AI generation */
  additionalInstructions?: InputMaybe<Scalars['String']['input']>;
  /** The slug of the Ai Assistant used to generate the nodes */
  aiAssistantSlug: Scalars['String']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The direction of the metrics (upstream or downstream) */
  direction: Scalars['String']['input'];
  /** The handle location (top, right, left, bottom) */
  handle: Scalars['String']['input'];
  /** The ID of the upstream node to link the metrics to */
  nodeId: Scalars['ID']['input'];
};

/** Autogenerated return type of AiNodesGenerate. */
export type AiNodesGeneratePayload = ClassTypeInterface & {
  __typename?: 'AiNodesGeneratePayload';
  /** The class type of the field */
  classType: Scalars['String']['output'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Whether the result was successful */
  success: Scalars['Boolean']['output'];
};

/** Amplitude Event Type */
export type AmplitudeEvent = ClassTypeInterface & {
  __typename?: 'AmplitudeEvent';
  /** Category of the event type */
  category?: Maybe<Scalars['String']['output']>;
  /** The class type of the field */
  classType: Scalars['String']['output'];
  /** Description of the event type */
  description?: Maybe<Scalars['String']['output']>;
  /** Name of the event type */
  name: Scalars['String']['output'];
};

/** EntityAttachments */
export type Attachment = ClassTypeInterface & {
  __typename?: 'Attachment';
  /** The class type of the field */
  classType: Scalars['String']['output'];
  /** Associated Entity */
  entity: Entity;
  /** Associated entity ID (performs no additional queries) */
  entityId: Scalars['ID']['output'];
  /** File extension */
  extension: Scalars['String']['output'];
  /** Object unique ID */
  id: Scalars['ID']['output'];
  /** File mime type */
  mimeType: Scalars['String']['output'];
  /** Original file name  */
  originalFilename: Scalars['String']['output'];
  /** URL to full attachment */
  url: Scalars['String']['output'];
};

/** Basic Card */
export type BasicCard = ClassTypeInterface & CommentableInterface & DomainObjectInterface & RfNodeInterface & {
  __typename?: 'BasicCard';
  /** Card Type of the Basic Card */
  cardType?: Maybe<CardType>;
  /** Card Type ID of the Basic Card */
  cardTypeId?: Maybe<Scalars['ID']['output']>;
  /** Card Type Name of the Basic Card */
  cardTypeName?: Maybe<Scalars['String']['output']>;
  /** The class type of the field */
  classType: Scalars['String']['output'];
  /** Comments left on the object */
  comments?: Maybe<Array<Comment>>;
  /** Number of comments left on the object */
  commentsCount: Scalars['Int']['output'];
  /** Confidence rating of the object */
  confidenceRating?: Maybe<ConfidenceRatingEnum>;
  /** Number of work items contained by this Basic Card */
  containeeCount?: Maybe<Scalars['Int']['output']>;
  /** IDs of Basic Cards contained by this Basic Card */
  containeeIds?: Maybe<Array<Scalars['ID']['output']>>;
  /** Object creation date */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** Description of the card */
  description?: Maybe<Scalars['String']['output']>;
  /** Direct collapsed incomers */
  directIncomers?: Maybe<Array<NodeObject>>;
  /** Due date for the Card */
  dueDate?: Maybe<Scalars['ISO8601Date']['output']>;
  /** All of the upstream Entities */
  entities: EntityCollection;
  /** External URL of the Card */
  externalUrl?: Maybe<Scalars['String']['output']>;
  /** Text to display for the external URL */
  externalUrlTitle?: Maybe<Scalars['String']['output']>;
  /** Goal Hypothesis of the Card */
  goalHypothesis?: Maybe<Scalars['String']['output']>;
  /** ID of object */
  id: Scalars['ID']['output'];
  /** Labels */
  labels?: Maybe<Array<Label>>;
  /** Name for the Card Type */
  name?: Maybe<Scalars['String']['output']>;
  /** Organization owning the Basic Card */
  organization?: Maybe<Organization>;
  /** Owner of this Basic Card */
  owner?: Maybe<User>;
  /** Owner ID of this Basic Card */
  ownerId?: Maybe<Scalars['ID']['output']>;
  /** Whether the Basic Card has recent activity */
  recentActivity?: Maybe<Scalars['Boolean']['output']>;
  /** Results of the Card */
  results?: Maybe<Scalars['String']['output']>;
  /** Strategy node id */
  rfId: Scalars['String']['output'];
  /** Whether to show the description field */
  showDescription?: Maybe<Scalars['Boolean']['output']>;
  /** Whether to show the goal_hypothesis field */
  showGoalHypothesis?: Maybe<Scalars['Boolean']['output']>;
  /** Whether to show the results field */
  showResults?: Maybe<Scalars['Boolean']['output']>;
  /** Status of the Basic Card */
  status: DomainObjectStatusEnum;
  /** Strategies that the Basic Card is associated with */
  strategies: Array<Strategy>;
  /** Type of Metric relative to the Strategy.  */
  teamType?: Maybe<TeamTypeEnum>;
  /** Object last updated date */
  updatedAt: Scalars['ISO8601DateTime']['output'];
};


/** Basic Card */
export type BasicCardDirectIncomersArgs = {
  strategyId?: InputMaybe<Scalars['ID']['input']>;
};


/** Basic Card */
export type BasicCardEntitiesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};

/** BasicCardCollection type */
export type BasicCardCollection = {
  __typename?: 'BasicCardCollection';
  /** A collection of paginated BasicCardCollection */
  collection: Array<BasicCard>;
  /** Pagination Metadata for navigating the Pagination */
  metadata: CollectionMetadata;
};

/** Input Type for Basic Card */
export type BasicCardCreateInput = {
  /** ID of the CardType for this Basic Card */
  cardTypeId?: InputMaybe<Scalars['ID']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The confidence rating of the Work */
  confidenceRating?: InputMaybe<ConfidenceRatingEnum>;
  /** Basic Card description */
  description?: InputMaybe<Scalars['String']['input']>;
  /** The due_date for the card */
  dueDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  /** Card external url */
  externalUrl?: InputMaybe<Scalars['String']['input']>;
  /** Card external url text */
  externalUrlTitle?: InputMaybe<Scalars['String']['input']>;
  /** The expected result or hypothesis for the card */
  goalHypothesis?: InputMaybe<Scalars['String']['input']>;
  /** Basic Card ID */
  id?: InputMaybe<Scalars['ID']['input']>;
  /** Optional labels to set on the Basic Card */
  labels?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Basic Card name */
  name?: InputMaybe<Scalars['String']['input']>;
  /** ID of the owner of this Basic Card */
  ownerId?: InputMaybe<Scalars['ID']['input']>;
  /** What result happened with the card */
  results?: InputMaybe<Scalars['String']['input']>;
  /** Whether to show the description field */
  showDescription?: InputMaybe<Scalars['CastableBoolean']['input']>;
  /** Whether to show the goal_hypothesis field */
  showGoalHypothesis?: InputMaybe<Scalars['CastableBoolean']['input']>;
  /** Whether to show the results field */
  showResults?: InputMaybe<Scalars['CastableBoolean']['input']>;
  /** Status of the Basic Card */
  status?: InputMaybe<DomainObjectStatusEnum>;
  /** The type of card as it relates to Strategy. This is a terrible name */
  teamType?: InputMaybe<TeamTypeEnum>;
};

/** Autogenerated return type of BasicCardCreate. */
export type BasicCardCreatePayload = ClassTypeInterface & {
  __typename?: 'BasicCardCreatePayload';
  /** Newly created Basic Card */
  basicCard?: Maybe<BasicCard>;
  /** The class type of the field */
  classType: Scalars['String']['output'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Array of Errors */
  errors: Array<Error>;
};

/** Autogenerated input type of BasicCardDelete */
export type BasicCardDeleteInput = {
  /** Basic Card ID to delete */
  basicCardId: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of BasicCardDelete. */
export type BasicCardDeletePayload = ClassTypeInterface & {
  __typename?: 'BasicCardDeletePayload';
  /** Deleted Basic Card */
  basicCard?: Maybe<BasicCard>;
  /** The class type of the field */
  classType: Scalars['String']['output'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Array of Errors */
  errors: Array<Error>;
};

/** Input Type for Basic Card */
export type BasicCardInput = {
  /** ID of the CardType for this Basic Card */
  cardTypeId?: InputMaybe<Scalars['ID']['input']>;
  /** The confidence rating of the Work */
  confidenceRating?: InputMaybe<ConfidenceRatingEnum>;
  /** Basic Card description */
  description?: InputMaybe<Scalars['String']['input']>;
  /** The due_date for the card */
  dueDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  /** Card external url */
  externalUrl?: InputMaybe<Scalars['String']['input']>;
  /** Card external url text */
  externalUrlTitle?: InputMaybe<Scalars['String']['input']>;
  /** The expected result or hypothesis for the card */
  goalHypothesis?: InputMaybe<Scalars['String']['input']>;
  /** Basic Card ID */
  id?: InputMaybe<Scalars['ID']['input']>;
  /** Optional labels to set on the Basic Card */
  labels?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Basic Card name */
  name?: InputMaybe<Scalars['String']['input']>;
  /** ID of the owner of this Basic Card */
  ownerId?: InputMaybe<Scalars['ID']['input']>;
  /** What result happened with the card */
  results?: InputMaybe<Scalars['String']['input']>;
  /** Whether to show the description field */
  showDescription?: InputMaybe<Scalars['CastableBoolean']['input']>;
  /** Whether to show the goal_hypothesis field */
  showGoalHypothesis?: InputMaybe<Scalars['CastableBoolean']['input']>;
  /** Whether to show the results field */
  showResults?: InputMaybe<Scalars['CastableBoolean']['input']>;
  /** Status of the Basic Card */
  status?: InputMaybe<DomainObjectStatusEnum>;
  /** The type of card as it relates to Strategy. This is a terrible name */
  teamType?: InputMaybe<TeamTypeEnum>;
};

export type BasicCardOrderingInput = {
  /** Sort by cardTypeName */
  cardTypeName?: InputMaybe<SortDirectionEnum>;
  /** Sort by name */
  name?: InputMaybe<SortDirectionEnum>;
};

/** Autogenerated input type of BillingCreateSubscription */
export type BillingCreateSubscriptionInput = {
  /** Billing period string */
  billingPeriod: Scalars['String']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Billing plan id string */
  planId: Scalars['String']['input'];
};

/** Autogenerated return type of BillingCreateSubscription. */
export type BillingCreateSubscriptionPayload = ClassTypeInterface & {
  __typename?: 'BillingCreateSubscriptionPayload';
  /** The class type of the field */
  classType: Scalars['String']['output'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Array of Errors */
  errors: Array<Error>;
  /** Response from the billing provider */
  response: Scalars['JSON']['output'];
};

/** Autogenerated input type of BillingProvisionSubscription */
export type BillingProvisionSubscriptionInput = {
  /** Billing period string */
  billingPeriod: Scalars['String']['input'];
  /** URL to return to on checkout cancel */
  cancelUrl?: InputMaybe<Scalars['String']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Billing plan id string */
  planId: Scalars['String']['input'];
  /** Number of seats */
  priceUnitAmount?: InputMaybe<Scalars['Float']['input']>;
  /** URL to return to on checkout success */
  successUrl?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of BillingProvisionSubscription. */
export type BillingProvisionSubscriptionPayload = ClassTypeInterface & {
  __typename?: 'BillingProvisionSubscriptionPayload';
  /** The class type of the field */
  classType: Scalars['String']['output'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Array of Errors */
  errors: Array<Error>;
  /** Response from the billing provider */
  response: Scalars['JSON']['output'];
};

/** Portable Business Context */
export type BusinessContext = ClassTypeInterface & {
  __typename?: 'BusinessContext';
  /** Child Business Contexts */
  businessContexts?: Maybe<Array<BusinessContext>>;
  /** Business name */
  businessName?: Maybe<Scalars['String']['output']>;
  /** AI Context Files */
  cachedAiAssistantFiles?: Maybe<Array<AiAssistantFile>>;
  /** The class type of the field */
  classType: Scalars['String']['output'];
  /** Business Context content in markdown format */
  content?: Maybe<Scalars['String']['output']>;
  /** Timestamp of when the Business Context was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /**
   * Business Context data (deprecated, use content instead)
   * @deprecated Use content field instead
   */
  data?: Maybe<Scalars['JSON']['output']>;
  /** ID of object */
  id: Scalars['ID']['output'];
  /** Initial context for the Business Context */
  initialContext?: Maybe<Scalars['String']['output']>;
  /** Name of the Business Context */
  name?: Maybe<Scalars['String']['output']>;
  /** ID of the associated organization */
  organizationId: Scalars['String']['output'];
  /** Parent Business Context */
  parentBusinessContext?: Maybe<BusinessContext>;
  /** Parent Business Context ID */
  parentBusinessContextId?: Maybe<Scalars['ID']['output']>;
  /** Parent Business Context slug */
  parentBusinessContextSlug?: Maybe<Scalars['String']['output']>;
  /** Parent Business Contexts */
  parentBusinessContexts?: Maybe<Array<BusinessContext>>;
  /** Slug of the Business Context */
  slug?: Maybe<Scalars['String']['output']>;
  /** Strategies associated with this Business Context */
  strategies?: Maybe<Array<Strategy>>;
  /** Timestamp of when the Business Context was last updated */
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** Input Type for BusinessContexts */
export type BusinessContextCreateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Context Content of the Business Context */
  content?: InputMaybe<Scalars['String']['input']>;
  /** ID of the Business Context */
  id?: InputMaybe<Scalars['ID']['input']>;
  /** Initial context for the Business Context */
  initialContext?: InputMaybe<Scalars['String']['input']>;
  /** Business name */
  name?: InputMaybe<Scalars['String']['input']>;
  /** ID of the parent Business Context */
  parentBusinessContextId?: InputMaybe<Scalars['ID']['input']>;
};

/** Autogenerated return type of BusinessContextCreate. */
export type BusinessContextCreatePayload = ClassTypeInterface & {
  __typename?: 'BusinessContextCreatePayload';
  /** Created BusinessContext */
  businessContext?: Maybe<BusinessContext>;
  /** The class type of the field */
  classType: Scalars['String']['output'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Array of Errors */
  errors: Array<Error>;
};

/** Autogenerated input type of BusinessContextDelete */
export type BusinessContextDeleteInput = {
  /** Business Context ID to delete */
  businessContextId: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of BusinessContextDelete. */
export type BusinessContextDeletePayload = ClassTypeInterface & {
  __typename?: 'BusinessContextDeletePayload';
  /** The class type of the field */
  classType: Scalars['String']['output'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** CRUD operation wrapper */
  crudOperation: TypesBusinessContextTypeGraphqlCrudOperation;
  /** Array of Errors */
  errors: Array<Error>;
};

/** Autogenerated input type of BusinessContextEmpty */
export type BusinessContextEmptyInput = {
  /** ID of the Business Context to empty */
  businessContextId: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of BusinessContextEmpty. */
export type BusinessContextEmptyPayload = ClassTypeInterface & {
  __typename?: 'BusinessContextEmptyPayload';
  /** Created BusinessContext */
  businessContext?: Maybe<BusinessContext>;
  /** The class type of the field */
  classType: Scalars['String']['output'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Array of Errors */
  errors: Array<Error>;
};

/** Autogenerated input type of BusinessContextGenerate */
export type BusinessContextGenerateInput = {
  /** Business context id */
  businessContextId?: InputMaybe<Scalars['ID']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Initial context for the Business Context */
  initialContext?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of BusinessContextGenerate. */
export type BusinessContextGeneratePayload = ClassTypeInterface & {
  __typename?: 'BusinessContextGeneratePayload';
  /** The class type of the field */
  classType: Scalars['String']['output'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Array of Errors */
  errors: Array<Error>;
};

/** Input Type for BusinessContexts */
export type BusinessContextInput = {
  /** Context Content of the Business Context */
  content?: InputMaybe<Scalars['String']['input']>;
  /** ID of the Business Context */
  id?: InputMaybe<Scalars['ID']['input']>;
  /** Initial context for the Business Context */
  initialContext?: InputMaybe<Scalars['String']['input']>;
  /** Business name */
  name?: InputMaybe<Scalars['String']['input']>;
};

/** Organization wide Card Types */
export type CardType = ClassTypeInterface & {
  __typename?: 'CardType';
  /** The class type of the field */
  classType: Scalars['String']['output'];
  /** Color for the Card Type */
  color?: Maybe<Scalars['String']['output']>;
  /** Object creation date */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** Icon for the Card Type */
  icon?: Maybe<Scalars['String']['output']>;
  /** ID of Card Type */
  id: Scalars['ID']['output'];
  /** Name of the Card Type */
  name?: Maybe<Scalars['String']['output']>;
  /** Organization owning the Card Type */
  organization?: Maybe<Organization>;
  /** Whether to show on the map menu or not */
  showInMenu: Scalars['Boolean']['output'];
  /** Object last updated date */
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** Input for basic card types */
export type CardTypeCreateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Card Type color */
  color?: InputMaybe<Scalars['String']['input']>;
  /** Card Type icon */
  icon?: InputMaybe<Scalars['String']['input']>;
  /** Card Type ID */
  id?: InputMaybe<Scalars['ID']['input']>;
  /** Card Type name */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Whether to show on the map menu or not */
  showInMenu?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Autogenerated return type of CardTypeCreate. */
export type CardTypeCreatePayload = ClassTypeInterface & {
  __typename?: 'CardTypeCreatePayload';
  /** Newly created CardType */
  cardType?: Maybe<CardType>;
  /** The class type of the field */
  classType: Scalars['String']['output'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Array of Errors */
  errors: Array<Error>;
};

/** Autogenerated input type of CardTypeDelete */
export type CardTypeDeleteInput = {
  /** Card Type ID to delete */
  cardTypeId: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of CardTypeDelete. */
export type CardTypeDeletePayload = ClassTypeInterface & {
  __typename?: 'CardTypeDeletePayload';
  /** The class type of the field */
  classType: Scalars['String']['output'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** CRUD operation wrapper */
  crudOperation: TypesCardTypeTypeGraphqlCrudOperation;
  /** Array of Errors */
  errors: Array<Error>;
};

/** Input for basic card types */
export type CardTypeInput = {
  /** Card Type color */
  color?: InputMaybe<Scalars['String']['input']>;
  /** Card Type icon */
  icon?: InputMaybe<Scalars['String']['input']>;
  /** Card Type ID */
  id?: InputMaybe<Scalars['ID']['input']>;
  /** Card Type name */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Whether to show on the map menu or not */
  showInMenu?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Input for basic card types */
export type CardTypeUpdateInput = {
  /** Card Type ID to update */
  cardTypeId: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Card Type color */
  color?: InputMaybe<Scalars['String']['input']>;
  /** Card Type icon */
  icon?: InputMaybe<Scalars['String']['input']>;
  /** Card Type ID */
  id?: InputMaybe<Scalars['ID']['input']>;
  /** Card Type name */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Whether to show on the map menu or not */
  showInMenu?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Autogenerated return type of CardTypeUpdate. */
export type CardTypeUpdatePayload = ClassTypeInterface & {
  __typename?: 'CardTypeUpdatePayload';
  /** Updated Card Type */
  cardType?: Maybe<CardType>;
  /** The class type of the field */
  classType: Scalars['String']['output'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Array of Errors */
  errors: Array<Error>;
};

/** A chat thread, used as communication / memory / context in pipelines */
export type Chat = ClassTypeInterface & {
  __typename?: 'Chat';
  /** List of chattables associated with the chat */
  chattables: Array<PolymorphicChattable>;
  /** The class type of the field */
  classType: Scalars['String']['output'];
  /** ID of the current assistant in the pipeline */
  currentAssistantId?: Maybe<Scalars['ID']['output']>;
  /** Whether the error is retryable */
  errorIsRetryable: Scalars['Boolean']['output'];
  /** Error message if the chat is in an error state */
  errorMessage?: Maybe<Scalars['String']['output']>;
  /** ID of the chat */
  id: Scalars['ID']['output'];
  /** Messages in the chat. System messages are not included. */
  messages: Array<Message>;
  /** Most recent user message */
  mostRecentPrompt?: Maybe<Message>;
  /** ID of the organization that owns the chat */
  organizationId: Scalars['ID']['output'];
  /** Slug of the pipeline that created the chat */
  pipelineSlug: Scalars['String']['output'];
  /** Current state of the chat */
  processedState: ChatProcessedStateEnum;
  /** Real time status of the chat */
  realTimeStatus?: Maybe<Scalars['String']['output']>;
  /** ID of the strategy associated with the chat */
  strategyId?: Maybe<Scalars['ID']['output']>;
  /** Last updated timestamp */
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** Autogenerated input type of ChatCancel */
export type ChatCancelInput = {
  /** ID of the chat to cancel runs on. */
  chatId: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of ChatCancel. */
export type ChatCancelPayload = ClassTypeInterface & {
  __typename?: 'ChatCancelPayload';
  /** The chat */
  chat?: Maybe<Chat>;
  /** The class type of the field */
  classType: Scalars['String']['output'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
};

/** AI Assistant Chat processing states */
export enum ChatProcessedStateEnum {
  /** Error - An error occurred during processing */
  Error = 'error',
  /** Idle - No processing is happening */
  Idle = 'idle',
  /** Processing - Chat is being processed */
  Processing = 'processing',
  /** Waiting - Chat is waiting on the system */
  Waiting = 'waiting'
}

/** Autogenerated input type of ChatUpdate */
export type ChatUpdateInput = {
  /** ID of the chat to cancel runs on. */
  chatId: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Update the current assistant id for a chat thread */
  currentAssistantId?: InputMaybe<Scalars['ID']['input']>;
};

/** Autogenerated return type of ChatUpdate. */
export type ChatUpdatePayload = ClassTypeInterface & {
  __typename?: 'ChatUpdatePayload';
  /** The chat */
  chat?: Maybe<Chat>;
  /** The class type of the field */
  classType: Scalars['String']['output'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
};

/** Input Type for Chattables */
export type ChattableObjectInput =
  /** Basic Card */
  { basicCard: BasicCardInput; businessContext?: never; cardType?: never; comment?: never; commentThread?: never; credential?: never; edge?: never; entity?: never; existing?: never; goal?: never; mapImage?: never; metric?: never; node?: never; note?: never; organization?: never; recurringReportConfiguration?: never; report?: never; schedule?: never; section?: never; strategy?: never; work?: never; }
  |  /** Business Context */
  { basicCard?: never; businessContext: BusinessContextInput; cardType?: never; comment?: never; commentThread?: never; credential?: never; edge?: never; entity?: never; existing?: never; goal?: never; mapImage?: never; metric?: never; node?: never; note?: never; organization?: never; recurringReportConfiguration?: never; report?: never; schedule?: never; section?: never; strategy?: never; work?: never; }
  |  /** Card Type */
  { basicCard?: never; businessContext?: never; cardType: CardTypeInput; comment?: never; commentThread?: never; credential?: never; edge?: never; entity?: never; existing?: never; goal?: never; mapImage?: never; metric?: never; node?: never; note?: never; organization?: never; recurringReportConfiguration?: never; report?: never; schedule?: never; section?: never; strategy?: never; work?: never; }
  |  /** Comment */
  { basicCard?: never; businessContext?: never; cardType?: never; comment: CommentInput; commentThread?: never; credential?: never; edge?: never; entity?: never; existing?: never; goal?: never; mapImage?: never; metric?: never; node?: never; note?: never; organization?: never; recurringReportConfiguration?: never; report?: never; schedule?: never; section?: never; strategy?: never; work?: never; }
  |  /** Comment Thread */
  { basicCard?: never; businessContext?: never; cardType?: never; comment?: never; commentThread: CommentThreadInput; credential?: never; edge?: never; entity?: never; existing?: never; goal?: never; mapImage?: never; metric?: never; node?: never; note?: never; organization?: never; recurringReportConfiguration?: never; report?: never; schedule?: never; section?: never; strategy?: never; work?: never; }
  |  /** Credential */
  { basicCard?: never; businessContext?: never; cardType?: never; comment?: never; commentThread?: never; credential: CredentialInput; edge?: never; entity?: never; existing?: never; goal?: never; mapImage?: never; metric?: never; node?: never; note?: never; organization?: never; recurringReportConfiguration?: never; report?: never; schedule?: never; section?: never; strategy?: never; work?: never; }
  |  /** Edge */
  { basicCard?: never; businessContext?: never; cardType?: never; comment?: never; commentThread?: never; credential?: never; edge: EdgeInput; entity?: never; existing?: never; goal?: never; mapImage?: never; metric?: never; node?: never; note?: never; organization?: never; recurringReportConfiguration?: never; report?: never; schedule?: never; section?: never; strategy?: never; work?: never; }
  |  /** Entity */
  { basicCard?: never; businessContext?: never; cardType?: never; comment?: never; commentThread?: never; credential?: never; edge?: never; entity: EntityInput; existing?: never; goal?: never; mapImage?: never; metric?: never; node?: never; note?: never; organization?: never; recurringReportConfiguration?: never; report?: never; schedule?: never; section?: never; strategy?: never; work?: never; }
  |  /** Existing Node */
  { basicCard?: never; businessContext?: never; cardType?: never; comment?: never; commentThread?: never; credential?: never; edge?: never; entity?: never; existing: ExistingDomainObjectInput; goal?: never; mapImage?: never; metric?: never; node?: never; note?: never; organization?: never; recurringReportConfiguration?: never; report?: never; schedule?: never; section?: never; strategy?: never; work?: never; }
  |  /** Goal */
  { basicCard?: never; businessContext?: never; cardType?: never; comment?: never; commentThread?: never; credential?: never; edge?: never; entity?: never; existing?: never; goal: GoalInput; mapImage?: never; metric?: never; node?: never; note?: never; organization?: never; recurringReportConfiguration?: never; report?: never; schedule?: never; section?: never; strategy?: never; work?: never; }
  |  /** Map Image */
  { basicCard?: never; businessContext?: never; cardType?: never; comment?: never; commentThread?: never; credential?: never; edge?: never; entity?: never; existing?: never; goal?: never; mapImage: MapImageInput; metric?: never; node?: never; note?: never; organization?: never; recurringReportConfiguration?: never; report?: never; schedule?: never; section?: never; strategy?: never; work?: never; }
  |  /** Metric */
  { basicCard?: never; businessContext?: never; cardType?: never; comment?: never; commentThread?: never; credential?: never; edge?: never; entity?: never; existing?: never; goal?: never; mapImage?: never; metric: MetricInput; node?: never; note?: never; organization?: never; recurringReportConfiguration?: never; report?: never; schedule?: never; section?: never; strategy?: never; work?: never; }
  |  /** Node */
  { basicCard?: never; businessContext?: never; cardType?: never; comment?: never; commentThread?: never; credential?: never; edge?: never; entity?: never; existing?: never; goal?: never; mapImage?: never; metric?: never; node: NodeInput; note?: never; organization?: never; recurringReportConfiguration?: never; report?: never; schedule?: never; section?: never; strategy?: never; work?: never; }
  |  /** Note */
  { basicCard?: never; businessContext?: never; cardType?: never; comment?: never; commentThread?: never; credential?: never; edge?: never; entity?: never; existing?: never; goal?: never; mapImage?: never; metric?: never; node?: never; note: NoteInput; organization?: never; recurringReportConfiguration?: never; report?: never; schedule?: never; section?: never; strategy?: never; work?: never; }
  |  /** Organization */
  { basicCard?: never; businessContext?: never; cardType?: never; comment?: never; commentThread?: never; credential?: never; edge?: never; entity?: never; existing?: never; goal?: never; mapImage?: never; metric?: never; node?: never; note?: never; organization: OrganizationInput; recurringReportConfiguration?: never; report?: never; schedule?: never; section?: never; strategy?: never; work?: never; }
  |  /** Recurring Report Configuration */
  { basicCard?: never; businessContext?: never; cardType?: never; comment?: never; commentThread?: never; credential?: never; edge?: never; entity?: never; existing?: never; goal?: never; mapImage?: never; metric?: never; node?: never; note?: never; organization?: never; recurringReportConfiguration: RecurringReportConfigurationInput; report?: never; schedule?: never; section?: never; strategy?: never; work?: never; }
  |  /** Report */
  { basicCard?: never; businessContext?: never; cardType?: never; comment?: never; commentThread?: never; credential?: never; edge?: never; entity?: never; existing?: never; goal?: never; mapImage?: never; metric?: never; node?: never; note?: never; organization?: never; recurringReportConfiguration?: never; report: ReportInput; schedule?: never; section?: never; strategy?: never; work?: never; }
  |  /** Schedule */
  { basicCard?: never; businessContext?: never; cardType?: never; comment?: never; commentThread?: never; credential?: never; edge?: never; entity?: never; existing?: never; goal?: never; mapImage?: never; metric?: never; node?: never; note?: never; organization?: never; recurringReportConfiguration?: never; report?: never; schedule: ScheduleInput; section?: never; strategy?: never; work?: never; }
  |  /** Section */
  { basicCard?: never; businessContext?: never; cardType?: never; comment?: never; commentThread?: never; credential?: never; edge?: never; entity?: never; existing?: never; goal?: never; mapImage?: never; metric?: never; node?: never; note?: never; organization?: never; recurringReportConfiguration?: never; report?: never; schedule?: never; section: SectionInput; strategy?: never; work?: never; }
  |  /** Strategy */
  { basicCard?: never; businessContext?: never; cardType?: never; comment?: never; commentThread?: never; credential?: never; edge?: never; entity?: never; existing?: never; goal?: never; mapImage?: never; metric?: never; node?: never; note?: never; organization?: never; recurringReportConfiguration?: never; report?: never; schedule?: never; section?: never; strategy: StrategyInput; work?: never; }
  |  /** Entity */
  { basicCard?: never; businessContext?: never; cardType?: never; comment?: never; commentThread?: never; credential?: never; edge?: never; entity?: never; existing?: never; goal?: never; mapImage?: never; metric?: never; node?: never; note?: never; organization?: never; recurringReportConfiguration?: never; report?: never; schedule?: never; section?: never; strategy?: never; work: EntityInput; };

/** Interface for storable objects */
export type ClassTypeInterface = {
  /** The class type of the field */
  classType: Scalars['String']['output'];
};

/** Classification */
export type Classification = ClassTypeInterface & {
  __typename?: 'Classification';
  /** Category name ex: Project */
  category?: Maybe<Scalars['String']['output']>;
  /** The class type of the field */
  classType: Scalars['String']['output'];
  /** Object creation date */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** Object unique ID */
  id: Scalars['ID']['output'];
  /** Classification name ex: Improve Performance */
  name?: Maybe<Scalars['String']['output']>;
  /** Associated Organization */
  organization: Organization;
  /** Source the classification is associated to */
  sourceName?: Maybe<Scalars['String']['output']>;
  /** Object last updated date */
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** Type for CollectionMetadataType */
export type CollectionMetadata = {
  __typename?: 'CollectionMetadata';
  /** Current Page of loaded data */
  currentPage: Scalars['Int']['output'];
  /** The number of items per page */
  limitValue: Scalars['Int']['output'];
  page: Scalars['Int']['output'];
  /** The total number of items to be paginated */
  totalCount: Scalars['Int']['output'];
  /** The total number of pages in the pagination */
  totalPages: Scalars['Int']['output'];
};

/** Comment */
export type Comment = ClassTypeInterface & {
  __typename?: 'Comment';
  /** Comment body */
  body: Scalars['String']['output'];
  /** The class type of the field */
  classType: Scalars['String']['output'];
  /** Commentable ID */
  commentableId: Scalars['ID']['output'];
  /** Commentable type */
  commentableType: Scalars['String']['output'];
  /** Comment created at */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** Comment creator */
  creator?: Maybe<User>;
  /** ID of the user that created the comment */
  creatorId?: Maybe<Scalars['ID']['output']>;
  /** Comment ID */
  id: Scalars['ID']['output'];
};

/** Input Type for Comments */
export type CommentCreateInput = {
  /** Comment body */
  body: Scalars['String']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Commentable ID */
  commentableId: Scalars['ID']['input'];
  /** Commentable type */
  commentableType: CommentableTypeEnum;
  /** Comment ID */
  id?: InputMaybe<Scalars['ID']['input']>;
};

/** Autogenerated return type of CommentCreate. */
export type CommentCreatePayload = ClassTypeInterface & {
  __typename?: 'CommentCreatePayload';
  /** The class type of the field */
  classType: Scalars['String']['output'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Newly created Comment */
  comment?: Maybe<Comment>;
  /** Array of Errors */
  errors: Array<Error>;
};

/** Autogenerated input type of CommentDelete */
export type CommentDeleteInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the comment */
  commentId: Scalars['ID']['input'];
};

/** Autogenerated return type of CommentDelete. */
export type CommentDeletePayload = ClassTypeInterface & {
  __typename?: 'CommentDeletePayload';
  /** The class type of the field */
  classType: Scalars['String']['output'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Deleted Comment */
  comment?: Maybe<Comment>;
  /** Array of Errors */
  errors: Array<Error>;
};

/** Input Type for Comments */
export type CommentInput = {
  /** Comment body */
  body: Scalars['String']['input'];
  /** Commentable ID */
  commentableId: Scalars['ID']['input'];
  /** Commentable type */
  commentableType: CommentableTypeEnum;
  /** Comment ID */
  id?: InputMaybe<Scalars['ID']['input']>;
};

/** Comment Thread */
export type CommentThread = ClassTypeInterface & CommentableInterface & DomainObjectInterface & RfNodeInterface & {
  __typename?: 'CommentThread';
  /** The class type of the field */
  classType: Scalars['String']['output'];
  /** Comments left on the object */
  comments?: Maybe<Array<Comment>>;
  /** Number of comments left on the object */
  commentsCount: Scalars['Int']['output'];
  /** Confidence rating of the object */
  confidenceRating?: Maybe<ConfidenceRatingEnum>;
  /** Object creation date */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** User that created the thread */
  creator: User;
  /** ID of the user that created the thread */
  creatorId: Scalars['ID']['output'];
  /** Object global id */
  gid: Scalars['ID']['output'];
  /** ID of object */
  id: Scalars['ID']['output'];
  /** Organization owning the thread */
  organization: Organization;
  /** Strategy node id */
  rfId: Scalars['String']['output'];
  /** Whether created comments should be sent to Slack */
  sendToSlack?: Maybe<Scalars['Boolean']['output']>;
  /** Object last updated date */
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** Input Type for Comment Threads */
export type CommentThreadInput = {
  /** Comment Thread ID */
  id?: InputMaybe<Scalars['ID']['input']>;
  /** Send created comments to Slack? */
  sendToSlack?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Objects that can be commented on */
export type CommentableInterface = {
  /** Comments left on the object */
  comments?: Maybe<Array<Comment>>;
  /** Number of comments left on the object */
  commentsCount: Scalars['Int']['output'];
};

/** Commentable types */
export enum CommentableTypeEnum {
  /** BasicCard */
  BasicCard = 'BasicCard',
  /** CommentThread */
  CommentThread = 'CommentThread',
  /** Entity */
  Entity = 'Entity',
  /** Metric */
  Metric = 'Metric',
  /** Strategy */
  Strategy = 'Strategy'
}

/** List of confidence ratings */
export enum ConfidenceRatingEnum {
  /** At Risk */
  AtRisk = 'at_risk',
  /** Off Track */
  OffTrack = 'off_track',
  /** On Track */
  OnTrack = 'on_track'
}

/** Contributor Types */
export type Contributor = SourceIdentity | User;

/** Correlation information between a pair of Metrics */
export type CorrelationPair = ClassTypeInterface & {
  __typename?: 'CorrelationPair';
  /** The class type of the field */
  classType: Scalars['String']['output'];
  /** An ending date to limit the correlation to */
  endDate?: Maybe<Scalars['ISO8601Date']['output']>;
  /** An ID based on the metrics, used in the frontend */
  id: Scalars['String']['output'];
  /** A symbolic date range to limit the data. Only applied if neither start_date nor end_date are set. */
  range?: Maybe<Scalars['String']['output']>;
  /** Correlation score */
  score?: Maybe<Scalars['Float']['output']>;
  /** Source metric lag days */
  sourceLagDays: Scalars['Int']['output'];
  /** Source metric */
  sourceMetric: Metric;
  /** Source metric ID */
  sourceMetricId: Scalars['ID']['output'];
  /** A starting date to limit the correlation to */
  startDate?: Maybe<Scalars['ISO8601Date']['output']>;
  /** Strategy ID */
  strategyId?: Maybe<Scalars['ID']['output']>;
  /** Target metric lag days */
  targetLagDays: Scalars['Int']['output'];
  /** Target metric */
  targetMetric: Metric;
  /** Target metric ID */
  targetMetricId: Scalars['ID']['output'];
};

/** Autogenerated input type of CorrelationPairUpdate */
export type CorrelationPairUpdateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** An ending date to limit the correlation to */
  endDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  /** A symbolic date range to limit the data. Only applied if neither start_date nor end_date are set. */
  range?: InputMaybe<Scalars['String']['input']>;
  /** ID of the source Metric */
  sourceId: Scalars['ID']['input'];
  /** number of days to lag the source Metric when correlating */
  sourceLagDays?: InputMaybe<Scalars['Int']['input']>;
  /** A starting date to limit the correlation to */
  startDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  /** ID of the strategy to use when correlating */
  strategyId?: InputMaybe<Scalars['ID']['input']>;
  /** ID of the target Metric */
  targetId: Scalars['ID']['input'];
  /** number of days to lag the target Metric when correlating */
  targetLagDays?: InputMaybe<Scalars['Int']['input']>;
};

/** Autogenerated return type of CorrelationPairUpdate. */
export type CorrelationPairUpdatePayload = ClassTypeInterface & {
  __typename?: 'CorrelationPairUpdatePayload';
  /** The class type of the field */
  classType: Scalars['String']['output'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Updated correlation pair */
  correlationPair?: Maybe<CorrelationPair>;
  /** Array of Errors */
  errors: Array<Error>;
};

/** Credential */
export type Credential = ClassTypeInterface & {
  __typename?: 'Credential';
  /** API Key for the Credential */
  apiKey?: Maybe<Scalars['String']['output']>;
  /** The class type of the field */
  classType: Scalars['String']['output'];
  /** Client ID for the Credential */
  clientId?: Maybe<Scalars['String']['output']>;
  /** When the Credential was created */
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Database name for the Credential */
  database?: Maybe<Scalars['String']['output']>;
  /** Display name for the Credential */
  displayName?: Maybe<Scalars['String']['output']>;
  /** File attached to the Credential */
  file?: Maybe<FileAttachment>;
  /** File's Shrine Hash for the Credential */
  fileData?: Maybe<Scalars['JSON']['output']>;
  /** Hostname for the Credential */
  host?: Maybe<Scalars['String']['output']>;
  /** Credential ID */
  id: Scalars['ID']['output'];
  /** Label for this Credential */
  label?: Maybe<Scalars['String']['output']>;
  /** Metrics associated with the Credential */
  metrics?: Maybe<Array<Metric>>;
  /** Port for the Credential */
  port?: Maybe<Scalars['String']['output']>;
  /** Project ID */
  projectId?: Maybe<Scalars['ID']['output']>;
  /** Region for the Credential */
  region?: Maybe<Scalars['String']['output']>;
  /** Role for the Credential */
  role?: Maybe<Scalars['String']['output']>;
  /** Schema name for the Credential */
  schema?: Maybe<Scalars['String']['output']>;
  /** Credential source */
  sourceName?: Maybe<Scalars['String']['output']>;
  /** When the Credential was last updated */
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Username for the Credential */
  username?: Maybe<Scalars['String']['output']>;
  /** Warehouse name for the Credential */
  warehouse?: Maybe<Scalars['String']['output']>;
  /** Workspace ID */
  workspaceId?: Maybe<Scalars['ID']['output']>;
};

/** Input for Credentials */
export type CredentialAttributesTestInput = {
  /** API Key */
  apiKey?: InputMaybe<Scalars['String']['input']>;
  /** Client ID */
  clientId?: InputMaybe<Scalars['String']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Client Secret */
  clientSecret?: InputMaybe<Scalars['String']['input']>;
  /** Database name */
  database?: InputMaybe<Scalars['String']['input']>;
  /** File Data Hash */
  file?: InputMaybe<Scalars['JSON']['input']>;
  /** Host name */
  host?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the credential to pull secret_fields from, for fields that are specified as such */
  id?: InputMaybe<Scalars['ID']['input']>;
  /** A label that can be used when displaying in a list etc. */
  label?: InputMaybe<Scalars['String']['input']>;
  /** Password */
  password?: InputMaybe<Scalars['String']['input']>;
  /** Port */
  port?: InputMaybe<Scalars['String']['input']>;
  /** Project ID */
  projectId?: InputMaybe<Scalars['String']['input']>;
  /** Region (Mixpanel / Amplitude) */
  region?: InputMaybe<Scalars['String']['input']>;
  /** Role */
  role?: InputMaybe<Scalars['String']['input']>;
  /** Schema name */
  schema?: InputMaybe<Scalars['String']['input']>;
  /**
   * Comma-separated list of fields to pull from the credential, if they are not
   * included / blank in the input. Implies a non-nil credential id. When
   * specifying, use the snake_case variant of the field name
   */
  secretFields?: InputMaybe<Scalars['String']['input']>;
  /** Secret Key */
  secretKey?: InputMaybe<Scalars['String']['input']>;
  /** The name of the source */
  sourceName: Scalars['String']['input'];
  /** Username */
  username?: InputMaybe<Scalars['String']['input']>;
  /** Warehouse name */
  warehouse?: InputMaybe<Scalars['String']['input']>;
  /** Workspace ID */
  workspaceId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of CredentialAttributesTest. */
export type CredentialAttributesTestPayload = ClassTypeInterface & {
  __typename?: 'CredentialAttributesTestPayload';
  /** The class type of the field */
  classType: Scalars['String']['output'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The array of errors */
  errors?: Maybe<Array<Error>>;
  /** Whether the test was successful */
  success: Scalars['Boolean']['output'];
};

/** Input for Credentials */
export type CredentialCreateInput = {
  /** API Key */
  apiKey?: InputMaybe<Scalars['String']['input']>;
  /** Client ID */
  clientId?: InputMaybe<Scalars['String']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Client Secret */
  clientSecret?: InputMaybe<Scalars['String']['input']>;
  /** Database name */
  database?: InputMaybe<Scalars['String']['input']>;
  /** File Data Hash */
  file?: InputMaybe<Scalars['JSON']['input']>;
  /** Host name */
  host?: InputMaybe<Scalars['String']['input']>;
  /** ID */
  id?: InputMaybe<Scalars['ID']['input']>;
  /** A label that can be used when displaying in a list etc. */
  label?: InputMaybe<Scalars['String']['input']>;
  /** Password */
  password?: InputMaybe<Scalars['String']['input']>;
  /** Port */
  port?: InputMaybe<Scalars['String']['input']>;
  /** Project ID */
  projectId?: InputMaybe<Scalars['String']['input']>;
  /** Region (Mixpanel / Amplitude) */
  region?: InputMaybe<Scalars['String']['input']>;
  /** Role */
  role?: InputMaybe<Scalars['String']['input']>;
  /** Schema name */
  schema?: InputMaybe<Scalars['String']['input']>;
  /** Secret Key */
  secretKey?: InputMaybe<Scalars['String']['input']>;
  /** Name of the source */
  sourceName: Scalars['String']['input'];
  /** Username */
  username?: InputMaybe<Scalars['String']['input']>;
  /** Warehouse name */
  warehouse?: InputMaybe<Scalars['String']['input']>;
  /** Workspace ID */
  workspaceId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of CredentialCreate. */
export type CredentialCreatePayload = ClassTypeInterface & {
  __typename?: 'CredentialCreatePayload';
  /** The class type of the field */
  classType: Scalars['String']['output'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The updated Credential */
  credential?: Maybe<Credential>;
  /** Errors encountered while updating the Credential */
  errors: Array<Error>;
};

/** Input for Credentials */
export type CredentialInput = {
  /** API Key */
  apiKey?: InputMaybe<Scalars['String']['input']>;
  /** Client ID */
  clientId?: InputMaybe<Scalars['String']['input']>;
  /** Client Secret */
  clientSecret?: InputMaybe<Scalars['String']['input']>;
  /** Database name */
  database?: InputMaybe<Scalars['String']['input']>;
  /** File Data Hash */
  file?: InputMaybe<Scalars['JSON']['input']>;
  /** Host name */
  host?: InputMaybe<Scalars['String']['input']>;
  /** ID */
  id?: InputMaybe<Scalars['ID']['input']>;
  /** A label that can be used when displaying in a list etc. */
  label?: InputMaybe<Scalars['String']['input']>;
  /** Password */
  password?: InputMaybe<Scalars['String']['input']>;
  /** Port */
  port?: InputMaybe<Scalars['String']['input']>;
  /** Project ID */
  projectId?: InputMaybe<Scalars['String']['input']>;
  /** Region (Mixpanel / Amplitude) */
  region?: InputMaybe<Scalars['String']['input']>;
  /** Role */
  role?: InputMaybe<Scalars['String']['input']>;
  /** Schema name */
  schema?: InputMaybe<Scalars['String']['input']>;
  /** Secret Key */
  secretKey?: InputMaybe<Scalars['String']['input']>;
  /** Name of the source */
  sourceName?: InputMaybe<Scalars['String']['input']>;
  /** Username */
  username?: InputMaybe<Scalars['String']['input']>;
  /** Warehouse name */
  warehouse?: InputMaybe<Scalars['String']['input']>;
  /** Workspace ID */
  workspaceId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated input type of CredentialTest */
export type CredentialTestInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the Credential to test */
  credentialId: Scalars['ID']['input'];
};

/** Autogenerated return type of CredentialTest. */
export type CredentialTestPayload = ClassTypeInterface & {
  __typename?: 'CredentialTestPayload';
  /** The class type of the field */
  classType: Scalars['String']['output'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The credential */
  credential: Credential;
  /** The array of errors */
  errors?: Maybe<Array<Error>>;
  /** Whether the test was successful */
  success: Scalars['Boolean']['output'];
};

/** enum of CRUD operations */
export enum CrudOperationEnum {
  /** Delete */
  Delete = 'delete',
  /** Upsert */
  Upsert = 'upsert'
}

/** Input Type for CSV Configuration Segment */
export type CsvConfigurationSegmentInput = {
  /** The name of the column in the CSV file */
  name: Scalars['String']['input'];
  /** The index of the column in the CSV file */
  valueIndex: Scalars['Int']['input'];
};

/** Autogenerated input type of CustomerCreate */
export type CustomerCreateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Homepage URL for the new organization */
  homepageUrl?: InputMaybe<Scalars['String']['input']>;
  /** Name for the new organization */
  name: Scalars['String']['input'];
};

/** Autogenerated return type of CustomerCreate. */
export type CustomerCreatePayload = ClassTypeInterface & {
  __typename?: 'CustomerCreatePayload';
  /** The class type of the field */
  classType: Scalars['String']['output'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Array of Errors */
  errors: Array<Error>;
  /** Newly created organization */
  organization?: Maybe<Organization>;
  /** Strategy created for the newly created organization */
  strategy?: Maybe<Strategy>;
};

/** Paid subscription data */
export type CustomerSubscription = ClassTypeInterface & {
  __typename?: 'CustomerSubscription';
  /** The class type of the field */
  classType: Scalars['String']['output'];
  /** End Date of the Subscription */
  endDate?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Stigg ID of the Subscription */
  id: Scalars['ID']['output'];
  /** Start Date of the Subscription */
  startDate?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Status of the Subscription */
  status: CustomerSubscriptionStatusEnum;
  /** End Date of the free Trial period */
  trialEndDate?: Maybe<Scalars['ISO8601DateTime']['output']>;
};

/** Enumeration of possible statuses for Customer Subscriptions */
export enum CustomerSubscriptionStatusEnum {
  /** Active subscription */
  Active = 'ACTIVE',
  /** Canceled subscription */
  Canceled = 'CANCELED',
  /** Expired subscription */
  Expired = 'EXPIRED',
  /** Trial subscription */
  InTrial = 'IN_TRIAL',
  /** Unpaid subscription */
  NotStarted = 'NOT_STARTED',
  /** Pending subscription */
  PaymentPending = 'PAYMENT_PENDING'
}

/** Dimensions */
export type DimensionsInput = {
  /** Height */
  height: Scalars['Int']['input'];
  /** Width */
  width: Scalars['Int']['input'];
};

/** List of possible Display Format values on Metric */
export enum DisplayFormatEnum {
  /** eur formatting */
  Eur = 'eur',
  /** gbp formatting */
  Gbp = 'gbp',
  /** hours formatting */
  Hours = 'hours',
  /** minutes formatting */
  Minutes = 'minutes',
  /** number formatting */
  Number = 'number',
  /** percent formatting */
  Percent = 'percent',
  /** seconds formatting */
  Seconds = 'seconds',
  /** usd formatting */
  Usd = 'usd'
}

/** Input Type for Labeling Domain Objects */
export type DomainObjectBulkLabelInput =
  /** BasicCard */
  { basicCard: Array<Scalars['ID']['input']>; entity?: never; metric?: never; strategy?: never; }
  |  /** Entity */
  { basicCard?: never; entity: Array<Scalars['ID']['input']>; metric?: never; strategy?: never; }
  |  /** Metric */
  { basicCard?: never; entity?: never; metric: Array<Scalars['ID']['input']>; strategy?: never; }
  |  /** Strategy */
  { basicCard?: never; entity?: never; metric?: never; strategy: Array<Scalars['ID']['input']>; };

/** Input Type for Deleting Domain Objects */
export type DomainObjectDeleteInput =
  /** Basic Card */
  { basicCard: Array<Scalars['ID']['input']>; chat?: never; credential?: never; entity?: never; existing?: never; goal?: never; integration?: never; mapImage?: never; metric?: never; note?: never; recurringReportConfiguration?: never; report?: never; section?: never; strategy?: never; work?: never; }
  |  /** Chat */
  { basicCard?: never; chat: Array<Scalars['ID']['input']>; credential?: never; entity?: never; existing?: never; goal?: never; integration?: never; mapImage?: never; metric?: never; note?: never; recurringReportConfiguration?: never; report?: never; section?: never; strategy?: never; work?: never; }
  |  /** Credential */
  { basicCard?: never; chat?: never; credential: Array<Scalars['ID']['input']>; entity?: never; existing?: never; goal?: never; integration?: never; mapImage?: never; metric?: never; note?: never; recurringReportConfiguration?: never; report?: never; section?: never; strategy?: never; work?: never; }
  |  /** Entity */
  { basicCard?: never; chat?: never; credential?: never; entity: Array<Scalars['ID']['input']>; existing?: never; goal?: never; integration?: never; mapImage?: never; metric?: never; note?: never; recurringReportConfiguration?: never; report?: never; section?: never; strategy?: never; work?: never; }
  |  /** Existing Node */
  { basicCard?: never; chat?: never; credential?: never; entity?: never; existing: Array<Scalars['ID']['input']>; goal?: never; integration?: never; mapImage?: never; metric?: never; note?: never; recurringReportConfiguration?: never; report?: never; section?: never; strategy?: never; work?: never; }
  |  /** Goal */
  { basicCard?: never; chat?: never; credential?: never; entity?: never; existing?: never; goal: Array<Scalars['ID']['input']>; integration?: never; mapImage?: never; metric?: never; note?: never; recurringReportConfiguration?: never; report?: never; section?: never; strategy?: never; work?: never; }
  |  /** Existing Integration */
  { basicCard?: never; chat?: never; credential?: never; entity?: never; existing?: never; goal?: never; integration: Array<Scalars['ID']['input']>; mapImage?: never; metric?: never; note?: never; recurringReportConfiguration?: never; report?: never; section?: never; strategy?: never; work?: never; }
  |  /** Map Image */
  { basicCard?: never; chat?: never; credential?: never; entity?: never; existing?: never; goal?: never; integration?: never; mapImage: Array<Scalars['ID']['input']>; metric?: never; note?: never; recurringReportConfiguration?: never; report?: never; section?: never; strategy?: never; work?: never; }
  |  /** Metric */
  { basicCard?: never; chat?: never; credential?: never; entity?: never; existing?: never; goal?: never; integration?: never; mapImage?: never; metric: Array<Scalars['ID']['input']>; note?: never; recurringReportConfiguration?: never; report?: never; section?: never; strategy?: never; work?: never; }
  |  /** Note */
  { basicCard?: never; chat?: never; credential?: never; entity?: never; existing?: never; goal?: never; integration?: never; mapImage?: never; metric?: never; note: Array<Scalars['ID']['input']>; recurringReportConfiguration?: never; report?: never; section?: never; strategy?: never; work?: never; }
  |  /** Recurring Report Configuration */
  { basicCard?: never; chat?: never; credential?: never; entity?: never; existing?: never; goal?: never; integration?: never; mapImage?: never; metric?: never; note?: never; recurringReportConfiguration: Array<Scalars['ID']['input']>; report?: never; section?: never; strategy?: never; work?: never; }
  |  /** Report */
  { basicCard?: never; chat?: never; credential?: never; entity?: never; existing?: never; goal?: never; integration?: never; mapImage?: never; metric?: never; note?: never; recurringReportConfiguration?: never; report: Array<Scalars['ID']['input']>; section?: never; strategy?: never; work?: never; }
  |  /** Section */
  { basicCard?: never; chat?: never; credential?: never; entity?: never; existing?: never; goal?: never; integration?: never; mapImage?: never; metric?: never; note?: never; recurringReportConfiguration?: never; report?: never; section: Array<Scalars['ID']['input']>; strategy?: never; work?: never; }
  |  /** Strategy */
  { basicCard?: never; chat?: never; credential?: never; entity?: never; existing?: never; goal?: never; integration?: never; mapImage?: never; metric?: never; note?: never; recurringReportConfiguration?: never; report?: never; section?: never; strategy: Array<Scalars['ID']['input']>; work?: never; }
  |  /** Entity */
  { basicCard?: never; chat?: never; credential?: never; entity?: never; existing?: never; goal?: never; integration?: never; mapImage?: never; metric?: never; note?: never; recurringReportConfiguration?: never; report?: never; section?: never; strategy?: never; work: Array<Scalars['ID']['input']>; };

/** An object that has a standard interface of a react flow node on a strategy map */
export type DomainObjectInterface = {
  /** Confidence rating of the object */
  confidenceRating?: Maybe<ConfidenceRatingEnum>;
};

/** DomainObject status enum */
export enum DomainObjectStatusEnum {
  /** Active */
  Active = 'active',
  /** Done */
  Done = 'done',
  /** Idea */
  Idea = 'idea',
  /** Learning review */
  LearningReview = 'learning_review',
  /** Next */
  Next = 'next'
}

/** Domain Object Types */
export type DomainObjectUnion = AiAssistantFile | BasicCard | BusinessContext | CardType | Chat | Comment | CommentThread | Credential | Edge | Entity | Favorite | Goal | GoogleIntegration | Integration | JiraIntegration | LookerDashboard | MapImage | Message | Metric | MetricSource | Node | Note | RecurringReportConfiguration | Report | Schedule | Section | Strategy | Task | User;

/** Autogenerated input type of DomainObjectUpdate */
export type DomainObjectUpdateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The objects to update */
  objects: Array<NodeObjectInput>;
};

/** Autogenerated return type of DomainObjectUpdate. */
export type DomainObjectUpdatePayload = ClassTypeInterface & {
  __typename?: 'DomainObjectUpdatePayload';
  /** The class type of the field */
  classType: Scalars['String']['output'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Array of Errors */
  errors: Array<Error>;
  /** Updated objects */
  nodeObjects?: Maybe<Array<DomainObjectUnion>>;
};

/** Autogenerated input type of DomainObjectsBulkLabel */
export type DomainObjectsBulkLabelInput = {
  /** Labels to add */
  add?: InputMaybe<Array<Scalars['String']['input']>>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The objects to label */
  objects: Array<DomainObjectBulkLabelInput>;
  /** Labels to remove */
  remove?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** Autogenerated return type of DomainObjectsBulkLabel. */
export type DomainObjectsBulkLabelPayload = ClassTypeInterface & {
  __typename?: 'DomainObjectsBulkLabelPayload';
  /** The class type of the field */
  classType: Scalars['String']['output'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Labeled objects */
  domainObjects?: Maybe<Array<LabelableObject>>;
  /** Array of Errors */
  errors: Array<Error>;
};

/** Autogenerated input type of DomainObjectsDelete */
export type DomainObjectsDeleteInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The objects to delete */
  objects: Array<DomainObjectDeleteInput>;
};

/** Autogenerated return type of DomainObjectsDelete. */
export type DomainObjectsDeletePayload = ClassTypeInterface & {
  __typename?: 'DomainObjectsDeletePayload';
  /** The class type of the field */
  classType: Scalars['String']['output'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** CRUD operation wrapper */
  crudOperation: TypesUnionsDomainObjectUnionArrayGraphqlCrudOperation;
  /** Array of Errors */
  errors: Array<Error>;
};

/** Edge */
export type Edge = ClassTypeInterface & {
  __typename?: 'Edge';
  /** The class type of the field */
  classType: Scalars['String']['output'];
  /** Manually set color for the edge */
  color?: Maybe<Scalars['String']['output']>;
  /** Correlation score if present */
  correlationScore?: Maybe<Scalars['String']['output']>;
  /** Correlation score updated at if present */
  correlationScoreUpdatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Object data */
  data: Scalars['JSON']['output'];
  /** The actual edge id for mutations */
  edgeId: Scalars['ID']['output'];
  /** Object unique ID */
  id: Scalars['ID']['output'];
  /** AI Insights if present */
  insights?: Maybe<Scalars['String']['output']>;
  /** Expanded AI Insights on edges */
  insightsDetails?: Maybe<Scalars['String']['output']>;
  /** Current insights details chat */
  insightsDetailsChat?: Maybe<Chat>;
  /** Current insights details chat id */
  insightsDetailsChatId?: Maybe<Scalars['ID']['output']>;
  /** Object React Flow ID */
  rfId: Scalars['String']['output'];
  /** Whether the edge is selected or not */
  selected?: Maybe<Scalars['Boolean']['output']>;
  /** Simulator impact */
  simImpact?: Maybe<Scalars['Float']['output']>;
  /** React flow source name */
  source: Scalars['String']['output'];
  /** Source position on the Strategy Map */
  sourceHandle: Scalars['String']['output'];
  /** Source domain object id */
  sourceId?: Maybe<Scalars['ID']['output']>;
  /** Source domain object type */
  sourceType: Scalars['String']['output'];
  /** associated Strategy */
  strategy?: Maybe<Strategy>;
  /** Strategy ID */
  strategyId: Scalars['ID']['output'];
  /** React flow target name */
  target: Scalars['String']['output'];
  /** Target position on the Strategy Map */
  targetHandle: Scalars['String']['output'];
  /** Target domain object id */
  targetId?: Maybe<Scalars['ID']['output']>;
  /** Source domain object type */
  targetType: Scalars['String']['output'];
  /** React flow type */
  type: Scalars['String']['output'];
  /** Z index for the edge */
  zIndex: Scalars['Int']['output'];
};

/** Autogenerated input type of EdgeCreate */
export type EdgeCreateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The Position of the Source to associate */
  sourceHandle: Scalars['String']['input'];
  /** The ID of the Source to associate */
  sourceId: Scalars['ID']['input'];
  /** The Type of the Source to associate */
  sourceType: Scalars['String']['input'];
  /** The ID of the Strategy to associate */
  strategyId: Scalars['ID']['input'];
  /** The Position of the Target to associate */
  targetHandle: Scalars['String']['input'];
  /** The ID of the Target to associate */
  targetId: Scalars['ID']['input'];
  /** The Type of the Target to associate */
  targetType: Scalars['String']['input'];
};

/** Autogenerated return type of EdgeCreate. */
export type EdgeCreatePayload = ClassTypeInterface & {
  __typename?: 'EdgeCreatePayload';
  /** The class type of the field */
  classType: Scalars['String']['output'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Edge returned */
  edge: Edge;
  /** Array of Errors */
  errors: Array<Error>;
};

/** Autogenerated input type of EdgeDelete */
export type EdgeDeleteInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the Edge to destroy */
  edgeId: Scalars['ID']['input'];
};

/** Autogenerated return type of EdgeDelete. */
export type EdgeDeletePayload = ClassTypeInterface & {
  __typename?: 'EdgeDeletePayload';
  /** The class type of the field */
  classType: Scalars['String']['output'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Destroyed Edge returned */
  edge: Edge;
  /** Array of Errors */
  errors: Array<Error>;
};

/** Input Type for Edges */
export type EdgeInput = {
  /** Color */
  color?: InputMaybe<Scalars['String']['input']>;
  /** Edge ID */
  id?: InputMaybe<Scalars['ID']['input']>;
  /** Insights */
  insights?: InputMaybe<Scalars['String']['input']>;
  /** Expanded Insights */
  insightsDetails?: InputMaybe<Scalars['String']['input']>;
  /** Simulator Impact */
  simImpact?: InputMaybe<Scalars['Float']['input']>;
  /** The Position of the Source to associate */
  sourceHandle?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the Strategy to associate */
  strategyId?: InputMaybe<Scalars['ID']['input']>;
  /** The Position of the Target to associate */
  targetHandle?: InputMaybe<Scalars['String']['input']>;
};

/** Entity */
export type Entity = ClassTypeInterface & CommentableInterface & DomainObjectInterface & RfNodeInterface & {
  __typename?: 'Entity';
  /** Activity that created this entity */
  activityId?: Maybe<Scalars['Int']['output']>;
  /** The class type of the field */
  classType: Scalars['String']['output'];
  /** List of entity classifications */
  classifications?: Maybe<Array<Classification>>;
  /** Comments left on the object */
  comments?: Maybe<Array<Comment>>;
  /** Number of comments left on the object */
  commentsCount: Scalars['Int']['output'];
  /** Confidence rating of the object */
  confidenceRating?: Maybe<ConfidenceRatingEnum>;
  /** Number of work items contained by this Work */
  containeeCount?: Maybe<Scalars['Int']['output']>;
  /** IDs of Entities contained by this Entity */
  containeeIds?: Maybe<Array<Scalars['ID']['output']>>;
  /** workflow_state counts for Entities contained by this Entity */
  containeeStats?: Maybe<Scalars['JSON']['output']>;
  /** Entity containments */
  containerEntityContainments?: Maybe<Array<EntityContainment>>;
  /** Object creation date */
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Entity summary text, intended for end-user display */
  displaySummary?: Maybe<Scalars['String']['output']>;
  /** Due date for the Entity */
  dueDate?: Maybe<Scalars['ISO8601Date']['output']>;
  /** Entity file attachments */
  entityAttachments?: Maybe<Array<Attachment>>;
  /** Number of file attachments to entity */
  entityAttachmentsCount: Scalars['Int']['output'];
  /** Entity Contributors */
  entityContributions?: Maybe<Array<EntityContribution>>;
  /** This is a poorly named field. Some form of first level descriptor like `chore`, `feature` */
  entityType?: Maybe<Scalars['String']['output']>;
  /** Primary ID in 3rd party Source like a Jira issue ID */
  foreignId?: Maybe<Scalars['String']['output']>;
  /** Foreign state like  Jira issue State */
  foreignState?: Maybe<Scalars['String']['output']>;
  /** Foreign type like  Jira issue */
  foreignType?: Maybe<Scalars['String']['output']>;
  /** What is the goal or hypothesis for this entity? */
  goalHypothesis?: Maybe<Scalars['String']['output']>;
  /** When the entity last had an event occur to it that we want to expose to the user */
  happenedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Unix timestamp of the week this entity happened_at. Used primarily for grouping */
  happenedOnWeek?: Maybe<Scalars['BigInt']['output']>;
  /** Whether the entity has an edited headline */
  hasEditedHeadline?: Maybe<Scalars['Boolean']['output']>;
  /** ID of object */
  id: Scalars['ID']['output'];
  /** Impact of either `positive` or `negative` */
  impact?: Maybe<ImpactEnum>;
  /** Importance of: `major`, `medium`, `minor` */
  importance?: Maybe<ImportanceEnum>;
  /** Entity labels */
  labels?: Maybe<Array<Label>>;
  /** First order link that will display on the Changelogs */
  linkTitle?: Maybe<Scalars['String']['output']>;
  /** First order link that will be used on the Changelog pages */
  linkUrl?: Maybe<Scalars['String']['output']>;
  /** the name of this entity */
  name?: Maybe<Scalars['String']['output']>;
  /** Associated Organization */
  organization: Organization;
  /** Organization ID */
  organizationId: Scalars['ID']['output'];
  /** Associated User */
  owner?: Maybe<User>;
  /** Owner ID */
  ownerId?: Maybe<Scalars['ID']['output']>;
  /** Whether the entity has recent activity */
  recentActivity?: Maybe<Scalars['Boolean']['output']>;
  /** Recorded results for the entity. Usually related to Goal / Hypothesis */
  results?: Maybe<Scalars['String']['output']>;
  /** Strategy node id */
  rfId: Scalars['String']['output'];
  /** Secondary ID in 3rd party Source like a Jira issue ID */
  secondaryForeignId?: Maybe<Scalars['String']['output']>;
  /** Whether to show the goal_hypothesis field */
  showGoalHypothesis?: Maybe<Scalars['Boolean']['output']>;
  /** Whether to show the results field */
  showResults?: Maybe<Scalars['Boolean']['output']>;
  /** Whether to show the summary field */
  showSummary?: Maybe<Scalars['Boolean']['output']>;
  /** Source name ex: Google or Jira */
  sourceName?: Maybe<Scalars['String']['output']>;
  /** Summary / Description on the Foreign Entity */
  sourceSummary?: Maybe<Scalars['String']['output']>;
  /** URL to entity on foreign service */
  sourceUrl?: Maybe<Scalars['String']['output']>;
  /** Strategies that the Work is associated with */
  strategies: Array<Strategy>;
  /** Entity summary */
  summary?: Maybe<Scalars['String']['output']>;
  /** Entity full summary */
  summaryFull?: Maybe<Scalars['String']['output']>;
  /** Entity shortened summary */
  summaryShort?: Maybe<Scalars['String']['output']>;
  /** Entity thumbnail */
  thumbnail?: Maybe<Attachment>;
  /** Object updated date */
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Workflow state of the entity */
  workflowState?: Maybe<EntityWorkflowStateEnum>;
};

/** EntityCollection type */
export type EntityCollection = {
  __typename?: 'EntityCollection';
  /** A collection of paginated EntityCollection */
  collection: Array<Entity>;
  /** Pagination Metadata for navigating the Pagination */
  metadata: CollectionMetadata;
};

/** Entity Containment */
export type EntityContainment = ClassTypeInterface & {
  __typename?: 'EntityContainment';
  /** The class type of the field */
  classType: Scalars['String']['output'];
  /** ID of the contained Entity */
  containeeId: Scalars['ID']['output'];
  /** Class name of the containing domain object */
  containerClassName: Scalars['String']['output'];
  /** ID of the containing domain object */
  containerId: Scalars['ID']['output'];
  /** Type of the containing domain object */
  containerType: Scalars['String']['output'];
  /** ID of object */
  id: Scalars['ID']['output'];
};

/** Autogenerated input type of EntityContainmentCreate */
export type EntityContainmentCreateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** ID of the containment to create */
  containerId: Scalars['ID']['input'];
  /** Type of containment to create */
  containerType: Scalars['String']['input'];
  /** ID of the entity to create the containment from */
  entityId: Scalars['ID']['input'];
};

/** Autogenerated return type of EntityContainmentCreate. */
export type EntityContainmentCreatePayload = ClassTypeInterface & {
  __typename?: 'EntityContainmentCreatePayload';
  /** The class type of the field */
  classType: Scalars['String']['output'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Deleted entity */
  entity?: Maybe<Entity>;
  /** Array of Errors */
  errors: Array<Error>;
};

/** Autogenerated input type of EntityContainmentDelete */
export type EntityContainmentDeleteInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** ID of the containment to delete */
  containerId: Scalars['ID']['input'];
  /** Type of containment to delete */
  containerType: Scalars['String']['input'];
  /** ID of the entity to delete the containment from */
  entityId: Scalars['ID']['input'];
};

/** Autogenerated return type of EntityContainmentDelete. */
export type EntityContainmentDeletePayload = ClassTypeInterface & {
  __typename?: 'EntityContainmentDeletePayload';
  /** The class type of the field */
  classType: Scalars['String']['output'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Deleted entity */
  entity?: Maybe<Entity>;
  /** Array of Errors */
  errors: Array<Error>;
};

/** A relationship between an Entity and a User or a SourceIdentity */
export type EntityContribution = ClassTypeInterface & {
  __typename?: 'EntityContribution';
  /** The class type of the field */
  classType: Scalars['String']['output'];
  /** Associated Contributor / User */
  contributor: Contributor;
  /** Object creation date */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** Associated Entity */
  entity: Entity;
  /** Object unique ID */
  id: Scalars['ID']['output'];
  /** Object last updated date */
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** Input Type for Entity Contributions */
export type EntityContributionInput = {
  /** Entity Contribution ID */
  id?: InputMaybe<Scalars['ID']['input']>;
  /** The name of the contributor */
  name?: InputMaybe<Scalars['String']['input']>;
  /** The source of the contributor */
  sourceName?: InputMaybe<Scalars['String']['input']>;
  /** The value of the contributor */
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated input type of EntityCreateAttachment */
export type EntityCreateAttachmentInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Entity ID to attach to */
  entityId: Scalars['ID']['input'];
  /** File Data Hash */
  shrineHash: Scalars['JSON']['input'];
};

/** Autogenerated return type of EntityCreateAttachment. */
export type EntityCreateAttachmentPayload = ClassTypeInterface & {
  __typename?: 'EntityCreateAttachmentPayload';
  /** The class type of the field */
  classType: Scalars['String']['output'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Updated entity */
  entity?: Maybe<Entity>;
  /** Array of Errors */
  errors: Array<Error>;
};

/** Autogenerated input type of EntityCreateContributor */
export type EntityCreateContributorInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** ID of the Contributor to add */
  contributorId?: InputMaybe<Scalars['ID']['input']>;
  /** Email of the Contributor to add */
  email?: InputMaybe<Scalars['String']['input']>;
  /** ID of the entity to add the label to */
  entityId: Scalars['ID']['input'];
  /** Source Name of the Contributor to add */
  sourceName?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of EntityCreateContributor. */
export type EntityCreateContributorPayload = ClassTypeInterface & {
  __typename?: 'EntityCreateContributorPayload';
  /** The class type of the field */
  classType: Scalars['String']['output'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Entity the Label was added to */
  entity: Entity;
  /** Newly created Contributor */
  entityContribution?: Maybe<EntityContribution>;
  /** Array of Errors */
  errors: Array<Error>;
};

/** Input Type for Entity */
export type EntityCreateInput = {
  /** Optional attachment Shrine hashes, to add to the Entity */
  attachmentHashes?: InputMaybe<Array<Scalars['JSON']['input']>>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Optional container to add to the Entity */
  containerId?: InputMaybe<Scalars['ID']['input']>;
  /** Optional container node ids to add to the Entity */
  containerNodeIds?: InputMaybe<Scalars['CommaSeparatedString']['input']>;
  /** Optional container type to add to the Entity */
  containerType?: InputMaybe<Scalars['String']['input']>;
  /** Optional contributors to add to the entity */
  contributors?: InputMaybe<Array<Scalars['JSON']['input']>>;
  /** The due_date for the Work */
  dueDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  /** Optional contributors to add to the entity */
  entityContributions?: InputMaybe<Array<EntityContributionInput>>;
  /** The type of the entity (chore, feature, fix, etc.) */
  entityType?: InputMaybe<Scalars['String']['input']>;
  /** The state of the Work in the source */
  foreignState?: InputMaybe<EntityWorkflowStateEnum>;
  /** The type of the Work in the source */
  foreignType?: InputMaybe<Scalars['String']['input']>;
  /** The expected result or hypothesis for the entity */
  goalHypothesis?: InputMaybe<Scalars['String']['input']>;
  /** When the entity / event occurred */
  happenedAt?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  /** Entity ID */
  id?: InputMaybe<Scalars['ID']['input']>;
  /** One of positive, negative, or null */
  impact?: InputMaybe<Scalars['String']['input']>;
  /** One of major, medium, minor */
  importance?: InputMaybe<Scalars['String']['input']>;
  /** Optional labels to add to the Entity */
  labels?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Title of the link on the Changelog */
  linkTitle?: InputMaybe<Scalars['String']['input']>;
  /** URL of the link on the Changelog */
  linkUrl?: InputMaybe<Scalars['String']['input']>;
  /** The name of the Work */
  name?: InputMaybe<Scalars['String']['input']>;
  /** ID of the owner of this Work */
  ownerId?: InputMaybe<Scalars['ID']['input']>;
  /** What result happened with the entity */
  results?: InputMaybe<Scalars['String']['input']>;
  /** Whether to show the goal_hypothesis field */
  showGoalHypothesis?: InputMaybe<Scalars['CastableBoolean']['input']>;
  /** Whether to show the results field */
  showResults?: InputMaybe<Scalars['CastableBoolean']['input']>;
  /** Whether to show the summary field */
  showSummary?: InputMaybe<Scalars['CastableBoolean']['input']>;
  /** The source of the Work */
  sourceName?: InputMaybe<Scalars['String']['input']>;
  /** Entity long-form summary */
  summary?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of EntityCreate. */
export type EntityCreatePayload = ClassTypeInterface & {
  __typename?: 'EntityCreatePayload';
  /** The class type of the field */
  classType: Scalars['String']['output'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Newly created entity */
  entity?: Maybe<Entity>;
  /** Array of Errors */
  errors: Array<Error>;
};

/** Autogenerated input type of EntityDeleteAttachment */
export type EntityDeleteAttachmentInput = {
  /** ID of attachment to destroy */
  attachmentId: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Entity ID to remove from */
  entityId: Scalars['ID']['input'];
};

/** Autogenerated return type of EntityDeleteAttachment. */
export type EntityDeleteAttachmentPayload = ClassTypeInterface & {
  __typename?: 'EntityDeleteAttachmentPayload';
  /** The class type of the field */
  classType: Scalars['String']['output'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Updated entity */
  entity?: Maybe<Entity>;
  /** Array of Errors */
  errors: Array<Error>;
};

/** Autogenerated input type of EntityDeleteContributor */
export type EntityDeleteContributorInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Contributor ID to delete */
  contributorId: Scalars['ID']['input'];
  /** ID of Entity to remove the label from */
  entityId: Scalars['ID']['input'];
  /** Source name of Contributor type to delete */
  sourceName: Scalars['String']['input'];
};

/** Autogenerated return type of EntityDeleteContributor. */
export type EntityDeleteContributorPayload = ClassTypeInterface & {
  __typename?: 'EntityDeleteContributorPayload';
  /** The class type of the field */
  classType: Scalars['String']['output'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Removed Label */
  contributor?: Maybe<Label>;
  /** Entity the Label was added to */
  entity: Entity;
  /** Array of Errors */
  errors: Array<Error>;
};

/** Input Type for Entity */
export type EntityInput = {
  /** The due_date for the Work */
  dueDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  /** Optional contributors to add to the entity */
  entityContributions?: InputMaybe<Array<EntityContributionInput>>;
  /** The state of the Work in the source */
  foreignState?: InputMaybe<EntityWorkflowStateEnum>;
  /** The type of the Work in the source */
  foreignType?: InputMaybe<Scalars['String']['input']>;
  /** The expected result or hypothesis for the entity */
  goalHypothesis?: InputMaybe<Scalars['String']['input']>;
  /** When the entity / event occurred */
  happenedAt?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  /** Entity ID */
  id?: InputMaybe<Scalars['ID']['input']>;
  /** One of positive, negative, or null */
  impact?: InputMaybe<Scalars['String']['input']>;
  /** One of major, medium, minor */
  importance?: InputMaybe<Scalars['String']['input']>;
  /** Optional labels to add to the Entity */
  labels?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Title of the link on the Changelog */
  linkTitle?: InputMaybe<Scalars['String']['input']>;
  /** URL of the link on the Changelog */
  linkUrl?: InputMaybe<Scalars['String']['input']>;
  /** The name of the Work */
  name?: InputMaybe<Scalars['String']['input']>;
  /** ID of the owner of this Work */
  ownerId?: InputMaybe<Scalars['ID']['input']>;
  /** What result happened with the entity */
  results?: InputMaybe<Scalars['String']['input']>;
  /** Whether to show the goal_hypothesis field */
  showGoalHypothesis?: InputMaybe<Scalars['CastableBoolean']['input']>;
  /** Whether to show the results field */
  showResults?: InputMaybe<Scalars['CastableBoolean']['input']>;
  /** Whether to show the summary field */
  showSummary?: InputMaybe<Scalars['CastableBoolean']['input']>;
  /** The source of the Work */
  sourceName?: InputMaybe<Scalars['String']['input']>;
  /** A summary of the Work */
  summary?: InputMaybe<Scalars['String']['input']>;
};

export type EntityOrderingInput = {
  /** Sort by foreignType */
  foreignType?: InputMaybe<SortDirectionEnum>;
  /** Sort by name */
  name?: InputMaybe<SortDirectionEnum>;
  /** Sort by sourceName */
  sourceName?: InputMaybe<SortDirectionEnum>;
};

/** Autogenerated input type of EntitySlack */
export type EntitySlackInput = {
  /** SlackChannel ID to send the message to */
  channelId: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Entity ID of the event to send. It will use the "latest" event as context */
  entityId: Scalars['ID']['input'];
  /** Strategy ID of the context to send the event within. Will link to the strategy changelog */
  strategyId?: InputMaybe<Scalars['ID']['input']>;
};

/** Autogenerated return type of EntitySlack. */
export type EntitySlackPayload = ClassTypeInterface & {
  __typename?: 'EntitySlackPayload';
  /** The class type of the field */
  classType: Scalars['String']['output'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Array of Errors */
  errors: Array<Error>;
  /** True if the Slack message sent */
  success?: Maybe<Scalars['Boolean']['output']>;
};

/** Input Type for Entity */
export type EntityUpdateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Optional contributors to add to the entity */
  contributors?: InputMaybe<Array<Scalars['JSON']['input']>>;
  /** The due_date for the Work */
  dueDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  /** Optional contributors to add to the entity */
  entityContributions?: InputMaybe<Array<EntityContributionInput>>;
  /** Entity ID to update */
  entityId: Scalars['ID']['input'];
  /** The type of the entity (chore, feature, fix, etc.) */
  entityType?: InputMaybe<Scalars['String']['input']>;
  /** The state of the Work in the source */
  foreignState?: InputMaybe<EntityWorkflowStateEnum>;
  /** The type of the Work in the source */
  foreignType?: InputMaybe<Scalars['String']['input']>;
  /** The expected result or hypothesis for the entity */
  goalHypothesis?: InputMaybe<Scalars['String']['input']>;
  /** When the entity / event occurred */
  happenedAt?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  /** Entity ID */
  id?: InputMaybe<Scalars['ID']['input']>;
  /** One of positive, negative, or null */
  impact?: InputMaybe<Scalars['String']['input']>;
  /** One of major, medium, minor */
  importance?: InputMaybe<Scalars['String']['input']>;
  /** Optional labels to add to the Entity */
  labels?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Title of the link on the Changelog */
  linkTitle?: InputMaybe<Scalars['String']['input']>;
  /** URL of the link on the Changelog */
  linkUrl?: InputMaybe<Scalars['String']['input']>;
  /** The name of the Work */
  name?: InputMaybe<Scalars['String']['input']>;
  /** ID of the owner of this Work */
  ownerId?: InputMaybe<Scalars['ID']['input']>;
  /** What result happened with the entity */
  results?: InputMaybe<Scalars['String']['input']>;
  /** Whether to show the goal_hypothesis field */
  showGoalHypothesis?: InputMaybe<Scalars['CastableBoolean']['input']>;
  /** Whether to show the results field */
  showResults?: InputMaybe<Scalars['CastableBoolean']['input']>;
  /** Whether to show the summary field */
  showSummary?: InputMaybe<Scalars['CastableBoolean']['input']>;
  /** The source of the Work */
  sourceName?: InputMaybe<Scalars['String']['input']>;
  /** Event long-form summary that came from a source */
  sourceSummary?: InputMaybe<Scalars['String']['input']>;
  /** Event long-form summary */
  summary?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of EntityUpdate. */
export type EntityUpdatePayload = ClassTypeInterface & {
  __typename?: 'EntityUpdatePayload';
  /** The class type of the field */
  classType: Scalars['String']['output'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Updated entity */
  entity?: Maybe<Entity>;
  /** Array of Errors */
  errors: Array<Error>;
};

/** List of possible values for an Entity's workflow_state */
export enum EntityWorkflowStateEnum {
  /** The work has been completed */
  Finished = 'finished',
  /** The work has not yet started */
  NotStarted = 'not_started',
  /** The work is currently being reviewed */
  Reviewing = 'reviewing',
  /** The work has started */
  Started = 'started'
}

/** Base error object */
export type Error = ClassTypeInterface & {
  __typename?: 'Error';
  /** The class type of the field */
  classType: Scalars['String']['output'];
  /** Error description */
  message: Scalars['String']['output'];
  /** Which input value this error came from */
  path?: Maybe<Array<Scalars['String']['output']>>;
};

/** Input Type for Existing Nodes */
export type ExistingDomainObjectInput = {
  /** ID of the existing object */
  id: Scalars['ID']['input'];
  /** Type of the existing object */
  type: Scalars['String']['input'];
};

/** An object that can be favorited */
export type FavoritableInterface = {
  /** The class type of the field */
  classType: Scalars['String']['output'];
  /** The ID of the current user's Favorite of this favoritable, if favorited */
  favoriteId?: Maybe<Scalars['ID']['output']>;
  /** The ID of the favoritable */
  id: Scalars['ID']['output'];
  /** The name of the favoritable */
  name?: Maybe<Scalars['String']['output']>;
};

/** A User favorite */
export type Favorite = ClassTypeInterface & {
  __typename?: 'Favorite';
  /** The class type of the field */
  classType: Scalars['String']['output'];
  /** The date and time the favorite was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** The favoritable */
  favoritable: FavoritableInterface;
  /** The ID of the favoritable */
  favoritableId: Scalars['ID']['output'];
  /** The type of the favoritable */
  favoritableType: Scalars['String']['output'];
  /** The ID of the favorite */
  id: Scalars['ID']['output'];
  /** The organizaiton the favorite belongs to */
  organization?: Maybe<Organization>;
  /** The date and time the favorite was last updated */
  updatedAt: Scalars['ISO8601DateTime']['output'];
  /** The polymorphic url of the favoritable */
  url: Scalars['String']['output'];
  /** The user who favorited the favoritable */
  user: User;
};

/** Autogenerated input type of FavoriteCreate */
export type FavoriteCreateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the favoritable */
  favoritableId: Scalars['ID']['input'];
  /** The type of the favoritable */
  favoritableType: Scalars['String']['input'];
};

/** Autogenerated return type of FavoriteCreate. */
export type FavoriteCreatePayload = ClassTypeInterface & {
  __typename?: 'FavoriteCreatePayload';
  /** The class type of the field */
  classType: Scalars['String']['output'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Array of Errors */
  errors: Array<Error>;
  /** Created favorite */
  favorite: Favorite;
};

/** Autogenerated input type of FavoriteDelete */
export type FavoriteDeleteInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the favoritable */
  favoritableId: Scalars['ID']['input'];
  /** The type of the favoritable */
  favoritableType: Scalars['String']['input'];
};

/** Autogenerated return type of FavoriteDelete. */
export type FavoriteDeletePayload = ClassTypeInterface & {
  __typename?: 'FavoriteDeletePayload';
  /** The class type of the field */
  classType: Scalars['String']['output'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Array of Errors */
  errors: Array<Error>;
  /** Deleted Favorite */
  favorite?: Maybe<Favorite>;
};

/** File data */
export type FileAttachment = ClassTypeInterface & {
  __typename?: 'FileAttachment';
  /** CDN URL */
  cdnUrl: Scalars['String']['output'];
  /** The class type of the field */
  classType: Scalars['String']['output'];
  /** Relative storage path */
  id: Scalars['String']['output'];
  /** Metadata */
  metadata?: Maybe<FileAttachmentMetadata>;
  /** Signed URL */
  url: Scalars['String']['output'];
};

/** File metadata */
export type FileAttachmentMetadata = ClassTypeInterface & {
  __typename?: 'FileAttachmentMetadata';
  /** The class type of the field */
  classType: Scalars['String']['output'];
  /** Original name of the file */
  filename: Scalars['String']['output'];
  /** File mime type */
  mimeType: Scalars['String']['output'];
  /** File size */
  size: Scalars['Int']['output'];
};

/** A formula (or portion of one) represented as text, since we cannot use plain Strings in a union */
export type FormulaText = {
  __typename?: 'FormulaText';
  /** formula (or portion of one) text */
  text: Scalars['String']['output'];
};

/** Goals */
export type Goal = ClassTypeInterface & {
  __typename?: 'Goal';
  /** The class type of the field */
  classType: Scalars['String']['output'];
  /** Current Value of the Goal */
  currentValue: Scalars['Float']['output'];
  /** End Date of the Goal */
  endDate?: Maybe<Scalars['ISO8601Date']['output']>;
  /** ID of the Goal */
  id: Scalars['ID']['output'];
  /** Displayable label of the Goal */
  label: Scalars['String']['output'];
  /** Metric of the Goal */
  metric: Metric;
  /** ID of the Metric of the Goal */
  metricId: Scalars['ID']['output'];
  /** Date of the newest metric data point */
  newestMetricDate?: Maybe<Scalars['ISO8601Date']['output']>;
  /** Date of the oldest metric data point */
  oldestMetricDate?: Maybe<Scalars['ISO8601Date']['output']>;
  /** Percentage Complete of the Goal */
  percentageComplete: Scalars['Float']['output'];
  /** Period Month / Quarter of the Goal */
  periodNumber?: Maybe<Scalars['Int']['output']>;
  /** Period Unit of the Goal */
  periodUnit: PeriodUnitEnum;
  /** Period Year of the Goal */
  periodYear?: Maybe<Scalars['Int']['output']>;
  /** Start Date of the Goal */
  startDate?: Maybe<Scalars['ISO8601Date']['output']>;
  /** Start Value of the Goal */
  startValue: Scalars['Float']['output'];
  /** Status of the Goal */
  status: GoalStatusEnum;
  /** Target Value of the Goal */
  targetValue: Scalars['Float']['output'];
};

/** Autogenerated input type of GoalCreate */
export type GoalCreateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** End Date of the Goal */
  endDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  /** The ID of the Metric that the Goal is for */
  metricId: Scalars['ID']['input'];
  /** The Period Number of the Goal */
  periodNumber?: InputMaybe<Scalars['Int']['input']>;
  /** The Period Unit of the Goal */
  periodUnit: PeriodUnitEnum;
  /** The Period Year of the Goal */
  periodYear?: InputMaybe<Scalars['Int']['input']>;
  /** Start Date of the Goal */
  startDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  /** The Start Value of the Goal */
  startValue?: InputMaybe<Scalars['Float']['input']>;
  /** The Target Value of the Goal */
  targetValue: Scalars['Float']['input'];
};

/** Autogenerated return type of GoalCreate. */
export type GoalCreatePayload = ClassTypeInterface & {
  __typename?: 'GoalCreatePayload';
  /** The class type of the field */
  classType: Scalars['String']['output'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Array of Errors */
  errors: Array<Error>;
  /** Newly created Goal */
  goal?: Maybe<Goal>;
};

/** Input Type for Goals */
export type GoalInput = {
  /** End Date of the Goal */
  endDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  /** Basic Card ID */
  id?: InputMaybe<Scalars['ID']['input']>;
  /** The period number of the Goal */
  periodNumber?: InputMaybe<Scalars['Int']['input']>;
  /** The period unit of the Goal */
  periodUnit?: InputMaybe<PeriodUnitEnum>;
  /** The period year of the Goal */
  periodYear?: InputMaybe<Scalars['Int']['input']>;
  /** Start Date of the Goal */
  startDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  /** The starting value of the Goal */
  startValue?: InputMaybe<Scalars['Float']['input']>;
  /** The target value of the Goal */
  targetValue?: InputMaybe<Scalars['Float']['input']>;
};

/** List of possible status values on Goals */
export enum GoalStatusEnum {
  /** The Goal is currently active */
  Current = 'current',
  /** The Goal starts in the future */
  Future = 'future',
  /** The Goal is in the past */
  Past = 'past',
  /** The Goal is in unknown status due to corrupt data */
  Unknown = 'unknown'
}

/** Autogenerated input type of GoogleAnalyticsPropertyImport */
export type GoogleAnalyticsPropertyImportInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the Google Analytics integration to use */
  integrationId: Scalars['ID']['input'];
  /** The ID of the GA4 property to import */
  propertyId: Scalars['String']['input'];
  /** The name of the GA4 property to import. Used for labeling */
  propertyName?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of GoogleAnalyticsPropertyImport. */
export type GoogleAnalyticsPropertyImportPayload = ClassTypeInterface & {
  __typename?: 'GoogleAnalyticsPropertyImportPayload';
  /** The class type of the field */
  classType: Scalars['String']['output'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The integration */
  integration: Integration;
};

/** Google Integration */
export type GoogleIntegration = ClassTypeInterface & IntegrationInterface & {
  __typename?: 'GoogleIntegration';
  /** Number of activities association to this integration */
  activitiesCount: Scalars['Int']['output'];
  /** Class type of the integration */
  classType: Scalars['String']['output'];
  /** Any custom configuration for the integration */
  configuration?: Maybe<Scalars['JSON']['output']>;
  /** Object creation date */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** User who performed the integration */
  creator: User;
  /** Number of entities associated ot the integration */
  entitiesCount: Scalars['Int']['output'];
  /** Types of entities associated to the integration */
  entityTypes: Array<Scalars['String']['output']>;
  /** Object unique ID */
  id: Scalars['ID']['output'];
  /** Whether or not the integration has imported historical data */
  importedHistory: Scalars['Boolean']['output'];
  /** Last time the importer was run */
  importerLastImportAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Number of entities to import */
  importerTotalEntitiesCount?: Maybe<Scalars['Int']['output']>;
  /** Any metadata we received during integration */
  installPayload?: Maybe<Scalars['JSON']['output']>;
  /** Associated Organization */
  organization: Organization;
  /** The list of available Google Analytics properties (V4) */
  propertiesV4?: Maybe<Scalars['JSON']['output']>;
  /** The hash of previously-imported GA4 properties. */
  propertyImports?: Maybe<Scalars['JSON']['output']>;
  /** Unique identifier for the integration */
  sourceId?: Maybe<Scalars['String']['output']>;
  /** Source name ex: Jira or Shortcut */
  sourceName: IntegrationSourceNamesEnum;
  /** STI column to denote which source. Superfluous with source_name in a lot of ways */
  type?: Maybe<Scalars['String']['output']>;
  /** Object last updated date */
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** A Google Sheet */
export type GoogleSheet = ClassTypeInterface & {
  __typename?: 'GoogleSheet';
  /** The class type of the field */
  classType: Scalars['String']['output'];
  /** ID of the Google Sheet */
  id: Scalars['ID']['output'];
  /** Whether the Google Sheet is the full multiple-metric organization-level sheet */
  organizationLevel: Scalars['Boolean']['output'];
  /** The URL of the Google Sheet */
  spreadsheetUrl: Scalars['String']['output'];
  /** The status of the Google Sheet */
  status: GoogleSheetStatusEnum;
};

/** Autogenerated input type of GoogleSheetDelete */
export type GoogleSheetDeleteInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the Google Sheet to delete */
  googleSheetId: Scalars['ID']['input'];
};

/** Autogenerated return type of GoogleSheetDelete. */
export type GoogleSheetDeletePayload = ClassTypeInterface & {
  __typename?: 'GoogleSheetDeletePayload';
  /** The class type of the field */
  classType: Scalars['String']['output'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Array of Errors */
  errors: Array<Error>;
  /** Deleted Google Sheet */
  googleSheet: GoogleSheet;
};

/** Autogenerated input type of GoogleSheetImport */
export type GoogleSheetImportInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the Google Sheet to import */
  googleSheetId: Scalars['ID']['input'];
};

/** Autogenerated return type of GoogleSheetImport. */
export type GoogleSheetImportPayload = ClassTypeInterface & {
  __typename?: 'GoogleSheetImportPayload';
  /** The class type of the field */
  classType: Scalars['String']['output'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The Google Sheet that was imported */
  googleSheet: GoogleSheet;
};

/** List of possible status values on Google Sheets */
export enum GoogleSheetStatusEnum {
  /** The Sheet is available for use */
  Active = 'active',
  /** The Sheet has encountered an error */
  Error = 'error',
  /** The Sheet is currently being exported */
  Exporting = 'exporting',
  /** The Sheet is currently being imported */
  Importing = 'importing',
  /** The Sheet is newly-created, but has not yet begun processing */
  New = 'new',
  /** The Sheet is queued for processing */
  Queued = 'queued'
}

/** List of possible Impact values on Entity */
export enum ImpactEnum {
  /** Negative - The entity caused a negative change */
  Negative = 'negative',
  /** Positive - The entity caused a positive change */
  Positive = 'positive'
}

/** List of entity importances */
export enum ImportanceEnum {
  /** Major - Very important, large changes */
  Major = 'major',
  /** Medium - Important enough to note */
  Medium = 'medium',
  /** Minor - Small changes, text updates */
  Minor = 'minor'
}

/** Base Integration */
export type Integration = ClassTypeInterface & IntegrationInterface & {
  __typename?: 'Integration';
  /** Number of activities association to this integration */
  activitiesCount: Scalars['Int']['output'];
  /** Class type of the integration */
  classType: Scalars['String']['output'];
  /** Any custom configuration for the integration */
  configuration?: Maybe<Scalars['JSON']['output']>;
  /** Object creation date */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** User who performed the integration */
  creator: User;
  /** Number of entities associated ot the integration */
  entitiesCount: Scalars['Int']['output'];
  /** Types of entities associated to the integration */
  entityTypes: Array<Scalars['String']['output']>;
  /** Object unique ID */
  id: Scalars['ID']['output'];
  /** Whether or not the integration has imported historical data */
  importedHistory: Scalars['Boolean']['output'];
  /** Last time the importer was run */
  importerLastImportAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Number of entities to import */
  importerTotalEntitiesCount?: Maybe<Scalars['Int']['output']>;
  /** Any metadata we received during integration */
  installPayload?: Maybe<Scalars['JSON']['output']>;
  /** Associated Organization */
  organization: Organization;
  /** Unique identifier for the integration */
  sourceId?: Maybe<Scalars['String']['output']>;
  /** Source name ex: Jira or Shortcut */
  sourceName: IntegrationSourceNamesEnum;
  /** STI column to denote which source. Superfluous with source_name in a lot of ways */
  type?: Maybe<Scalars['String']['output']>;
  /** Object last updated date */
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** Autogenerated input type of IntegrationCreate */
export type IntegrationCreateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The id of the source being created */
  sourceId: Scalars['String']['input'];
  /** The name of the source being connected.  */
  sourceName: Scalars['String']['input'];
};

/** Autogenerated return type of IntegrationCreate. */
export type IntegrationCreatePayload = ClassTypeInterface & {
  __typename?: 'IntegrationCreatePayload';
  /** The class type of the field */
  classType: Scalars['String']['output'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Array of Errors */
  errors: Array<Error>;
  /** Newly created Integration */
  integration?: Maybe<Integration>;
  /** Associated Organization */
  organization: Organization;
};

/** Autogenerated input type of IntegrationImportHistory */
export type IntegrationImportHistoryInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the Integration */
  integrationId: Scalars['ID']['input'];
};

/** Autogenerated return type of IntegrationImportHistory. */
export type IntegrationImportHistoryPayload = ClassTypeInterface & {
  __typename?: 'IntegrationImportHistoryPayload';
  /** The class type of the field */
  classType: Scalars['String']['output'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The errors */
  errors: Array<Error>;
  /** The integration */
  integration: Integration;
};

/** Base interface for all Integration types. Use when an Integration needs non-standard fields like GoogleIntegrationType */
export type IntegrationInterface = {
  /** Number of activities association to this integration */
  activitiesCount: Scalars['Int']['output'];
  /** Class type of the integration */
  classType: Scalars['String']['output'];
  /** Any custom configuration for the integration */
  configuration?: Maybe<Scalars['JSON']['output']>;
  /** Object creation date */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** User who performed the integration */
  creator: User;
  /** Number of entities associated ot the integration */
  entitiesCount: Scalars['Int']['output'];
  /** Types of entities associated to the integration */
  entityTypes: Array<Scalars['String']['output']>;
  /** Object unique ID */
  id: Scalars['ID']['output'];
  /** Whether or not the integration has imported historical data */
  importedHistory: Scalars['Boolean']['output'];
  /** Last time the importer was run */
  importerLastImportAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Number of entities to import */
  importerTotalEntitiesCount?: Maybe<Scalars['Int']['output']>;
  /** Any metadata we received during integration */
  installPayload?: Maybe<Scalars['JSON']['output']>;
  /** Associated Organization */
  organization: Organization;
  /** Unique identifier for the integration */
  sourceId?: Maybe<Scalars['String']['output']>;
  /** Source name ex: Jira or Shortcut */
  sourceName: IntegrationSourceNamesEnum;
  /** STI column to denote which source. Superfluous with source_name in a lot of ways */
  type?: Maybe<Scalars['String']['output']>;
  /** Object last updated date */
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** Source names of Integrations */
export enum IntegrationSourceNamesEnum {
  /** Asana */
  Asana = 'asana',
  /** Google */
  Google = 'google',
  /** Jira */
  Jira = 'jira',
  /** Linear */
  Linear = 'linear',
  /** Productboard */
  Productboard = 'productboard',
  /** Shortcut */
  Shortcut = 'shortcut',
  /** Slack */
  Slack = 'slack'
}

/** Union of Integration types */
export type IntegrationUnion = GoogleIntegration | Integration | JiraIntegration;

/** Input Type for an Integration */
export type IntegrationUpdateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the Integration */
  integrationId: Scalars['ID']['input'];
  /** Jira project keys to skip importing */
  restrictedProjects?: InputMaybe<Scalars['CommaSeparatedString']['input']>;
};

/** Autogenerated return type of IntegrationUpdate. */
export type IntegrationUpdatePayload = ClassTypeInterface & {
  __typename?: 'IntegrationUpdatePayload';
  /** The class type of the field */
  classType: Scalars['String']['output'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The errors */
  errors: Array<Error>;
  /** The updated integration */
  integration: IntegrationUnion;
};

/** List of intervals */
export enum IntervalEnum {
  /** Day */
  Day = 'day',
  /** Month */
  Month = 'month',
  /** Quarter */
  Quarter = 'quarter',
  /** Week */
  Week = 'week',
  /** Year */
  Year = 'year'
}

/** Invitation */
export type Invitation = ClassTypeInterface & {
  __typename?: 'Invitation';
  /** The class type of the field */
  classType: Scalars['String']['output'];
  /** Object creation date */
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Email of person invited */
  email: Scalars['String']['output'];
  /** ID of object */
  id?: Maybe<Scalars['ID']['output']>;
  /** Invitation code */
  inviteCode?: Maybe<Scalars['String']['output']>;
  /** User who invited the person */
  invitedBy?: Maybe<User>;
  /** Last date we sent an invitation */
  lastSentAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Associated Organization */
  organization: Organization;
  /** Role the user will be created with */
  role?: Maybe<RoleEnum>;
  /** Object updated date */
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** User created from this invitation */
  user?: Maybe<User>;
};

/** Autogenerated input type of InvitationCreate */
export type InvitationCreateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Email for the user to invite */
  email: Scalars['String']['input'];
  /** The role for the newly created user */
  role: RoleEnum;
};

/** Autogenerated return type of InvitationCreate. */
export type InvitationCreatePayload = ClassTypeInterface & {
  __typename?: 'InvitationCreatePayload';
  /** The class type of the field */
  classType: Scalars['String']['output'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Array of Errors */
  errors: Array<Error>;
  /** Newly created Invitation */
  invitation?: Maybe<Invitation>;
};

/** Autogenerated input type of InvitationDelete */
export type InvitationDeleteInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Invitation to delete */
  invitationId: Scalars['ID']['input'];
};

/** Autogenerated return type of InvitationDelete. */
export type InvitationDeletePayload = ClassTypeInterface & {
  __typename?: 'InvitationDeletePayload';
  /** The class type of the field */
  classType: Scalars['String']['output'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** CRUD operation wrapper */
  crudOperation: TypesInvitationTypeGraphqlCrudOperation;
  /** Array of Errors */
  errors: Array<Error>;
};

/** Autogenerated input type of InvitationResend */
export type InvitationResendInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Invitation ID to update */
  invitationId: Scalars['ID']['input'];
};

/** Autogenerated return type of InvitationResend. */
export type InvitationResendPayload = ClassTypeInterface & {
  __typename?: 'InvitationResendPayload';
  /** The class type of the field */
  classType: Scalars['String']['output'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Resent Invitation */
  invitation?: Maybe<Invitation>;
};

/** Jira Integration */
export type JiraIntegration = ClassTypeInterface & IntegrationInterface & {
  __typename?: 'JiraIntegration';
  /** Number of activities association to this integration */
  activitiesCount: Scalars['Int']['output'];
  /** Class type of the integration */
  classType: Scalars['String']['output'];
  /** Any custom configuration for the integration */
  configuration?: Maybe<Scalars['JSON']['output']>;
  /** Object creation date */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** User who performed the integration */
  creator: User;
  /** Number of entities associated ot the integration */
  entitiesCount: Scalars['Int']['output'];
  /** Types of entities associated to the integration */
  entityTypes: Array<Scalars['String']['output']>;
  /** Object unique ID */
  id: Scalars['ID']['output'];
  /** Whether or not the integration has imported historical data */
  importedHistory: Scalars['Boolean']['output'];
  /** Last time the importer was run */
  importerLastImportAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Number of entities to import */
  importerTotalEntitiesCount?: Maybe<Scalars['Int']['output']>;
  /** Any metadata we received during integration */
  installPayload?: Maybe<Scalars['JSON']['output']>;
  /** Associated Organization */
  organization: Organization;
  /** The list of project keys to skip imports for */
  restrictedProjects: Array<Scalars['String']['output']>;
  /** Unique identifier for the integration */
  sourceId?: Maybe<Scalars['String']['output']>;
  /** Source name ex: Jira or Shortcut */
  sourceName: IntegrationSourceNamesEnum;
  /** STI column to denote which source. Superfluous with source_name in a lot of ways */
  type?: Maybe<Scalars['String']['output']>;
  /** Object last updated date */
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** Label */
export type Label = ClassTypeInterface & {
  __typename?: 'Label';
  /** The class type of the field */
  classType: Scalars['String']['output'];
  /** Object creation date */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** List of entities associated to Label */
  entities?: Maybe<Array<Entity>>;
  /** Object unique ID */
  id: Scalars['ID']['output'];
  /** Label name */
  name: Scalars['String']['output'];
  /** Associated Organization */
  organization: Organization;
  /** Object last updated date */
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** Autogenerated input type of LabelCreate */
export type LabelCreateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** domain object to add the label to */
  domainObject: LabelableObjectInput;
  /** Name of the Label */
  name: Scalars['String']['input'];
};

/** Autogenerated return type of LabelCreate. */
export type LabelCreatePayload = ClassTypeInterface & {
  __typename?: 'LabelCreatePayload';
  /** The class type of the field */
  classType: Scalars['String']['output'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Object the Label was added to */
  domainObject: LabelableObject;
  /** Array of Errors */
  errors: Array<Error>;
  /** Newly-created Label */
  label?: Maybe<Label>;
};

/** Autogenerated input type of LabelDelete */
export type LabelDeleteInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The domain object to remove the label from */
  domainObject: LabelableObjectInput;
  /** Label ID to delete */
  labelId: Scalars['ID']['input'];
};

/** Autogenerated return type of LabelDelete. */
export type LabelDeletePayload = ClassTypeInterface & {
  __typename?: 'LabelDeletePayload';
  /** The class type of the field */
  classType: Scalars['String']['output'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The domain object the Label was removed from */
  domainObject: LabelableObject;
  /** Array of Errors */
  errors: Array<Error>;
  /** Removed Label */
  label?: Maybe<Label>;
};

/** Objects that can have labels applied to them */
export type LabelableObject = BasicCard | Entity | Metric | Strategy;

/** Input Type for Labeling domain objects */
export type LabelableObjectInput =
  /** Basic Card */
  { basicCardId: Scalars['ID']['input']; entityId?: never; metricId?: never; strategyId?: never; }
  |  /** Entity */
  { basicCardId?: never; entityId: Scalars['ID']['input']; metricId?: never; strategyId?: never; }
  |  /** Metric */
  { basicCardId?: never; entityId?: never; metricId: Scalars['ID']['input']; strategyId?: never; }
  |  /** Strategy */
  { basicCardId?: never; entityId?: never; metricId?: never; strategyId: Scalars['ID']['input']; };

/** Looker Dashboard */
export type LookerDashboard = ClassTypeInterface & {
  __typename?: 'LookerDashboard';
  /** The class type of the field */
  classType: Scalars['String']['output'];
  /** When the MetricSource was last errored */
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Associated Credential */
  credential: Credential;
  /** ID of the attached credential */
  credentialId: Scalars['ID']['output'];
  /** ID of the Looker Dashboard */
  dashboardId: Scalars['ID']['output'];
  /** URL of the Looker Dashboard */
  dashboardUrl: Scalars['String']['output'];
  /** Object unique ID */
  id: Scalars['ID']['output'];
  /** Last error message */
  lastError?: Maybe<Scalars['String']['output']>;
  /** When the MetricSource was last run */
  lastRunAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** MetricSource Organization */
  organization: Organization;
  /** ID of the associated Organization */
  organizationId: Scalars['ID']['output'];
  /** Title of the Looker Dashboard */
  title?: Maybe<Scalars['String']['output']>;
  /** When the MetricSource was last updated */
  updatedAt?: Maybe<Scalars['ISO8601Date']['output']>;
};

/** Autogenerated input type of LookerDashboardCreate */
export type LookerDashboardCreateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Associated Looker credential */
  credentialId: Scalars['ID']['input'];
  /** URL of the Looker dashboard */
  dashboardUrl: Scalars['String']['input'];
};

/** Autogenerated return type of LookerDashboardCreate. */
export type LookerDashboardCreatePayload = ClassTypeInterface & {
  __typename?: 'LookerDashboardCreatePayload';
  /** The class type of the field */
  classType: Scalars['String']['output'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Array of Errors */
  errors: Array<Error>;
  /** Newly created Looker Dashboard */
  lookerDashboard?: Maybe<LookerDashboard>;
};

/** Autogenerated input type of LookerDashboardDelete */
export type LookerDashboardDeleteInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Looker Dashboard ID to delete */
  lookerDashboardId: Scalars['ID']['input'];
};

/** Autogenerated return type of LookerDashboardDelete. */
export type LookerDashboardDeletePayload = ClassTypeInterface & {
  __typename?: 'LookerDashboardDeletePayload';
  /** The class type of the field */
  classType: Scalars['String']['output'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** CRUD operation wrapper */
  crudOperation: TypesLookerDashboardTypeGraphqlCrudOperation;
  /** Array of Errors */
  errors: Array<Error>;
};

/** Autogenerated input type of MapClone */
export type MapCloneInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the Strategy */
  strategyId: Scalars['ID']['input'];
};

/** Autogenerated return type of MapClone. */
export type MapClonePayload = ClassTypeInterface & {
  __typename?: 'MapClonePayload';
  /** The class type of the field */
  classType: Scalars['String']['output'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The errors */
  errors: Array<Error>;
  /** The newly-created strategy */
  strategy: Strategy;
};

/** Autogenerated input type of MapCloneToOrganization */
export type MapCloneToOrganizationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The id of the organization to duplicate the strategy into */
  organizationId: Scalars['ID']['input'];
  /** The id of the strategy to duplicate */
  strategyId: Scalars['ID']['input'];
};

/** Autogenerated return type of MapCloneToOrganization. */
export type MapCloneToOrganizationPayload = ClassTypeInterface & {
  __typename?: 'MapCloneToOrganizationPayload';
  /** The class type of the field */
  classType: Scalars['String']['output'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Array of Errors */
  errors: Array<Error>;
  /** The ID of the duplicated strategy. We avoid using the Type, to avoid permissions issues with non-org members */
  strategyId?: Maybe<Scalars['ID']['output']>;
  /** The name of the duplicated strategy */
  strategyName?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of MapCreateFromExisting */
export type MapCreateFromExistingInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The IDs of the edges to move */
  edgeIds: Array<Scalars['ID']['input']>;
  /** The IDs of the nodes to move */
  nodeIds: Array<Scalars['ID']['input']>;
  /** The position of the submap card */
  position: PositionInput;
  /** The ID of the Strategy to associate */
  strategyId: Scalars['ID']['input'];
};

/** Autogenerated return type of MapCreateFromExisting. */
export type MapCreateFromExistingPayload = ClassTypeInterface & {
  __typename?: 'MapCreateFromExistingPayload';
  /** The class type of the field */
  classType: Scalars['String']['output'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Array of Errors */
  errors: Array<Error>;
  /** The newly created map */
  map: Strategy;
  /** The newly created node */
  node: Node;
};

/** List of broadcast event names */
export enum MapEventsEnum {
  /** FIT_VIEW */
  FitView = 'FIT_VIEW'
}

/** Autogenerated return type of MapEvents. */
export type MapEventsPayload = ClassTypeInterface & {
  __typename?: 'MapEventsPayload';
  /** The class type of the field */
  classType: Scalars['String']['output'];
  /** Additional data */
  data: Scalars['JSON']['output'];
  /** The event that occurred */
  event: MapEventsEnum;
};

/** Map image */
export type MapImage = ClassTypeInterface & RfNodeInterface & {
  __typename?: 'MapImage';
  /** The class type of the field */
  classType: Scalars['String']['output'];
  /** Object creation date */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** File extension */
  extension: Scalars['String']['output'];
  /** Object unique ID */
  id: Scalars['ID']['output'];
  /** File mime type */
  mimeType: Scalars['String']['output'];
  /** Original file name  */
  originalFilename: Scalars['String']['output'];
  /** Strategy node id */
  rfId: Scalars['String']['output'];
  /** Object last updated date */
  updatedAt: Scalars['ISO8601DateTime']['output'];
  /** URL to full attachment */
  url: Scalars['String']['output'];
};

/** Input Type for MapImage */
export type MapImageInput =
  /** The Shrine Hash of the file */
  { file: ShrineInput; fileDataUri?: never; id?: never; }
  |  /** The data URI of the file */
  { file?: never; fileDataUri: Scalars['String']['input']; id?: never; }
  |  /** MapImage ID */
  { file?: never; fileDataUri?: never; id: Scalars['ID']['input']; };

/** Autogenerated input type of MapRunStats */
export type MapRunStatsInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Strategy ID to run stats for */
  strategyId: Scalars['ID']['input'];
};

/** Autogenerated return type of MapRunStats. */
export type MapRunStatsPayload = ClassTypeInterface & {
  __typename?: 'MapRunStatsPayload';
  /** The class type of the field */
  classType: Scalars['String']['output'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The strategy */
  strategy: Strategy;
};

/** Autogenerated input type of MapSimulate */
export type MapSimulateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the Strategy to simulate */
  strategyId: Scalars['ID']['input'];
};

/** Autogenerated return type of MapSimulate. */
export type MapSimulatePayload = ClassTypeInterface & {
  __typename?: 'MapSimulatePayload';
  /** The class type of the field */
  classType: Scalars['String']['output'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Array of Errors */
  errors: Array<Error>;
  /** Strategy returned */
  strategy: Strategy;
};

/** Autogenerated return type of MapStructureChanged. */
export type MapStructureChangedPayload = ClassTypeInterface & {
  __typename?: 'MapStructureChangedPayload';
  /** The class type of the field */
  classType: Scalars['String']['output'];
  /** The node or edge that was affected */
  data: Array<MapStructureElement>;
  /** The operation that was performed */
  operation: CrudOperationEnum;
};

/** Map structural elements */
export type MapStructureElement = Edge | Node;

/** A message in a chat thread */
export type Message = ClassTypeInterface & {
  __typename?: 'Message';
  /** Assistant that sent the message */
  assistant?: Maybe<AiAssistant>;
  /** ID of the assistant */
  assistantId?: Maybe<Scalars['ID']['output']>;
  /** ID of the chat */
  chatId: Scalars['ID']['output'];
  /** The class type of the field */
  classType: Scalars['String']['output'];
  /** Content of the message */
  content: Scalars['String']['output'];
  /** Creation date of the message */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** ID of the chat */
  id: Scalars['ID']['output'];
  /** Role of the message */
  role: AiAssistantRoleEnum;
  /** Last updated timestamp */
  updatedAt: Scalars['ISO8601DateTime']['output'];
  /** User who sent the message */
  user?: Maybe<User>;
  /** ID of the user who sent the message */
  userId?: Maybe<Scalars['ID']['output']>;
};

/** Metric */
export type Metric = ClassTypeInterface & CommentableInterface & DomainObjectInterface & FavoritableInterface & RfNodeInterface & {
  __typename?: 'Metric';
  /** True if the Metric is calculated */
  calculated?: Maybe<Scalars['Boolean']['output']>;
  /** The class type of the field */
  classType: Scalars['String']['output'];
  /** Comments left on the object */
  comments?: Maybe<Array<Comment>>;
  /** Number of comments left on the object */
  commentsCount: Scalars['Int']['output'];
  /** Whether the Metric stat values should be displayed in a compact format */
  compactDisplay: Scalars['Boolean']['output'];
  /** Confidence rating of the object */
  confidenceRating?: Maybe<ConfidenceRatingEnum>;
  /** IDs of Metrics contained by this Metric */
  containeeIds?: Maybe<Array<Scalars['ID']['output']>>;
  /** Correlation information between this metric, and other organization metrics */
  correlations: Array<CorrelationPair>;
  /** Object creation date */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** Credential for the metric source, if any */
  credential?: Maybe<Credential>;
  /** Metric description */
  description?: Maybe<Scalars['String']['output']>;
  /** Metric display type */
  displayFormat: DisplayFormatEnum;
  /** The entities for the metric */
  entities: EntityCollection;
  /** Whether the Metric should exclude weekends when calculating stats */
  excludeWeekends: Scalars['Boolean']['output'];
  /** External URL to where metric data is viewable */
  externalUrl?: Maybe<Scalars['String']['output']>;
  /** Text to display for the external URL */
  externalUrlTitle?: Maybe<Scalars['String']['output']>;
  /** The ID of the current user's Favorite of this favoritable, if favorited */
  favoriteId?: Maybe<Scalars['ID']['output']>;
  /** Goals associated with this Metric */
  goals: Array<Goal>;
  /** Object unique ID */
  id: Scalars['ID']['output'];
  /** Labels */
  labels?: Maybe<Array<Label>>;
  /** Maximum precision to use when displaying the stats */
  maximumDisplayPrecision: Scalars['Int']['output'];
  /** Metric data points */
  metricDataPoints: Array<MetricDataPoint>;
  /** Number of metric data points */
  metricDataPointsCount: Scalars['Int']['output'];
  /** Associated MetricSource */
  metricSource?: Maybe<MetricSource>;
  /** Whether the MetricSource has errored */
  metricSourceErrored: Scalars['Boolean']['output'];
  /** Minimum precision to use when displaying the stats */
  minimumDisplayPrecision: Scalars['Int']['output'];
  /** Metric name */
  name?: Maybe<Scalars['String']['output']>;
  /** Associated Organization */
  organization: Organization;
  /** Owner of this Metric */
  owner?: Maybe<User>;
  /** Owner ID of this Metric */
  ownerId?: Maybe<Scalars['ID']['output']>;
  /** True if stats should be based on MTD, QTD, and YTD */
  periodToDate: Scalars['Boolean']['output'];
  /** Whether the metric going up or down indicates success */
  positiveDirection: MetricPositiveDirectionsEnum;
  /** Whether the Metric has recent activity */
  recentActivity?: Maybe<Scalars['Boolean']['output']>;
  /** Are `percentage` format stat values multiplied by 100 for display? */
  redecimalPercentages?: Maybe<Scalars['Boolean']['output']>;
  /** Strategy node id */
  rfId: Scalars['String']['output'];
  /** Metric roll up calculation type */
  rollUp: RollUpEnum;
  /** Metric data points grouped by year and week */
  sampledMetricDataPoints: Array<MetricDataPoint>;
  /** What operation to use to de-duplicate segmented data points for a single day */
  segmentedDataType: SegmentedDataTypeEnum;
  /** Whether to show the description field */
  showDescription?: Maybe<Scalars['Boolean']['output']>;
  /** Whether to show the technical_description field */
  showTechnicalDescription?: Maybe<Scalars['Boolean']['output']>;
  /** Slack Channel ID attached to this Metric */
  slackChannelId?: Maybe<Scalars['ID']['output']>;
  /** Immutable Slug for accessing the Metric */
  slug?: Maybe<Scalars['String']['output']>;
  /** Strategy associated source metrics */
  sourceMetrics?: Maybe<Array<Metric>>;
  /** Source name where Metric comes from. Ex: Looker */
  sourceName?: Maybe<Scalars['String']['output']>;
  /** Strategies that the Metric is associated with */
  strategies: Array<Strategy>;
  /** Array of Strategy Stats */
  strategyStats: Array<StrategyStat>;
  /** Type of Metric relative to the Strategy.  */
  strategyType?: Maybe<StrategyTypeEnum>;
  /** Strategy associated target metrics */
  targetMetrics?: Maybe<Array<Metric>>;
  /** Technical description of metric. How to implement */
  technicalDescription?: Maybe<Scalars['String']['output']>;
  /** Object last updated date */
  updatedAt: Scalars['ISO8601DateTime']['output'];
};


/** Metric */
export type MetricCorrelationsArgs = {
  strategyId?: InputMaybe<Scalars['ID']['input']>;
};


/** Metric */
export type MetricEntitiesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


/** Metric */
export type MetricMetricDataPointsArgs = {
  cumulative?: InputMaybe<Scalars['CastableBoolean']['input']>;
  endDate?: InputMaybe<Scalars['String']['input']>;
  forecast?: InputMaybe<Scalars['CastableBoolean']['input']>;
  interval?: InputMaybe<IntervalEnum>;
  lagDays?: InputMaybe<Scalars['Int']['input']>;
  range?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['String']['input']>;
  strategyId?: InputMaybe<Scalars['ID']['input']>;
};


/** Metric */
export type MetricSampledMetricDataPointsArgs = {
  strategyId?: InputMaybe<Scalars['ID']['input']>;
};


/** Metric */
export type MetricSourceMetricsArgs = {
  strategyId?: InputMaybe<Scalars['ID']['input']>;
};


/** Metric */
export type MetricTargetMetricsArgs = {
  strategyId?: InputMaybe<Scalars['ID']['input']>;
};

/** MetricCollection type */
export type MetricCollection = {
  __typename?: 'MetricCollection';
  /** A collection of paginated MetricCollection */
  collection: Array<Metric>;
  /** Pagination Metadata for navigating the Pagination */
  metadata: CollectionMetadata;
};

/** Input Type for Metric */
export type MetricCreateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Whether the Metric stat values should be displayed in a compact format */
  compactDisplay?: InputMaybe<Scalars['CastableBoolean']['input']>;
  /** Metric description */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Metric display format */
  displayFormat?: InputMaybe<DisplayFormatEnum>;
  /** Whether to exclude weekends when calculating stats */
  excludeWeekends?: InputMaybe<Scalars['CastableBoolean']['input']>;
  /** Metric external url */
  externalUrl?: InputMaybe<Scalars['String']['input']>;
  /** Metric external url text */
  externalUrlTitle?: InputMaybe<Scalars['String']['input']>;
  /** Metric ID */
  id?: InputMaybe<Scalars['ID']['input']>;
  /** Optional labels to set on the Metric */
  labels?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Maximum precision to use when displaying stats */
  maximumDisplayPrecision?: InputMaybe<Scalars['Int']['input']>;
  /** Minimum precision to use when displaying stats */
  minimumDisplayPrecision?: InputMaybe<Scalars['Int']['input']>;
  /** Metric name */
  name: Scalars['String']['input'];
  /** ID of the owner of this Metric */
  ownerId?: InputMaybe<Scalars['ID']['input']>;
  /** True if the stat periods should be MTD, QTD, YTD. */
  periodToDate?: InputMaybe<Scalars['CastableBoolean']['input']>;
  /** Direction the metric should move to indicate success */
  positiveDirection?: InputMaybe<MetricPositiveDirectionsEnum>;
  /** Whether the metric values should be multiplied by 100 for display as percentages */
  redecimalPercentages?: InputMaybe<Scalars['CastableBoolean']['input']>;
  /** Metric roll up type */
  rollUp?: InputMaybe<RollUpEnum>;
  /** Segmented data type */
  segmentedDataType?: InputMaybe<SegmentedDataTypeEnum>;
  /** Whether to show the description field */
  showDescription?: InputMaybe<Scalars['CastableBoolean']['input']>;
  /** Whether to show the technical_description field */
  showTechnicalDescription?: InputMaybe<Scalars['CastableBoolean']['input']>;
  /** Metric Slack Channel */
  slackChannelId?: InputMaybe<Scalars['ID']['input']>;
  /** The period for the first strategy stat */
  strategyStatPeriod0?: InputMaybe<Scalars['ISO8601Duration']['input']>;
  /** The period for the second strategy stat */
  strategyStatPeriod1?: InputMaybe<Scalars['ISO8601Duration']['input']>;
  /** The period for the third strategy stat */
  strategyStatPeriod2?: InputMaybe<Scalars['ISO8601Duration']['input']>;
  /** Metric strategy type */
  strategyType?: InputMaybe<Scalars['String']['input']>;
  /** Metric technical description */
  technicalDescription?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of MetricCreate. */
export type MetricCreatePayload = ClassTypeInterface & {
  __typename?: 'MetricCreatePayload';
  /** The class type of the field */
  classType: Scalars['String']['output'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Array of Errors */
  errors: Array<Error>;
  /** Newly created Metric */
  metric?: Maybe<Metric>;
};

/** Metric Data Point */
export type MetricDataPoint = ClassTypeInterface & SegmentFilterableInterface & {
  __typename?: 'MetricDataPoint';
  /** The class type of the field */
  classType: Scalars['String']['output'];
  /** Object creation date */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** Date of metric data point */
  date: Scalars['ISO8601Date']['output'];
  /** ID for used through the SegmentFilterable interface. Cannot be null. */
  filterableId: Scalars['ID']['output'];
  /** Is this a forecasted data point? */
  forecasted: Scalars['Boolean']['output'];
  /** ID of object */
  id: Scalars['ID']['output'];
  /** Associated Metric */
  metric: Metric;
  /** ID of associated Metric */
  metricId: Scalars['ID']['output'];
  /** Associated MetricSource */
  metricSource?: Maybe<MetricSource>;
  /** Segment filters for the Metric Data  */
  segmentFilters?: Maybe<Array<SegmentFilter>>;
  /** Object last updated date */
  updatedAt: Scalars['ISO8601DateTime']['output'];
  /** Metric data point Value */
  value: Scalars['Float']['output'];
};

/** MetricDataPointCollection type */
export type MetricDataPointCollection = {
  __typename?: 'MetricDataPointCollection';
  /** A collection of paginated MetricDataPointCollection */
  collection: Array<MetricDataPoint>;
  /** Pagination Metadata for navigating the Pagination */
  metadata: CollectionMetadata;
};

/** Autogenerated input type of MetricDataPointCreate */
export type MetricDataPointCreateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Data Point occurrence date */
  date: Scalars['String']['input'];
  /** Metric ID for the Data Point */
  metricId: Scalars['ID']['input'];
  /** The hash of segments to set. */
  segments?: InputMaybe<Scalars['JSON']['input']>;
  /** Value of the Data Point */
  value: Scalars['Float']['input'];
};

/** Autogenerated return type of MetricDataPointCreate. */
export type MetricDataPointCreatePayload = ClassTypeInterface & {
  __typename?: 'MetricDataPointCreatePayload';
  /** The class type of the field */
  classType: Scalars['String']['output'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Array of Errors */
  errors: Array<Error>;
  /** Newly created Metric Data Point */
  metricDataPoint?: Maybe<MetricDataPoint>;
};

/** Autogenerated input type of MetricDataPointDelete */
export type MetricDataPointDeleteInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Metric Data Point ID to delete */
  metricDataPointId: Scalars['ID']['input'];
};

/** Autogenerated return type of MetricDataPointDelete. */
export type MetricDataPointDeletePayload = ClassTypeInterface & {
  __typename?: 'MetricDataPointDeletePayload';
  /** The class type of the field */
  classType: Scalars['String']['output'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** CRUD operation wrapper */
  crudOperation: TypesMetricDataPointTypeGraphqlCrudOperation;
  /** Array of Errors */
  errors: Array<Error>;
};

/** Autogenerated input type of MetricDataPointUpdate */
export type MetricDataPointUpdateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Data Point occurrence date */
  date?: InputMaybe<Scalars['String']['input']>;
  /** Metric Data Point ID to update */
  metricDataPointId: Scalars['ID']['input'];
  /** The hash of segments to set. */
  segments?: InputMaybe<Scalars['JSON']['input']>;
  /** Value of the Data Point */
  value?: InputMaybe<Scalars['Float']['input']>;
};

/** Autogenerated return type of MetricDataPointUpdate. */
export type MetricDataPointUpdatePayload = ClassTypeInterface & {
  __typename?: 'MetricDataPointUpdatePayload';
  /** The class type of the field */
  classType: Scalars['String']['output'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Array of Errors */
  errors: Array<Error>;
  /** Updated Metric Data Point */
  metricDataPoint?: Maybe<MetricDataPoint>;
};

/** Autogenerated input type of MetricDeleteAllMetricDataPoints */
export type MetricDeleteAllMetricDataPointsInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Metric ID whose data points to delete */
  metricId: Scalars['ID']['input'];
};

/** Autogenerated return type of MetricDeleteAllMetricDataPoints. */
export type MetricDeleteAllMetricDataPointsPayload = ClassTypeInterface & {
  __typename?: 'MetricDeleteAllMetricDataPointsPayload';
  /** The class type of the field */
  classType: Scalars['String']['output'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Array of Errors */
  errors: Array<Error>;
  /** Metric that had points deleted */
  metric: Metric;
};

/** Autogenerated input type of MetricDescriptionSuggest */
export type MetricDescriptionSuggestInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the metric to update */
  metricId: Scalars['ID']['input'];
};

/** Autogenerated return type of MetricDescriptionSuggest. */
export type MetricDescriptionSuggestPayload = ClassTypeInterface & {
  __typename?: 'MetricDescriptionSuggestPayload';
  /** The class type of the field */
  classType: Scalars['String']['output'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The returned result */
  result: Scalars['String']['output'];
};

/** Autogenerated input type of MetricFormulasSuggest */
export type MetricFormulasSuggestInput = {
  /** Additional instructions for the AI to follow */
  additionalInstructions?: InputMaybe<Scalars['String']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the subject Node */
  nodeId: Scalars['ID']['input'];
};

/** Autogenerated return type of MetricFormulasSuggest. */
export type MetricFormulasSuggestPayload = ClassTypeInterface & {
  __typename?: 'MetricFormulasSuggestPayload';
  /** The class type of the field */
  classType: Scalars['String']['output'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The error, if any, returned by OpenAI */
  error?: Maybe<Scalars['String']['output']>;
  /** The suggested metric formulas, returned by OpenAI */
  result?: Maybe<Array<Scalars['String']['output']>>;
};

/** Input Type for Metric */
export type MetricInput = {
  /** Whether the Metric stat values should be displayed in a compact format */
  compactDisplay?: InputMaybe<Scalars['CastableBoolean']['input']>;
  /** Metric description */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Metric display format */
  displayFormat?: InputMaybe<DisplayFormatEnum>;
  /** Whether to exclude weekends when calculating stats */
  excludeWeekends?: InputMaybe<Scalars['CastableBoolean']['input']>;
  /** Metric external url */
  externalUrl?: InputMaybe<Scalars['String']['input']>;
  /** Metric external url text */
  externalUrlTitle?: InputMaybe<Scalars['String']['input']>;
  /** Metric ID */
  id?: InputMaybe<Scalars['ID']['input']>;
  /** Optional labels to set on the Metric */
  labels?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Maximum precision to use when displaying stats */
  maximumDisplayPrecision?: InputMaybe<Scalars['Int']['input']>;
  /** Minimum precision to use when displaying stats */
  minimumDisplayPrecision?: InputMaybe<Scalars['Int']['input']>;
  /** Metric name */
  name?: InputMaybe<Scalars['String']['input']>;
  /** ID of the owner of this Metric */
  ownerId?: InputMaybe<Scalars['ID']['input']>;
  /** True if the stat periods should be MTD, QTD, YTD. */
  periodToDate?: InputMaybe<Scalars['CastableBoolean']['input']>;
  /** Direction the metric should move to indicate success */
  positiveDirection?: InputMaybe<MetricPositiveDirectionsEnum>;
  /** Whether the metric values should be multiplied by 100 for display as percentages */
  redecimalPercentages?: InputMaybe<Scalars['CastableBoolean']['input']>;
  /** Metric roll up type */
  rollUp?: InputMaybe<RollUpEnum>;
  /** Segmented data type */
  segmentedDataType?: InputMaybe<SegmentedDataTypeEnum>;
  /** Whether to show the description field */
  showDescription?: InputMaybe<Scalars['CastableBoolean']['input']>;
  /** Whether to show the technical_description field */
  showTechnicalDescription?: InputMaybe<Scalars['CastableBoolean']['input']>;
  /** Metric Slack Channel */
  slackChannelId?: InputMaybe<Scalars['ID']['input']>;
  /** The period for the first strategy stat */
  strategyStatPeriod0?: InputMaybe<Scalars['ISO8601Duration']['input']>;
  /** The period for the second strategy stat */
  strategyStatPeriod1?: InputMaybe<Scalars['ISO8601Duration']['input']>;
  /** The period for the third strategy stat */
  strategyStatPeriod2?: InputMaybe<Scalars['ISO8601Duration']['input']>;
  /** Metric strategy type */
  strategyType?: InputMaybe<Scalars['String']['input']>;
  /** Metric technical description */
  technicalDescription?: InputMaybe<Scalars['String']['input']>;
};

export type MetricOrderingInput = {
  /** Sort by metric_data_points_count */
  metricDataPointsCount?: InputMaybe<SortDirectionEnum>;
  /** Sort by name */
  name?: InputMaybe<SortDirectionEnum>;
  /** Sort by source_name */
  sourceName?: InputMaybe<SortDirectionEnum>;
};

/** Autogenerated input type of MetricPopulateEmpty */
export type MetricPopulateEmptyInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Standard deviation */
  stdDeviation?: InputMaybe<Scalars['Float']['input']>;
  /** Strategy id */
  strategyId: Scalars['ID']['input'];
  /** Upward move percentage */
  upwardMovePercentage?: InputMaybe<Scalars['Float']['input']>;
};

/** Autogenerated return type of MetricPopulateEmpty. */
export type MetricPopulateEmptyPayload = ClassTypeInterface & {
  __typename?: 'MetricPopulateEmptyPayload';
  /** The class type of the field */
  classType: Scalars['String']['output'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Array of Errors */
  errors: Array<Error>;
  /** Newly created Metric Sources */
  metricSources?: Maybe<Array<MetricSource>>;
  /** Updated metrics */
  metrics?: Maybe<Array<Metric>>;
};

/** Metric positive directions enum */
export enum MetricPositiveDirectionsEnum {
  /** Down - Uses when the value of the metric should go down to indicate success, like page load time */
  Down = 'down',
  /** Up - Used when the value of the metric should go up to indicate success, like customer count */
  Up = 'up'
}

/** MetricSource */
export type MetricSource = ClassTypeInterface & {
  __typename?: 'MetricSource';
  /** The class type of the field */
  classType: Scalars['String']['output'];
  /** MetricSource configuration */
  configuration?: Maybe<Scalars['JSON']['output']>;
  /** When the MetricSource was created */
  createdAt?: Maybe<Scalars['ISO8601Date']['output']>;
  /** Associated Credential */
  credential?: Maybe<Credential>;
  /** ID of the attached credential */
  credentialId?: Maybe<Scalars['ID']['output']>;
  /** MetricSource description */
  description?: Maybe<Scalars['String']['output']>;
  /** Error message, if applicable */
  errorMessage?: Maybe<Scalars['String']['output']>;
  /** When the MetricSource was last errored */
  erroredAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Event name */
  event?: Maybe<Scalars['String']['output']>;
  /** ID of an associated Google Sheet */
  googleSheet?: Maybe<GoogleSheet>;
  /** Object unique ID */
  id: Scalars['ID']['output'];
  /** Associated Integration */
  integration?: Maybe<Integration>;
  /** When the MetricSource was last run */
  lastRunAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Associated Metrics */
  metric: Metric;
  /** Associated Metric Data Points */
  metricDataPoints?: Maybe<Array<MetricDataPoint>>;
  /** ID of the associated Metric */
  metricId: Scalars['ID']['output'];
  /** MetricSource name */
  name?: Maybe<Scalars['String']['output']>;
  /** MetricSource Organization */
  organization: Organization;
  /** If the MetricSource updates nightly */
  scheduled: Scalars['Boolean']['output'];
  /** MetricSource slug */
  slug?: Maybe<Scalars['String']['output']>;
  /** MetricSource source name */
  sourceName?: Maybe<Scalars['String']['output']>;
  /** Associated Strategies */
  strategies?: Maybe<Array<Strategy>>;
  /** The structure of a calculated metric formula, so displays can be created */
  structuredFormula?: Maybe<Array<StructuredFormulaUnion>>;
  /** When the MetricSource was last updated */
  updatedAt?: Maybe<Scalars['ISO8601Date']['output']>;
};

/** Metric Source Activity */
export type MetricSourceActivity = ClassTypeInterface & {
  __typename?: 'MetricSourceActivity';
  /** The class type of the field */
  classType: Scalars['String']['output'];
  /** When the MetricSourceActivity was created */
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Object unique ID */
  id: Scalars['ID']['output'];
  /** Associated Metric Source */
  metricSource?: Maybe<MetricSource>;
  /** MetricSourceActivity Organization */
  organization: Organization;
  /** MetricSourceActivity Payload */
  payload?: Maybe<Scalars['JSON']['output']>;
  /** MetricSourceActivity processed data points count */
  processedCount: Scalars['Int']['output'];
  /** MetricSourceActivity processed state */
  processedState?: Maybe<MetricSourceActivityProcessedStateEnum>;
  /** MetricSource source name */
  sourceName?: Maybe<Scalars['String']['output']>;
  /** MetricSource total data points count */
  totalCount: Scalars['Int']['output'];
  /** When the MetricSourceActivity was last updated */
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
};

/** MetricSourceActivityCollection type */
export type MetricSourceActivityCollection = {
  __typename?: 'MetricSourceActivityCollection';
  /** A collection of paginated MetricSourceActivityCollection */
  collection: Array<MetricSourceActivity>;
  /** Pagination Metadata for navigating the Pagination */
  metadata: CollectionMetadata;
};

/** List of metric source processed states */
export enum MetricSourceActivityProcessedStateEnum {
  /** Failed - Finished processing with errors */
  Failed = 'failed',
  /** No Integration - Could not process because there is no integration */
  NoIntegration = 'no_integration',
  /** Processed - Finished processing successfully */
  Processed = 'processed',
  /** Processing - Currently being processed */
  Processing = 'processing',
  /** Unprocessed - Waiting to be processed */
  Unprocessed = 'unprocessed'
}

/** Input Type for MetricSource */
export type MetricSourceCreateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Metric Source configuration JSON */
  configuration?: InputMaybe<Scalars['JSON']['input']>;
  /** Associated metric source credential */
  credentialId?: InputMaybe<Scalars['ID']['input']>;
  /** Metric Source description */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Event name */
  event?: InputMaybe<Scalars['String']['input']>;
  /** Associated Integration */
  integrationId?: InputMaybe<Scalars['ID']['input']>;
  /** ID of Metric to attach the source to */
  metricId: Scalars['ID']['input'];
  /** Metric Source name */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Metric Source source name */
  sourceName?: InputMaybe<Scalars['String']['input']>;
  /** Where clause (Mixpanel) */
  where?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of MetricSourceCreate. */
export type MetricSourceCreatePayload = ClassTypeInterface & {
  __typename?: 'MetricSourceCreatePayload';
  /** The class type of the field */
  classType: Scalars['String']['output'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Array of Errors */
  errors: Array<Error>;
  /** Newly created Metric Source */
  metricSource?: Maybe<MetricSource>;
};

/** Autogenerated input type of MetricSourceDelete */
export type MetricSourceDeleteInput = {
  /** Whether to clear existing data for the source */
  clearExistingData: Scalars['Boolean']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Metric Source ID to delete */
  metricSourceId: Scalars['ID']['input'];
};

/** Autogenerated return type of MetricSourceDelete. */
export type MetricSourceDeletePayload = ClassTypeInterface & {
  __typename?: 'MetricSourceDeletePayload';
  /** The class type of the field */
  classType: Scalars['String']['output'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** CRUD operation wrapper */
  crudOperation: TypesMetricSourceTypeGraphqlCrudOperation;
  /** Array of Errors */
  errors: Array<Error>;
};

/** Autogenerated input type of MetricSourceRun */
export type MetricSourceRunInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Metric Source ID to run */
  metricSourceId: Scalars['ID']['input'];
};

/** Autogenerated return type of MetricSourceRun. */
export type MetricSourceRunPayload = ClassTypeInterface & {
  __typename?: 'MetricSourceRunPayload';
  /** The class type of the field */
  classType: Scalars['String']['output'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Array of Errors */
  errors: Array<Error>;
  /** Metric Source the results belong to */
  metricSource?: Maybe<MetricSource>;
  /** Status of the run */
  status: Scalars['String']['output'];
  /** True if the job enqueued */
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of MetricSourceTestAttributes */
export type MetricSourceTestAttributesInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Metric Source attributes */
  input: Scalars['JSON']['input'];
};

/** Autogenerated return type of MetricSourceTestAttributes. */
export type MetricSourceTestAttributesPayload = ClassTypeInterface & {
  __typename?: 'MetricSourceTestAttributesPayload';
  /** The class type of the field */
  classType: Scalars['String']['output'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Test results */
  results: Scalars['JSON']['output'];
};

/** Autogenerated input type of MetricSourceTest */
export type MetricSourceTestInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Metric Source ID to test */
  metricSourceId: Scalars['ID']['input'];
};

/** Autogenerated return type of MetricSourceTest. */
export type MetricSourceTestPayload = ClassTypeInterface & {
  __typename?: 'MetricSourceTestPayload';
  /** The class type of the field */
  classType: Scalars['String']['output'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Array of Errors */
  errors: Array<Error>;
  /** Metric Source the results belong to */
  metricSource?: Maybe<MetricSource>;
  /** Test results */
  results: Scalars['JSON']['output'];
};

/** Input Type for MetricSource */
export type MetricSourceUpdateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Metric Source configuration JSON */
  configuration?: InputMaybe<Scalars['JSON']['input']>;
  /** Associated metric source credential */
  credentialId?: InputMaybe<Scalars['ID']['input']>;
  /** Metric Source description */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Event name */
  event?: InputMaybe<Scalars['String']['input']>;
  /** Associated Integration */
  integrationId?: InputMaybe<Scalars['ID']['input']>;
  /** Metric Source ID to update */
  metricSourceId: Scalars['ID']['input'];
  /** Metric Source name */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Metric Source source name */
  sourceName?: InputMaybe<Scalars['String']['input']>;
  /** Where clause (Mixpanel) */
  where?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of MetricSourceUpdate. */
export type MetricSourceUpdatePayload = ClassTypeInterface & {
  __typename?: 'MetricSourceUpdatePayload';
  /** The class type of the field */
  classType: Scalars['String']['output'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Array of Errors */
  errors: Array<Error>;
  /** Updated Metric Source */
  metricSource?: Maybe<MetricSource>;
};

/** Autogenerated input type of MetricTechnicalDescriptionSuggest */
export type MetricTechnicalDescriptionSuggestInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the metric to update */
  metricId: Scalars['ID']['input'];
};

/** Autogenerated return type of MetricTechnicalDescriptionSuggest. */
export type MetricTechnicalDescriptionSuggestPayload = ClassTypeInterface & {
  __typename?: 'MetricTechnicalDescriptionSuggestPayload';
  /** The class type of the field */
  classType: Scalars['String']['output'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The returned result */
  result: Scalars['String']['output'];
};

/** Input Type for Metric */
export type MetricUpdateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Whether the Metric stat values should be displayed in a compact format */
  compactDisplay?: InputMaybe<Scalars['CastableBoolean']['input']>;
  /** Metric description */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Metric display format */
  displayFormat?: InputMaybe<DisplayFormatEnum>;
  /** Whether to exclude weekends when calculating stats */
  excludeWeekends?: InputMaybe<Scalars['CastableBoolean']['input']>;
  /** Metric external url */
  externalUrl?: InputMaybe<Scalars['String']['input']>;
  /** Metric external url text */
  externalUrlTitle?: InputMaybe<Scalars['String']['input']>;
  /** Metric ID */
  id?: InputMaybe<Scalars['ID']['input']>;
  /** Optional labels to set on the Metric */
  labels?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Maximum precision to use when displaying stats */
  maximumDisplayPrecision?: InputMaybe<Scalars['Int']['input']>;
  /** Metric ID to update */
  metricId: Scalars['ID']['input'];
  /** Minimum precision to use when displaying stats */
  minimumDisplayPrecision?: InputMaybe<Scalars['Int']['input']>;
  /** Metric name */
  name?: InputMaybe<Scalars['String']['input']>;
  /** ID of the owner of this Metric */
  ownerId?: InputMaybe<Scalars['ID']['input']>;
  /** True if the stat periods should be MTD, QTD, YTD. */
  periodToDate?: InputMaybe<Scalars['CastableBoolean']['input']>;
  /** Direction the metric should move to indicate success */
  positiveDirection?: InputMaybe<MetricPositiveDirectionsEnum>;
  /** Whether the metric values should be multiplied by 100 for display as percentages */
  redecimalPercentages?: InputMaybe<Scalars['CastableBoolean']['input']>;
  /** Metric roll up type */
  rollUp?: InputMaybe<RollUpEnum>;
  /** Segmented data type */
  segmentedDataType?: InputMaybe<SegmentedDataTypeEnum>;
  /** Whether to show the description field */
  showDescription?: InputMaybe<Scalars['CastableBoolean']['input']>;
  /** Whether to show the technical_description field */
  showTechnicalDescription?: InputMaybe<Scalars['CastableBoolean']['input']>;
  /** Metric Slack Channel */
  slackChannelId?: InputMaybe<Scalars['ID']['input']>;
  /** The period for the first strategy stat */
  strategyStatPeriod0?: InputMaybe<Scalars['ISO8601Duration']['input']>;
  /** The period for the second strategy stat */
  strategyStatPeriod1?: InputMaybe<Scalars['ISO8601Duration']['input']>;
  /** The period for the third strategy stat */
  strategyStatPeriod2?: InputMaybe<Scalars['ISO8601Duration']['input']>;
  /** Metric strategy type */
  strategyType?: InputMaybe<Scalars['String']['input']>;
  /** Metric technical description */
  technicalDescription?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of MetricUpdate. */
export type MetricUpdatePayload = ClassTypeInterface & {
  __typename?: 'MetricUpdatePayload';
  /** The class type of the field */
  classType: Scalars['String']['output'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Array of Errors */
  errors: Array<Error>;
  /** Updated Metric */
  metric?: Maybe<Metric>;
};

/** Input Type for a CSV Configuration */
export type MetricUploadBatchFileInput = {
  /** Clear existing data points before adding new ones? */
  clearExistingData?: InputMaybe<Scalars['CastableBoolean']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The index of the date column in the CSV file */
  dateIndex: Scalars['Int']['input'];
  /** Does the CSV file include headers? */
  headers?: InputMaybe<Scalars['CastableBoolean']['input']>;
  /** The index of the id column in the CSV file */
  idIndex: Scalars['Int']['input'];
  /** The segments of the column in the CSV file */
  segments?: InputMaybe<Array<CsvConfigurationSegmentInput>>;
  /** File Data Hash */
  shrineHash: Scalars['JSON']['input'];
  /** The index of the value column in the CSV file */
  valueIndex: Scalars['Int']['input'];
};

/** Autogenerated return type of MetricUploadBatchFile. */
export type MetricUploadBatchFilePayload = ClassTypeInterface & {
  __typename?: 'MetricUploadBatchFilePayload';
  /** The class type of the field */
  classType: Scalars['String']['output'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** True if the request succeeded. */
  success: Scalars['Boolean']['output'];
};

/** Input Type for a CSV Configuration */
export type MetricUploadFileInput = {
  /** Clear existing data points before adding new ones? */
  clearExistingData?: InputMaybe<Scalars['CastableBoolean']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The index of the date column in the CSV file */
  dateIndex: Scalars['Int']['input'];
  /** Does the CSV file include headers? */
  headers?: InputMaybe<Scalars['CastableBoolean']['input']>;
  /** The index of the id column in the CSV file */
  idIndex?: InputMaybe<Scalars['Int']['input']>;
  /** Metric ID to add data points to */
  metricId: Scalars['ID']['input'];
  /** The segments of the column in the CSV file */
  segments?: InputMaybe<Array<CsvConfigurationSegmentInput>>;
  /** File Data Hash */
  shrineHash: Scalars['JSON']['input'];
  /** The index of the value column in the CSV file */
  valueIndex: Scalars['Int']['input'];
};

/** Autogenerated return type of MetricUploadFile. */
export type MetricUploadFilePayload = ClassTypeInterface & {
  __typename?: 'MetricUploadFilePayload';
  /** The class type of the field */
  classType: Scalars['String']['output'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Array of Errors */
  errors: Array<Error>;
  /** Newly created Metric */
  metric?: Maybe<Metric>;
};

/** Autogenerated input type of MetricsGenerateFromFormula */
export type MetricsGenerateFromFormulaInput = {
  /** Additional instructions for AI generation */
  additionalInstructions?: InputMaybe<Scalars['String']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The direction of the metrics (upstream or downstream) */
  direction: Scalars['String']['input'];
  /** The formula to extract metrics from */
  formula: Scalars['String']['input'];
  /** The handle location (top, right, left, bottom) */
  handle: Scalars['String']['input'];
  /** The ID of the node to link the metrics to */
  nodeId: Scalars['ID']['input'];
};

/** Autogenerated return type of MetricsGenerateFromFormula. */
export type MetricsGenerateFromFormulaPayload = ClassTypeInterface & {
  __typename?: 'MetricsGenerateFromFormulaPayload';
  /** The class type of the field */
  classType: Scalars['String']['output'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Whether the result was successful */
  success: Scalars['Boolean']['output'];
};

/** Multiple objects' autocomplete item types such as basic cards, metrics, strategies, and entities */
export type MultiObjectAutocompleteItem = BasicCard | Entity | Metric | Strategy;

/** Base Mutation Types for DoubleLoop */
export type Mutation = ClassTypeInterface & {
  __typename?: 'Mutation';
  /** Delete an Account */
  accountDelete?: Maybe<AccountDeletePayload>;
  /** Switch to a different Account */
  accountSwitch?: Maybe<AccountSwitchPayload>;
  /** Update an Account */
  accountUpdate?: Maybe<AccountUpdatePayload>;
  /** Add ancillary files to a file cache */
  aiAssistantFileCacheFilesAdd?: Maybe<AiAssistantFileCacheFilesAddPayload>;
  /** Remove ancillary files from a file cache */
  aiAssistantFileCacheFilesRemove?: Maybe<AiAssistantFileCacheFilesRemovePayload>;
  /** Generate Metric Nodes via AI prompt */
  aiNodesGenerate?: Maybe<AiNodesGeneratePayload>;
  /** Create a Basic Card */
  basicCardCreate?: Maybe<BasicCardCreatePayload>;
  /** Delete an existing Basic Card */
  basicCardDelete?: Maybe<BasicCardDeletePayload>;
  /** Create a billing subscription */
  billingCreateSubscription?: Maybe<BillingCreateSubscriptionPayload>;
  /** Provision a billing subscription */
  billingProvisionSubscription?: Maybe<BillingProvisionSubscriptionPayload>;
  /** Create a Business Context */
  businessContextCreate?: Maybe<BusinessContextCreatePayload>;
  /** Delete a Business Context */
  businessContextDelete?: Maybe<BusinessContextDeletePayload>;
  /** Empty a Business Context */
  businessContextEmpty?: Maybe<BusinessContextEmptyPayload>;
  /** Generate a Business Context */
  businessContextGenerate?: Maybe<BusinessContextGeneratePayload>;
  /** Create a Card Type */
  cardTypeCreate?: Maybe<CardTypeCreatePayload>;
  /** Delete a Card Type */
  cardTypeDelete?: Maybe<CardTypeDeletePayload>;
  /** Update a Card Type */
  cardTypeUpdate?: Maybe<CardTypeUpdatePayload>;
  /** Cancel a running AI chat thread */
  chatCancel?: Maybe<ChatCancelPayload>;
  /** Update a chat thread properties */
  chatUpdate?: Maybe<ChatUpdatePayload>;
  /** The class type of the field */
  classType: Scalars['String']['output'];
  /** Create a Comment */
  commentCreate?: Maybe<CommentCreatePayload>;
  /** Delete an existing Comment */
  commentDelete?: Maybe<CommentDeletePayload>;
  /** Create or update the configuration for correlating a pair of Metrics */
  correlationPairUpdate?: Maybe<CorrelationPairUpdatePayload>;
  /** Test a Credential for validity, via a set of attributes */
  credentialAttributesTest?: Maybe<CredentialAttributesTestPayload>;
  /** Create a Credential */
  credentialCreate?: Maybe<CredentialCreatePayload>;
  /** Test a Credential for validity */
  credentialTest?: Maybe<CredentialTestPayload>;
  /** Create a new customer */
  customerCreate?: Maybe<CustomerCreatePayload>;
  /** Update a Node */
  domainObjectUpdate?: Maybe<DomainObjectUpdatePayload>;
  /** Bulk add and remove labels from domain objects */
  domainObjectsBulkLabel?: Maybe<DomainObjectsBulkLabelPayload>;
  /** Delete domain objects */
  domainObjectsDelete?: Maybe<DomainObjectsDeletePayload>;
  /** Creating a relationship between two nodes for a strategy */
  edgeCreate?: Maybe<EdgeCreatePayload>;
  /** Destroying a relationship between two nodes for a strategy */
  edgeDelete?: Maybe<EdgeDeletePayload>;
  /** Create an entity containment */
  entityContainmentCreate?: Maybe<EntityContainmentCreatePayload>;
  /** Delete an entity containment */
  entityContainmentDelete?: Maybe<EntityContainmentDeletePayload>;
  /** Create an Entity + Event */
  entityCreate?: Maybe<EntityCreatePayload>;
  /** Adds an attachment to an entity */
  entityCreateAttachment?: Maybe<EntityCreateAttachmentPayload>;
  /** Adds a contributor to an entity */
  entityCreateContributor?: Maybe<EntityCreateContributorPayload>;
  /** Removes an attachment from an entity */
  entityDeleteAttachment?: Maybe<EntityDeleteAttachmentPayload>;
  /** Removes a contributor from an entity */
  entityDeleteContributor?: Maybe<EntityDeleteContributorPayload>;
  /** Send an Event to Slack */
  entitySlack?: Maybe<EntitySlackPayload>;
  /** Updates an existing Entity */
  entityUpdate?: Maybe<EntityUpdatePayload>;
  /** Create a Favorite */
  favoriteCreate?: Maybe<FavoriteCreatePayload>;
  /** Delete a Favorite */
  favoriteDelete?: Maybe<FavoriteDeletePayload>;
  /** Create a Goal */
  goalCreate?: Maybe<GoalCreatePayload>;
  /** Create metrics for all Google Analytics metrics of the given GA4 property */
  googleAnalyticsPropertyImport?: Maybe<GoogleAnalyticsPropertyImportPayload>;
  /** Delete a Google Sheet. This does not delete it from Google. */
  googleSheetDelete?: Maybe<GoogleSheetDeletePayload>;
  /** Import a Google Sheet into the current user's Organization */
  googleSheetImport?: Maybe<GoogleSheetImportPayload>;
  /** Create an Integration */
  integrationCreate?: Maybe<IntegrationCreatePayload>;
  /** Import history for an Integration */
  integrationImportHistory?: Maybe<IntegrationImportHistoryPayload>;
  /** Update an existing Integration */
  integrationUpdate?: Maybe<IntegrationUpdatePayload>;
  /** Create an Invitation */
  invitationCreate?: Maybe<InvitationCreatePayload>;
  /** Deletes an existing Invitation */
  invitationDelete?: Maybe<InvitationDeletePayload>;
  /** Resends an existing Invitation */
  invitationResend?: Maybe<InvitationResendPayload>;
  /** Add a Label to a domain object */
  labelCreate?: Maybe<LabelCreatePayload>;
  /** Remove a Label from a domain object */
  labelDelete?: Maybe<LabelDeletePayload>;
  /** Create a Looker Dashboard */
  lookerDashboardCreate?: Maybe<LookerDashboardCreatePayload>;
  /** Delete a Looker Dashboard */
  lookerDashboardDelete?: Maybe<LookerDashboardDeletePayload>;
  /** Clone a Strategy Map */
  mapClone?: Maybe<MapClonePayload>;
  /** Clone a Strategy to another Organization */
  mapCloneToOrganization?: Maybe<MapCloneToOrganizationPayload>;
  /** Moves nodes to a new map */
  mapCreateFromExisting?: Maybe<MapCreateFromExistingPayload>;
  /** Run stats for a Strategy, on demand */
  mapRunStats?: Maybe<MapRunStatsPayload>;
  /** Run a map simulation */
  mapSimulate?: Maybe<MapSimulatePayload>;
  /** Create a Metric */
  metricCreate?: Maybe<MetricCreatePayload>;
  /** Create a Metric Data Point */
  metricDataPointCreate?: Maybe<MetricDataPointCreatePayload>;
  /** Delete a Metric Data Point */
  metricDataPointDelete?: Maybe<MetricDataPointDeletePayload>;
  /** Update a Metric Data Point */
  metricDataPointUpdate?: Maybe<MetricDataPointUpdatePayload>;
  /** Delete all of a Metric's data points */
  metricDeleteAllMetricDataPoints?: Maybe<MetricDeleteAllMetricDataPointsPayload>;
  /** Suggest a Metric description, based on an AI prompt */
  metricDescriptionSuggest?: Maybe<MetricDescriptionSuggestPayload>;
  /** Suggest metric formula breakdowns */
  metricFormulasSuggest?: Maybe<MetricFormulasSuggestPayload>;
  /** Populate empty metrics */
  metricPopulateEmpty?: Maybe<MetricPopulateEmptyPayload>;
  /** Create a Metric Source */
  metricSourceCreate?: Maybe<MetricSourceCreatePayload>;
  /** Delete a Metric Source */
  metricSourceDelete?: Maybe<MetricSourceDeletePayload>;
  /** Run a Metric Source */
  metricSourceRun?: Maybe<MetricSourceRunPayload>;
  /** Test a Metric Source */
  metricSourceTest?: Maybe<MetricSourceTestPayload>;
  /** Test a Metric Source via attributes */
  metricSourceTestAttributes?: Maybe<MetricSourceTestAttributesPayload>;
  /** Update a Metric Source */
  metricSourceUpdate?: Maybe<MetricSourceUpdatePayload>;
  /** Suggest a Metric technical_description, based on an AI prompt */
  metricTechnicalDescriptionSuggest?: Maybe<MetricTechnicalDescriptionSuggestPayload>;
  /** Update a Metric */
  metricUpdate?: Maybe<MetricUpdatePayload>;
  /** Add data points to multiple metric via CSV */
  metricUploadBatchFile?: Maybe<MetricUploadBatchFilePayload>;
  /** Add data points to a metric via CSV */
  metricUploadFile?: Maybe<MetricUploadFilePayload>;
  /** Generate Metrics from a formula */
  metricsGenerateFromFormula?: Maybe<MetricsGenerateFromFormulaPayload>;
  /** Create a Node */
  nodeCreate?: Maybe<NodeCreatePayload>;
  /** Duplicate one or more nodes, *AND* their domain objects */
  nodesDuplicate?: Maybe<NodesDuplicatePayload>;
  /** Delete a file directly from OpenAI */
  openAiFileDelete?: Maybe<OpenAiFileDeletePayload>;
  /** Create an Organization */
  organizationCreate?: Maybe<OrganizationCreatePayload>;
  /** Apply default organization stat intervals to all metrics in an organization */
  organizationDefaultMetricStatIntervalsApply?: Maybe<OrganizationDefaultMetricStatIntervalsApplyPayload>;
  /** Update an existing Organization */
  organizationUpdate?: Maybe<OrganizationUpdatePayload>;
  /** Run a pipeline */
  pipelineRun?: Maybe<PipelineRunPayload>;
  /** Apply a Playbook to an existing Strategy and start AI pipeline */
  playbookApplyToStrategyWithAi?: Maybe<PlaybookApplyToStrategyWithAiPayload>;
  /** Apply a Playbook to the current Organization and start AI pipeline */
  playbookApplyWithAi?: Maybe<PlaybookApplyWithAiPayload>;
  /** Create a Playbook from a Strategy */
  playbookCreateFromStrategy?: Maybe<PlaybookCreateFromStrategyPayload>;
  /** Submit a Playbook for review, to have it published */
  playbookSubmitForReview?: Maybe<PlaybookSubmitForReviewPayload>;
  /** Suggest Product Initiatives */
  productInitiativesSuggest?: Maybe<ProductInitiativesSuggestPayload>;
  /** Create a RecurringReportConfiguration */
  recurringReportConfigurationCreate?: Maybe<RecurringReportConfigurationCreatePayload>;
  /** Delete a RecurringReportConfiguration */
  recurringReportConfigurationDelete?: Maybe<RecurringReportConfigurationDeletePayload>;
  /** Test a new prompt for a RecurringReportConfiguration */
  recurringReportConfigurationPromptTest?: Maybe<RecurringReportConfigurationPromptTestPayload>;
  /** Run a RecurringReportConfiguration */
  recurringReportConfigurationRun?: Maybe<RecurringReportConfigurationRunPayload>;
  /** Update a RecurringReportConfiguration */
  recurringReportConfigurationUpdate?: Maybe<RecurringReportConfigurationUpdatePayload>;
  /** Create a Report */
  reportCreate?: Maybe<ReportCreatePayload>;
  /** Send a Report */
  reportSend?: Maybe<ReportSendPayload>;
  /** Update a Report */
  reportUpdate?: Maybe<ReportUpdatePayload>;
  /** Create and delete one or more Segment Filters */
  segmentFiltersUpdate?: Maybe<SegmentFiltersUpdatePayload>;
  /** Bulk business context reassignment operation for strategies */
  strategiesBulkReassignBusinessContext?: Maybe<StrategiesBulkReassignBusinessContextPayload>;
  /** Add a batch of existing cards to a Strategy */
  strategyBulkAddExistingCards?: Maybe<StrategyBulkAddExistingCardsPayload>;
  /** Add multiple metrics to a strategy via URLs */
  strategyBulkImportUrls?: Maybe<StrategyBulkImportUrlsPayload>;
  /** Delete a Strategy */
  strategyDelete?: Maybe<StrategyDeletePayload>;
  /** Suggest a Strategy description, based on an AI prompt */
  strategyDescriptionSuggest?: Maybe<StrategyDescriptionSuggestPayload>;
  /** Run a multi-regression on strategy metrics */
  strategyMetricMultiRegression?: Maybe<StrategyMetricMultiRegressionPayload>;
  /** Suggest Strategy Metrics */
  strategyMetricsSuggest?: Maybe<StrategyMetricsSuggestPayload>;
  /** Suggest a Strategy name, based on an AI prompt */
  strategyNameSuggest?: Maybe<StrategyNameSuggestPayload>;
  /** Delete a Strategy Node */
  strategyNodeDelete?: Maybe<StrategyNodeDeletePayload>;
  /** Update a Strategy Node data, one or more. Useful for position updates. */
  strategyNodeUpdate?: Maybe<StrategyNodeUpdatePayload>;
  /** Use a playbook template to populate an existing strategy */
  strategyPopulateFromPlaybookTemplate?: Maybe<StrategyPopulateFromPlaybookTemplatePayload>;
  /** Populate node (metrics) simulation baselines with AI */
  strategyPopulateSimulationBaselines?: Maybe<StrategyPopulateSimulationBaselinesPayload>;
  /** Clear regression scores for a strategy */
  strategyRegressionScoresClear?: Maybe<StrategyRegressionScoresClearPayload>;
  /** Send the Strategy digest to Slack */
  strategyReviewSend?: Maybe<StrategyReviewSendPayload>;
  /** Update a Strategy */
  strategyUpdate?: Maybe<StrategyUpdatePayload>;
  /** Generate a ticket to use the streaming upload proxy */
  uploadTicketGenerate?: Maybe<UploadTicketGeneratePayload>;
  /** Authenticate a User */
  userAuthenticate?: Maybe<UserAuthenticatePayload>;
  /** Send a new confirm email email */
  userConfirmEmail?: Maybe<UserConfirmEmailPayload>;
  /** Create a User */
  userCreate?: Maybe<UserCreatePayload>;
  /** Capture email to create a User via Identity */
  userEmailCapture?: Maybe<UserEmailCapturePayload>;
  /** Reset a user's password */
  userResetPassword?: Maybe<UserResetPasswordPayload>;
  /** Create a request to reset a user's password */
  userResetPasswordRequest?: Maybe<UserResetPasswordRequestPayload>;
  /** Updates a User */
  userUpdate?: Maybe<UserUpdatePayload>;
};


/** Base Mutation Types for DoubleLoop */
export type MutationAccountDeleteArgs = {
  input: AccountDeleteInput;
};


/** Base Mutation Types for DoubleLoop */
export type MutationAccountSwitchArgs = {
  input: AccountSwitchInput;
};


/** Base Mutation Types for DoubleLoop */
export type MutationAccountUpdateArgs = {
  input: AccountUpdateInput;
};


/** Base Mutation Types for DoubleLoop */
export type MutationAiAssistantFileCacheFilesAddArgs = {
  input: AiAssistantFileCacheFilesAddInput;
};


/** Base Mutation Types for DoubleLoop */
export type MutationAiAssistantFileCacheFilesRemoveArgs = {
  input: AiAssistantFileCacheFilesRemoveInput;
};


/** Base Mutation Types for DoubleLoop */
export type MutationAiNodesGenerateArgs = {
  input: AiNodesGenerateInput;
};


/** Base Mutation Types for DoubleLoop */
export type MutationBasicCardCreateArgs = {
  input: BasicCardCreateInput;
};


/** Base Mutation Types for DoubleLoop */
export type MutationBasicCardDeleteArgs = {
  input: BasicCardDeleteInput;
};


/** Base Mutation Types for DoubleLoop */
export type MutationBillingCreateSubscriptionArgs = {
  input: BillingCreateSubscriptionInput;
};


/** Base Mutation Types for DoubleLoop */
export type MutationBillingProvisionSubscriptionArgs = {
  input: BillingProvisionSubscriptionInput;
};


/** Base Mutation Types for DoubleLoop */
export type MutationBusinessContextCreateArgs = {
  input: BusinessContextCreateInput;
};


/** Base Mutation Types for DoubleLoop */
export type MutationBusinessContextDeleteArgs = {
  input: BusinessContextDeleteInput;
};


/** Base Mutation Types for DoubleLoop */
export type MutationBusinessContextEmptyArgs = {
  input: BusinessContextEmptyInput;
};


/** Base Mutation Types for DoubleLoop */
export type MutationBusinessContextGenerateArgs = {
  input: BusinessContextGenerateInput;
};


/** Base Mutation Types for DoubleLoop */
export type MutationCardTypeCreateArgs = {
  input: CardTypeCreateInput;
};


/** Base Mutation Types for DoubleLoop */
export type MutationCardTypeDeleteArgs = {
  input: CardTypeDeleteInput;
};


/** Base Mutation Types for DoubleLoop */
export type MutationCardTypeUpdateArgs = {
  input: CardTypeUpdateInput;
};


/** Base Mutation Types for DoubleLoop */
export type MutationChatCancelArgs = {
  input: ChatCancelInput;
};


/** Base Mutation Types for DoubleLoop */
export type MutationChatUpdateArgs = {
  input: ChatUpdateInput;
};


/** Base Mutation Types for DoubleLoop */
export type MutationCommentCreateArgs = {
  input: CommentCreateInput;
};


/** Base Mutation Types for DoubleLoop */
export type MutationCommentDeleteArgs = {
  input: CommentDeleteInput;
};


/** Base Mutation Types for DoubleLoop */
export type MutationCorrelationPairUpdateArgs = {
  input: CorrelationPairUpdateInput;
};


/** Base Mutation Types for DoubleLoop */
export type MutationCredentialAttributesTestArgs = {
  input: CredentialAttributesTestInput;
};


/** Base Mutation Types for DoubleLoop */
export type MutationCredentialCreateArgs = {
  input: CredentialCreateInput;
};


/** Base Mutation Types for DoubleLoop */
export type MutationCredentialTestArgs = {
  input: CredentialTestInput;
};


/** Base Mutation Types for DoubleLoop */
export type MutationCustomerCreateArgs = {
  input: CustomerCreateInput;
};


/** Base Mutation Types for DoubleLoop */
export type MutationDomainObjectUpdateArgs = {
  input: DomainObjectUpdateInput;
};


/** Base Mutation Types for DoubleLoop */
export type MutationDomainObjectsBulkLabelArgs = {
  input: DomainObjectsBulkLabelInput;
};


/** Base Mutation Types for DoubleLoop */
export type MutationDomainObjectsDeleteArgs = {
  input: DomainObjectsDeleteInput;
};


/** Base Mutation Types for DoubleLoop */
export type MutationEdgeCreateArgs = {
  input: EdgeCreateInput;
};


/** Base Mutation Types for DoubleLoop */
export type MutationEdgeDeleteArgs = {
  input: EdgeDeleteInput;
};


/** Base Mutation Types for DoubleLoop */
export type MutationEntityContainmentCreateArgs = {
  input: EntityContainmentCreateInput;
};


/** Base Mutation Types for DoubleLoop */
export type MutationEntityContainmentDeleteArgs = {
  input: EntityContainmentDeleteInput;
};


/** Base Mutation Types for DoubleLoop */
export type MutationEntityCreateArgs = {
  input: EntityCreateInput;
};


/** Base Mutation Types for DoubleLoop */
export type MutationEntityCreateAttachmentArgs = {
  input: EntityCreateAttachmentInput;
};


/** Base Mutation Types for DoubleLoop */
export type MutationEntityCreateContributorArgs = {
  input: EntityCreateContributorInput;
};


/** Base Mutation Types for DoubleLoop */
export type MutationEntityDeleteAttachmentArgs = {
  input: EntityDeleteAttachmentInput;
};


/** Base Mutation Types for DoubleLoop */
export type MutationEntityDeleteContributorArgs = {
  input: EntityDeleteContributorInput;
};


/** Base Mutation Types for DoubleLoop */
export type MutationEntitySlackArgs = {
  input: EntitySlackInput;
};


/** Base Mutation Types for DoubleLoop */
export type MutationEntityUpdateArgs = {
  input: EntityUpdateInput;
};


/** Base Mutation Types for DoubleLoop */
export type MutationFavoriteCreateArgs = {
  input: FavoriteCreateInput;
};


/** Base Mutation Types for DoubleLoop */
export type MutationFavoriteDeleteArgs = {
  input: FavoriteDeleteInput;
};


/** Base Mutation Types for DoubleLoop */
export type MutationGoalCreateArgs = {
  input: GoalCreateInput;
};


/** Base Mutation Types for DoubleLoop */
export type MutationGoogleAnalyticsPropertyImportArgs = {
  input: GoogleAnalyticsPropertyImportInput;
};


/** Base Mutation Types for DoubleLoop */
export type MutationGoogleSheetDeleteArgs = {
  input: GoogleSheetDeleteInput;
};


/** Base Mutation Types for DoubleLoop */
export type MutationGoogleSheetImportArgs = {
  input: GoogleSheetImportInput;
};


/** Base Mutation Types for DoubleLoop */
export type MutationIntegrationCreateArgs = {
  input: IntegrationCreateInput;
};


/** Base Mutation Types for DoubleLoop */
export type MutationIntegrationImportHistoryArgs = {
  input: IntegrationImportHistoryInput;
};


/** Base Mutation Types for DoubleLoop */
export type MutationIntegrationUpdateArgs = {
  input: IntegrationUpdateInput;
};


/** Base Mutation Types for DoubleLoop */
export type MutationInvitationCreateArgs = {
  input: InvitationCreateInput;
};


/** Base Mutation Types for DoubleLoop */
export type MutationInvitationDeleteArgs = {
  input: InvitationDeleteInput;
};


/** Base Mutation Types for DoubleLoop */
export type MutationInvitationResendArgs = {
  input: InvitationResendInput;
};


/** Base Mutation Types for DoubleLoop */
export type MutationLabelCreateArgs = {
  input: LabelCreateInput;
};


/** Base Mutation Types for DoubleLoop */
export type MutationLabelDeleteArgs = {
  input: LabelDeleteInput;
};


/** Base Mutation Types for DoubleLoop */
export type MutationLookerDashboardCreateArgs = {
  input: LookerDashboardCreateInput;
};


/** Base Mutation Types for DoubleLoop */
export type MutationLookerDashboardDeleteArgs = {
  input: LookerDashboardDeleteInput;
};


/** Base Mutation Types for DoubleLoop */
export type MutationMapCloneArgs = {
  input: MapCloneInput;
};


/** Base Mutation Types for DoubleLoop */
export type MutationMapCloneToOrganizationArgs = {
  input: MapCloneToOrganizationInput;
};


/** Base Mutation Types for DoubleLoop */
export type MutationMapCreateFromExistingArgs = {
  input: MapCreateFromExistingInput;
};


/** Base Mutation Types for DoubleLoop */
export type MutationMapRunStatsArgs = {
  input: MapRunStatsInput;
};


/** Base Mutation Types for DoubleLoop */
export type MutationMapSimulateArgs = {
  input: MapSimulateInput;
};


/** Base Mutation Types for DoubleLoop */
export type MutationMetricCreateArgs = {
  input: MetricCreateInput;
};


/** Base Mutation Types for DoubleLoop */
export type MutationMetricDataPointCreateArgs = {
  input: MetricDataPointCreateInput;
};


/** Base Mutation Types for DoubleLoop */
export type MutationMetricDataPointDeleteArgs = {
  input: MetricDataPointDeleteInput;
};


/** Base Mutation Types for DoubleLoop */
export type MutationMetricDataPointUpdateArgs = {
  input: MetricDataPointUpdateInput;
};


/** Base Mutation Types for DoubleLoop */
export type MutationMetricDeleteAllMetricDataPointsArgs = {
  input: MetricDeleteAllMetricDataPointsInput;
};


/** Base Mutation Types for DoubleLoop */
export type MutationMetricDescriptionSuggestArgs = {
  input: MetricDescriptionSuggestInput;
};


/** Base Mutation Types for DoubleLoop */
export type MutationMetricFormulasSuggestArgs = {
  input: MetricFormulasSuggestInput;
};


/** Base Mutation Types for DoubleLoop */
export type MutationMetricPopulateEmptyArgs = {
  input: MetricPopulateEmptyInput;
};


/** Base Mutation Types for DoubleLoop */
export type MutationMetricSourceCreateArgs = {
  input: MetricSourceCreateInput;
};


/** Base Mutation Types for DoubleLoop */
export type MutationMetricSourceDeleteArgs = {
  input: MetricSourceDeleteInput;
};


/** Base Mutation Types for DoubleLoop */
export type MutationMetricSourceRunArgs = {
  input: MetricSourceRunInput;
};


/** Base Mutation Types for DoubleLoop */
export type MutationMetricSourceTestArgs = {
  input: MetricSourceTestInput;
};


/** Base Mutation Types for DoubleLoop */
export type MutationMetricSourceTestAttributesArgs = {
  input: MetricSourceTestAttributesInput;
};


/** Base Mutation Types for DoubleLoop */
export type MutationMetricSourceUpdateArgs = {
  input: MetricSourceUpdateInput;
};


/** Base Mutation Types for DoubleLoop */
export type MutationMetricTechnicalDescriptionSuggestArgs = {
  input: MetricTechnicalDescriptionSuggestInput;
};


/** Base Mutation Types for DoubleLoop */
export type MutationMetricUpdateArgs = {
  input: MetricUpdateInput;
};


/** Base Mutation Types for DoubleLoop */
export type MutationMetricUploadBatchFileArgs = {
  input: MetricUploadBatchFileInput;
};


/** Base Mutation Types for DoubleLoop */
export type MutationMetricUploadFileArgs = {
  input: MetricUploadFileInput;
};


/** Base Mutation Types for DoubleLoop */
export type MutationMetricsGenerateFromFormulaArgs = {
  input: MetricsGenerateFromFormulaInput;
};


/** Base Mutation Types for DoubleLoop */
export type MutationNodeCreateArgs = {
  input: NodeCreateInput;
};


/** Base Mutation Types for DoubleLoop */
export type MutationNodesDuplicateArgs = {
  input: NodesDuplicateInput;
};


/** Base Mutation Types for DoubleLoop */
export type MutationOpenAiFileDeleteArgs = {
  input: OpenAiFileDeleteInput;
};


/** Base Mutation Types for DoubleLoop */
export type MutationOrganizationCreateArgs = {
  input: OrganizationCreateInput;
};


/** Base Mutation Types for DoubleLoop */
export type MutationOrganizationDefaultMetricStatIntervalsApplyArgs = {
  input: OrganizationDefaultMetricStatIntervalsApplyInput;
};


/** Base Mutation Types for DoubleLoop */
export type MutationOrganizationUpdateArgs = {
  input: OrganizationUpdateInput;
};


/** Base Mutation Types for DoubleLoop */
export type MutationPipelineRunArgs = {
  input: PipelineRunInput;
};


/** Base Mutation Types for DoubleLoop */
export type MutationPlaybookApplyToStrategyWithAiArgs = {
  input: PlaybookApplyToStrategyWithAiInput;
};


/** Base Mutation Types for DoubleLoop */
export type MutationPlaybookApplyWithAiArgs = {
  input: PlaybookApplyWithAiInput;
};


/** Base Mutation Types for DoubleLoop */
export type MutationPlaybookCreateFromStrategyArgs = {
  input: PlaybookCreateFromStrategyInput;
};


/** Base Mutation Types for DoubleLoop */
export type MutationPlaybookSubmitForReviewArgs = {
  input: PlaybookSubmitForReviewInput;
};


/** Base Mutation Types for DoubleLoop */
export type MutationProductInitiativesSuggestArgs = {
  input: ProductInitiativesSuggestInput;
};


/** Base Mutation Types for DoubleLoop */
export type MutationRecurringReportConfigurationCreateArgs = {
  input: RecurringReportConfigurationCreateInput;
};


/** Base Mutation Types for DoubleLoop */
export type MutationRecurringReportConfigurationDeleteArgs = {
  input: RecurringReportConfigurationDeleteInput;
};


/** Base Mutation Types for DoubleLoop */
export type MutationRecurringReportConfigurationPromptTestArgs = {
  input: RecurringReportConfigurationPromptTestInput;
};


/** Base Mutation Types for DoubleLoop */
export type MutationRecurringReportConfigurationRunArgs = {
  input: RecurringReportConfigurationRunInput;
};


/** Base Mutation Types for DoubleLoop */
export type MutationRecurringReportConfigurationUpdateArgs = {
  input: RecurringReportConfigurationUpdateInput;
};


/** Base Mutation Types for DoubleLoop */
export type MutationReportCreateArgs = {
  input: ReportCreateInput;
};


/** Base Mutation Types for DoubleLoop */
export type MutationReportSendArgs = {
  input: ReportSendInput;
};


/** Base Mutation Types for DoubleLoop */
export type MutationReportUpdateArgs = {
  input: ReportUpdateInput;
};


/** Base Mutation Types for DoubleLoop */
export type MutationSegmentFiltersUpdateArgs = {
  input: SegmentFiltersUpdateInput;
};


/** Base Mutation Types for DoubleLoop */
export type MutationStrategiesBulkReassignBusinessContextArgs = {
  input: StrategiesBulkReassignBusinessContextInput;
};


/** Base Mutation Types for DoubleLoop */
export type MutationStrategyBulkAddExistingCardsArgs = {
  input: StrategyBulkAddExistingCardsInput;
};


/** Base Mutation Types for DoubleLoop */
export type MutationStrategyBulkImportUrlsArgs = {
  input: StrategyBulkImportUrlsInput;
};


/** Base Mutation Types for DoubleLoop */
export type MutationStrategyDeleteArgs = {
  input: StrategyDeleteInput;
};


/** Base Mutation Types for DoubleLoop */
export type MutationStrategyDescriptionSuggestArgs = {
  input: StrategyDescriptionSuggestInput;
};


/** Base Mutation Types for DoubleLoop */
export type MutationStrategyMetricMultiRegressionArgs = {
  input: StrategyMetricMultiRegressionInput;
};


/** Base Mutation Types for DoubleLoop */
export type MutationStrategyMetricsSuggestArgs = {
  input: StrategyMetricsSuggestInput;
};


/** Base Mutation Types for DoubleLoop */
export type MutationStrategyNameSuggestArgs = {
  input: StrategyNameSuggestInput;
};


/** Base Mutation Types for DoubleLoop */
export type MutationStrategyNodeDeleteArgs = {
  input: StrategyNodeDeleteInput;
};


/** Base Mutation Types for DoubleLoop */
export type MutationStrategyNodeUpdateArgs = {
  input: StrategyNodeUpdateInput;
};


/** Base Mutation Types for DoubleLoop */
export type MutationStrategyPopulateFromPlaybookTemplateArgs = {
  input: StrategyPopulateFromPlaybookTemplateInput;
};


/** Base Mutation Types for DoubleLoop */
export type MutationStrategyPopulateSimulationBaselinesArgs = {
  input: StrategyPopulateSimulationBaselinesInput;
};


/** Base Mutation Types for DoubleLoop */
export type MutationStrategyRegressionScoresClearArgs = {
  input: StrategyRegressionScoresClearInput;
};


/** Base Mutation Types for DoubleLoop */
export type MutationStrategyReviewSendArgs = {
  input: StrategyReviewSendInput;
};


/** Base Mutation Types for DoubleLoop */
export type MutationStrategyUpdateArgs = {
  input: StrategyUpdateInput;
};


/** Base Mutation Types for DoubleLoop */
export type MutationUploadTicketGenerateArgs = {
  input: UploadTicketGenerateInput;
};


/** Base Mutation Types for DoubleLoop */
export type MutationUserAuthenticateArgs = {
  input: UserAuthenticateInput;
};


/** Base Mutation Types for DoubleLoop */
export type MutationUserConfirmEmailArgs = {
  input: UserConfirmEmailInput;
};


/** Base Mutation Types for DoubleLoop */
export type MutationUserCreateArgs = {
  input: UserCreateInput;
};


/** Base Mutation Types for DoubleLoop */
export type MutationUserEmailCaptureArgs = {
  input: UserEmailCaptureInput;
};


/** Base Mutation Types for DoubleLoop */
export type MutationUserResetPasswordArgs = {
  input: UserResetPasswordInput;
};


/** Base Mutation Types for DoubleLoop */
export type MutationUserResetPasswordRequestArgs = {
  input: UserResetPasswordRequestInput;
};


/** Base Mutation Types for DoubleLoop */
export type MutationUserUpdateArgs = {
  input: UserUpdateInput;
};

/** Node */
export type Node = ClassTypeInterface & {
  __typename?: 'Node';
  /** The class type of the field */
  classType: Scalars['String']['output'];
  /** Object data */
  data: Scalars['JSON']['output'];
  /** Domain Object ID */
  domainObjectId: Scalars['ID']['output'];
  /** Domain Object Type */
  domainObjectType: Scalars['String']['output'];
  /** Object height */
  height?: Maybe<Scalars['Int']['output']>;
  /** Whether the node is hidden */
  hidden: Scalars['Boolean']['output'];
  /** Object unique ID */
  id: Scalars['ID']['output'];
  /** Object metadata, such as colors */
  metadata?: Maybe<Scalars['JSON']['output']>;
  /** Node ID */
  nodeId?: Maybe<Scalars['ID']['output']>;
  /** Parent node in react flow structure */
  parentId?: Maybe<Scalars['String']['output']>;
  /** Whether the node is marked as pending_ai */
  pendingAi: Scalars['Boolean']['output'];
  /** Object position */
  position: Scalars['JSON']['output'];
  /** Simulator baseline */
  simBaseline?: Maybe<Scalars['Float']['output']>;
  /** Simulator impacts */
  simImpacts: Array<SimulatorPartialResult>;
  /** Simulator partial results (1% change) */
  simPartials1p: Array<SimulatorPartialResult>;
  /** Simulator percent change between baseline and target */
  simPercentChange?: Maybe<Scalars['Float']['output']>;
  /** Simulator target */
  simTarget?: Maybe<Scalars['Float']['output']>;
  /** When the stats were last updated */
  statsUpdatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** associated Strategy */
  strategy?: Maybe<Strategy>;
  /** Strategy ID */
  strategyId: Scalars['ID']['output'];
  /** Array of Strategy Stats */
  strategyStats: Array<StrategyStat>;
  /** Object type */
  type: Scalars['String']['output'];
  /** Object width */
  width?: Maybe<Scalars['Int']['output']>;
  /** Object z-index */
  zIndex: Scalars['Int']['output'];
};

/** Autogenerated input type of NodeCreate */
export type NodeCreateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Dimensions of the object */
  dimensions?: InputMaybe<DimensionsInput>;
  /** The object to associate */
  object: NodeObjectInput;
  /** Position on the strategy */
  position?: InputMaybe<PositionInput>;
  /** The ID of the Strategy to associate */
  strategyId: Scalars['ID']['input'];
};

/** Autogenerated return type of NodeCreate. */
export type NodeCreatePayload = ClassTypeInterface & {
  __typename?: 'NodeCreatePayload';
  /** The class type of the field */
  classType: Scalars['String']['output'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Array of Errors */
  errors: Array<Error>;
  /** Created node */
  node?: Maybe<Node>;
  /** Created node_object */
  nodeObject?: Maybe<NodeObject>;
  /** Updated strategy */
  strategy: Strategy;
};

/** Input Type for Node */
export type NodeInput = {
  /** Dimensions of the object */
  dimensions?: InputMaybe<DimensionsInput>;
  /** Object unique ID */
  id?: InputMaybe<Scalars['ID']['input']>;
  /** Object metadata, such as colors */
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  /** Parent node in react flow structure */
  parentNodeId?: InputMaybe<Scalars['ID']['input']>;
  /** Position on the strategy */
  position?: InputMaybe<PositionInput>;
  /** Simulator baseline */
  simBaseline?: InputMaybe<Scalars['ToDecimal']['input']>;
  /** Strategy ID */
  strategyId?: InputMaybe<Scalars['ID']['input']>;
};

/** Node Object Types */
export type NodeObject = BasicCard | CommentThread | Entity | MapImage | Metric | Note | Section | Strategy;

/** Input Type for Node */
export type NodeObjectInput =
  /** Basic Card */
  { basicCard: BasicCardInput; businessContext?: never; cardType?: never; comment?: never; commentThread?: never; credential?: never; edge?: never; entity?: never; existing?: never; goal?: never; mapImage?: never; metric?: never; node?: never; note?: never; recurringReportConfiguration?: never; report?: never; schedule?: never; section?: never; strategy?: never; work?: never; }
  |  /** Business Context */
  { basicCard?: never; businessContext: BusinessContextInput; cardType?: never; comment?: never; commentThread?: never; credential?: never; edge?: never; entity?: never; existing?: never; goal?: never; mapImage?: never; metric?: never; node?: never; note?: never; recurringReportConfiguration?: never; report?: never; schedule?: never; section?: never; strategy?: never; work?: never; }
  |  /** Card Type */
  { basicCard?: never; businessContext?: never; cardType: CardTypeInput; comment?: never; commentThread?: never; credential?: never; edge?: never; entity?: never; existing?: never; goal?: never; mapImage?: never; metric?: never; node?: never; note?: never; recurringReportConfiguration?: never; report?: never; schedule?: never; section?: never; strategy?: never; work?: never; }
  |  /** Comment */
  { basicCard?: never; businessContext?: never; cardType?: never; comment: CommentInput; commentThread?: never; credential?: never; edge?: never; entity?: never; existing?: never; goal?: never; mapImage?: never; metric?: never; node?: never; note?: never; recurringReportConfiguration?: never; report?: never; schedule?: never; section?: never; strategy?: never; work?: never; }
  |  /** Comment Thread */
  { basicCard?: never; businessContext?: never; cardType?: never; comment?: never; commentThread: CommentThreadInput; credential?: never; edge?: never; entity?: never; existing?: never; goal?: never; mapImage?: never; metric?: never; node?: never; note?: never; recurringReportConfiguration?: never; report?: never; schedule?: never; section?: never; strategy?: never; work?: never; }
  |  /** Credential */
  { basicCard?: never; businessContext?: never; cardType?: never; comment?: never; commentThread?: never; credential: CredentialInput; edge?: never; entity?: never; existing?: never; goal?: never; mapImage?: never; metric?: never; node?: never; note?: never; recurringReportConfiguration?: never; report?: never; schedule?: never; section?: never; strategy?: never; work?: never; }
  |  /** Edge */
  { basicCard?: never; businessContext?: never; cardType?: never; comment?: never; commentThread?: never; credential?: never; edge: EdgeInput; entity?: never; existing?: never; goal?: never; mapImage?: never; metric?: never; node?: never; note?: never; recurringReportConfiguration?: never; report?: never; schedule?: never; section?: never; strategy?: never; work?: never; }
  |  /** Entity */
  { basicCard?: never; businessContext?: never; cardType?: never; comment?: never; commentThread?: never; credential?: never; edge?: never; entity: EntityInput; existing?: never; goal?: never; mapImage?: never; metric?: never; node?: never; note?: never; recurringReportConfiguration?: never; report?: never; schedule?: never; section?: never; strategy?: never; work?: never; }
  |  /** Existing Node */
  { basicCard?: never; businessContext?: never; cardType?: never; comment?: never; commentThread?: never; credential?: never; edge?: never; entity?: never; existing: ExistingDomainObjectInput; goal?: never; mapImage?: never; metric?: never; node?: never; note?: never; recurringReportConfiguration?: never; report?: never; schedule?: never; section?: never; strategy?: never; work?: never; }
  |  /** Goal */
  { basicCard?: never; businessContext?: never; cardType?: never; comment?: never; commentThread?: never; credential?: never; edge?: never; entity?: never; existing?: never; goal: GoalInput; mapImage?: never; metric?: never; node?: never; note?: never; recurringReportConfiguration?: never; report?: never; schedule?: never; section?: never; strategy?: never; work?: never; }
  |  /** Map Image */
  { basicCard?: never; businessContext?: never; cardType?: never; comment?: never; commentThread?: never; credential?: never; edge?: never; entity?: never; existing?: never; goal?: never; mapImage: MapImageInput; metric?: never; node?: never; note?: never; recurringReportConfiguration?: never; report?: never; schedule?: never; section?: never; strategy?: never; work?: never; }
  |  /** Metric */
  { basicCard?: never; businessContext?: never; cardType?: never; comment?: never; commentThread?: never; credential?: never; edge?: never; entity?: never; existing?: never; goal?: never; mapImage?: never; metric: MetricInput; node?: never; note?: never; recurringReportConfiguration?: never; report?: never; schedule?: never; section?: never; strategy?: never; work?: never; }
  |  /** Node */
  { basicCard?: never; businessContext?: never; cardType?: never; comment?: never; commentThread?: never; credential?: never; edge?: never; entity?: never; existing?: never; goal?: never; mapImage?: never; metric?: never; node: NodeInput; note?: never; recurringReportConfiguration?: never; report?: never; schedule?: never; section?: never; strategy?: never; work?: never; }
  |  /** Note */
  { basicCard?: never; businessContext?: never; cardType?: never; comment?: never; commentThread?: never; credential?: never; edge?: never; entity?: never; existing?: never; goal?: never; mapImage?: never; metric?: never; node?: never; note: NoteInput; recurringReportConfiguration?: never; report?: never; schedule?: never; section?: never; strategy?: never; work?: never; }
  |  /** Recurring Report Configuration */
  { basicCard?: never; businessContext?: never; cardType?: never; comment?: never; commentThread?: never; credential?: never; edge?: never; entity?: never; existing?: never; goal?: never; mapImage?: never; metric?: never; node?: never; note?: never; recurringReportConfiguration: RecurringReportConfigurationInput; report?: never; schedule?: never; section?: never; strategy?: never; work?: never; }
  |  /** Report */
  { basicCard?: never; businessContext?: never; cardType?: never; comment?: never; commentThread?: never; credential?: never; edge?: never; entity?: never; existing?: never; goal?: never; mapImage?: never; metric?: never; node?: never; note?: never; recurringReportConfiguration?: never; report: ReportInput; schedule?: never; section?: never; strategy?: never; work?: never; }
  |  /** Schedule */
  { basicCard?: never; businessContext?: never; cardType?: never; comment?: never; commentThread?: never; credential?: never; edge?: never; entity?: never; existing?: never; goal?: never; mapImage?: never; metric?: never; node?: never; note?: never; recurringReportConfiguration?: never; report?: never; schedule: ScheduleInput; section?: never; strategy?: never; work?: never; }
  |  /** Section */
  { basicCard?: never; businessContext?: never; cardType?: never; comment?: never; commentThread?: never; credential?: never; edge?: never; entity?: never; existing?: never; goal?: never; mapImage?: never; metric?: never; node?: never; note?: never; recurringReportConfiguration?: never; report?: never; schedule?: never; section: SectionInput; strategy?: never; work?: never; }
  |  /** Strategy */
  { basicCard?: never; businessContext?: never; cardType?: never; comment?: never; commentThread?: never; credential?: never; edge?: never; entity?: never; existing?: never; goal?: never; mapImage?: never; metric?: never; node?: never; note?: never; recurringReportConfiguration?: never; report?: never; schedule?: never; section?: never; strategy: StrategyInput; work?: never; }
  |  /** Entity */
  { basicCard?: never; businessContext?: never; cardType?: never; comment?: never; commentThread?: never; credential?: never; edge?: never; entity?: never; existing?: never; goal?: never; mapImage?: never; metric?: never; node?: never; note?: never; recurringReportConfiguration?: never; report?: never; schedule?: never; section?: never; strategy?: never; work: EntityInput; };

/** Autogenerated input type of NodesDuplicate */
export type NodesDuplicateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The ids of the nodes to duplicate */
  nodeIds: Array<Scalars['ID']['input']>;
  /** The x offset for the duplicated nodes */
  offsetX?: InputMaybe<Scalars['Int']['input']>;
  /** The y offset for the duplicated nodes */
  offsetY?: InputMaybe<Scalars['Int']['input']>;
  /** The id of the strategy to duplicate the nodes into */
  strategyId?: InputMaybe<Scalars['ID']['input']>;
};

/** Autogenerated return type of NodesDuplicate. */
export type NodesDuplicatePayload = ClassTypeInterface & {
  __typename?: 'NodesDuplicatePayload';
  /** The class type of the field */
  classType: Scalars['String']['output'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The duplicated edges */
  edges?: Maybe<Array<Edge>>;
  /** Array of Errors */
  errors: Array<Error>;
  /** The duplicated nodes */
  nodes?: Maybe<Array<Node>>;
};

/** Note */
export type Note = ClassTypeInterface & RfNodeInterface & {
  __typename?: 'Note';
  /** The class type of the field */
  classType: Scalars['String']['output'];
  /** Object creation date */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** Object unique ID */
  id: Scalars['ID']['output'];
  /** Strategy node id */
  rfId: Scalars['String']['output'];
  /** Label name */
  text?: Maybe<Scalars['String']['output']>;
  /** Object last updated date */
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** Input Type for Notes */
export type NoteInput = {
  /** Note ID */
  id?: InputMaybe<Scalars['ID']['input']>;
  /** The text of the note */
  text?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated input type of OpenAiFileDelete */
export type OpenAiFileDeleteInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The OpenAI ID of the file to delete. */
  fileId: Scalars['ID']['input'];
};

/** Autogenerated return type of OpenAiFileDelete. */
export type OpenAiFileDeletePayload = ClassTypeInterface & {
  __typename?: 'OpenAiFileDeletePayload';
  /** The class type of the field */
  classType: Scalars['String']['output'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Whether the file was successfully deleted. */
  success: Scalars['Boolean']['output'];
};

/** Label / Value Option Pair */
export type Option = ClassTypeInterface & {
  __typename?: 'Option';
  /** The class type of the field */
  classType: Scalars['String']['output'];
  /** Label of the Option */
  label: Scalars['String']['output'];
  /** Value of the Option */
  value: Scalars['String']['output'];
};

/** Organization */
export type Organization = ClassTypeInterface & {
  __typename?: 'Organization';
  /** Customer Subscription */
  activeSubscription?: Maybe<CustomerSubscription>;
  /** API Token for sending webhooks */
  apiToken?: Maybe<Scalars['String']['output']>;
  /** Automatically import Google Sheet data */
  autoImportGoogleSheet: Scalars['Boolean']['output'];
  /** Business context JSON */
  businessContext?: Maybe<BusinessContext>;
  /** Organization wide Card Types */
  cardTypes?: Maybe<Array<CardType>>;
  /** List of chats associated with the organization */
  chats?: Maybe<Array<Chat>>;
  /** The class type of the field */
  classType: Scalars['String']['output'];
  /** Get correlation information for a pair of Organization Metrics */
  correlate?: Maybe<CorrelationPair>;
  /** Object creation date */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** User who created Organization */
  creator?: Maybe<User>;
  /** The time that organization data is imported */
  defaultImportTime: Scalars['String']['output'];
  /** List of sources we have entities for */
  eventSources?: Maybe<Array<Scalars['String']['output']>>;
  /** Google Sheet associated with the organization */
  googleSheet?: Maybe<GoogleSheet>;
  /** Organization homepage URL */
  homepageUrl?: Maybe<Scalars['String']['output']>;
  /** ID of object */
  id: Scalars['ID']['output'];
  /** SSO x.509 IdP Certification */
  idpCert?: Maybe<Scalars['String']['output']>;
  /** SSO Entity ID */
  idpEntityId?: Maybe<Scalars['String']['output']>;
  /** SSO Service URL */
  idpSsoServiceUrl?: Maybe<Scalars['String']['output']>;
  /** Organizations integration records */
  integrations?: Maybe<Array<Integration>>;
  /** SSO Issuer */
  issuer?: Maybe<Scalars['String']['output']>;
  /** Count of Jira entities */
  jiraCount?: Maybe<Scalars['Int']['output']>;
  /** URL of Logo */
  logo?: Maybe<Scalars['String']['output']>;
  /** Default metric settings for the organization */
  metricDefaults?: Maybe<Scalars['JSON']['output']>;
  /** List of metric sources associated with the organization */
  metricSources?: Maybe<Array<MetricSource>>;
  /** Organization name */
  name: Scalars['String']['output'];
  /** Count of Shortcut entities */
  shortcutCount?: Maybe<Scalars['Int']['output']>;
  /** Slack integration present */
  slackable: Scalars['Boolean']['output'];
  /** Organization slug */
  slug: Scalars['String']['output'];
  /** SSO Identifier for logging in */
  ssoIdentifier?: Maybe<Scalars['String']['output']>;
  /** SSO Provider Name */
  ssoProvider?: Maybe<Scalars['String']['output']>;
  /** List of strategies associated with the organization */
  strategies?: Maybe<Array<Strategy>>;
  /** Object last updated date */
  updatedAt: Scalars['ISO8601DateTime']['output'];
};


/** Organization */
export type OrganizationChatsArgs = {
  chattableId: Scalars['ID']['input'];
  chattableType: Scalars['String']['input'];
};


/** Organization */
export type OrganizationCorrelateArgs = {
  endDate?: InputMaybe<Scalars['String']['input']>;
  range?: InputMaybe<Scalars['String']['input']>;
  sourceId: Scalars['ID']['input'];
  startDate?: InputMaybe<Scalars['String']['input']>;
  targetId: Scalars['ID']['input'];
};

/** Autogenerated input type of OrganizationCreate */
export type OrganizationCreateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Homepage URL for the new organization */
  homepageUrl?: InputMaybe<Scalars['String']['input']>;
  /** Name for the new organization */
  name: Scalars['String']['input'];
};

/** Autogenerated return type of OrganizationCreate. */
export type OrganizationCreatePayload = ClassTypeInterface & {
  __typename?: 'OrganizationCreatePayload';
  /** The class type of the field */
  classType: Scalars['String']['output'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Array of Errors */
  errors: Array<Error>;
  /** Newly created organization */
  organization?: Maybe<Organization>;
  /** Strategy created for the newly created organization */
  strategy?: Maybe<Strategy>;
};

/** Autogenerated return type of OrganizationCrud. */
export type OrganizationCrudPayload = ClassTypeInterface & {
  __typename?: 'OrganizationCrudPayload';
  /** The class type of the field */
  classType: Scalars['String']['output'];
  /** The object that was affected */
  data: Array<DomainObjectUnion>;
  /** The operation that was performed */
  operation: CrudOperationEnum;
};

/** Autogenerated input type of OrganizationDefaultMetricStatIntervalsApply */
export type OrganizationDefaultMetricStatIntervalsApplyInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Organization ID */
  organizationId: Scalars['ID']['input'];
};

/** Autogenerated return type of OrganizationDefaultMetricStatIntervalsApply. */
export type OrganizationDefaultMetricStatIntervalsApplyPayload = ClassTypeInterface & {
  __typename?: 'OrganizationDefaultMetricStatIntervalsApplyPayload';
  /** The class type of the field */
  classType: Scalars['String']['output'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Array of Errors */
  errors: Array<Error>;
  /** Updated Organization */
  organization?: Maybe<Organization>;
};

/** Input Type for Organizations */
export type OrganizationInput = {
  /** ID of the Organization */
  id?: InputMaybe<Scalars['ID']['input']>;
};

/** Autogenerated input type of OrganizationUpdate */
export type OrganizationUpdateInput = {
  /** Automatically import Google Sheet */
  autoImportGoogleSheet?: InputMaybe<Scalars['CastableBoolean']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The time that daily Metric Source imports happen at */
  defaultImportTime?: InputMaybe<Scalars['String']['input']>;
  /** Organization homepage */
  homepageUrl?: InputMaybe<Scalars['String']['input']>;
  /** SSO x.509 IdP Certification */
  idpCert?: InputMaybe<Scalars['String']['input']>;
  /** SSO Entity ID */
  idpEntityId?: InputMaybe<Scalars['String']['input']>;
  /** SSO Service URL */
  idpSsoServiceUrl?: InputMaybe<Scalars['String']['input']>;
  /** SSO Issuer */
  issuer?: InputMaybe<Scalars['String']['input']>;
  /** Logo File Data Hash */
  logo?: InputMaybe<Scalars['JSON']['input']>;
  /** Default metric settings for the organization */
  metricDefaults?: InputMaybe<Scalars['JSON']['input']>;
  /** Organization name */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Organization ID to update */
  organizationId: Scalars['ID']['input'];
  /** SSO Provider Name */
  ssoProvider?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of OrganizationUpdate. */
export type OrganizationUpdatePayload = ClassTypeInterface & {
  __typename?: 'OrganizationUpdatePayload';
  /** The class type of the field */
  classType: Scalars['String']['output'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Array of Errors */
  errors: Array<Error>;
  /** Updated organization */
  organization?: Maybe<Organization>;
};

/** List of possible Period Unit values on Goals */
export enum PeriodUnitEnum {
  /** All - The Goal is for all time */
  All = 'all',
  /** Custom - The Goal is for a custom date range */
  Custom = 'custom',
  /** Month - The Goal is for a specific month */
  Month = 'month',
  /** Quarter - The Goal is for a specific quarter */
  Quarter = 'quarter',
  /** Year - The Goal is for a specific year */
  Year = 'year'
}

/** A pipeline of assistants to run on a chat */
export type Pipeline = ClassTypeInterface & {
  __typename?: 'Pipeline';
  /** All AI Assistant Types  */
  assistants: Array<AiAssistant>;
  /** The class type of the field */
  classType: Scalars['String']['output'];
  /** ID of the pipeline */
  id: Scalars['ID']['output'];
  /** Name of the pipeline */
  name: Scalars['String']['output'];
  /** Slug of the pipeline */
  slug: Scalars['String']['output'];
};

/** Pipeline names enum */
export enum PipelineEnum {
  /** Generate an AI Strategy to understand how to integrate AI into your organization */
  AiStrategy = 'ai_strategy',
  /** Iterate on an organization's business context via chat */
  BusinessContextChat = 'business_context_chat',
  /** Build an organization's business context */
  BusinessContextGenerator = 'business_context_generator',
  /** Generate a Competitive Advantage Flywheel to identify and develop long-term competitive moats */
  CompetitiveAdvantageFlywheel = 'competitive_advantage_flywheel',
  /** Generate a Conversion Funnel Map to analyze and optimize user journey stages */
  ConversionFunnelMap = 'conversion_funnel_map',
  /** Generate reports from an AI prompt  */
  CustomPromptReport = 'custom_prompt_report',
  /** Chat with a data scientist bot */
  DataScientistChat = 'data_scientist_chat',
  /** Generate an eCommerce KPI tree to estimate digital sales impact */
  EcommerceKpiTree = 'ecommerce_kpi_tree',
  /** Chat with and operate on a metric */
  MetricContext = 'metric_context',
  /** Analyze the relationship between metrics using the Metric Relationship Analyzer */
  MetricRelationshipAnalyzer = 'metric_relationship_analyzer',
  /** Generate a North Star Framework map */
  NorthStarFramework = 'north_star_framework',
  /** Generate an OKR map */
  OkrMap = 'okr_map',
  /** Generate a SaaS KPI tree to estimate ARR growth impact */
  SaasKpiTree = 'saas_kpi_tree',
  /** Generate a Software Experience map using Pendo */
  SoftwareExperienceMap = 'software_experience_map'
}

/** Autogenerated input type of PipelineRun */
export type PipelineRunInput = {
  /** ID of the chat to run the pipeline on. If not given, a new chat will be created. */
  chatId?: InputMaybe<Scalars['ID']['input']>;
  /** Object to run the pipeline on */
  chattable: ChattableObjectInput;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** File IDs to attach to the prompt */
  fileIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Pipeline to apply */
  pipelineId: PipelineEnum;
  /** Prompt to start the chat with */
  prompt?: InputMaybe<Scalars['String']['input']>;
  /** Strategy ID to use as context */
  strategyId?: InputMaybe<Scalars['ID']['input']>;
};

/** Autogenerated return type of PipelineRun. */
export type PipelineRunPayload = ClassTypeInterface & {
  __typename?: 'PipelineRunPayload';
  /** Chat created for the pipeline */
  chat?: Maybe<Chat>;
  /** The class type of the field */
  classType: Scalars['String']['output'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Array of Errors */
  errors: Array<Error>;
};

/** Playbook */
export type Playbook = ClassTypeInterface & {
  __typename?: 'Playbook';
  /** AI Builder slug */
  aiBuilderSlug?: Maybe<Scalars['String']['output']>;
  /** Playbook category */
  category?: Maybe<Scalars['String']['output']>;
  /** The class type of the field */
  classType: Scalars['String']['output'];
  /** Object creation date */
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Playbook description */
  description?: Maybe<Scalars['String']['output']>;
  /** Friendly ID for the playbook */
  friendlyId?: Maybe<Scalars['String']['output']>;
  /** Playbook hero image URL */
  hero?: Maybe<Scalars['String']['output']>;
  /** Playbook ID */
  id: Scalars['ID']['output'];
  /** Playbook title */
  name: Scalars['String']['output'];
  /** Playbook creator organization */
  organization?: Maybe<Organization>;
  /** Playbook template */
  playbookTemplate: PlaybookTemplate;
  /** Playbook publication state */
  publicationState: PublicationStateEnum;
  /** Playbook order */
  rowOrder?: Maybe<Scalars['Int']['output']>;
  /** Playbook description */
  shortDescription?: Maybe<Scalars['String']['output']>;
  /** Playbook creator */
  user?: Maybe<User>;
};

/** Autogenerated input type of PlaybookApplyToStrategyWithAi */
export type PlaybookApplyToStrategyWithAiInput = {
  /** Additional instructions for AI generation */
  additionalInstructions?: InputMaybe<Scalars['String']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Playbook ID to apply */
  playbookId: Scalars['ID']['input'];
  /** Strategy ID to update */
  strategyId: Scalars['ID']['input'];
};

/** Autogenerated return type of PlaybookApplyToStrategyWithAi. */
export type PlaybookApplyToStrategyWithAiPayload = ClassTypeInterface & {
  __typename?: 'PlaybookApplyToStrategyWithAiPayload';
  /** Chat created for the AI pipeline */
  chat?: Maybe<Chat>;
  /** The class type of the field */
  classType: Scalars['String']['output'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Array of Errors */
  errors: Array<Error>;
  /** Newly created Strategy */
  strategy?: Maybe<Strategy>;
};

/** Autogenerated input type of PlaybookApplyWithAi */
export type PlaybookApplyWithAiInput = {
  /** Additional instructions for AI generation */
  additionalInstructions?: InputMaybe<Scalars['String']['input']>;
  /** Business context ID to use */
  businessContextId: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Playbook ID to apply */
  playbookId: Scalars['ID']['input'];
};

/** Autogenerated return type of PlaybookApplyWithAi. */
export type PlaybookApplyWithAiPayload = ClassTypeInterface & {
  __typename?: 'PlaybookApplyWithAiPayload';
  /** Chat created for the AI pipeline */
  chat?: Maybe<Chat>;
  /** The class type of the field */
  classType: Scalars['String']['output'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Array of Errors */
  errors: Array<Error>;
  /** Newly created Strategy */
  strategy?: Maybe<Strategy>;
};

/** Autogenerated input type of PlaybookCreateFromStrategy */
export type PlaybookCreateFromStrategyInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** ID of the Strategy that will be dumped into a Playbook */
  strategyId: Scalars['ID']['input'];
};

/** Autogenerated return type of PlaybookCreateFromStrategy. */
export type PlaybookCreateFromStrategyPayload = ClassTypeInterface & {
  __typename?: 'PlaybookCreateFromStrategyPayload';
  /** The class type of the field */
  classType: Scalars['String']['output'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Array of Errors */
  errors: Array<Error>;
  /** Newly created Playbook */
  playbook?: Maybe<Playbook>;
};

/** Autogenerated input type of PlaybookSubmitForReview */
export type PlaybookSubmitForReviewInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** ID of the playbook to submit for review */
  playbookId: Scalars['ID']['input'];
};

/** Autogenerated return type of PlaybookSubmitForReview. */
export type PlaybookSubmitForReviewPayload = ClassTypeInterface & {
  __typename?: 'PlaybookSubmitForReviewPayload';
  /** The class type of the field */
  classType: Scalars['String']['output'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Array of errors */
  errors: Array<Error>;
  /** The updated Playbook */
  playbook?: Maybe<Playbook>;
};

/** Playbook template */
export type PlaybookTemplate = ClassTypeInterface & {
  __typename?: 'PlaybookTemplate';
  /** The class type of the field */
  classType: Scalars['String']['output'];
  /** Playbook template edges */
  edges: Array<Scalars['JSON']['output']>;
  /** Playbook template entities */
  entities: Scalars['JSON']['output'];
  /** Playbook template labels */
  labels: Scalars['JSON']['output'];
  /** Playbook template metrics */
  metrics: Scalars['JSON']['output'];
};

export type PolymorphicChattable = {
  __typename?: 'PolymorphicChattable';
  /** ID of the chattable */
  chattableId: Scalars['ID']['output'];
  /** Type of the chattable */
  chattableType: Scalars['String']['output'];
};

/** Position */
export type PositionInput = {
  /** X Coordinate */
  x: Scalars['Int']['input'];
  /** Y Coordinate */
  y: Scalars['Int']['input'];
};

/** Autogenerated input type of ProductInitiativesSuggest */
export type ProductInitiativesSuggestInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the subject Node */
  nodeId: Scalars['ID']['input'];
};

/** Autogenerated return type of ProductInitiativesSuggest. */
export type ProductInitiativesSuggestPayload = ClassTypeInterface & {
  __typename?: 'ProductInitiativesSuggestPayload';
  /** The class type of the field */
  classType: Scalars['String']['output'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The error, if any, returned by OpenAI */
  error?: Maybe<Scalars['String']['output']>;
  /** The suggestions, returned by OpenAI */
  result?: Maybe<Array<Scalars['String']['output']>>;
};

/** List of Playbook publication states */
export enum PublicationStateEnum {
  /** In review for publication */
  PendingReview = 'pending_review',
  /** Private to the Organization */
  Private = 'private',
  /** Published, and available publicly */
  Published = 'published'
}

/** Master list of queries */
export type Query = ClassTypeInterface & {
  __typename?: 'Query';
  /** All active accounts for an Organization */
  accounts?: Maybe<Array<Account>>;
  /** Get all eval results */
  aiAssistantEvalResults: Array<AiAssistantEvalResult>;
  /** Get the Amplitude event taxonomy for a credential */
  amplitudeEventTaxonomy: Array<AmplitudeEvent>;
  /** Get the event names for an Amplitude metric source */
  amplitudeMetricSourceEventNames?: Maybe<Array<Option>>;
  /** Returns a single Basic Card for an Organization */
  basicCard?: Maybe<BasicCard>;
  /** The upstream Entities of the passed BasicCard */
  basicCardEntities?: Maybe<EntityCollection>;
  /** Basic cards for the current organization */
  basicCards?: Maybe<BasicCardCollection>;
  /** Business context for the organization */
  businessContext?: Maybe<BusinessContext>;
  /** All Business Contexts for the current organization */
  businessContexts?: Maybe<Array<BusinessContext>>;
  /** All Card Types scoped to an Organization */
  cardTypes?: Maybe<Array<CardType>>;
  /** A single chat */
  chat?: Maybe<Chat>;
  /** The class type of the field */
  classType: Scalars['String']['output'];
  /** Look up Contributor by searchable id */
  contributor?: Maybe<Contributor>;
  /** Autocomplete endpoint for Contributors */
  contributorsAutocomplete?: Maybe<Array<Contributor>>;
  /** Get the data for a specific Credential */
  credential?: Maybe<Credential>;
  /** Credentials for an Organization */
  credentials?: Maybe<Array<Credential>>;
  /** Work items for the current organization */
  entities?: Maybe<EntityCollection>;
  /** A single Entity by ID scoped to an Organization ID */
  entity?: Maybe<Entity>;
  /** The contained under an entity */
  entityEntities?: Maybe<EntityCollection>;
  /** Get the event data for the graph */
  eventsGraph?: Maybe<Scalars['JSON']['output']>;
  /** All of the User's Favorites */
  favorites: Array<Favorite>;
  /** Get a single Goal */
  goal?: Maybe<Goal>;
  /** Google Integration */
  googleIntegration?: Maybe<GoogleIntegration>;
  /** A single Google Sheet */
  googleSheet?: Maybe<GoogleSheet>;
  /** Get the Identity ID of a logged-out user */
  identityId?: Maybe<Scalars['ID']['output']>;
  /** Get the impactful events for the graph */
  impactfulEntities?: Maybe<Array<Entity>>;
  /** Return integration for an organization by name */
  integration?: Maybe<IntegrationUnion>;
  /** Return all Integrations for an organization */
  integrations?: Maybe<Array<IntegrationUnion>>;
  /** An unused invitation for an Organization */
  invitation?: Maybe<Invitation>;
  /** All unused invitations for an Organization */
  invitations?: Maybe<Array<Invitation>>;
  /** All labels scoped to an Organization */
  labels?: Maybe<Array<Label>>;
  /** Autocomplete endpoint for Labels */
  labelsAutocomplete?: Maybe<Array<Label>>;
  /** Get the Looker Look fields for the given Credential and Look */
  lookerApiLookFields?: Maybe<Array<Option>>;
  /** Get the Looker Look options for the given Credential */
  lookerApiLooks?: Maybe<Array<Option>>;
  /** All the Looker Dashboards for the current organization */
  lookerDashboards?: Maybe<Array<LookerDashboard>>;
  /** Get the currently logged-in user */
  me?: Maybe<User>;
  /** Autocomplete endpoint for Members */
  membersAutocomplete?: Maybe<Array<User>>;
  /** Get the metrics data for a specific metric */
  metric?: Maybe<Metric>;
  /** A single metric data point */
  metricDataPoint?: Maybe<MetricDataPoint>;
  /** The metric data points for a specific metric */
  metricDataPoints?: Maybe<MetricDataPointCollection>;
  /** The entities for all of the passed Metric */
  metricEntities?: Maybe<EntityCollection>;
  /** Get all upstream events data for a metric graph */
  metricEventsGraph?: Maybe<Scalars['JSON']['output']>;
  /** A single MetricSource */
  metricSource?: Maybe<MetricSource>;
  /** MetricSourceActivities for the selected metric */
  metricSourceActivities?: Maybe<MetricSourceActivityCollection>;
  /** A single MetricSourceActivity */
  metricSourceActivity?: Maybe<MetricSourceActivity>;
  /** All the MetricSources for the current Organization */
  metricSources?: Maybe<Array<MetricSource>>;
  /** Metrics for the current organization */
  metrics?: Maybe<MetricCollection>;
  /** Autocomplete endpoint for Metrics */
  metricsAutocomplete?: Maybe<Array<Metric>>;
  /** Organization for current user */
  organization?: Maybe<Organization>;
  /** All organizations (super-admin only) */
  organizations?: Maybe<Array<Organization>>;
  /** A single pipeline with its assistants */
  pipeline?: Maybe<Pipeline>;
  /** A single Playbook */
  playbook?: Maybe<Playbook>;
  /** All Playbooks scoped to the user's Organization */
  playbooks: Array<Playbook>;
  /** A single RecurringReportConfiguration */
  recurringReportConfiguration?: Maybe<RecurringReportConfiguration>;
  /** All recurring report configurations scoped to an strategy */
  recurringReportConfigurations?: Maybe<RecurringReportConfigurationCollection>;
  /** A single report */
  report?: Maybe<Report>;
  /** All reports scoped to an strategy */
  reports?: Maybe<ReportCollection>;
  /** Get the sampled metric data points */
  sampledMetricDataPoints?: Maybe<Array<MetricDataPoint>>;
  /** All active Slack channels for the current organization */
  slackChannels?: Maybe<Array<SlackChannel>>;
  /** Autocomplete endpoint for Slack Channels */
  slackChannelsAutocomplete?: Maybe<Array<SlackChannel>>;
  /** All sources for the current organization */
  sources?: Maybe<Sources>;
  /** Organization strategies */
  strategies?: Maybe<StrategyCollection>;
  /** A single organization strategy */
  strategy?: Maybe<Strategy>;
  /** The changelog for a specific strategy */
  strategyChangelog?: Maybe<EntityCollection>;
  /** An entity on the strategy specific changelog */
  strategyChangelogEntity?: Maybe<Entity>;
  /** All credentials accessible to super admins */
  superAdminCredentials?: Maybe<Array<SuperAdminCredential>>;
  /** Tasks for the current organization */
  tasks?: Maybe<TaskCollection>;
  /** Accounts for the current user */
  userAccounts?: Maybe<Array<Account>>;
};


/** Master list of queries */
export type QueryAccountsArgs = {
  includeDisabled?: InputMaybe<Scalars['CastableBoolean']['input']>;
};


/** Master list of queries */
export type QueryAiAssistantEvalResultsArgs = {
  states?: InputMaybe<Array<Scalars['String']['input']>>;
};


/** Master list of queries */
export type QueryAmplitudeEventTaxonomyArgs = {
  credentialId: Scalars['ID']['input'];
};


/** Master list of queries */
export type QueryAmplitudeMetricSourceEventNamesArgs = {
  credentialId: Scalars['ID']['input'];
};


/** Master list of queries */
export type QueryBasicCardArgs = {
  id: Scalars['ID']['input'];
};


/** Master list of queries */
export type QueryBasicCardEntitiesArgs = {
  basicCardId: Scalars['ID']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  workflowState?: InputMaybe<EntityWorkflowStateEnum>;
};


/** Master list of queries */
export type QueryBasicCardsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<BasicCardOrderingInput>;
  page?: InputMaybe<Scalars['Int']['input']>;
  strategyId?: InputMaybe<Scalars['ID']['input']>;
};


/** Master list of queries */
export type QueryBusinessContextArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


/** Master list of queries */
export type QueryBusinessContextsArgs = {
  parentBusinessContextId?: InputMaybe<Scalars['ID']['input']>;
};


/** Master list of queries */
export type QueryChatArgs = {
  id: Scalars['ID']['input'];
};


/** Master list of queries */
export type QueryContributorArgs = {
  id: Scalars['String']['input'];
};


/** Master list of queries */
export type QueryContributorsAutocompleteArgs = {
  query: Scalars['String']['input'];
  requireEmail?: InputMaybe<Scalars['CastableBoolean']['input']>;
};


/** Master list of queries */
export type QueryCredentialArgs = {
  id: Scalars['ID']['input'];
};


/** Master list of queries */
export type QueryCredentialsArgs = {
  sourceName?: InputMaybe<Scalars['String']['input']>;
};


/** Master list of queries */
export type QueryEntitiesArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<EntityOrderingInput>;
  page?: InputMaybe<Scalars['Int']['input']>;
  strategyId?: InputMaybe<Scalars['ID']['input']>;
};


/** Master list of queries */
export type QueryEntityArgs = {
  id: Scalars['ID']['input'];
};


/** Master list of queries */
export type QueryEntityEntitiesArgs = {
  entityId: Scalars['ID']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  workflowState?: InputMaybe<EntityWorkflowStateEnum>;
};


/** Master list of queries */
export type QueryEventsGraphArgs = {
  filters?: InputMaybe<Scalars['JSON']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
};


/** Master list of queries */
export type QueryGoalArgs = {
  id: Scalars['ID']['input'];
};


/** Master list of queries */
export type QueryGoogleSheetArgs = {
  id: Scalars['ID']['input'];
};


/** Master list of queries */
export type QueryImpactfulEntitiesArgs = {
  filters?: InputMaybe<Scalars['JSON']['input']>;
  metricId: Scalars['ID']['input'];
};


/** Master list of queries */
export type QueryIntegrationArgs = {
  sourceName: Scalars['String']['input'];
};


/** Master list of queries */
export type QueryInvitationArgs = {
  inviteCode: Scalars['String']['input'];
};


/** Master list of queries */
export type QueryLabelsAutocompleteArgs = {
  query: Scalars['String']['input'];
};


/** Master list of queries */
export type QueryLookerApiLookFieldsArgs = {
  credentialId: Scalars['ID']['input'];
  lookId: Scalars['ID']['input'];
};


/** Master list of queries */
export type QueryLookerApiLooksArgs = {
  credentialId: Scalars['ID']['input'];
};


/** Master list of queries */
export type QueryMembersAutocompleteArgs = {
  query: Scalars['String']['input'];
};


/** Master list of queries */
export type QueryMetricArgs = {
  id: Scalars['ID']['input'];
};


/** Master list of queries */
export type QueryMetricDataPointArgs = {
  metricDataPointId: Scalars['ID']['input'];
};


/** Master list of queries */
export type QueryMetricDataPointsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  metricId: Scalars['ID']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  strategyId?: InputMaybe<Scalars['ID']['input']>;
};


/** Master list of queries */
export type QueryMetricEntitiesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  metricId: Scalars['ID']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  workflowState?: InputMaybe<EntityWorkflowStateEnum>;
};


/** Master list of queries */
export type QueryMetricEventsGraphArgs = {
  filters?: InputMaybe<Scalars['JSON']['input']>;
  metricId: Scalars['ID']['input'];
};


/** Master list of queries */
export type QueryMetricSourceArgs = {
  metricId: Scalars['ID']['input'];
};


/** Master list of queries */
export type QueryMetricSourceActivitiesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  metricSourceId: Scalars['ID']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
};


/** Master list of queries */
export type QueryMetricSourceActivityArgs = {
  id: Scalars['ID']['input'];
};


/** Master list of queries */
export type QueryMetricsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<MetricOrderingInput>;
  page?: InputMaybe<Scalars['Int']['input']>;
  strategyId?: InputMaybe<Scalars['ID']['input']>;
  unsourced?: InputMaybe<Scalars['CastableBoolean']['input']>;
};


/** Master list of queries */
export type QueryMetricsAutocompleteArgs = {
  query: Scalars['String']['input'];
  strategyId?: InputMaybe<Scalars['ID']['input']>;
};


/** Master list of queries */
export type QueryPipelineArgs = {
  id: PipelineEnum;
};


/** Master list of queries */
export type QueryPlaybookArgs = {
  id: Scalars['ID']['input'];
};


/** Master list of queries */
export type QueryPlaybooksArgs = {
  aiOnly?: InputMaybe<Scalars['CastableBoolean']['input']>;
};


/** Master list of queries */
export type QueryRecurringReportConfigurationArgs = {
  id: Scalars['ID']['input'];
};


/** Master list of queries */
export type QueryRecurringReportConfigurationsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  service?: InputMaybe<RecurringReportConfigurationServiceEnum>;
  strategyId: Scalars['ID']['input'];
};


/** Master list of queries */
export type QueryReportArgs = {
  id: Scalars['ID']['input'];
};


/** Master list of queries */
export type QueryReportsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  strategyId: Scalars['ID']['input'];
};


/** Master list of queries */
export type QuerySampledMetricDataPointsArgs = {
  metricId: Scalars['ID']['input'];
  strategyId?: InputMaybe<Scalars['ID']['input']>;
};


/** Master list of queries */
export type QuerySlackChannelsAutocompleteArgs = {
  query: Scalars['String']['input'];
};


/** Master list of queries */
export type QueryStrategiesArgs = {
  businessContextId?: InputMaybe<Scalars['ID']['input']>;
  filter?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<StrategyOrderingInput>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


/** Master list of queries */
export type QueryStrategyArgs = {
  id: Scalars['ID']['input'];
  loadAsAnonymous?: InputMaybe<Scalars['CastableBoolean']['input']>;
};


/** Master list of queries */
export type QueryStrategyChangelogArgs = {
  containerNodeIds?: InputMaybe<Scalars['CommaSeparatedString']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  loadAsAnonymous?: InputMaybe<Scalars['CastableBoolean']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  strategyId: Scalars['ID']['input'];
};


/** Master list of queries */
export type QueryStrategyChangelogEntityArgs = {
  id: Scalars['ID']['input'];
  strategyId: Scalars['ID']['input'];
};


/** Master list of queries */
export type QuerySuperAdminCredentialsArgs = {
  sourceName?: InputMaybe<Scalars['String']['input']>;
};


/** Master list of queries */
export type QueryTasksArgs = {
  domainObjectId?: InputMaybe<Scalars['ID']['input']>;
  domainObjectType?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};

/** Recurring Report Configurations */
export type RecurringReportConfiguration = ClassTypeInterface & {
  __typename?: 'RecurringReportConfiguration';
  /** AI Prompt to use for report */
  aiPrompt?: Maybe<Scalars['String']['output']>;
  /** Result of the AI Prompt test */
  aiPromptTestResult?: Maybe<Scalars['String']['output']>;
  /** The class type of the field */
  classType: Scalars['String']['output'];
  /** Object creation date */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** Emails to send reports to */
  emails: Scalars['String']['output'];
  /** Object unique ID */
  id: Scalars['ID']['output'];
  /** Name of report */
  name?: Maybe<Scalars['String']['output']>;
  /** Position of the report on the dashboard */
  position?: Maybe<Scalars['Int']['output']>;
  /** Reports associated with this configuration */
  reports: Array<Report>;
  /** The recurrence rule for creation of new Reports */
  schedule?: Maybe<Schedule>;
  /** Send reports to email? */
  sendToEmail: Scalars['Boolean']['output'];
  /** Send reports to slack? */
  sendToSlack: Scalars['Boolean']['output'];
  /** Service to run */
  service: RecurringReportConfigurationServiceEnum;
  /** Slack Channel ID to send reports to */
  slackChannel?: Maybe<SlackChannel>;
  /** Slack Channel ID to send reports to */
  slackChannelId?: Maybe<Scalars['ID']['output']>;
  /** Associated Strategy */
  strategy: Strategy;
  /** Associated Strategy ID. Used for filtering the store in the frontend. */
  strategyId: Scalars['ID']['output'];
  /** Object last updated date */
  updatedAt: Scalars['ISO8601DateTime']['output'];
};


/** Recurring Report Configurations */
export type RecurringReportConfigurationReportsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
};

/** RecurringReportConfigurationCollection type */
export type RecurringReportConfigurationCollection = {
  __typename?: 'RecurringReportConfigurationCollection';
  /** A collection of paginated RecurringReportConfigurationCollection */
  collection: Array<RecurringReportConfiguration>;
  /** Pagination Metadata for navigating the Pagination */
  metadata: CollectionMetadata;
};

/** Input Type for RecurringReportConfiguration */
export type RecurringReportConfigurationCreateInput = {
  /** AI Prompt to use for report */
  aiPrompt?: InputMaybe<Scalars['String']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Comma-separated list of emails to send reports to */
  emails?: InputMaybe<Scalars['String']['input']>;
  /** ID of the report */
  id?: InputMaybe<Scalars['ID']['input']>;
  /** Name that will be given to created reports */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Position of the report on the dashboard */
  position?: InputMaybe<Scalars['Int']['input']>;
  /** RRule schedule for reports to be created */
  schedule?: InputMaybe<Scalars['String']['input']>;
  /** Send report to email? */
  sendToEmail?: InputMaybe<Scalars['CastableBoolean']['input']>;
  /** Send report to slack? */
  sendToSlack?: InputMaybe<Scalars['CastableBoolean']['input']>;
  /** Service to run */
  service?: InputMaybe<RecurringReportConfigurationServiceEnum>;
  /** Slack Channel to send to */
  slackChannelId?: InputMaybe<Scalars['ID']['input']>;
  /** Strategy ID */
  strategyId: Scalars['ID']['input'];
};

/** Autogenerated return type of RecurringReportConfigurationCreate. */
export type RecurringReportConfigurationCreatePayload = ClassTypeInterface & {
  __typename?: 'RecurringReportConfigurationCreatePayload';
  /** The class type of the field */
  classType: Scalars['String']['output'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Array of Errors */
  errors: Array<Error>;
  /** Updated RecurringReportConfiguration */
  recurringReportConfiguration?: Maybe<RecurringReportConfiguration>;
};

/** Autogenerated input type of RecurringReportConfigurationDelete */
export type RecurringReportConfigurationDeleteInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** RecurringReportConfiguration ID to delete */
  recurringReportConfigurationId: Scalars['ID']['input'];
};

/** Autogenerated return type of RecurringReportConfigurationDelete. */
export type RecurringReportConfigurationDeletePayload = ClassTypeInterface & {
  __typename?: 'RecurringReportConfigurationDeletePayload';
  /** The class type of the field */
  classType: Scalars['String']['output'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** CRUD operation wrapper */
  crudOperation: TypesRecurringReportConfigurationTypeGraphqlCrudOperation;
  /** Array of Errors */
  errors: Array<Error>;
};

/** Input Type for RecurringReportConfiguration */
export type RecurringReportConfigurationInput = {
  /** AI Prompt to use for report */
  aiPrompt?: InputMaybe<Scalars['String']['input']>;
  /** Comma-separated list of emails to send reports to */
  emails?: InputMaybe<Scalars['String']['input']>;
  /** ID of the report */
  id?: InputMaybe<Scalars['ID']['input']>;
  /** Name that will be given to created reports */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Position of the report on the dashboard */
  position?: InputMaybe<Scalars['Int']['input']>;
  /** RRule schedule for reports to be created */
  schedule?: InputMaybe<Scalars['String']['input']>;
  /** Send report to email? */
  sendToEmail?: InputMaybe<Scalars['CastableBoolean']['input']>;
  /** Send report to slack? */
  sendToSlack?: InputMaybe<Scalars['CastableBoolean']['input']>;
  /** Service to run */
  service?: InputMaybe<RecurringReportConfigurationServiceEnum>;
  /** Slack Channel to send to */
  slackChannelId?: InputMaybe<Scalars['ID']['input']>;
};

/** Autogenerated input type of RecurringReportConfigurationPromptTest */
export type RecurringReportConfigurationPromptTestInput = {
  /** AI Prompt to use for report */
  aiPrompt: Scalars['String']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Account to switch to */
  recurringReportConfigurationId: Scalars['ID']['input'];
};

/** Autogenerated return type of RecurringReportConfigurationPromptTest. */
export type RecurringReportConfigurationPromptTestPayload = ClassTypeInterface & {
  __typename?: 'RecurringReportConfigurationPromptTestPayload';
  /** Chat created for the pipeline */
  chat?: Maybe<Chat>;
  /** The class type of the field */
  classType: Scalars['String']['output'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Recurring report configuration */
  recurringReportConfiguration: RecurringReportConfiguration;
};

/** Autogenerated input type of RecurringReportConfigurationRun */
export type RecurringReportConfigurationRunInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Strategy ID */
  recurringReportConfigurationId: Scalars['ID']['input'];
};

/** Autogenerated return type of RecurringReportConfigurationRun. */
export type RecurringReportConfigurationRunPayload = ClassTypeInterface & {
  __typename?: 'RecurringReportConfigurationRunPayload';
  /** The class type of the field */
  classType: Scalars['String']['output'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Updated RecurringReportConfiguration */
  recurringReportConfiguration?: Maybe<RecurringReportConfiguration>;
};

/** Service to run */
export enum RecurringReportConfigurationServiceEnum {
  /** Emit Report */
  EmitReport = 'emit_report',
  /** Send Changelog */
  SendChangelog = 'send_changelog',
  /** Send Goals */
  SendGoals = 'send_goals'
}

/** Input Type for RecurringReportConfiguration */
export type RecurringReportConfigurationUpdateInput = {
  /** AI Prompt to use for report */
  aiPrompt?: InputMaybe<Scalars['String']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Comma-separated list of emails to send reports to */
  emails?: InputMaybe<Scalars['String']['input']>;
  /** ID of the report */
  id?: InputMaybe<Scalars['ID']['input']>;
  /** Name that will be given to created reports */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Position of the report on the dashboard */
  position?: InputMaybe<Scalars['Int']['input']>;
  /** Strategy ID */
  recurringReportConfigurationId: Scalars['ID']['input'];
  /** RRule schedule for reports to be created */
  schedule?: InputMaybe<Scalars['String']['input']>;
  /** Send report to email? */
  sendToEmail?: InputMaybe<Scalars['CastableBoolean']['input']>;
  /** Send report to slack? */
  sendToSlack?: InputMaybe<Scalars['CastableBoolean']['input']>;
  /** Service to run */
  service?: InputMaybe<RecurringReportConfigurationServiceEnum>;
  /** Slack Channel to send to */
  slackChannelId?: InputMaybe<Scalars['ID']['input']>;
};

/** Autogenerated return type of RecurringReportConfigurationUpdate. */
export type RecurringReportConfigurationUpdatePayload = ClassTypeInterface & {
  __typename?: 'RecurringReportConfigurationUpdatePayload';
  /** The class type of the field */
  classType: Scalars['String']['output'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Array of Errors */
  errors: Array<Error>;
  /** Updated RecurringReportConfiguration */
  recurringReportConfiguration?: Maybe<RecurringReportConfiguration>;
};

/** Report */
export type Report = ClassTypeInterface & RfNodeInterface & {
  __typename?: 'Report';
  /** The class type of the field */
  classType: Scalars['String']['output'];
  /** Object creation date */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** Emails to send report to */
  emails: Scalars['String']['output'];
  /** Report period end date */
  endDate?: Maybe<Scalars['ISO8601Date']['output']>;
  /** Object unique ID */
  id: Scalars['ID']['output'];
  /** Name of report */
  name?: Maybe<Scalars['String']['output']>;
  /** Recurring Report Configuration ID */
  recurringReportConfigurationId?: Maybe<Scalars['ID']['output']>;
  /** Strategy node id */
  rfId: Scalars['String']['output'];
  /** Send report to email? */
  sendToEmail: Scalars['Boolean']['output'];
  /** Send report to slack? */
  sendToSlack: Scalars['Boolean']['output'];
  /** Slack Channel attached to this Strategy */
  slackChannel?: Maybe<SlackChannel>;
  /** Slack Channel ID attached to this Strategy */
  slackChannelId?: Maybe<Scalars['ID']['output']>;
  /** Report period start date */
  startDate?: Maybe<Scalars['ISO8601Date']['output']>;
  /** Associated Strategy */
  strategy: Strategy;
  /** Strategy ID without going through join record */
  strategyId: Scalars['ID']['output'];
  /** Report summary */
  summary?: Maybe<Scalars['String']['output']>;
  /** Object last updated date */
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** ReportCollection type */
export type ReportCollection = {
  __typename?: 'ReportCollection';
  /** A collection of paginated ReportCollection */
  collection: Array<Report>;
  /** Pagination Metadata for navigating the Pagination */
  metadata: CollectionMetadata;
};

/** Autogenerated input type of ReportCreate */
export type ReportCreateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Report end date */
  endDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  /** Report name */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Report start date */
  startDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  /** Strategy ID */
  strategyId?: InputMaybe<Scalars['ID']['input']>;
};

/** Autogenerated return type of ReportCreate. */
export type ReportCreatePayload = ClassTypeInterface & {
  __typename?: 'ReportCreatePayload';
  /** The class type of the field */
  classType: Scalars['String']['output'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Array of Errors */
  errors: Array<Error>;
  /** Updated Report */
  report?: Maybe<Report>;
};

/** Input Type for Report */
export type ReportInput = {
  /** Emails to send report to */
  emails?: InputMaybe<Scalars['String']['input']>;
  /** Report end date */
  endDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  /** Report ID */
  id?: InputMaybe<Scalars['ID']['input']>;
  /** Report name */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Send report to email? */
  sendToEmail?: InputMaybe<Scalars['CastableBoolean']['input']>;
  /** Send report to slack? */
  sendToSlack?: InputMaybe<Scalars['CastableBoolean']['input']>;
  /** Strategy Slack Channel */
  slackChannelId?: InputMaybe<Scalars['ID']['input']>;
  /** Report start date */
  startDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  /** Report text summary */
  summary?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated input type of ReportSend */
export type ReportSendInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Report ID to update */
  reportId: Scalars['ID']['input'];
};

/** Autogenerated return type of ReportSend. */
export type ReportSendPayload = ClassTypeInterface & {
  __typename?: 'ReportSendPayload';
  /** The class type of the field */
  classType: Scalars['String']['output'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Array of Errors */
  errors: Array<Error>;
  /** Updated Report */
  report?: Maybe<Report>;
};

/** Autogenerated input type of ReportUpdate */
export type ReportUpdateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Emails to send report to */
  emails?: InputMaybe<Scalars['String']['input']>;
  /** Report end date */
  endDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  /** Report name */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Report ID to update */
  reportId: Scalars['ID']['input'];
  /** Send report to email? */
  sendToEmail?: InputMaybe<Scalars['CastableBoolean']['input']>;
  /** Send report to slack? */
  sendToSlack?: InputMaybe<Scalars['CastableBoolean']['input']>;
  /** Strategy Slack Channel */
  slackChannelId?: InputMaybe<Scalars['ID']['input']>;
  /** Report start date */
  startDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
};

/** Autogenerated return type of ReportUpdate. */
export type ReportUpdatePayload = ClassTypeInterface & {
  __typename?: 'ReportUpdatePayload';
  /** The class type of the field */
  classType: Scalars['String']['output'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Array of Errors */
  errors: Array<Error>;
  /** Updated Report */
  report?: Maybe<Report>;
};

/** An object that can be included as a React Flow node on a Strategy Map */
export type RfNodeInterface = {
  /** Strategy node id */
  rfId: Scalars['String']['output'];
};

/** List of possible Role values on User */
export enum RoleEnum {
  /** Admin - The User can make changes and manage integrations */
  Admin = 'admin',
  /** Editor - The User can make changes */
  Editor = 'editor',
  /** Viewer - The User can view but not make changes */
  Viewer = 'viewer'
}

/** List of possible Roll Up values on Metric */
export enum RollUpEnum {
  /** Average */
  Average = 'average',
  /** Amount Increased */
  Increase = 'increase',
  /** Sum */
  Sum = 'sum'
}

/** Schedulable types */
export enum SchedulableTypeEnum {
  /** Organization */
  Organization = 'Organization',
  /** RecurringReportConfiguration */
  RecurringReportConfiguration = 'RecurringReportConfiguration'
}

/** Schedule */
export type Schedule = ClassTypeInterface & {
  __typename?: 'Schedule';
  /** The class type of the field */
  classType: Scalars['String']['output'];
  /** Cron string for cron schedules */
  cron?: Maybe<Scalars['String']['output']>;
  /** Human-readable description of the schedule */
  humanized: Scalars['String']['output'];
  /** Comment ID */
  id: Scalars['ID']['output'];
  /** RRule string for rrule schedules */
  rrule?: Maybe<Scalars['String']['output']>;
  /** Schedulable ID */
  schedulableId: Scalars['ID']['output'];
  /** Schedulable type */
  schedulableType: Scalars['String']['output'];
};

/** Input Type for Schedules */
export type ScheduleInput = {
  /** Cron schedule */
  cron?: InputMaybe<Scalars['String']['input']>;
  /** Schedule ID */
  id?: InputMaybe<Scalars['ID']['input']>;
  /** Schedule name */
  name?: InputMaybe<Scalars['String']['input']>;
  /** RRule schedule */
  rrule?: InputMaybe<Scalars['String']['input']>;
  /** Schedulable ID */
  schedulableId?: InputMaybe<Scalars['ID']['input']>;
  /** Schedulable type */
  schedulableType?: InputMaybe<SchedulableTypeEnum>;
};

/** Section */
export type Section = ClassTypeInterface & RfNodeInterface & {
  __typename?: 'Section';
  /** The class type of the field */
  classType: Scalars['String']['output'];
  /** Object creation date */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** Object unique ID */
  id: Scalars['ID']['output'];
  /** Label name */
  name?: Maybe<Scalars['String']['output']>;
  /** Strategy node id */
  rfId: Scalars['String']['output'];
  /** Object last updated date */
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** Input Type for Section */
export type SectionInput = {
  /** Section ID */
  id?: InputMaybe<Scalars['ID']['input']>;
  /** The name of the section */
  name?: InputMaybe<Scalars['String']['input']>;
};

/** Segment filters */
export type SegmentFilter = ClassTypeInterface & {
  __typename?: 'SegmentFilter';
  /** The class type of the field */
  classType: Scalars['String']['output'];
  /** Segment Filter ID */
  id: Scalars['ID']['output'];
  /** Name / Category / key of this filter */
  segmentName: SegmentName;
  /** Value of this filter */
  segmentValue: SegmentValue;
};

/** Objects which may have Segment Filters attached to them */
export type SegmentFilterableInterface = {
  /** The ID of the filterable */
  filterableId: Scalars['ID']['output'];
};

/** Autogenerated input type of SegmentFiltersUpdate */
export type SegmentFiltersUpdateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** ID of the filterable to modify Segment Filters for */
  filterableId: Scalars['ID']['input'];
  /** Type of the filterable to modify Segment Filters for */
  filterableType: Scalars['String']['input'];
  /** IDs of the Segment Filters to delete */
  segmentFilterIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** IDs of the Segment Values to filter on (for creation) */
  segmentValueIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/** Autogenerated return type of SegmentFiltersUpdate. */
export type SegmentFiltersUpdatePayload = ClassTypeInterface & {
  __typename?: 'SegmentFiltersUpdatePayload';
  /** The class type of the field */
  classType: Scalars['String']['output'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Array of Errors */
  errors: Array<Error>;
  /** Filterable object */
  filterable: SegmentFilterableInterface;
  /** Modified Segment Filters */
  segmentFilters: Array<SegmentFilter>;
};

/** Segment names / categories / keys */
export type SegmentName = ClassTypeInterface & {
  __typename?: 'SegmentName';
  /** The class type of the field */
  classType: Scalars['String']['output'];
  /** Segment name ID */
  id: Scalars['ID']['output'];
  /** Name / Category / key */
  name: Scalars['String']['output'];
  /** The Organization */
  organization: Organization;
  /** Values in this category */
  segmentValues: Array<SegmentValue>;
};

/** Segment values (note that this does not include the key / category) */
export type SegmentValue = ClassTypeInterface & {
  __typename?: 'SegmentValue';
  /** The class type of the field */
  classType: Scalars['String']['output'];
  /** Segment name ID */
  id: Scalars['ID']['output'];
  /** Filters that use this value */
  segmentFilters: Array<SegmentFilter>;
  /** My segment category */
  segmentName: SegmentName;
  /** The actual value */
  value: Scalars['String']['output'];
};

/** List of possible segmented data types (i.e. date de-duplicating operations) */
export enum SegmentedDataTypeEnum {
  /** Average */
  Average = 'average',
  /** Sum */
  Sum = 'sum'
}

/** Sharing possible values */
export enum SharingTypesEnum {
  /** Private Access  - Only logged in users can access */
  PrivateAccess = 'private_access',
  /** Public Access - Any user can access */
  PublicAccess = 'public_access',
  /** Token Access - Any user with a the token can access */
  TokenAccess = 'token_access'
}

/** Input Type for Shrine Uploads */
export type ShrineInput = {
  /** The id of the file */
  id: Scalars['String']['input'];
  /** The metadata of the file */
  metadata: ShrineMetadataInput;
  /** The storage of the file */
  storage: Scalars['String']['input'];
};

/** Input Type for Shrine Metadata */
export type ShrineMetadataInput = {
  /** The name of the file */
  filename: Scalars['String']['input'];
  /** The height of the file */
  height?: InputMaybe<Scalars['Int']['input']>;
  /** The mime-type of the file */
  mimeType: Scalars['String']['input'];
  /** The size of the file */
  size: Scalars['Int']['input'];
  /** The width of the file */
  width?: InputMaybe<Scalars['Int']['input']>;
};

/** Sources of simulation baseline data */
export enum SimulationBaselineSourceEnum {
  /** via AI prompt */
  Ai = 'ai',
  /** via the metric's existing historical data */
  History = 'history'
}

/** The time base that the range is taken from */
export enum SimulationBaselineTimeBaseEnum {
  /** use the most recent interval */
  MostRecent = 'most_recent',
  /** start from a year previous to the current date */
  PreviousYear = 'previous_year'
}

/** Partial Simulator Result */
export type SimulatorPartialResult = ClassTypeInterface & {
  __typename?: 'SimulatorPartialResult';
  /** The class type of the field */
  classType: Scalars['String']['output'];
  /** Delta R of the partial result */
  deltaR?: Maybe<Scalars['Float']['output']>;
  /** Name of the affected metric (note this is NOT the metric this data belongs to) */
  name: Scalars['String']['output'];
  /** Node ID */
  nodeId: Scalars['ID']['output'];
  /** Node React Flow ID */
  nodeRfId: Scalars['ID']['output'];
  /** Percent R of the partial result */
  percentR?: Maybe<Scalars['Float']['output']>;
};

/** A single slack channel */
export type SlackChannel = ClassTypeInterface & {
  __typename?: 'SlackChannel';
  /** Slack channel id */
  channelId: Scalars['String']['output'];
  /** The class type of the field */
  classType: Scalars['String']['output'];
  /** Object creation date */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** Creator ID */
  creatorId?: Maybe<Scalars['String']['output']>;
  /** Object unique ID */
  id: Scalars['ID']['output'];
  /** True if the channel is archived */
  isArchived?: Maybe<Scalars['Boolean']['output']>;
  /** True if the object is a channel */
  isChannel?: Maybe<Scalars['Boolean']['output']>;
  /** True if externally shared */
  isExtShared?: Maybe<Scalars['Boolean']['output']>;
  /** True if it is the general channel */
  isGeneral?: Maybe<Scalars['Boolean']['output']>;
  /** True if it is a group channel */
  isGroup?: Maybe<Scalars['Boolean']['output']>;
  /** True if it is a direct message */
  isIm?: Maybe<Scalars['Boolean']['output']>;
  /** True if it is a member message */
  isMember?: Maybe<Scalars['Boolean']['output']>;
  /** True if the organization is shared */
  isOrgShared?: Maybe<Scalars['Boolean']['output']>;
  /** True if the channel is private */
  isPrivate?: Maybe<Scalars['Boolean']['output']>;
  /** Slack channel label */
  label: Scalars['String']['output'];
  /** Slack channel name */
  name: Scalars['String']['output'];
  /** Slack channel name normalized */
  nameNormalized: Scalars['String']['output'];
  /** Slack channel member count */
  numMembers?: Maybe<Scalars['Int']['output']>;
  /** Associated Organization */
  organization: Organization;
  /** Slack channel purpose */
  purpose?: Maybe<Scalars['JSON']['output']>;
  /** Slack channel topic */
  topic?: Maybe<Scalars['JSON']['output']>;
  /** Slack channel type */
  type: Scalars['String']['output'];
  /** Object last updated date */
  updatedAt: Scalars['ISO8601DateTime']['output'];
  /** Slack channel value */
  value: Scalars['ID']['output'];
};

/** Direction to sort a list of items */
export enum SortDirectionEnum {
  /** Sort in ascending order */
  Asc = 'asc',
  /** Sort in descending order */
  Desc = 'desc'
}

/** A single SourceIdentity object */
export type SourceIdentity = ClassTypeInterface & {
  __typename?: 'SourceIdentity';
  /** The class type of the field */
  classType: Scalars['String']['output'];
  /** Object creation date */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** Source user email address for lookup */
  email?: Maybe<Scalars['String']['output']>;
  /** ID of object */
  id: Scalars['ID']['output'];
  /** Name of source identity */
  name: Scalars['String']['output'];
  /** Associated Organization */
  organization: Organization;
  /** Associated user if present */
  searchableContributorId?: Maybe<Scalars['String']['output']>;
  /** ID in 3rd party service of user ID */
  sourceId?: Maybe<Scalars['String']['output']>;
  /** Name of 3rd party service user was discovered at */
  sourceName: Scalars['String']['output'];
  /** Object last updated date */
  updatedAt: Scalars['ISO8601DateTime']['output'];
  /** Associated user */
  user?: Maybe<User>;
};

/** Collection of Sources */
export type Sources = ClassTypeInterface & {
  __typename?: 'Sources';
  /** The class type of the field */
  classType: Scalars['String']['output'];
  /** List of Entity sources on the Organization */
  entity?: Maybe<Array<Integration>>;
  /** List of Metric sources on the Organization */
  metric?: Maybe<Array<MetricSource>>;
};

/** List of stat display types */
export enum StatDisplayEnum {
  /** Charts */
  Charts = 'charts',
  /** Stats */
  Stats = 'stats'
}

/** Autogenerated input type of StrategiesBulkReassignBusinessContext */
export type StrategiesBulkReassignBusinessContextInput = {
  /** The business context to assign to the strategies */
  businessContextId: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The strategies to assign the business context to */
  strategyIds: Array<Scalars['ID']['input']>;
};

/** Autogenerated return type of StrategiesBulkReassignBusinessContext. */
export type StrategiesBulkReassignBusinessContextPayload = ClassTypeInterface & {
  __typename?: 'StrategiesBulkReassignBusinessContextPayload';
  /** The class type of the field */
  classType: Scalars['String']['output'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Array of Errors */
  errors: Array<Error>;
  /** Strategies with updated business context */
  strategies?: Maybe<Array<Strategy>>;
};

/** Strategy */
export type Strategy = ClassTypeInterface & CommentableInterface & DomainObjectInterface & FavoritableInterface & RfNodeInterface & SegmentFilterableInterface & {
  __typename?: 'Strategy';
  /** AI Context, passed to AI pipelines */
  aiContext?: Maybe<Scalars['String']['output']>;
  /** AI Context Files */
  aiContextVectorStoreFiles?: Maybe<Array<AiAssistantFile>>;
  /**
   * AI Conversation
   * @deprecated Uses of this should eventually use chats instead.
   */
  aiConversation?: Maybe<AiConversation>;
  /** Whether a change to the map is running in the background */
  backgroundChangeInProgress: Scalars['Boolean']['output'];
  /** The upstream entities for all of the passed Basic Cards */
  basicCardEntities?: Maybe<EntityCollection>;
  /** Associated Basic Cards */
  basicCards?: Maybe<Array<BasicCard>>;
  /** Business Context */
  businessContext?: Maybe<BusinessContext>;
  /** Business Context ID */
  businessContextId?: Maybe<Scalars['ID']['output']>;
  /** The class type of the field */
  classType: Scalars['String']['output'];
  /** Comments for the Comment Thread */
  commentThreadComments?: Maybe<Array<Comment>>;
  /** Associated Comment Threads */
  commentThreads?: Maybe<Array<CommentThread>>;
  /** Comments left on the object */
  comments?: Maybe<Array<Comment>>;
  /** Number of comments left on the object */
  commentsCount: Scalars['Int']['output'];
  /** Confidence rating of the object */
  confidenceRating?: Maybe<ConfidenceRatingEnum>;
  /** True if the Strategy is connected to a Slack Channel */
  connected: Scalars['Boolean']['output'];
  /** IDs of Strategies contained by this Strategy */
  containeeIds?: Maybe<Array<Scalars['ID']['output']>>;
  /** Object creation date */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** Description */
  description?: Maybe<Scalars['String']['output']>;
  /** Edges */
  edges?: Maybe<Array<Edge>>;
  /** True if the Strategy has no nodes */
  empty: Scalars['Boolean']['output'];
  /** Strategy end date */
  endDate?: Maybe<Scalars['ISO8601Date']['output']>;
  /** Associated entities */
  entities?: Maybe<Array<Entity>>;
  /** Entity finder */
  entity?: Maybe<Entity>;
  /** The contained entities passed in entity */
  entityEntities?: Maybe<EntityCollection>;
  /** Get all upstream events data for a entity graph */
  entityEventsGraph?: Maybe<Scalars['JSON']['output']>;
  /** Search for Strategies, Metrics, and Entities */
  existingObjectAutocomplete?: Maybe<Array<MultiObjectAutocompleteItem>>;
  /** The ID of the current user's Favorite of this favoritable, if favorited */
  favoriteId?: Maybe<Scalars['ID']['output']>;
  /** ID for used through the SegmentFilterable interface */
  filterableId: Scalars['ID']['output'];
  /** Object global id */
  gid: Scalars['ID']['output'];
  /** Object unique ID */
  id: Scalars['ID']['output'];
  /** Number of processes currently running that want to show an indicator in the frontend */
  indicatorCounter: Scalars['Int']['output'];
  /** Labels */
  labels?: Maybe<Array<Label>>;
  /** Associated map images */
  mapImages?: Maybe<Array<MapImage>>;
  /** Metric finder */
  metric?: Maybe<Metric>;
  /** List of segment names */
  metricDataPointSegmentNames?: Maybe<Array<SegmentName>>;
  /** List of segment values */
  metricDataPointSegmentValues?: Maybe<Array<SegmentValue>>;
  /** The entities for all of the passed Metric */
  metricEntities?: Maybe<EntityCollection>;
  /** Get all upstream events data for a metric graph */
  metricEventsGraph?: Maybe<Scalars['JSON']['output']>;
  /** Associated metrics */
  metrics?: Maybe<Array<Metric>>;
  /** Strategy name */
  name?: Maybe<Scalars['String']['output']>;
  /** Nodes */
  nodes?: Maybe<Array<Node>>;
  /** Associated notes */
  notes?: Maybe<Array<Note>>;
  /** Associated Organization */
  organization: Organization;
  /** Owner of this Strategy */
  owner?: Maybe<User>;
  /** Owner ID of this Strategy */
  ownerId?: Maybe<Scalars['ID']['output']>;
  /** Name of the playbook template used for this strategy */
  playbookName?: Maybe<Scalars['String']['output']>;
  /** Strategy date range */
  range?: Maybe<Scalars['String']['output']>;
  /** Associated Recurring Report Configurations */
  recurringReportConfigurations?: Maybe<Array<RecurringReportConfiguration>>;
  /** Number of Recurring Report Configurations */
  recurringReportConfigurationsCount: Scalars['Int']['output'];
  /** Associated Reports */
  reports?: Maybe<Array<Report>>;
  /** Strategy node id */
  rfId: Scalars['String']['output'];
  /** Associated sections */
  sections?: Maybe<Array<Section>>;
  /** Segment filters for the Strategy */
  segmentFilters?: Maybe<Array<SegmentFilter>>;
  /** Sharing status for the Strategy. */
  sharing: SharingTypesEnum;
  /** Show correlations for the Strategy. */
  showCorrelations: Scalars['Boolean']['output'];
  /** Whether to show the "Segment" button in the frontend */
  showSegmentCreate: Scalars['Boolean']['output'];
  /** Slack Channel attached to this Strategy */
  slackChannel?: Maybe<SlackChannel>;
  /** Slack Channel ID attached to this Strategy */
  slackChannelId?: Maybe<Scalars['ID']['output']>;
  /** Strategy start date */
  startDate?: Maybe<Scalars['ISO8601Date']['output']>;
  /** Strategy stat display */
  statDisplay?: Maybe<StatDisplayEnum>;
  /** When the stats for the strategy were last updated */
  statsUpdatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Status of the Strategy */
  status: DomainObjectStatusEnum;
  /** Associated strategies */
  strategies?: Maybe<Array<Strategy>>;
  /** The upstream entities for all of the passed Strategies */
  strategyEntities?: Maybe<EntityCollection>;
  /** Access token for when not public */
  token?: Maybe<Scalars['String']['output']>;
  /** Object last updated date */
  updatedAt: Scalars['ISO8601DateTime']['output'];
};


/** Strategy */
export type StrategyBasicCardEntitiesArgs = {
  basicCardId: Scalars['ID']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  workflowState?: InputMaybe<EntityWorkflowStateEnum>;
};


/** Strategy */
export type StrategyCommentThreadCommentsArgs = {
  commentThreadId: Scalars['ID']['input'];
};


/** Strategy */
export type StrategyEntityArgs = {
  id: Scalars['ID']['input'];
  metricId?: InputMaybe<Scalars['ID']['input']>;
};


/** Strategy */
export type StrategyEntityEntitiesArgs = {
  entityId: Scalars['ID']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  workflowState?: InputMaybe<EntityWorkflowStateEnum>;
};


/** Strategy */
export type StrategyEntityEventsGraphArgs = {
  entityId: Scalars['ID']['input'];
  filters?: InputMaybe<Scalars['JSON']['input']>;
};


/** Strategy */
export type StrategyExistingObjectAutocompleteArgs = {
  labels?: InputMaybe<Scalars['String']['input']>;
  query: Scalars['String']['input'];
  scope?: InputMaybe<Scalars['JSON']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};


/** Strategy */
export type StrategyMetricArgs = {
  id: Scalars['ID']['input'];
};


/** Strategy */
export type StrategyMetricDataPointSegmentValuesArgs = {
  segmentNameId: Scalars['ID']['input'];
};


/** Strategy */
export type StrategyMetricEntitiesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  metricId: Scalars['ID']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  workflowState?: InputMaybe<EntityWorkflowStateEnum>;
};


/** Strategy */
export type StrategyMetricEventsGraphArgs = {
  filters?: InputMaybe<Scalars['JSON']['input']>;
  metricId: Scalars['ID']['input'];
};


/** Strategy */
export type StrategyStrategyEntitiesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  workflowState?: InputMaybe<EntityWorkflowStateEnum>;
};

/** Autogenerated input type of StrategyBulkAddExistingCards */
export type StrategyBulkAddExistingCardsInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Array of Card IDs to add to Strategy */
  domainObjectIds: Array<Scalars['ID']['input']>;
  /** Type of Card to add to Strategy */
  domainObjectType: Scalars['String']['input'];
  /** Position on the strategy */
  offset?: InputMaybe<PositionInput>;
  /** ID of Strategy whose file cache is updated */
  strategyId: Scalars['ID']['input'];
};

/** Autogenerated return type of StrategyBulkAddExistingCards. */
export type StrategyBulkAddExistingCardsPayload = ClassTypeInterface & {
  __typename?: 'StrategyBulkAddExistingCardsPayload';
  /** The class type of the field */
  classType: Scalars['String']['output'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Array of Errors */
  errors: Array<Error>;
  /** Updated Strategy */
  strategy?: Maybe<Strategy>;
};

/** Autogenerated input type of StrategyBulkImportUrls */
export type StrategyBulkImportUrlsInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Position to insert the new node */
  offset?: InputMaybe<PositionInput>;
  /** ID of Strategy on which to add the nodes */
  strategyId: Scalars['ID']['input'];
  /** Array of URLs to import */
  urls: Array<Scalars['String']['input']>;
};

/** Autogenerated return type of StrategyBulkImportUrls. */
export type StrategyBulkImportUrlsPayload = ClassTypeInterface & {
  __typename?: 'StrategyBulkImportUrlsPayload';
  /** The class type of the field */
  classType: Scalars['String']['output'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Array of Errors */
  errors: Array<Error>;
  /** Updated Strategy */
  strategy?: Maybe<Strategy>;
};

/** StrategyCollection type */
export type StrategyCollection = {
  __typename?: 'StrategyCollection';
  /** A collection of paginated StrategyCollection */
  collection: Array<Strategy>;
  /** Pagination Metadata for navigating the Pagination */
  metadata: CollectionMetadata;
};

/** Autogenerated input type of StrategyDelete */
export type StrategyDeleteInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Strategy ID to delete */
  strategyId: Scalars['ID']['input'];
};

/** Autogenerated return type of StrategyDelete. */
export type StrategyDeletePayload = ClassTypeInterface & {
  __typename?: 'StrategyDeletePayload';
  /** The class type of the field */
  classType: Scalars['String']['output'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Array of Errors */
  errors: Array<Error>;
  /** Deleted Strategy */
  strategy?: Maybe<Strategy>;
};

/** Autogenerated input type of StrategyDescriptionSuggest */
export type StrategyDescriptionSuggestInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the strategy to update */
  strategyId: Scalars['ID']['input'];
};

/** Autogenerated return type of StrategyDescriptionSuggest. */
export type StrategyDescriptionSuggestPayload = ClassTypeInterface & {
  __typename?: 'StrategyDescriptionSuggestPayload';
  /** The class type of the field */
  classType: Scalars['String']['output'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The returned result */
  result: Scalars['String']['output'];
};

/** Input Type for Strategy */
export type StrategyInput = {
  /** The AI context of the Strategy */
  aiContext?: InputMaybe<Scalars['String']['input']>;
  /** Strategy Business Context ID */
  businessContextId?: InputMaybe<Scalars['ID']['input']>;
  /** The confidence rating of the Work */
  confidenceRating?: InputMaybe<ConfidenceRatingEnum>;
  /** Strategy description */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Strategy end date */
  endDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  /** Strategy ID */
  id?: InputMaybe<Scalars['ID']['input']>;
  /** Optional labels to set on the Strategy */
  labels?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Strategy name */
  name?: InputMaybe<Scalars['String']['input']>;
  /** ID of the owner of this Strategy */
  ownerId?: InputMaybe<Scalars['ID']['input']>;
  /** Strategy date range */
  range?: InputMaybe<Scalars['String']['input']>;
  /** Strategy sharing type */
  sharing?: InputMaybe<SharingTypesEnum>;
  /** Should the Strategy show correlations */
  showCorrelations?: InputMaybe<Scalars['CastableBoolean']['input']>;
  /** Strategy Slack Channel */
  slackChannelId?: InputMaybe<Scalars['ID']['input']>;
  /** Strategy start date */
  startDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  /** Strategy card stat display */
  statDisplay?: InputMaybe<Scalars['String']['input']>;
  /** Strategy status */
  status?: InputMaybe<DomainObjectStatusEnum>;
};

/** Autogenerated input type of StrategyMetricMultiRegression */
export type StrategyMetricMultiRegressionInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** ID of the metric that will act as the dependent metric */
  dependentId: Scalars['ID']['input'];
  /** ID of the strategy to use */
  strategyId: Scalars['ID']['input'];
};

/** Autogenerated return type of StrategyMetricMultiRegression. */
export type StrategyMetricMultiRegressionPayload = ClassTypeInterface & {
  __typename?: 'StrategyMetricMultiRegressionPayload';
  /** The class type of the field */
  classType: Scalars['String']['output'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The partial r2 for each independent metric. Object is of form Record<id: Float>. */
  partials: Scalars['JSON']['output'];
  /** The R^2 value of the regression */
  r2?: Maybe<Scalars['Float']['output']>;
  /** The report with the regression data */
  report?: Maybe<Report>;
};

/** Autogenerated input type of StrategyMetricsSuggest */
export type StrategyMetricsSuggestInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the Metric */
  metricId: Scalars['ID']['input'];
  /** The ID of the Strategy */
  strategyId: Scalars['ID']['input'];
};

/** Autogenerated return type of StrategyMetricsSuggest. */
export type StrategyMetricsSuggestPayload = ClassTypeInterface & {
  __typename?: 'StrategyMetricsSuggestPayload';
  /** The class type of the field */
  classType: Scalars['String']['output'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The error, if any, returned by OpenAI */
  error?: Maybe<Scalars['String']['output']>;
  /** The suggestions, returned by OpenAI */
  result?: Maybe<Array<Scalars['String']['output']>>;
};

/** Autogenerated input type of StrategyNameSuggest */
export type StrategyNameSuggestInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the strategy to update */
  strategyId: Scalars['ID']['input'];
};

/** Autogenerated return type of StrategyNameSuggest. */
export type StrategyNameSuggestPayload = ClassTypeInterface & {
  __typename?: 'StrategyNameSuggestPayload';
  /** The class type of the field */
  classType: Scalars['String']['output'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The returned result */
  result: Scalars['String']['output'];
};

/** Autogenerated input type of StrategyNodeDelete */
export type StrategyNodeDeleteInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the Node to destroy */
  nodes: Array<Scalars['ID']['input']>;
  /** The ID of the Strategy to associate */
  strategyId: Scalars['ID']['input'];
};

/** Autogenerated return type of StrategyNodeDelete. */
export type StrategyNodeDeletePayload = ClassTypeInterface & {
  __typename?: 'StrategyNodeDeletePayload';
  /** The class type of the field */
  classType: Scalars['String']['output'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Array of Errors */
  errors: Array<Error>;
  /** Destroyed nodes */
  nodes: Array<Node>;
  /** Updated strategy */
  strategy: Strategy;
};

/** Autogenerated input type of StrategyNodeUpdate */
export type StrategyNodeUpdateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Array of nodes that either need updated */
  nodes?: InputMaybe<Array<NodeInput>>;
  /** Strategy ID to update */
  strategyId: Scalars['ID']['input'];
};

/** Autogenerated return type of StrategyNodeUpdate. */
export type StrategyNodeUpdatePayload = ClassTypeInterface & {
  __typename?: 'StrategyNodeUpdatePayload';
  /** The class type of the field */
  classType: Scalars['String']['output'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Array of Errors */
  errors: Array<Error>;
  /** Updated Nodes */
  nodes?: Maybe<Array<Node>>;
  /** Updated Strategy */
  strategy?: Maybe<Strategy>;
};

export type StrategyOrderingInput = {
  /** Sort by created_at */
  createdAt?: InputMaybe<SortDirectionEnum>;
  /** Sort by name */
  name?: InputMaybe<SortDirectionEnum>;
  /** Sort by sharing */
  sharing?: InputMaybe<SortDirectionEnum>;
};

/** Autogenerated input type of StrategyPopulateFromPlaybookTemplate */
export type StrategyPopulateFromPlaybookTemplateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Playbook template to apply */
  playbookTemplate: Scalars['JSON']['input'];
  /** Playbook ID to apply */
  strategyId: Scalars['ID']['input'];
};

/** Autogenerated return type of StrategyPopulateFromPlaybookTemplate. */
export type StrategyPopulateFromPlaybookTemplatePayload = ClassTypeInterface & {
  __typename?: 'StrategyPopulateFromPlaybookTemplatePayload';
  /** The class type of the field */
  classType: Scalars['String']['output'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Array of Errors */
  errors: Array<Error>;
  /** Newly created Strategy */
  strategy?: Maybe<Strategy>;
};

/** Autogenerated input type of StrategyPopulateSimulationBaselines */
export type StrategyPopulateSimulationBaselinesInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Historical data duration */
  range?: InputMaybe<Scalars['String']['input']>;
  /** The source of the simulation baseline data */
  source: SimulationBaselineSourceEnum;
  /** The ID of the Strategy */
  strategyId: Scalars['ID']['input'];
  /** Historical data time base */
  timeBase?: InputMaybe<SimulationBaselineTimeBaseEnum>;
};

/** Autogenerated return type of StrategyPopulateSimulationBaselines. */
export type StrategyPopulateSimulationBaselinesPayload = ClassTypeInterface & {
  __typename?: 'StrategyPopulateSimulationBaselinesPayload';
  /** The class type of the field */
  classType: Scalars['String']['output'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The error, if any */
  error?: Maybe<Scalars['String']['output']>;
  /** The updated Nodes */
  result?: Maybe<Array<Node>>;
};

/** Autogenerated input type of StrategyRegressionScoresClear */
export type StrategyRegressionScoresClearInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** ID of the strategy to clear regression scores */
  strategyId: Scalars['ID']['input'];
};

/** Autogenerated return type of StrategyRegressionScoresClear. */
export type StrategyRegressionScoresClearPayload = ClassTypeInterface & {
  __typename?: 'StrategyRegressionScoresClearPayload';
  /** The class type of the field */
  classType: Scalars['String']['output'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Indicates if the operation was successful */
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of StrategyReviewSend */
export type StrategyReviewSendInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Strategy ID to send */
  strategyId: Scalars['ID']['input'];
};

/** Autogenerated return type of StrategyReviewSend. */
export type StrategyReviewSendPayload = ClassTypeInterface & {
  __typename?: 'StrategyReviewSendPayload';
  /** The class type of the field */
  classType: Scalars['String']['output'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Array of Errors */
  errors: Array<Error>;
  /** True if the send succeeded */
  success: Scalars['Boolean']['output'];
};

/** Strategy stats for Metric */
export type StrategyStat = ClassTypeInterface & {
  __typename?: 'StrategyStat';
  /** Change in the total from the previous period */
  change?: Maybe<Scalars['Float']['output']>;
  /** The class type of the field */
  classType: Scalars['String']['output'];
  /** The User-facing displayable period */
  displayPeriod: Scalars['String']['output'];
  /** The period of time this Stat measures */
  period: Scalars['ISO8601Duration']['output'];
  /** Total value of the Stat's period */
  total: Scalars['Float']['output'];
};

/** List of Strategy types */
export enum StrategyTypeEnum {
  /** Diagnostic Node for Metrics */
  Diagnostic = 'diagnostic',
  /** Input Node for Metrics */
  Input = 'input',
  /** Kpi Node for Metrics */
  Kpi = 'kpi',
  /** North star Node for Metrics */
  NorthStar = 'north_star'
}

/** Input Type for Strategy attributes (i.e. no ID, which is used in DomainObjectUpdate) */
export type StrategyUpdateInput = {
  /** The AI context of the Strategy */
  aiContext?: InputMaybe<Scalars['String']['input']>;
  /** ID of the Business Context this Strategy belongs to */
  businessContextId?: InputMaybe<Scalars['ID']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The confidence rating of the Work */
  confidenceRating?: InputMaybe<ConfidenceRatingEnum>;
  /** Strategy description */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Strategy end date */
  endDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  /** Optional labels to set on the Strategy */
  labels?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Strategy name */
  name?: InputMaybe<Scalars['String']['input']>;
  /** ID of the owner of this Strategy */
  ownerId?: InputMaybe<Scalars['ID']['input']>;
  /** Strategy date range */
  range?: InputMaybe<Scalars['String']['input']>;
  /** Strategy sharing type */
  sharing?: InputMaybe<SharingTypesEnum>;
  /** Should the Strategy show correlations */
  showCorrelations?: InputMaybe<Scalars['CastableBoolean']['input']>;
  /** Strategy Slack Channel */
  slackChannelId?: InputMaybe<Scalars['ID']['input']>;
  /** Strategy start date */
  startDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  /** Strategy card stat display */
  statDisplay?: InputMaybe<Scalars['String']['input']>;
  /** Strategy status */
  status?: InputMaybe<DomainObjectStatusEnum>;
  /** Strategy ID to update */
  strategyId: Scalars['ID']['input'];
};

/** Autogenerated return type of StrategyUpdate. */
export type StrategyUpdatePayload = ClassTypeInterface & {
  __typename?: 'StrategyUpdatePayload';
  /** The class type of the field */
  classType: Scalars['String']['output'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Array of Errors */
  errors: Array<Error>;
  /** Updated Strategy */
  strategy?: Maybe<Strategy>;
};

/** Objects that can be returned in a structured formula */
export type StructuredFormulaUnion = FormulaText | Metric;

/** DoubleLoop subscriptions */
export type Subscription = {
  __typename?: 'Subscription';
  /** Subscription for imperative events on maps */
  mapEvents: MapEventsPayload;
  /** Subscription for when an object is deleted, within a Strategy */
  mapStructureChanged: MapStructureChangedPayload;
  /** Subscription for domain object crud, at the organization level */
  organizationCrud: OrganizationCrudPayload;
};


/** DoubleLoop subscriptions */
export type SubscriptionMapEventsArgs = {
  strategyId: Scalars['ID']['input'];
};


/** DoubleLoop subscriptions */
export type SubscriptionMapStructureChangedArgs = {
  strategyId: Scalars['ID']['input'];
};


/** DoubleLoop subscriptions */
export type SubscriptionOrganizationCrudArgs = {
  organizationId: Scalars['ID']['input'];
};

/** Credential with different policies for super admin testing */
export type SuperAdminCredential = ClassTypeInterface & {
  __typename?: 'SuperAdminCredential';
  /** API Key for the Credential */
  apiKey?: Maybe<Scalars['String']['output']>;
  /** The class type of the field */
  classType: Scalars['String']['output'];
  /** Client ID for the Credential */
  clientId?: Maybe<Scalars['String']['output']>;
  /** When the Credential was created */
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Database name for the Credential */
  database?: Maybe<Scalars['String']['output']>;
  /** Display name for the Credential */
  displayName?: Maybe<Scalars['String']['output']>;
  /** File attached to the Credential */
  file?: Maybe<FileAttachment>;
  /** File's Shrine Hash for the Credential */
  fileData?: Maybe<Scalars['JSON']['output']>;
  /** Hostname for the Credential */
  host?: Maybe<Scalars['String']['output']>;
  /** Credential ID */
  id: Scalars['ID']['output'];
  /** Label for this Credential */
  label?: Maybe<Scalars['String']['output']>;
  /** Metrics associated with the Credential */
  metrics?: Maybe<Array<Metric>>;
  /** Port for the Credential */
  port?: Maybe<Scalars['String']['output']>;
  /** Project ID */
  projectId?: Maybe<Scalars['ID']['output']>;
  /** Region for the Credential */
  region?: Maybe<Scalars['String']['output']>;
  /** Role for the Credential */
  role?: Maybe<Scalars['String']['output']>;
  /** Schema name for the Credential */
  schema?: Maybe<Scalars['String']['output']>;
  /** Credential source */
  sourceName?: Maybe<Scalars['String']['output']>;
  /** When the Credential was last updated */
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Username for the Credential */
  username?: Maybe<Scalars['String']['output']>;
  /** Warehouse name for the Credential */
  warehouse?: Maybe<Scalars['String']['output']>;
  /** Workspace ID */
  workspaceId?: Maybe<Scalars['ID']['output']>;
};

/** A single task object */
export type Task = ClassTypeInterface & {
  __typename?: 'Task';
  /** The class type of the field */
  classType: Scalars['String']['output'];
  /** Object creation date */
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Description of task */
  description?: Maybe<Scalars['String']['output']>;
  /** Domain object with task */
  domainObject?: Maybe<DomainObjectUnion>;
  /** Domain object id with task */
  domainObjectId: Scalars['ID']['output'];
  /** Domain object type with task */
  domainObjectType: Scalars['String']['output'];
  /** ID of object */
  id: Scalars['ID']['output'];
  /** Background job ID */
  jobId?: Maybe<Scalars['String']['output']>;
  /** Organization with task */
  organization: Organization;
  /** Progress of task */
  progress?: Maybe<Scalars['Int']['output']>;
  /** Status of task */
  status: TaskStatusesEnum;
  /** Summary of task */
  summary?: Maybe<Scalars['String']['output']>;
  /** Type of task */
  taskType: TaskTypesEnum;
  /** Object last updated date */
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
};

/** TaskCollection type */
export type TaskCollection = {
  __typename?: 'TaskCollection';
  /** A collection of paginated TaskCollection */
  collection: Array<Task>;
  /** Pagination Metadata for navigating the Pagination */
  metadata: CollectionMetadata;
};

/** Task status options */
export enum TaskStatusesEnum {
  /** Completed */
  Completed = 'completed',
  /** Failed */
  Failed = 'failed',
  /** In progress */
  InProgress = 'in_progress',
  /** Scheduled */
  Scheduled = 'scheduled'
}

/** Task type options */
export enum TaskTypesEnum {
  /** Bulk url import */
  BulkUrlImport = 'bulk_url_import',
  /** Context create */
  ContextCreate = 'context_create',
  /** Csv import */
  CsvImport = 'csv_import',
  /** Google sheet export */
  GoogleSheetExport = 'google_sheet_export',
  /** Google sheet import */
  GoogleSheetImport = 'google_sheet_import',
  /** Looker dashboard import */
  LookerDashboardImport = 'looker_dashboard_import',
  /** Metric activity process */
  MetricActivityProcess = 'metric_activity_process',
  /** Metric source history import */
  MetricSourceHistoryImport = 'metric_source_history_import',
  /** Metric source import */
  MetricSourceImport = 'metric_source_import',
  /** Root context create */
  RootContextCreate = 'root_context_create',
  /** Work history import */
  WorkHistoryImport = 'work_history_import'
}

/** List of Team types */
export enum TeamTypeEnum {
  /** Engineering Node for BasicCards */
  Engineering = 'engineering',
  /** Marketing Node for BasicCards */
  Marketing = 'marketing',
  /** Product Node for BasicCards */
  Product = 'product',
  /** Sales Node for BasicCards */
  Sales = 'sales',
  /** Support Node for BasicCards */
  Support = 'support'
}

/** CRUD operation wrapper for Types::AccountType */
export type TypesAccountTypeGraphqlCrudOperation = ClassTypeInterface & {
  __typename?: 'TypesAccountTypeGraphqlCrudOperation';
  /** The class type of the field */
  classType: Scalars['String']['output'];
  /** Data that the operation was performed on */
  data?: Maybe<Account>;
  /** Operation that was performed */
  operation: CrudOperationEnum;
};

/** CRUD operation wrapper for Types::BusinessContextType */
export type TypesBusinessContextTypeGraphqlCrudOperation = ClassTypeInterface & {
  __typename?: 'TypesBusinessContextTypeGraphqlCrudOperation';
  /** The class type of the field */
  classType: Scalars['String']['output'];
  /** Data that the operation was performed on */
  data?: Maybe<BusinessContext>;
  /** Operation that was performed */
  operation: CrudOperationEnum;
};

/** CRUD operation wrapper for Types::CardTypeType */
export type TypesCardTypeTypeGraphqlCrudOperation = ClassTypeInterface & {
  __typename?: 'TypesCardTypeTypeGraphqlCrudOperation';
  /** The class type of the field */
  classType: Scalars['String']['output'];
  /** Data that the operation was performed on */
  data?: Maybe<CardType>;
  /** Operation that was performed */
  operation: CrudOperationEnum;
};

/** CRUD operation wrapper for Types::InvitationType */
export type TypesInvitationTypeGraphqlCrudOperation = ClassTypeInterface & {
  __typename?: 'TypesInvitationTypeGraphqlCrudOperation';
  /** The class type of the field */
  classType: Scalars['String']['output'];
  /** Data that the operation was performed on */
  data?: Maybe<Invitation>;
  /** Operation that was performed */
  operation: CrudOperationEnum;
};

/** CRUD operation wrapper for Types::LookerDashboardType */
export type TypesLookerDashboardTypeGraphqlCrudOperation = ClassTypeInterface & {
  __typename?: 'TypesLookerDashboardTypeGraphqlCrudOperation';
  /** The class type of the field */
  classType: Scalars['String']['output'];
  /** Data that the operation was performed on */
  data?: Maybe<LookerDashboard>;
  /** Operation that was performed */
  operation: CrudOperationEnum;
};

/** CRUD operation wrapper for Types::MetricDataPointType */
export type TypesMetricDataPointTypeGraphqlCrudOperation = ClassTypeInterface & {
  __typename?: 'TypesMetricDataPointTypeGraphqlCrudOperation';
  /** The class type of the field */
  classType: Scalars['String']['output'];
  /** Data that the operation was performed on */
  data?: Maybe<MetricDataPoint>;
  /** Operation that was performed */
  operation: CrudOperationEnum;
};

/** CRUD operation wrapper for Types::MetricSourceType */
export type TypesMetricSourceTypeGraphqlCrudOperation = ClassTypeInterface & {
  __typename?: 'TypesMetricSourceTypeGraphqlCrudOperation';
  /** The class type of the field */
  classType: Scalars['String']['output'];
  /** Data that the operation was performed on */
  data?: Maybe<MetricSource>;
  /** Operation that was performed */
  operation: CrudOperationEnum;
};

/** CRUD operation wrapper for Types::RecurringReportConfigurationType */
export type TypesRecurringReportConfigurationTypeGraphqlCrudOperation = ClassTypeInterface & {
  __typename?: 'TypesRecurringReportConfigurationTypeGraphqlCrudOperation';
  /** The class type of the field */
  classType: Scalars['String']['output'];
  /** Data that the operation was performed on */
  data?: Maybe<RecurringReportConfiguration>;
  /** Operation that was performed */
  operation: CrudOperationEnum;
};

/** CRUD operation wrapper for Types::Unions::DomainObjectUnionArray */
export type TypesUnionsDomainObjectUnionArrayGraphqlCrudOperation = ClassTypeInterface & {
  __typename?: 'TypesUnionsDomainObjectUnionArrayGraphqlCrudOperation';
  /** The class type of the field */
  classType: Scalars['String']['output'];
  /** Data that the operation was performed on */
  data?: Maybe<Array<DomainObjectUnion>>;
  /** Operation that was performed */
  operation: CrudOperationEnum;
};

/** Autogenerated input type of UploadTicketGenerate */
export type UploadTicketGenerateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of UploadTicketGenerate. */
export type UploadTicketGeneratePayload = ClassTypeInterface & {
  __typename?: 'UploadTicketGeneratePayload';
  /** The class type of the field */
  classType: Scalars['String']['output'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The ticket to use */
  ticket: Scalars['String']['output'];
};

/** A single user object */
export type User = ClassTypeInterface & {
  __typename?: 'User';
  /** User authorization list */
  abilities?: Maybe<Scalars['JSON']['output']>;
  /** Number of accounts */
  accountsCount: Scalars['Int']['output'];
  /** The class type of the field */
  classType: Scalars['String']['output'];
  /** When the user was confirmed / verified at */
  confirmedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Object creation date */
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** If applicable, date and time user was disabled at */
  disabledAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** User email address */
  email: Scalars['String']['output'];
  /** ID of object */
  id: Scalars['ID']['output'];
  /** Users job title */
  jobTitle?: Maybe<Scalars['String']['output']>;
  /** Users name */
  name: Scalars['String']['output'];
  /** Whether a user is opted into platform analytics */
  optedInToAnalytics?: Maybe<Scalars['Boolean']['output']>;
  /** Associated Organization */
  organization?: Maybe<Organization>;
  /** Users role */
  role?: Maybe<RoleEnum>;
  /** Uniquely search ID to locate contribution records */
  searchableContributorId?: Maybe<Scalars['String']['output']>;
  /** If we retrieved the user from a Source such as Slack */
  sourceName: Scalars['String']['output'];
  /** Internal DL Admin flag */
  superAdmin: Scalars['Boolean']['output'];
  /** Users preferred timezone */
  timeZone: Scalars['String']['output'];
  /** Object last updated date */
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
};

/** Autogenerated input type of UserAuthenticate */
export type UserAuthenticateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The email account to use for login */
  email: Scalars['String']['input'];
  /** The password to use for login */
  password: Scalars['String']['input'];
};

/** Autogenerated return type of UserAuthenticate. */
export type UserAuthenticatePayload = ClassTypeInterface & {
  __typename?: 'UserAuthenticatePayload';
  /** The class type of the field */
  classType: Scalars['String']['output'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Array of Errors */
  errors: Array<Error>;
  /** Path to redirect to */
  redirect?: Maybe<Scalars['String']['output']>;
  /** true/false if the login was successful */
  success: Scalars['Boolean']['output'];
  /** Logged in User */
  user?: Maybe<User>;
};

/** Autogenerated input type of UserConfirmEmail */
export type UserConfirmEmailInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of UserConfirmEmail. */
export type UserConfirmEmailPayload = ClassTypeInterface & {
  __typename?: 'UserConfirmEmailPayload';
  /** The class type of the field */
  classType: Scalars['String']['output'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** true/false if email was sent successfully */
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of UserCreate */
export type UserCreateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Email for new account */
  email: Scalars['String']['input'];
  /** Optional invite code to join an existing organization */
  inviteCode?: InputMaybe<Scalars['String']['input']>;
  /** Name for new account */
  name: Scalars['String']['input'];
  /** Password for new account */
  password: Scalars['String']['input'];
  /** Password confirmation for new account */
  passwordConfirmation: Scalars['String']['input'];
  /** Optional time zone for new account */
  timeZone?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of UserCreate. */
export type UserCreatePayload = ClassTypeInterface & {
  __typename?: 'UserCreatePayload';
  /** The class type of the field */
  classType: Scalars['String']['output'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Array of Errors */
  errors: Array<Error>;
  /** Newly created User */
  user?: Maybe<User>;
};

/** Autogenerated input type of UserEmailCapture */
export type UserEmailCaptureInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Email for new account */
  email: Scalars['String']['input'];
  /** Job title for the new account */
  jobTitle?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of UserEmailCapture. */
export type UserEmailCapturePayload = ClassTypeInterface & {
  __typename?: 'UserEmailCapturePayload';
  /** The class type of the field */
  classType: Scalars['String']['output'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Array of Errors */
  errors: Array<Error>;
  /** Whether or not the user was created properly */
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of UserResetPassword */
export type UserResetPasswordInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Password to set on the user */
  password: Scalars['String']['input'];
  /** Password reset token for the user */
  passwordResetToken: Scalars['String']['input'];
};

/** Autogenerated return type of UserResetPassword. */
export type UserResetPasswordPayload = ClassTypeInterface & {
  __typename?: 'UserResetPasswordPayload';
  /** The class type of the field */
  classType: Scalars['String']['output'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Array of Errors */
  errors: Array<Error>;
  /** If the reset password was successful */
  success?: Maybe<Scalars['Boolean']['output']>;
};

/** Autogenerated input type of UserResetPasswordRequest */
export type UserResetPasswordRequestInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Email for new account */
  email: Scalars['String']['input'];
};

/** Autogenerated return type of UserResetPasswordRequest. */
export type UserResetPasswordRequestPayload = ClassTypeInterface & {
  __typename?: 'UserResetPasswordRequestPayload';
  /** The class type of the field */
  classType: Scalars['String']['output'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Array of Errors */
  errors: Array<Error>;
  /** Success */
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of UserUpdate */
export type UserUpdateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** User email address */
  email?: InputMaybe<Scalars['String']['input']>;
  /** User job title */
  jobTitle?: InputMaybe<Scalars['String']['input']>;
  /** User name */
  name?: InputMaybe<Scalars['String']['input']>;
  /** User boolean flag for opting into analytics */
  optedInToAnalytics?: InputMaybe<Scalars['CastableBoolean']['input']>;
  /** User time zone */
  timeZone?: InputMaybe<Scalars['String']['input']>;
  /** User ID to update */
  userId: Scalars['ID']['input'];
};

/** Autogenerated return type of UserUpdate. */
export type UserUpdatePayload = ClassTypeInterface & {
  __typename?: 'UserUpdatePayload';
  /** The class type of the field */
  classType: Scalars['String']['output'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Array of Errors */
  errors: Array<Error>;
  /** Updated User */
  user?: Maybe<User>;
};

export type AccountSubscriptionFieldsFragment = { __typename?: 'Account', id: string, classType: string, organizationName: string, organizationLogoUrl?: string | null, name?: string | null, role: RoleEnum, disabledAt?: any | null };

export type AccountRequiredFieldsFragment = { __typename?: 'Account', id: string, classType: string, name?: string | null, organizationId: string, organizationLogoUrl?: string | null, organizationName: string, role: RoleEnum, userId: string, disabledAt?: any | null };

export type AccountsQueryVariables = Exact<{
  includeDisabled?: InputMaybe<Scalars['CastableBoolean']['input']>;
}>;


export type AccountsQuery = { __typename?: 'Query', accounts?: Array<{ __typename?: 'Account', createdAt?: any | null, updatedAt?: any | null, id: string, classType: string, name?: string | null, organizationId: string, organizationLogoUrl?: string | null, organizationName: string, role: RoleEnum, userId: string, disabledAt?: any | null, user?: { __typename?: 'User', id: string, classType: string, name: string, email: string, superAdmin: boolean, createdAt?: any | null } | null }> | null };

export type MembersAutocompleteQueryVariables = Exact<{
  query: Scalars['String']['input'];
}>;


export type MembersAutocompleteQuery = { __typename?: 'Query', membersAutocomplete?: Array<{ __typename?: 'User', id: string, classType: string, name: string, email: string }> | null };

export type AccountUpdateMutationVariables = Exact<{
  input: AccountUpdateInput;
}>;


export type AccountUpdateMutation = { __typename?: 'Mutation', accountUpdate?: { __typename?: 'AccountUpdatePayload', account?: { __typename?: 'Account', createdAt?: any | null, updatedAt?: any | null, id: string, classType: string, name?: string | null, organizationId: string, organizationLogoUrl?: string | null, organizationName: string, role: RoleEnum, userId: string, disabledAt?: any | null } | null, user?: { __typename?: 'User', id: string, classType: string, name: string, email: string, createdAt?: any | null, superAdmin: boolean } | null } | null };

export type AccountDeleteMutationVariables = Exact<{
  input: AccountDeleteInput;
}>;


export type AccountDeleteMutation = { __typename?: 'Mutation', crudOperation?: { __typename?: 'AccountDeletePayload', crudOperation: { __typename?: 'TypesAccountTypeGraphqlCrudOperation', operation: CrudOperationEnum, data?: { __typename?: 'Account', id: string, classType: string, name?: string | null, role: RoleEnum, disabledAt?: any | null, createdAt?: any | null, updatedAt?: any | null } | null }, errors: Array<{ __typename?: 'Error', message: string, path?: Array<string> | null }> } | null };

export type AccountSwitchMutationVariables = Exact<{
  input: AccountSwitchInput;
}>;


export type AccountSwitchMutation = { __typename?: 'Mutation', accountSwitch?: { __typename?: 'AccountSwitchPayload', account?: { __typename?: 'Account', createdAt?: any | null, updatedAt?: any | null, id: string, classType: string, name?: string | null, organizationId: string, organizationLogoUrl?: string | null, organizationName: string, role: RoleEnum, userId: string, disabledAt?: any | null } | null, user?: { __typename?: 'User', id: string, classType: string, name: string, email: string } | null } | null };

export type StrategyMetricsSuggestMutationVariables = Exact<{
  input: StrategyMetricsSuggestInput;
}>;


export type StrategyMetricsSuggestMutation = { __typename?: 'Mutation', strategyMetricsSuggest?: { __typename?: 'StrategyMetricsSuggestPayload', result?: Array<string> | null, error?: string | null } | null };

export type MetricDescriptionSuggestMutationVariables = Exact<{
  input: MetricDescriptionSuggestInput;
}>;


export type MetricDescriptionSuggestMutation = { __typename?: 'Mutation', metricDescriptionSuggest?: { __typename?: 'MetricDescriptionSuggestPayload', result: string } | null };

export type StrategyDescriptionSuggestMutationVariables = Exact<{
  input: StrategyDescriptionSuggestInput;
}>;


export type StrategyDescriptionSuggestMutation = { __typename?: 'Mutation', strategyDescriptionSuggest?: { __typename?: 'StrategyDescriptionSuggestPayload', result: string } | null };

export type StrategyNameSuggestMutationVariables = Exact<{
  input: StrategyNameSuggestInput;
}>;


export type StrategyNameSuggestMutation = { __typename?: 'Mutation', strategyNameSuggest?: { __typename?: 'StrategyNameSuggestPayload', result: string } | null };

export type MetricTechnicalDescriptionSuggestMutationVariables = Exact<{
  input: MetricTechnicalDescriptionSuggestInput;
}>;


export type MetricTechnicalDescriptionSuggestMutation = { __typename?: 'Mutation', metricTechnicalDescriptionSuggest?: { __typename?: 'MetricTechnicalDescriptionSuggestPayload', result: string } | null };

export type ProductInitiativesSuggestMutationVariables = Exact<{
  input: ProductInitiativesSuggestInput;
}>;


export type ProductInitiativesSuggestMutation = { __typename?: 'Mutation', productInitiativesSuggest?: { __typename?: 'ProductInitiativesSuggestPayload', result?: Array<string> | null } | null };

export type OpenAiFileDeleteMutationVariables = Exact<{
  input: OpenAiFileDeleteInput;
}>;


export type OpenAiFileDeleteMutation = { __typename?: 'Mutation', openAiFileDelete?: { __typename?: 'OpenAiFileDeletePayload', success: boolean } | null };

export type MetricFormulasSuggestMutationVariables = Exact<{
  input: MetricFormulasSuggestInput;
}>;


export type MetricFormulasSuggestMutation = { __typename?: 'Mutation', metricFormulasSuggest?: { __typename?: 'MetricFormulasSuggestPayload', result?: Array<string> | null, error?: string | null } | null };

export type ChatSubscriptionFieldsFragment = { __typename?: 'Chat', id: string, classType: string, currentAssistantId?: string | null, errorIsRetryable: boolean, errorMessage?: string | null, organizationId: string, pipelineSlug: string, processedState: ChatProcessedStateEnum, realTimeStatus?: string | null, strategyId?: string | null };

export type ChatFieldsFragment = { __typename?: 'Chat', id: string, classType: string, currentAssistantId?: string | null, errorIsRetryable: boolean, errorMessage?: string | null, organizationId: string, pipelineSlug: string, processedState: ChatProcessedStateEnum, realTimeStatus?: string | null, strategyId?: string | null, chattables: Array<{ __typename?: 'PolymorphicChattable', chattableId: string, chattableType: string }> };

export type MessageSubscriptionFieldsFragment = { __typename?: 'Message', id: string, chatId: string, classType: string, content: string, createdAt: any, role: AiAssistantRoleEnum, updatedAt: any, userId?: string | null, assistantId?: string | null, assistant?: { __typename?: 'AiAssistant', id: string, name: string } | null, user?: { __typename?: 'User', id: string, name: string, email: string } | null };

export type AiAssistantFilesSubscriptionFieldsFragment = { __typename?: 'AiAssistantFile', id: string, classType: string, name: string, remoteId: string, cacheableId: string, cacheableType: string };

export type OrganizationChatsQueryVariables = Exact<{
  chattableType: Scalars['String']['input'];
  chattableId: Scalars['ID']['input'];
}>;


export type OrganizationChatsQuery = { __typename?: 'Query', organization?: { __typename?: 'Organization', id: string, chats?: Array<{ __typename?: 'Chat', id: string, classType: string, currentAssistantId?: string | null, errorIsRetryable: boolean, errorMessage?: string | null, organizationId: string, pipelineSlug: string, processedState: ChatProcessedStateEnum, realTimeStatus?: string | null, strategyId?: string | null, mostRecentPrompt?: { __typename?: 'Message', id: string, chatId: string, classType: string, content: string, createdAt: any, role: AiAssistantRoleEnum, updatedAt: any, userId?: string | null, assistantId?: string | null, user?: { __typename?: 'User', id: string, classType: string, name: string, email: string } | null, assistant?: { __typename?: 'AiAssistant', id: string, name: string } | null } | null, chattables: Array<{ __typename?: 'PolymorphicChattable', chattableId: string, chattableType: string }> }> | null } | null };

export type PipelineQueryVariables = Exact<{
  id: PipelineEnum;
}>;


export type PipelineQuery = { __typename?: 'Query', pipeline?: { __typename?: 'Pipeline', id: string, name: string, slug: string, classType: string, assistants: Array<{ __typename?: 'AiAssistant', id: string, name: string }> } | null };

export type ChatQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type ChatQuery = { __typename?: 'Query', chat?: { __typename?: 'Chat', id: string, classType: string, currentAssistantId?: string | null, errorIsRetryable: boolean, errorMessage?: string | null, organizationId: string, pipelineSlug: string, processedState: ChatProcessedStateEnum, realTimeStatus?: string | null, strategyId?: string | null, messages: Array<{ __typename?: 'Message', id: string, chatId: string, classType: string, content: string, createdAt: any, role: AiAssistantRoleEnum, updatedAt: any, userId?: string | null, assistantId?: string | null, user?: { __typename?: 'User', id: string, name: string, email: string } | null, assistant?: { __typename?: 'AiAssistant', id: string, name: string } | null }>, chattables: Array<{ __typename?: 'PolymorphicChattable', chattableId: string, chattableType: string }> } | null };

export type PipelineRunMutationVariables = Exact<{
  input: PipelineRunInput;
}>;


export type PipelineRunMutation = { __typename?: 'Mutation', pipelineRun?: { __typename?: 'PipelineRunPayload', chat?: { __typename?: 'Chat', id: string, classType: string, currentAssistantId?: string | null, errorIsRetryable: boolean, errorMessage?: string | null, organizationId: string, pipelineSlug: string, processedState: ChatProcessedStateEnum, realTimeStatus?: string | null, strategyId?: string | null } | null, errors: Array<{ __typename?: 'Error', message: string }> } | null };

export type ChatCancelMutationVariables = Exact<{
  input: ChatCancelInput;
}>;


export type ChatCancelMutation = { __typename?: 'Mutation', chatCancel?: { __typename?: 'ChatCancelPayload', chat?: { __typename?: 'Chat', id: string, classType: string, currentAssistantId?: string | null, errorIsRetryable: boolean, errorMessage?: string | null, organizationId: string, pipelineSlug: string, processedState: ChatProcessedStateEnum, realTimeStatus?: string | null, strategyId?: string | null } | null } | null };

export type ChatUpdateMutationVariables = Exact<{
  input: ChatUpdateInput;
}>;


export type ChatUpdateMutation = { __typename?: 'Mutation', chatUpdate?: { __typename?: 'ChatUpdatePayload', chat?: { __typename?: 'Chat', id: string, classType: string, currentAssistantId?: string | null, errorIsRetryable: boolean, errorMessage?: string | null, organizationId: string, pipelineSlug: string, processedState: ChatProcessedStateEnum, realTimeStatus?: string | null, strategyId?: string | null } | null } | null };

export type UploadTicketGenerateMutationVariables = Exact<{
  input: UploadTicketGenerateInput;
}>;


export type UploadTicketGenerateMutation = { __typename?: 'Mutation', uploadTicketGenerate?: { __typename?: 'UploadTicketGeneratePayload', ticket: string } | null };

export type AiAssistantFileCacheFilesAddMutationVariables = Exact<{
  input: AiAssistantFileCacheFilesAddInput;
}>;


export type AiAssistantFileCacheFilesAddMutation = { __typename?: 'Mutation', aiAssistantFileCacheFilesAdd?: { __typename?: 'AiAssistantFileCacheFilesAddPayload', success?: boolean | null } | null };

export type AiAssistantFileCacheFilesRemoveMutationVariables = Exact<{
  input: AiAssistantFileCacheFilesRemoveInput;
}>;


export type AiAssistantFileCacheFilesRemoveMutation = { __typename?: 'Mutation', aiAssistantFileCacheFilesRemove?: { __typename?: 'AiAssistantFileCacheFilesRemovePayload', success?: boolean | null } | null };

export type AiAssistantEvalResultsQueryVariables = Exact<{
  states?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type AiAssistantEvalResultsQuery = { __typename?: 'Query', aiAssistantEvalResults: Array<{ __typename?: 'AiAssistantEvalResult', id: string, score?: number | null, model: string, processedState: string, assistantFingerprint?: string | null, assistantName?: string | null, contextSnapshot?: string | null, eval: { __typename?: 'AiAssistantEval', id: string, name: string, retryBelow?: number | null, live: boolean } }> };

export type AiNodesGenerateMutationVariables = Exact<{
  input: AiNodesGenerateInput;
}>;


export type AiNodesGenerateMutation = { __typename?: 'Mutation', aiNodesGenerate?: { __typename?: 'AiNodesGeneratePayload', success: boolean } | null };

export type MetricsGenerateFromFormulaMutationVariables = Exact<{
  input: MetricsGenerateFromFormulaInput;
}>;


export type MetricsGenerateFromFormulaMutation = { __typename?: 'Mutation', metricsGenerateFromFormula?: { __typename?: 'MetricsGenerateFromFormulaPayload', success: boolean } | null };

export type StrategyAiConversationQueryVariables = Exact<{
  strategyId: Scalars['ID']['input'];
}>;


export type StrategyAiConversationQuery = { __typename?: 'Query', strategy?: { __typename?: 'Strategy', id: string, aiConversation?: { __typename?: 'AiConversation', id: string, aiConversationMessages: Array<{ __typename?: 'AiConversationMessage', id: string, requestRole: string, requestContent: string, responseRole: string, responseContent: string }> } | null } | null };

export type BasicCardRequiredFieldsFragment = { __typename?: 'BasicCard', id: string, classType: string };

export type BasicCardIndexFieldsFragment = { __typename?: 'BasicCard', cardTypeId?: string | null, createdAt: any, description?: string | null, dueDate?: any | null, externalUrl?: string | null, externalUrlTitle?: string | null, goalHypothesis?: string | null, name?: string | null, results?: string | null, teamType?: TeamTypeEnum | null, id: string, classType: string };

export type BasicCardPrivateFieldsFragment = { __typename?: 'BasicCard', ownerId?: string | null, owner?: { __typename?: 'User', id: string, classType: string, name: string, email: string } | null };

export type BasicCardSubscriptionFieldsFragment = { __typename?: 'BasicCard', classType: string, commentsCount: number, confidenceRating?: ConfidenceRatingEnum | null, createdAt: any, ownerId?: string | null, recentActivity?: boolean | null, rfId: string, showDescription?: boolean | null, showGoalHypothesis?: boolean | null, showResults?: boolean | null, status: DomainObjectStatusEnum, updatedAt: any, cardTypeId?: string | null, description?: string | null, dueDate?: any | null, externalUrl?: string | null, externalUrlTitle?: string | null, goalHypothesis?: string | null, name?: string | null, results?: string | null, teamType?: TeamTypeEnum | null, id: string };

export type BasicCardFieldsFragment = { __typename?: 'BasicCard', classType: string, commentsCount: number, confidenceRating?: ConfidenceRatingEnum | null, createdAt: any, ownerId?: string | null, recentActivity?: boolean | null, rfId: string, showDescription?: boolean | null, showGoalHypothesis?: boolean | null, showResults?: boolean | null, status: DomainObjectStatusEnum, updatedAt: any, cardTypeId?: string | null, description?: string | null, dueDate?: any | null, externalUrl?: string | null, externalUrlTitle?: string | null, goalHypothesis?: string | null, name?: string | null, results?: string | null, teamType?: TeamTypeEnum | null, id: string, cardType?: { __typename?: 'CardType', id: string, classType: string, name?: string | null, icon?: string | null, color?: string | null, showInMenu: boolean } | null, labels?: Array<{ __typename?: 'Label', id: string, classType: string, name: string }> | null, owner?: { __typename?: 'User', id: string, classType: string, name: string, email: string } | null };

export type BasicCardQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type BasicCardQuery = { __typename?: 'Query', basicCard?: { __typename?: 'BasicCard', classType: string, commentsCount: number, confidenceRating?: ConfidenceRatingEnum | null, createdAt: any, ownerId?: string | null, recentActivity?: boolean | null, rfId: string, showDescription?: boolean | null, showGoalHypothesis?: boolean | null, showResults?: boolean | null, status: DomainObjectStatusEnum, updatedAt: any, cardTypeId?: string | null, description?: string | null, dueDate?: any | null, externalUrl?: string | null, externalUrlTitle?: string | null, goalHypothesis?: string | null, name?: string | null, results?: string | null, teamType?: TeamTypeEnum | null, id: string, cardType?: { __typename?: 'CardType', id: string, classType: string, name?: string | null, icon?: string | null, color?: string | null, showInMenu: boolean } | null, labels?: Array<{ __typename?: 'Label', id: string, classType: string, name: string }> | null, owner?: { __typename?: 'User', id: string, classType: string, name: string, email: string } | null } | null };

export type BasicCardsQueryVariables = Exact<{
  filter?: InputMaybe<Scalars['String']['input']>;
  strategyId?: InputMaybe<Scalars['ID']['input']>;
  order?: InputMaybe<BasicCardOrderingInput>;
  page?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type BasicCardsQuery = { __typename?: 'Query', basicCards?: { __typename?: 'BasicCardCollection', collection: Array<{ __typename?: 'BasicCard', id: string, cardTypeName?: string | null, containeeCount?: number | null, classType: string, commentsCount: number, confidenceRating?: ConfidenceRatingEnum | null, createdAt: any, ownerId?: string | null, recentActivity?: boolean | null, rfId: string, showDescription?: boolean | null, showGoalHypothesis?: boolean | null, showResults?: boolean | null, status: DomainObjectStatusEnum, updatedAt: any, cardTypeId?: string | null, description?: string | null, dueDate?: any | null, externalUrl?: string | null, externalUrlTitle?: string | null, goalHypothesis?: string | null, name?: string | null, results?: string | null, teamType?: TeamTypeEnum | null, strategies: Array<{ __typename?: 'Strategy', id: string, name?: string | null, classType: string }>, cardType?: { __typename?: 'CardType', id: string, classType: string, name?: string | null, icon?: string | null, color?: string | null, showInMenu: boolean } | null, labels?: Array<{ __typename?: 'Label', id: string, classType: string, name: string }> | null, owner?: { __typename?: 'User', id: string, classType: string, name: string, email: string } | null }>, metadata: { __typename?: 'CollectionMetadata', page: number, totalPages: number, limitValue: number, totalCount: number } } | null, organization?: { __typename?: 'Organization', id: string, classType: string } | null };

export type BasicCardEntitiesQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  workflowState?: InputMaybe<EntityWorkflowStateEnum>;
}>;


export type BasicCardEntitiesQuery = { __typename?: 'Query', basicCardEntities?: { __typename?: 'EntityCollection', collection: Array<{ __typename?: 'Entity', id: string, classType: string, entityAttachmentsCount: number, foreignId?: string | null, foreignType?: string | null, happenedOnWeek?: any | null, sourceName?: string | null, sourceUrl?: string | null, summaryFull?: string | null, summaryShort?: string | null, commentsCount: number, displaySummary?: string | null, dueDate?: any | null, entityType?: string | null, foreignState?: string | null, goalHypothesis?: string | null, happenedAt?: any | null, hasEditedHeadline?: boolean | null, impact?: ImpactEnum | null, importance?: ImportanceEnum | null, linkTitle?: string | null, linkUrl?: string | null, name?: string | null, organizationId: string, ownerId?: string | null, results?: string | null, rfId: string, showGoalHypothesis?: boolean | null, showResults?: boolean | null, showSummary?: boolean | null, summary?: string | null, workflowState?: EntityWorkflowStateEnum | null, containerEntityContainments?: Array<{ __typename?: 'EntityContainment', id: string, classType: string, containerId: string, containerClassName: string }> | null, labels?: Array<{ __typename?: 'Label', id: string, classType: string, name: string }> | null, thumbnail?: { __typename?: 'Attachment', id: string, classType: string, entityId: string, url: string } | null, owner?: { __typename?: 'User', id: string, classType: string, name: string, email: string, sourceName: string } | null, classifications?: Array<{ __typename?: 'Classification', id: string, classType: string, category?: string | null, name?: string | null }> | null }>, metadata: { __typename?: 'CollectionMetadata', page: number, totalPages: number, limitValue: number, totalCount: number } } | null };

export type BasicCardCommentsQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type BasicCardCommentsQuery = { __typename?: 'Query', basicCard?: { __typename?: 'BasicCard', id: string, classType: string, comments?: Array<{ __typename?: 'Comment', id: string, body: string, classType: string, commentableId: string, commentableType: string, createdAt: any, creatorId?: string | null, creator?: { __typename?: 'User', id: string, classType: string, email: string, name: string } | null }> | null } | null };

export type BasicCardCreateMutationVariables = Exact<{
  input: BasicCardCreateInput;
}>;


export type BasicCardCreateMutation = { __typename?: 'Mutation', basicCardCreate?: { __typename?: 'BasicCardCreatePayload', basicCard?: { __typename?: 'BasicCard', classType: string, commentsCount: number, confidenceRating?: ConfidenceRatingEnum | null, createdAt: any, ownerId?: string | null, recentActivity?: boolean | null, rfId: string, showDescription?: boolean | null, showGoalHypothesis?: boolean | null, showResults?: boolean | null, status: DomainObjectStatusEnum, updatedAt: any, cardTypeId?: string | null, description?: string | null, dueDate?: any | null, externalUrl?: string | null, externalUrlTitle?: string | null, goalHypothesis?: string | null, name?: string | null, results?: string | null, teamType?: TeamTypeEnum | null, id: string, cardType?: { __typename?: 'CardType', id: string, classType: string, name?: string | null, icon?: string | null, color?: string | null, showInMenu: boolean } | null, labels?: Array<{ __typename?: 'Label', id: string, classType: string, name: string }> | null, owner?: { __typename?: 'User', id: string, classType: string, name: string, email: string } | null } | null, errors: Array<{ __typename?: 'Error', message: string, path?: Array<string> | null }> } | null };

export type BasicCardDeleteMutationVariables = Exact<{
  input: BasicCardDeleteInput;
}>;


export type BasicCardDeleteMutation = { __typename?: 'Mutation', basicCardDelete?: { __typename?: 'BasicCardDeletePayload', basicCard?: { __typename?: 'BasicCard', classType: string, commentsCount: number, confidenceRating?: ConfidenceRatingEnum | null, createdAt: any, ownerId?: string | null, recentActivity?: boolean | null, rfId: string, showDescription?: boolean | null, showGoalHypothesis?: boolean | null, showResults?: boolean | null, status: DomainObjectStatusEnum, updatedAt: any, cardTypeId?: string | null, description?: string | null, dueDate?: any | null, externalUrl?: string | null, externalUrlTitle?: string | null, goalHypothesis?: string | null, name?: string | null, results?: string | null, teamType?: TeamTypeEnum | null, id: string, cardType?: { __typename?: 'CardType', id: string, classType: string, name?: string | null, icon?: string | null, color?: string | null, showInMenu: boolean } | null, labels?: Array<{ __typename?: 'Label', id: string, classType: string, name: string }> | null, owner?: { __typename?: 'User', id: string, classType: string, name: string, email: string } | null } | null, errors: Array<{ __typename?: 'Error', message: string, path?: Array<string> | null }> } | null };

export type BillingCreateSubscriptionMutationVariables = Exact<{
  input: BillingCreateSubscriptionInput;
}>;


export type BillingCreateSubscriptionMutation = { __typename?: 'Mutation', billingCreateSubscription?: { __typename?: 'BillingCreateSubscriptionPayload', response: any } | null };

export type BillingProvisionSubscriptionMutationVariables = Exact<{
  input: BillingProvisionSubscriptionInput;
}>;


export type BillingProvisionSubscriptionMutation = { __typename?: 'Mutation', billingProvisionSubscription?: { __typename?: 'BillingProvisionSubscriptionPayload', response: any } | null };

export type BusinessContextRequiredFieldsFragment = { __typename?: 'BusinessContext', id: string, classType: string, slug?: string | null };

export type BusinessContextSubscriptionFieldsFragment = { __typename?: 'BusinessContext', businessName?: string | null, content?: string | null, organizationId: string, parentBusinessContextId?: string | null, parentBusinessContextSlug?: string | null, createdAt: any, data?: any | null, name?: string | null, updatedAt: any, id: string, classType: string, slug?: string | null };

export type BusinessContextFieldsFragment = { __typename?: 'BusinessContext', businessName?: string | null, content?: string | null, organizationId: string, parentBusinessContextId?: string | null, parentBusinessContextSlug?: string | null, createdAt: any, data?: any | null, name?: string | null, updatedAt: any, id: string, classType: string, slug?: string | null, businessContexts?: Array<{ __typename?: 'BusinessContext', businessName?: string | null, name?: string | null, organizationId: string, parentBusinessContextId?: string | null, parentBusinessContextSlug?: string | null, id: string, classType: string, slug?: string | null }> | null, parentBusinessContexts?: Array<{ __typename?: 'BusinessContext', businessName?: string | null, name?: string | null, organizationId: string, parentBusinessContextId?: string | null, parentBusinessContextSlug?: string | null, id: string, classType: string, slug?: string | null }> | null, strategies?: Array<{ __typename?: 'Strategy', id: string, classType: string, name?: string | null, businessContextId?: string | null }> | null, cachedAiAssistantFiles?: Array<{ __typename?: 'AiAssistantFile', id: string, classType: string, name: string, remoteId: string, cacheableId: string, cacheableType: string }> | null };

export type BusinessContextQueryVariables = Exact<{
  id?: InputMaybe<Scalars['ID']['input']>;
}>;


export type BusinessContextQuery = { __typename?: 'Query', businessContext?: { __typename?: 'BusinessContext', businessName?: string | null, content?: string | null, organizationId: string, parentBusinessContextId?: string | null, parentBusinessContextSlug?: string | null, createdAt: any, data?: any | null, name?: string | null, updatedAt: any, id: string, classType: string, slug?: string | null, parentBusinessContext?: { __typename?: 'BusinessContext', name?: string | null, parentBusinessContextId?: string | null, parentBusinessContextSlug?: string | null, businessName?: string | null, content?: string | null, organizationId: string, createdAt: any, data?: any | null, updatedAt: any, id: string, classType: string, slug?: string | null, businessContexts?: Array<{ __typename?: 'BusinessContext', businessName?: string | null, name?: string | null, organizationId: string, parentBusinessContextId?: string | null, parentBusinessContextSlug?: string | null, id: string, classType: string, slug?: string | null }> | null, parentBusinessContexts?: Array<{ __typename?: 'BusinessContext', businessName?: string | null, name?: string | null, organizationId: string, parentBusinessContextId?: string | null, parentBusinessContextSlug?: string | null, id: string, classType: string, slug?: string | null }> | null, strategies?: Array<{ __typename?: 'Strategy', id: string, classType: string, name?: string | null, businessContextId?: string | null }> | null, cachedAiAssistantFiles?: Array<{ __typename?: 'AiAssistantFile', id: string, classType: string, name: string, remoteId: string, cacheableId: string, cacheableType: string }> | null } | null, businessContexts?: Array<{ __typename?: 'BusinessContext', businessName?: string | null, name?: string | null, organizationId: string, parentBusinessContextId?: string | null, parentBusinessContextSlug?: string | null, id: string, classType: string, slug?: string | null }> | null, parentBusinessContexts?: Array<{ __typename?: 'BusinessContext', businessName?: string | null, name?: string | null, organizationId: string, parentBusinessContextId?: string | null, parentBusinessContextSlug?: string | null, id: string, classType: string, slug?: string | null }> | null, strategies?: Array<{ __typename?: 'Strategy', id: string, classType: string, name?: string | null, businessContextId?: string | null }> | null, cachedAiAssistantFiles?: Array<{ __typename?: 'AiAssistantFile', id: string, classType: string, name: string, remoteId: string, cacheableId: string, cacheableType: string }> | null } | null };

export type BusinessContextsQueryVariables = Exact<{
  parentBusinessContextId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type BusinessContextsQuery = { __typename?: 'Query', businessContexts?: Array<{ __typename?: 'BusinessContext', businessName?: string | null, content?: string | null, organizationId: string, parentBusinessContextId?: string | null, parentBusinessContextSlug?: string | null, createdAt: any, data?: any | null, name?: string | null, updatedAt: any, id: string, classType: string, slug?: string | null, businessContexts?: Array<{ __typename?: 'BusinessContext', businessName?: string | null, name?: string | null, organizationId: string, parentBusinessContextId?: string | null, parentBusinessContextSlug?: string | null, id: string, classType: string, slug?: string | null }> | null, parentBusinessContexts?: Array<{ __typename?: 'BusinessContext', businessName?: string | null, name?: string | null, organizationId: string, parentBusinessContextId?: string | null, parentBusinessContextSlug?: string | null, id: string, classType: string, slug?: string | null }> | null, strategies?: Array<{ __typename?: 'Strategy', id: string, classType: string, name?: string | null, businessContextId?: string | null }> | null, cachedAiAssistantFiles?: Array<{ __typename?: 'AiAssistantFile', id: string, classType: string, name: string, remoteId: string, cacheableId: string, cacheableType: string }> | null }> | null };

export type BusinessContextCreateMutationVariables = Exact<{
  input: BusinessContextCreateInput;
}>;


export type BusinessContextCreateMutation = { __typename?: 'Mutation', businessContextCreate?: { __typename?: 'BusinessContextCreatePayload', businessContext?: { __typename?: 'BusinessContext', businessName?: string | null, content?: string | null, organizationId: string, parentBusinessContextId?: string | null, parentBusinessContextSlug?: string | null, createdAt: any, data?: any | null, name?: string | null, updatedAt: any, id: string, classType: string, slug?: string | null } | null, errors: Array<{ __typename?: 'Error', message: string, path?: Array<string> | null }> } | null };

export type BusinessContextGenerateMutationVariables = Exact<{
  input: BusinessContextGenerateInput;
}>;


export type BusinessContextGenerateMutation = { __typename?: 'Mutation', businessContextGenerate?: { __typename?: 'BusinessContextGeneratePayload', errors: Array<{ __typename?: 'Error', message: string, path?: Array<string> | null }> } | null };

export type BusinessContextEmptyMutationVariables = Exact<{
  input: BusinessContextEmptyInput;
}>;


export type BusinessContextEmptyMutation = { __typename?: 'Mutation', businessContextEmpty?: { __typename?: 'BusinessContextEmptyPayload', businessContext?: { __typename?: 'BusinessContext', businessName?: string | null, content?: string | null, organizationId: string, parentBusinessContextId?: string | null, parentBusinessContextSlug?: string | null, createdAt: any, data?: any | null, name?: string | null, updatedAt: any, id: string, classType: string, slug?: string | null, businessContexts?: Array<{ __typename?: 'BusinessContext', businessName?: string | null, name?: string | null, organizationId: string, parentBusinessContextId?: string | null, parentBusinessContextSlug?: string | null, id: string, classType: string, slug?: string | null }> | null, parentBusinessContexts?: Array<{ __typename?: 'BusinessContext', businessName?: string | null, name?: string | null, organizationId: string, parentBusinessContextId?: string | null, parentBusinessContextSlug?: string | null, id: string, classType: string, slug?: string | null }> | null, strategies?: Array<{ __typename?: 'Strategy', id: string, classType: string, name?: string | null, businessContextId?: string | null }> | null, cachedAiAssistantFiles?: Array<{ __typename?: 'AiAssistantFile', id: string, classType: string, name: string, remoteId: string, cacheableId: string, cacheableType: string }> | null } | null, errors: Array<{ __typename?: 'Error', message: string, path?: Array<string> | null }> } | null };

export type BusinessContextDeleteMutationVariables = Exact<{
  input: BusinessContextDeleteInput;
}>;


export type BusinessContextDeleteMutation = { __typename?: 'Mutation', businessContextDelete?: { __typename?: 'BusinessContextDeletePayload', crudOperation: { __typename?: 'TypesBusinessContextTypeGraphqlCrudOperation', operation: CrudOperationEnum, data?: { __typename?: 'BusinessContext', id: string } | null }, errors: Array<{ __typename?: 'Error', message: string, path?: Array<string> | null }> } | null };

export type CommonCardTypeFieldsFragment = { __typename?: 'CardType', id: string, classType: string, name?: string | null, icon?: string | null, color?: string | null, showInMenu: boolean };

export type CardTypeSubscriptionFieldsFragment = { __typename?: 'CardType', id: string, classType: string, name?: string | null, icon?: string | null, color?: string | null, showInMenu: boolean };

export type CardTypesQueryVariables = Exact<{ [key: string]: never; }>;


export type CardTypesQuery = { __typename?: 'Query', cardTypes?: Array<{ __typename?: 'CardType', id: string, classType: string, name?: string | null, icon?: string | null, color?: string | null, showInMenu: boolean }> | null };

export type CardTypeCreateMutationVariables = Exact<{
  input: CardTypeCreateInput;
}>;


export type CardTypeCreateMutation = { __typename?: 'Mutation', cardTypeCreate?: { __typename?: 'CardTypeCreatePayload', cardType?: { __typename?: 'CardType', id: string, classType: string, name?: string | null, icon?: string | null, color?: string | null, showInMenu: boolean } | null, errors: Array<{ __typename?: 'Error', message: string, path?: Array<string> | null }> } | null };

export type CardTypeUpdateMutationVariables = Exact<{
  input: CardTypeUpdateInput;
}>;


export type CardTypeUpdateMutation = { __typename?: 'Mutation', cardTypeUpdate?: { __typename?: 'CardTypeUpdatePayload', cardType?: { __typename?: 'CardType', id: string, classType: string, name?: string | null, icon?: string | null, color?: string | null, showInMenu: boolean } | null, errors: Array<{ __typename?: 'Error', message: string, path?: Array<string> | null }> } | null };

export type CardTypeDeleteMutationVariables = Exact<{
  input: CardTypeDeleteInput;
}>;


export type CardTypeDeleteMutation = { __typename?: 'Mutation', crudOperation?: { __typename?: 'CardTypeDeletePayload', crudOperation: { __typename?: 'TypesCardTypeTypeGraphqlCrudOperation', operation: CrudOperationEnum, data?: { __typename?: 'CardType', id: string, classType: string } | null }, errors: Array<{ __typename?: 'Error', message: string, path?: Array<string> | null }> } | null };

export type ChangelogEntityFieldsFragment = { __typename?: 'Entity', id: string, classType: string, dueDate?: any | null, entityAttachmentsCount: number, entityType?: string | null, goalHypothesis?: string | null, happenedAt?: any | null, happenedOnWeek?: any | null, importance?: ImportanceEnum | null, impact?: ImpactEnum | null, linkTitle?: string | null, linkUrl?: string | null, name?: string | null, organizationId: string, results?: string | null, sourceName?: string | null, summary?: string | null, summaryShort?: string | null, summaryFull?: string | null, classifications?: Array<{ __typename?: 'Classification', id: string, classType: string, category?: string | null, name?: string | null }> | null, containerEntityContainments?: Array<{ __typename?: 'EntityContainment', id: string, classType: string, containerId: string, containerClassName: string }> | null, entityContributions?: Array<{ __typename?: 'EntityContribution', id: string, classType: string, contributor: { __typename?: 'SourceIdentity', id: string, name: string, email?: string | null, sourceName: string } | { __typename?: 'User', id: string, name: string, email: string, sourceName: string } }> | null, thumbnail?: { __typename?: 'Attachment', id: string, classType: string, entityId: string, url: string } | null, labels?: Array<{ __typename?: 'Label', id: string, classType: string, name: string }> | null };

export type CommentSubscriptionFieldsFragment = { __typename?: 'Comment', id: string, body: string, classType: string, commentableId: string, commentableType: string, createdAt: any, creatorId?: string | null };

export type CommentFieldsFragment = { __typename?: 'Comment', id: string, body: string, classType: string, commentableId: string, commentableType: string, createdAt: any, creatorId?: string | null, creator?: { __typename?: 'User', id: string, classType: string, email: string, name: string } | null };

export type CommentCreateMutationVariables = Exact<{
  input: CommentCreateInput;
}>;


export type CommentCreateMutation = { __typename?: 'Mutation', commentCreate?: { __typename?: 'CommentCreatePayload', comment?: { __typename?: 'Comment', id: string, body: string, classType: string, commentableId: string, commentableType: string, createdAt: any, creatorId?: string | null, creator?: { __typename?: 'User', id: string, classType: string, email: string, name: string } | null } | null } | null };

export type CommentDeleteMutationVariables = Exact<{
  input: CommentDeleteInput;
}>;


export type CommentDeleteMutation = { __typename?: 'Mutation', commentDelete?: { __typename?: 'CommentDeletePayload', comment?: { __typename?: 'Comment', id: string, body: string, classType: string, commentableId: string, commentableType: string, createdAt: any, creatorId?: string | null, creator?: { __typename?: 'User', id: string, classType: string, email: string, name: string } | null } | null } | null };

export type CommentThreadSubscriptionFieldsFragment = { __typename?: 'CommentThread', id: string, classType: string, commentsCount: number, createdAt: any, creatorId: string, rfId: string, sendToSlack?: boolean | null, updatedAt: any };

export type CommentThreadFieldsFragment = { __typename?: 'CommentThread', id: string, classType: string, commentsCount: number, createdAt: any, creatorId: string, rfId: string, sendToSlack?: boolean | null, updatedAt: any, creator: { __typename?: 'User', id: string, classType: string, name: string, email: string } };

export type ContributorQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type ContributorQuery = { __typename?: 'Query', contributor?: { __typename?: 'SourceIdentity', id: string, classType: string, name: string, sourceName: string, searchableContributorId?: string | null } | { __typename?: 'User', id: string, classType: string, name: string, sourceName: string, searchableContributorId?: string | null } | null };

export type ContributorsAutocompleteQueryVariables = Exact<{
  query: Scalars['String']['input'];
}>;


export type ContributorsAutocompleteQuery = { __typename?: 'Query', contributorsAutocomplete?: Array<{ __typename?: 'SourceIdentity', id: string, classType: string, name: string, sourceName: string, searchableContributorId?: string | null } | { __typename?: 'User', id: string, classType: string, name: string, sourceName: string, searchableContributorId?: string | null }> | null };

export type EmailAutocompleteQueryVariables = Exact<{
  query: Scalars['String']['input'];
  requireEmail?: InputMaybe<Scalars['CastableBoolean']['input']>;
}>;


export type EmailAutocompleteQuery = { __typename?: 'Query', contributorsAutocomplete?: Array<{ __typename?: 'SourceIdentity', id: string, classType: string, name: string, email?: string | null } | { __typename?: 'User', id: string, classType: string, name: string, email: string }> | null };

export type EntityCreateContributorMutationVariables = Exact<{
  input: EntityCreateContributorInput;
}>;


export type EntityCreateContributorMutation = { __typename?: 'Mutation', entityCreateContributor?: { __typename?: 'EntityCreateContributorPayload', entity: { __typename?: 'Entity', id: string, classType: string, entityContributions?: Array<{ __typename?: 'EntityContribution', id: string, classType: string, contributor: { __typename?: 'SourceIdentity', id: string, name: string, email?: string | null, sourceName: string } | { __typename?: 'User', id: string, name: string, email: string, sourceName: string } }> | null } } | null };

export type EntityDeleteContributorMutationVariables = Exact<{
  input: EntityDeleteContributorInput;
}>;


export type EntityDeleteContributorMutation = { __typename?: 'Mutation', entityDeleteContributor?: { __typename?: 'EntityDeleteContributorPayload', entity: { __typename?: 'Entity', id: string, classType: string, entityContributions?: Array<{ __typename?: 'EntityContribution', id: string, contributor: { __typename?: 'SourceIdentity', id: string, classType: string, name: string, email?: string | null, sourceName: string } | { __typename?: 'User', id: string, classType: string, name: string, email: string, sourceName: string } }> | null } } | null };

export type CorrelationPairQueryVariables = Exact<{
  sourceId: Scalars['ID']['input'];
  targetId: Scalars['ID']['input'];
  range?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['String']['input']>;
}>;


export type CorrelationPairQuery = { __typename?: 'Query', organization?: { __typename?: 'Organization', id: string, classType: string, correlate?: { __typename?: 'CorrelationPair', id: string, classType: string, score?: number | null, sourceLagDays: number, targetLagDays: number, range?: string | null, startDate?: any | null, endDate?: any | null, sourceMetric: { __typename?: 'Metric', id: string, classType: string, name?: string | null, positiveDirection: MetricPositiveDirectionsEnum }, targetMetric: { __typename?: 'Metric', id: string, classType: string, name?: string | null, positiveDirection: MetricPositiveDirectionsEnum } } | null } | null };

export type CorrelationPairMetricsQueryVariables = Exact<{
  sourceId: Scalars['ID']['input'];
  targetId: Scalars['ID']['input'];
  range?: InputMaybe<Scalars['String']['input']>;
  interval?: InputMaybe<IntervalEnum>;
  startDate?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['String']['input']>;
  cumulative?: InputMaybe<Scalars['CastableBoolean']['input']>;
  sourceLagDays?: InputMaybe<Scalars['Int']['input']>;
  targetLagDays?: InputMaybe<Scalars['Int']['input']>;
}>;


export type CorrelationPairMetricsQuery = { __typename?: 'Query', organization?: { __typename?: 'Organization', id: string, classType: string, correlate?: { __typename?: 'CorrelationPair', id: string, classType: string, sourceMetric: { __typename?: 'Metric', id: string, classType: string, name?: string | null, positiveDirection: MetricPositiveDirectionsEnum, metricDataPoints: Array<{ __typename?: 'MetricDataPoint', date: any, value: number }> }, targetMetric: { __typename?: 'Metric', id: string, classType: string, name?: string | null, positiveDirection: MetricPositiveDirectionsEnum, metricDataPoints: Array<{ __typename?: 'MetricDataPoint', date: any, value: number }> } } | null } | null };

export type CorrelationPairUpdateMutationVariables = Exact<{
  input: CorrelationPairUpdateInput;
}>;


export type CorrelationPairUpdateMutation = { __typename?: 'Mutation', correlationPairUpdate?: { __typename?: 'CorrelationPairUpdatePayload', correlationPair?: { __typename?: 'CorrelationPair', id: string, classType: string, sourceLagDays: number, targetLagDays: number, range?: string | null, startDate?: any | null, endDate?: any | null } | null, errors: Array<{ __typename?: 'Error', message: string, path?: Array<string> | null }> } | null };

export type CredentialFieldsFragment = { __typename?: 'Credential', id: string, classType: string, displayName?: string | null, createdAt?: any | null, sourceName?: string | null, updatedAt?: any | null, apiKey?: string | null, clientId?: string | null, database?: string | null, fileData?: any | null, host?: string | null, label?: string | null, port?: string | null, projectId?: string | null, region?: string | null, role?: string | null, schema?: string | null, username?: string | null, warehouse?: string | null, workspaceId?: string | null, file?: { __typename?: 'FileAttachment', id: string, metadata?: { __typename?: 'FileAttachmentMetadata', filename: string } | null } | null };

export type CredentialQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type CredentialQuery = { __typename?: 'Query', credential?: { __typename?: 'Credential', id: string, classType: string, displayName?: string | null, createdAt?: any | null, sourceName?: string | null, updatedAt?: any | null, apiKey?: string | null, clientId?: string | null, database?: string | null, fileData?: any | null, host?: string | null, label?: string | null, port?: string | null, projectId?: string | null, region?: string | null, role?: string | null, schema?: string | null, username?: string | null, warehouse?: string | null, workspaceId?: string | null, file?: { __typename?: 'FileAttachment', id: string, metadata?: { __typename?: 'FileAttachmentMetadata', filename: string } | null } | null } | null };

export type CredentialsQueryVariables = Exact<{
  sourceName?: InputMaybe<Scalars['String']['input']>;
}>;


export type CredentialsQuery = { __typename?: 'Query', credentials?: Array<{ __typename?: 'Credential', id: string, classType: string, displayName?: string | null, createdAt?: any | null, sourceName?: string | null, updatedAt?: any | null, apiKey?: string | null, clientId?: string | null, database?: string | null, fileData?: any | null, host?: string | null, label?: string | null, port?: string | null, projectId?: string | null, region?: string | null, role?: string | null, schema?: string | null, username?: string | null, warehouse?: string | null, workspaceId?: string | null, file?: { __typename?: 'FileAttachment', id: string, metadata?: { __typename?: 'FileAttachmentMetadata', filename: string } | null } | null }> | null };

export type SuperAdminCredentialsQueryVariables = Exact<{
  sourceName?: InputMaybe<Scalars['String']['input']>;
}>;


export type SuperAdminCredentialsQuery = { __typename?: 'Query', superAdminCredentials?: Array<{ __typename?: 'SuperAdminCredential', id: string, displayName?: string | null }> | null };

export type CredentialMetricNamesQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type CredentialMetricNamesQuery = { __typename?: 'Query', credential?: { __typename?: 'Credential', id: string, metrics?: Array<{ __typename?: 'Metric', id: string, classType: string, name?: string | null }> | null } | null };

export type CredentialCreateMutationVariables = Exact<{
  input: CredentialCreateInput;
}>;


export type CredentialCreateMutation = { __typename?: 'Mutation', credentialCreate?: { __typename?: 'CredentialCreatePayload', credential?: { __typename?: 'Credential', id: string, classType: string, displayName?: string | null, createdAt?: any | null, sourceName?: string | null, updatedAt?: any | null, apiKey?: string | null, clientId?: string | null, database?: string | null, fileData?: any | null, host?: string | null, label?: string | null, port?: string | null, projectId?: string | null, region?: string | null, role?: string | null, schema?: string | null, username?: string | null, warehouse?: string | null, workspaceId?: string | null, file?: { __typename?: 'FileAttachment', id: string, metadata?: { __typename?: 'FileAttachmentMetadata', filename: string } | null } | null } | null, errors: Array<{ __typename?: 'Error', message: string, path?: Array<string> | null }> } | null };

export type CredentialTestMutationVariables = Exact<{
  input: CredentialTestInput;
}>;


export type CredentialTestMutation = { __typename?: 'Mutation', credentialTest?: { __typename?: 'CredentialTestPayload', success: boolean, credential: { __typename?: 'Credential', id: string, classType: string, displayName?: string | null, createdAt?: any | null, sourceName?: string | null, updatedAt?: any | null, apiKey?: string | null, clientId?: string | null, database?: string | null, fileData?: any | null, host?: string | null, label?: string | null, port?: string | null, projectId?: string | null, region?: string | null, role?: string | null, schema?: string | null, username?: string | null, warehouse?: string | null, workspaceId?: string | null, file?: { __typename?: 'FileAttachment', id: string, metadata?: { __typename?: 'FileAttachmentMetadata', filename: string } | null } | null }, errors?: Array<{ __typename?: 'Error', message: string, path?: Array<string> | null }> | null } | null };

export type CredentialAttributesTestMutationVariables = Exact<{
  input: CredentialAttributesTestInput;
}>;


export type CredentialAttributesTestMutation = { __typename?: 'Mutation', credentialAttributesTest?: { __typename?: 'CredentialAttributesTestPayload', success: boolean, errors?: Array<{ __typename?: 'Error', message: string, path?: Array<string> | null }> | null } | null };

export type DomainObjectsDeleteMutationVariables = Exact<{
  input: DomainObjectsDeleteInput;
}>;


export type DomainObjectsDeleteMutation = { __typename?: 'Mutation', crudOperation?: { __typename?: 'DomainObjectsDeletePayload', crudOperation: { __typename?: 'TypesUnionsDomainObjectUnionArrayGraphqlCrudOperation', operation: CrudOperationEnum, data?: Array<{ __typename?: 'AiAssistantFile' } | { __typename?: 'BasicCard', id: string, classType: string } | { __typename?: 'BusinessContext' } | { __typename?: 'CardType', id: string, classType: string } | { __typename?: 'Chat' } | { __typename?: 'Comment' } | { __typename?: 'CommentThread' } | { __typename?: 'Credential' } | { __typename?: 'Edge' } | { __typename?: 'Entity', id: string, classType: string } | { __typename?: 'Favorite' } | { __typename?: 'Goal' } | { __typename?: 'GoogleIntegration' } | { __typename?: 'Integration', id: string, classType: string } | { __typename?: 'JiraIntegration' } | { __typename?: 'LookerDashboard' } | { __typename?: 'MapImage', id: string, classType: string } | { __typename?: 'Message' } | { __typename?: 'Metric', id: string, classType: string } | { __typename?: 'MetricSource' } | { __typename?: 'Node' } | { __typename?: 'Note', id: string, classType: string } | { __typename?: 'RecurringReportConfiguration' } | { __typename?: 'Report' } | { __typename?: 'Schedule' } | { __typename?: 'Section', id: string, classType: string } | { __typename?: 'Strategy', id: string, classType: string } | { __typename?: 'Task' } | { __typename?: 'User' }> | null }, errors: Array<{ __typename?: 'Error', message: string, path?: Array<string> | null }> } | null };

export type DomainObjectsBulkLabelMutationVariables = Exact<{
  input: DomainObjectsBulkLabelInput;
}>;


export type DomainObjectsBulkLabelMutation = { __typename?: 'Mutation', domainObjectsBulkLabel?: { __typename?: 'DomainObjectsBulkLabelPayload', domainObjects?: Array<{ __typename?: 'BasicCard' } | { __typename?: 'Entity', id: string, rfId: string, classType: string, labels?: Array<{ __typename?: 'Label', id: string, name: string }> | null } | { __typename?: 'Metric', id: string, rfId: string, classType: string, labels?: Array<{ __typename?: 'Label', id: string, name: string }> | null } | { __typename?: 'Strategy', id: string, rfId: string, classType: string, labels?: Array<{ __typename?: 'Label', id: string, name: string }> | null }> | null } | null };

export type EntitySubscriptionFieldsFragment = { __typename?: 'Entity', commentsCount: number, classType: string, displaySummary?: string | null, dueDate?: any | null, entityType?: string | null, foreignState?: string | null, foreignType?: string | null, goalHypothesis?: string | null, happenedAt?: any | null, hasEditedHeadline?: boolean | null, id: string, impact?: ImpactEnum | null, importance?: ImportanceEnum | null, linkTitle?: string | null, linkUrl?: string | null, name?: string | null, organizationId: string, ownerId?: string | null, results?: string | null, rfId: string, showGoalHypothesis?: boolean | null, showResults?: boolean | null, showSummary?: boolean | null, sourceName?: string | null, sourceUrl?: string | null, summary?: string | null, summaryShort?: string | null, summaryFull?: string | null, workflowState?: EntityWorkflowStateEnum | null };

export type EntityFieldsFragment = { __typename?: 'Entity', commentsCount: number, classType: string, displaySummary?: string | null, dueDate?: any | null, entityType?: string | null, foreignState?: string | null, foreignType?: string | null, goalHypothesis?: string | null, happenedAt?: any | null, hasEditedHeadline?: boolean | null, id: string, impact?: ImpactEnum | null, importance?: ImportanceEnum | null, linkTitle?: string | null, linkUrl?: string | null, name?: string | null, organizationId: string, ownerId?: string | null, results?: string | null, rfId: string, showGoalHypothesis?: boolean | null, showResults?: boolean | null, showSummary?: boolean | null, sourceName?: string | null, sourceUrl?: string | null, summary?: string | null, summaryShort?: string | null, summaryFull?: string | null, workflowState?: EntityWorkflowStateEnum | null, classifications?: Array<{ __typename?: 'Classification', id: string, classType: string, category?: string | null, name?: string | null }> | null };

export type EntityStrategyCardFragment = { __typename?: 'Entity', foreignId?: string | null, linkUrl?: string | null, recentActivity?: boolean | null, rfId: string, workflowState?: EntityWorkflowStateEnum | null, containeeStats?: any | null, entityAttachmentsCount: number, sourceSummary?: string | null, commentsCount: number, classType: string, displaySummary?: string | null, dueDate?: any | null, entityType?: string | null, foreignState?: string | null, foreignType?: string | null, goalHypothesis?: string | null, happenedAt?: any | null, hasEditedHeadline?: boolean | null, id: string, impact?: ImpactEnum | null, importance?: ImportanceEnum | null, linkTitle?: string | null, name?: string | null, organizationId: string, ownerId?: string | null, results?: string | null, showGoalHypothesis?: boolean | null, showResults?: boolean | null, showSummary?: boolean | null, sourceName?: string | null, sourceUrl?: string | null, summary?: string | null, summaryShort?: string | null, summaryFull?: string | null, entityContributions?: Array<{ __typename?: 'EntityContribution', id: string, classType: string, contributor: { __typename?: 'SourceIdentity', id: string, classType: string, name: string, email?: string | null, sourceName: string } | { __typename?: 'User', id: string, classType: string, name: string, email: string, sourceName: string } }> | null, organization: { __typename?: 'Organization', id: string, classType: string, name: string }, owner?: { __typename?: 'User', id: string, classType: string, name: string, email: string, sourceName: string } | null, labels?: Array<{ __typename?: 'Label', id: string, classType: string, name: string }> | null, classifications?: Array<{ __typename?: 'Classification', id: string, classType: string, category?: string | null, name?: string | null }> | null };

export type EntityBasicsFragment = { __typename?: 'Entity', entityAttachmentsCount: number, foreignId?: string | null, foreignType?: string | null, happenedOnWeek?: any | null, sourceName?: string | null, sourceUrl?: string | null, summaryFull?: string | null, summaryShort?: string | null, commentsCount: number, classType: string, displaySummary?: string | null, dueDate?: any | null, entityType?: string | null, foreignState?: string | null, goalHypothesis?: string | null, happenedAt?: any | null, hasEditedHeadline?: boolean | null, id: string, impact?: ImpactEnum | null, importance?: ImportanceEnum | null, linkTitle?: string | null, linkUrl?: string | null, name?: string | null, organizationId: string, ownerId?: string | null, results?: string | null, rfId: string, showGoalHypothesis?: boolean | null, showResults?: boolean | null, showSummary?: boolean | null, summary?: string | null, workflowState?: EntityWorkflowStateEnum | null, containerEntityContainments?: Array<{ __typename?: 'EntityContainment', id: string, classType: string, containerId: string, containerClassName: string }> | null, labels?: Array<{ __typename?: 'Label', id: string, classType: string, name: string }> | null, thumbnail?: { __typename?: 'Attachment', id: string, classType: string, entityId: string, url: string } | null, owner?: { __typename?: 'User', id: string, classType: string, name: string, email: string, sourceName: string } | null, classifications?: Array<{ __typename?: 'Classification', id: string, classType: string, category?: string | null, name?: string | null }> | null };

export type EntitiesFormAttributesFragment = { __typename?: 'Entity', createdAt?: any | null, goalHypothesis?: string | null, linkTitle?: string | null, linkUrl?: string | null, results?: string | null, summary?: string | null, sourceSummary?: string | null, updatedAt?: any | null, commentsCount: number, classType: string, displaySummary?: string | null, dueDate?: any | null, entityType?: string | null, foreignState?: string | null, foreignType?: string | null, happenedAt?: any | null, hasEditedHeadline?: boolean | null, id: string, impact?: ImpactEnum | null, importance?: ImportanceEnum | null, name?: string | null, organizationId: string, ownerId?: string | null, rfId: string, showGoalHypothesis?: boolean | null, showResults?: boolean | null, showSummary?: boolean | null, sourceName?: string | null, sourceUrl?: string | null, summaryShort?: string | null, summaryFull?: string | null, workflowState?: EntityWorkflowStateEnum | null, entityAttachments?: Array<{ __typename?: 'Attachment', id: string, classType: string, entityId: string, url: string }> | null, classifications?: Array<{ __typename?: 'Classification', id: string, classType: string, category?: string | null, name?: string | null }> | null };

export type EntityPrivateFieldsFragment = { __typename?: 'Entity', entityContributions?: Array<{ __typename?: 'EntityContribution', id: string, contributor: { __typename?: 'SourceIdentity', id: string, classType: string, name: string, email?: string | null, sourceName: string } | { __typename?: 'User', id: string, classType: string, name: string, email: string, sourceName: string } }> | null };

export type EntityDetailsFragment = { __typename?: 'Entity', goalHypothesis?: string | null, linkTitle?: string | null, linkUrl?: string | null, results?: string | null, sourceSummary?: string | null, summary?: string | null, summaryFull?: string | null, workflowState?: EntityWorkflowStateEnum | null, entityAttachmentsCount: number, foreignId?: string | null, foreignType?: string | null, happenedOnWeek?: any | null, sourceName?: string | null, sourceUrl?: string | null, summaryShort?: string | null, commentsCount: number, classType: string, displaySummary?: string | null, dueDate?: any | null, entityType?: string | null, foreignState?: string | null, happenedAt?: any | null, hasEditedHeadline?: boolean | null, id: string, impact?: ImpactEnum | null, importance?: ImportanceEnum | null, name?: string | null, organizationId: string, ownerId?: string | null, rfId: string, showGoalHypothesis?: boolean | null, showResults?: boolean | null, showSummary?: boolean | null, entityAttachments?: Array<{ __typename?: 'Attachment', id: string, entityId: string, url: string, classType: string }> | null, containerEntityContainments?: Array<{ __typename?: 'EntityContainment', id: string, classType: string, containerId: string, containerClassName: string }> | null, labels?: Array<{ __typename?: 'Label', id: string, classType: string, name: string }> | null, thumbnail?: { __typename?: 'Attachment', id: string, classType: string, entityId: string, url: string } | null, owner?: { __typename?: 'User', id: string, classType: string, name: string, email: string, sourceName: string } | null, classifications?: Array<{ __typename?: 'Classification', id: string, classType: string, category?: string | null, name?: string | null }> | null };

export type EntityQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type EntityQuery = { __typename?: 'Query', entity?: { __typename?: 'Entity', goalHypothesis?: string | null, linkTitle?: string | null, linkUrl?: string | null, results?: string | null, sourceSummary?: string | null, summary?: string | null, summaryFull?: string | null, workflowState?: EntityWorkflowStateEnum | null, entityAttachmentsCount: number, foreignId?: string | null, foreignType?: string | null, happenedOnWeek?: any | null, sourceName?: string | null, sourceUrl?: string | null, summaryShort?: string | null, commentsCount: number, classType: string, displaySummary?: string | null, dueDate?: any | null, entityType?: string | null, foreignState?: string | null, happenedAt?: any | null, hasEditedHeadline?: boolean | null, id: string, impact?: ImpactEnum | null, importance?: ImportanceEnum | null, name?: string | null, organizationId: string, ownerId?: string | null, rfId: string, showGoalHypothesis?: boolean | null, showResults?: boolean | null, showSummary?: boolean | null, entityAttachments?: Array<{ __typename?: 'Attachment', id: string, entityId: string, url: string, classType: string }> | null, entityContributions?: Array<{ __typename?: 'EntityContribution', id: string, contributor: { __typename?: 'SourceIdentity', id: string, classType: string, name: string, email?: string | null, sourceName: string } | { __typename?: 'User', id: string, classType: string, name: string, email: string, sourceName: string } }> | null, containerEntityContainments?: Array<{ __typename?: 'EntityContainment', id: string, classType: string, containerId: string, containerClassName: string }> | null, labels?: Array<{ __typename?: 'Label', id: string, classType: string, name: string }> | null, thumbnail?: { __typename?: 'Attachment', id: string, classType: string, entityId: string, url: string } | null, owner?: { __typename?: 'User', id: string, classType: string, name: string, email: string, sourceName: string } | null, classifications?: Array<{ __typename?: 'Classification', id: string, classType: string, category?: string | null, name?: string | null }> | null } | null };

export type EntityFormQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type EntityFormQuery = { __typename?: 'Query', entity?: { __typename?: 'Entity', id: string, createdAt?: any | null, goalHypothesis?: string | null, linkTitle?: string | null, linkUrl?: string | null, results?: string | null, summary?: string | null, sourceSummary?: string | null, updatedAt?: any | null, commentsCount: number, classType: string, displaySummary?: string | null, dueDate?: any | null, entityType?: string | null, foreignState?: string | null, foreignType?: string | null, happenedAt?: any | null, hasEditedHeadline?: boolean | null, impact?: ImpactEnum | null, importance?: ImportanceEnum | null, name?: string | null, organizationId: string, ownerId?: string | null, rfId: string, showGoalHypothesis?: boolean | null, showResults?: boolean | null, showSummary?: boolean | null, sourceName?: string | null, sourceUrl?: string | null, summaryShort?: string | null, summaryFull?: string | null, workflowState?: EntityWorkflowStateEnum | null, labels?: Array<{ __typename?: 'Label', id: string, classType: string, name: string }> | null, entityContributions?: Array<{ __typename?: 'EntityContribution', id: string, contributor: { __typename?: 'SourceIdentity', id: string, classType: string, name: string, email?: string | null, sourceName: string } | { __typename?: 'User', id: string, classType: string, name: string, email: string, sourceName: string } }> | null, entityAttachments?: Array<{ __typename?: 'Attachment', id: string, classType: string, entityId: string, url: string }> | null, classifications?: Array<{ __typename?: 'Classification', id: string, classType: string, category?: string | null, name?: string | null }> | null } | null };

export type EntitiesQueryVariables = Exact<{
  filter?: InputMaybe<Scalars['String']['input']>;
  strategyId?: InputMaybe<Scalars['ID']['input']>;
  order?: InputMaybe<EntityOrderingInput>;
  page?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type EntitiesQuery = { __typename?: 'Query', entities?: { __typename?: 'EntityCollection', collection: Array<{ __typename?: 'Entity', id: string, classType: string, foreignType?: string | null, name?: string | null, sourceName?: string | null, containeeCount?: number | null, labels?: Array<{ __typename?: 'Label', id: string, classType: string, name: string }> | null, strategies: Array<{ __typename?: 'Strategy', id: string, name?: string | null, classType: string }> }>, metadata: { __typename?: 'CollectionMetadata', page: number, totalPages: number, limitValue: number, totalCount: number } } | null };

export type EntityEntitiesQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  page: Scalars['Int']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  workflowState?: InputMaybe<EntityWorkflowStateEnum>;
}>;


export type EntityEntitiesQuery = { __typename?: 'Query', entityEntities?: { __typename?: 'EntityCollection', collection: Array<{ __typename?: 'Entity', entityAttachmentsCount: number, foreignId?: string | null, foreignType?: string | null, happenedOnWeek?: any | null, sourceName?: string | null, sourceUrl?: string | null, summaryFull?: string | null, summaryShort?: string | null, commentsCount: number, classType: string, displaySummary?: string | null, dueDate?: any | null, entityType?: string | null, foreignState?: string | null, goalHypothesis?: string | null, happenedAt?: any | null, hasEditedHeadline?: boolean | null, id: string, impact?: ImpactEnum | null, importance?: ImportanceEnum | null, linkTitle?: string | null, linkUrl?: string | null, name?: string | null, organizationId: string, ownerId?: string | null, results?: string | null, rfId: string, showGoalHypothesis?: boolean | null, showResults?: boolean | null, showSummary?: boolean | null, summary?: string | null, workflowState?: EntityWorkflowStateEnum | null, containerEntityContainments?: Array<{ __typename?: 'EntityContainment', id: string, classType: string, containerId: string, containerClassName: string }> | null, labels?: Array<{ __typename?: 'Label', id: string, classType: string, name: string }> | null, thumbnail?: { __typename?: 'Attachment', id: string, classType: string, entityId: string, url: string } | null, owner?: { __typename?: 'User', id: string, classType: string, name: string, email: string, sourceName: string } | null, classifications?: Array<{ __typename?: 'Classification', id: string, classType: string, category?: string | null, name?: string | null }> | null }>, metadata: { __typename?: 'CollectionMetadata', page: number, totalPages: number, limitValue: number, totalCount: number } } | null };

export type EntityCommentsQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type EntityCommentsQuery = { __typename?: 'Query', entity?: { __typename?: 'Entity', entityAttachmentsCount: number, foreignId?: string | null, foreignType?: string | null, happenedOnWeek?: any | null, sourceName?: string | null, sourceUrl?: string | null, summaryFull?: string | null, summaryShort?: string | null, commentsCount: number, classType: string, displaySummary?: string | null, dueDate?: any | null, entityType?: string | null, foreignState?: string | null, goalHypothesis?: string | null, happenedAt?: any | null, hasEditedHeadline?: boolean | null, id: string, impact?: ImpactEnum | null, importance?: ImportanceEnum | null, linkTitle?: string | null, linkUrl?: string | null, name?: string | null, organizationId: string, ownerId?: string | null, results?: string | null, rfId: string, showGoalHypothesis?: boolean | null, showResults?: boolean | null, showSummary?: boolean | null, summary?: string | null, workflowState?: EntityWorkflowStateEnum | null, comments?: Array<{ __typename?: 'Comment', id: string, body: string, classType: string, commentableId: string, commentableType: string, createdAt: any, creatorId?: string | null, creator?: { __typename?: 'User', id: string, classType: string, email: string, name: string } | null }> | null, containerEntityContainments?: Array<{ __typename?: 'EntityContainment', id: string, classType: string, containerId: string, containerClassName: string }> | null, labels?: Array<{ __typename?: 'Label', id: string, classType: string, name: string }> | null, thumbnail?: { __typename?: 'Attachment', id: string, classType: string, entityId: string, url: string } | null, owner?: { __typename?: 'User', id: string, classType: string, name: string, email: string, sourceName: string } | null, classifications?: Array<{ __typename?: 'Classification', id: string, classType: string, category?: string | null, name?: string | null }> | null } | null };

export type EntityCreateMutationVariables = Exact<{
  input: EntityCreateInput;
}>;


export type EntityCreateMutation = { __typename?: 'Mutation', entityCreate?: { __typename?: 'EntityCreatePayload', entity?: { __typename?: 'Entity', entityAttachmentsCount: number, foreignId?: string | null, foreignType?: string | null, happenedOnWeek?: any | null, sourceName?: string | null, sourceUrl?: string | null, summaryFull?: string | null, summaryShort?: string | null, commentsCount: number, classType: string, displaySummary?: string | null, dueDate?: any | null, entityType?: string | null, foreignState?: string | null, goalHypothesis?: string | null, happenedAt?: any | null, hasEditedHeadline?: boolean | null, id: string, impact?: ImpactEnum | null, importance?: ImportanceEnum | null, linkTitle?: string | null, linkUrl?: string | null, name?: string | null, organizationId: string, ownerId?: string | null, results?: string | null, rfId: string, showGoalHypothesis?: boolean | null, showResults?: boolean | null, showSummary?: boolean | null, summary?: string | null, workflowState?: EntityWorkflowStateEnum | null, containerEntityContainments?: Array<{ __typename?: 'EntityContainment', id: string, classType: string, containerId: string, containerClassName: string }> | null, labels?: Array<{ __typename?: 'Label', id: string, classType: string, name: string }> | null, thumbnail?: { __typename?: 'Attachment', id: string, classType: string, entityId: string, url: string } | null, owner?: { __typename?: 'User', id: string, classType: string, name: string, email: string, sourceName: string } | null, classifications?: Array<{ __typename?: 'Classification', id: string, classType: string, category?: string | null, name?: string | null }> | null } | null, errors: Array<{ __typename?: 'Error', message: string, path?: Array<string> | null }> } | null };

export type EntityUpdateMutationVariables = Exact<{
  input: EntityUpdateInput;
}>;


export type EntityUpdateMutation = { __typename?: 'Mutation', entityUpdate?: { __typename?: 'EntityUpdatePayload', entity?: { __typename?: 'Entity', entityAttachmentsCount: number, foreignId?: string | null, foreignType?: string | null, happenedOnWeek?: any | null, sourceName?: string | null, sourceUrl?: string | null, summaryFull?: string | null, summaryShort?: string | null, createdAt?: any | null, goalHypothesis?: string | null, linkTitle?: string | null, linkUrl?: string | null, results?: string | null, summary?: string | null, sourceSummary?: string | null, updatedAt?: any | null, commentsCount: number, classType: string, displaySummary?: string | null, dueDate?: any | null, entityType?: string | null, foreignState?: string | null, happenedAt?: any | null, hasEditedHeadline?: boolean | null, id: string, impact?: ImpactEnum | null, importance?: ImportanceEnum | null, name?: string | null, organizationId: string, ownerId?: string | null, rfId: string, showGoalHypothesis?: boolean | null, showResults?: boolean | null, showSummary?: boolean | null, workflowState?: EntityWorkflowStateEnum | null, labels?: Array<{ __typename?: 'Label', id: string, classType: string, name: string }> | null, entityContributions?: Array<{ __typename?: 'EntityContribution', id: string, classType: string, contributor: { __typename?: 'SourceIdentity', id: string, classType: string, name: string, email?: string | null, sourceName: string } | { __typename?: 'User', id: string, classType: string, name: string, email: string, sourceName: string } }> | null, containerEntityContainments?: Array<{ __typename?: 'EntityContainment', id: string, classType: string, containerId: string, containerClassName: string }> | null, thumbnail?: { __typename?: 'Attachment', id: string, classType: string, entityId: string, url: string } | null, owner?: { __typename?: 'User', id: string, classType: string, name: string, email: string, sourceName: string } | null, entityAttachments?: Array<{ __typename?: 'Attachment', id: string, classType: string, entityId: string, url: string }> | null, classifications?: Array<{ __typename?: 'Classification', id: string, classType: string, category?: string | null, name?: string | null }> | null } | null, errors: Array<{ __typename?: 'Error', message: string, path?: Array<string> | null }> } | null };

export type EntitySlackMutationVariables = Exact<{
  input: EntitySlackInput;
}>;


export type EntitySlackMutation = { __typename?: 'Mutation', entitySlack?: { __typename?: 'EntitySlackPayload', success?: boolean | null, errors: Array<{ __typename?: 'Error', message: string, path?: Array<string> | null }> } | null };

export type EntityCreateAttachmentMutationVariables = Exact<{
  input: EntityCreateAttachmentInput;
}>;


export type EntityCreateAttachmentMutation = { __typename?: 'Mutation', entityCreateAttachment?: { __typename?: 'EntityCreateAttachmentPayload', entity?: { __typename?: 'Entity', id: string, classType: string, entityAttachmentsCount: number, entityAttachments?: Array<{ __typename?: 'Attachment', id: string, classType: string, entityId: string, url: string }> | null, thumbnail?: { __typename?: 'Attachment', id: string, classType: string, entityId: string, url: string } | null } | null, errors: Array<{ __typename?: 'Error', message: string, path?: Array<string> | null }> } | null };

export type EntityDeleteAttachmentMutationVariables = Exact<{
  input: EntityDeleteAttachmentInput;
}>;


export type EntityDeleteAttachmentMutation = { __typename?: 'Mutation', entityDeleteAttachment?: { __typename?: 'EntityDeleteAttachmentPayload', entity?: { __typename?: 'Entity', id: string, classType: string, entityAttachmentsCount: number, entityAttachments?: Array<{ __typename?: 'Attachment', id: string, classType: string, entityId: string, url: string }> | null, thumbnail?: { __typename?: 'Attachment', id: string, classType: string, entityId: string, url: string } | null } | null, errors: Array<{ __typename?: 'Error', message: string, path?: Array<string> | null }> } | null };

export type EntityContainmentCreateMutationVariables = Exact<{
  input: EntityContainmentCreateInput;
}>;


export type EntityContainmentCreateMutation = { __typename?: 'Mutation', entityContainmentCreate?: { __typename?: 'EntityContainmentCreatePayload', entity?: { __typename?: 'Entity', id: string, classType: string } | null, errors: Array<{ __typename?: 'Error', message: string, path?: Array<string> | null }> } | null };

export type EntityContainmentDeleteMutationVariables = Exact<{
  input: EntityContainmentDeleteInput;
}>;


export type EntityContainmentDeleteMutation = { __typename?: 'Mutation', entityContainmentDelete?: { __typename?: 'EntityContainmentDeletePayload', entity?: { __typename?: 'Entity', id: string, classType: string } | null, errors: Array<{ __typename?: 'Error', message: string, path?: Array<string> | null }> } | null };

export type CommonFavoriteFieldsFragment = { __typename?: 'Favorite', id: string, classType: string, favoritableId: string, favoritableType: string, favoritable: { __typename?: 'Metric', id: string, classType: string, name?: string | null, favoriteId?: string | null } | { __typename?: 'Strategy', id: string, classType: string, name?: string | null, favoriteId?: string | null } };

export type FavoritesQueryVariables = Exact<{ [key: string]: never; }>;


export type FavoritesQuery = { __typename?: 'Query', favorites: Array<{ __typename?: 'Favorite', id: string, classType: string, favoritableId: string, favoritableType: string, favoritable: { __typename?: 'Metric', id: string, classType: string, name?: string | null, favoriteId?: string | null } | { __typename?: 'Strategy', id: string, classType: string, name?: string | null, favoriteId?: string | null } }> };

export type FavoriteCreateMutationVariables = Exact<{
  input: FavoriteCreateInput;
}>;


export type FavoriteCreateMutation = { __typename?: 'Mutation', favoriteCreate?: { __typename?: 'FavoriteCreatePayload', favorite: { __typename?: 'Favorite', id: string, classType: string, favoritableId: string, favoritableType: string, favoritable: { __typename?: 'Metric', id: string, classType: string, name?: string | null, favoriteId?: string | null } | { __typename?: 'Strategy', id: string, classType: string, name?: string | null, favoriteId?: string | null } }, errors: Array<{ __typename?: 'Error', message: string, path?: Array<string> | null }> } | null };

export type FavoriteDeleteMutationVariables = Exact<{
  input: FavoriteDeleteInput;
}>;


export type FavoriteDeleteMutation = { __typename?: 'Mutation', favoriteDelete?: { __typename?: 'FavoriteDeletePayload', favorite?: { __typename?: 'Favorite', id: string, classType: string, favoritableId: string, favoritableType: string, favoritable: { __typename?: 'Metric', id: string, classType: string, name?: string | null, favoriteId?: string | null } | { __typename?: 'Strategy', id: string, classType: string, name?: string | null, favoriteId?: string | null } } | null } | null };

export type MetricDisplayFormatFieldsFragment = { __typename?: 'Metric', compactDisplay: boolean, displayFormat: DisplayFormatEnum, maximumDisplayPrecision: number, minimumDisplayPrecision: number, redecimalPercentages?: boolean | null };

export type GoalSubscriptionFieldsFragment = { __typename?: 'Goal', id: string, classType: string, currentValue: number, endDate?: any | null, label: string, metricId: string, newestMetricDate?: any | null, oldestMetricDate?: any | null, percentageComplete: number, periodUnit: PeriodUnitEnum, periodNumber?: number | null, periodYear?: number | null, startValue: number, targetValue: number, startDate?: any | null, status: GoalStatusEnum };

export type GoalFieldsFragment = { __typename?: 'Goal', id: string, classType: string, currentValue: number, endDate?: any | null, label: string, metricId: string, newestMetricDate?: any | null, oldestMetricDate?: any | null, percentageComplete: number, periodUnit: PeriodUnitEnum, periodNumber?: number | null, periodYear?: number | null, startValue: number, targetValue: number, startDate?: any | null, status: GoalStatusEnum };

export type GoalsQueryVariables = Exact<{
  metricId: Scalars['ID']['input'];
}>;


export type GoalsQuery = { __typename?: 'Query', metric?: { __typename?: 'Metric', id: string, classType: string, compactDisplay: boolean, displayFormat: DisplayFormatEnum, maximumDisplayPrecision: number, minimumDisplayPrecision: number, redecimalPercentages?: boolean | null, goals: Array<{ __typename?: 'Goal', id: string, classType: string, currentValue: number, endDate?: any | null, label: string, metricId: string, newestMetricDate?: any | null, oldestMetricDate?: any | null, percentageComplete: number, periodUnit: PeriodUnitEnum, periodNumber?: number | null, periodYear?: number | null, startValue: number, targetValue: number, startDate?: any | null, status: GoalStatusEnum }> } | null };

export type GoalQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GoalQuery = { __typename?: 'Query', goal?: { __typename?: 'Goal', id: string, classType: string, currentValue: number, endDate?: any | null, label: string, metricId: string, newestMetricDate?: any | null, oldestMetricDate?: any | null, percentageComplete: number, periodUnit: PeriodUnitEnum, periodNumber?: number | null, periodYear?: number | null, startValue: number, targetValue: number, startDate?: any | null, status: GoalStatusEnum } | null };

export type GoalCreateMutationVariables = Exact<{
  input: GoalCreateInput;
}>;


export type GoalCreateMutation = { __typename?: 'Mutation', goalCreate?: { __typename?: 'GoalCreatePayload', goal?: { __typename?: 'Goal', id: string, classType: string, currentValue: number, endDate?: any | null, label: string, metricId: string, newestMetricDate?: any | null, oldestMetricDate?: any | null, percentageComplete: number, periodUnit: PeriodUnitEnum, periodNumber?: number | null, periodYear?: number | null, startValue: number, targetValue: number, startDate?: any | null, status: GoalStatusEnum } | null, errors: Array<{ __typename?: 'Error', message: string, path?: Array<string> | null }> } | null };

export type GoogleSheetFieldsFragment = { __typename?: 'GoogleSheet', id: string, classType: string, organizationLevel: boolean, spreadsheetUrl: string, status: GoogleSheetStatusEnum };

export type GoogleSheetQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GoogleSheetQuery = { __typename?: 'Query', googleSheet?: { __typename?: 'GoogleSheet', id: string, classType: string, organizationLevel: boolean, spreadsheetUrl: string, status: GoogleSheetStatusEnum } | null };

export type OrganizationGoogleSheetQueryVariables = Exact<{ [key: string]: never; }>;


export type OrganizationGoogleSheetQuery = { __typename?: 'Query', organization?: { __typename?: 'Organization', id: string, googleSheet?: { __typename?: 'GoogleSheet', id: string, classType: string, organizationLevel: boolean, spreadsheetUrl: string, status: GoogleSheetStatusEnum } | null } | null };

export type GoogleSheetDeleteMutationVariables = Exact<{
  input: GoogleSheetDeleteInput;
}>;


export type GoogleSheetDeleteMutation = { __typename?: 'Mutation', googleSheetDelete?: { __typename?: 'GoogleSheetDeletePayload', googleSheet: { __typename?: 'GoogleSheet', id: string } } | null };

export type GoogleSheetImportMutationVariables = Exact<{
  input: GoogleSheetImportInput;
}>;


export type GoogleSheetImportMutation = { __typename?: 'Mutation', googleSheetImport?: { __typename?: 'GoogleSheetImportPayload', googleSheet: { __typename?: 'GoogleSheet', id: string } } | null };

export type GraphEventsQueryVariables = Exact<{
  filters?: InputMaybe<Scalars['JSON']['input']>;
}>;


export type GraphEventsQuery = { __typename?: 'Query', eventsGraph?: any | null };

export type GraphMetricEventsQueryVariables = Exact<{
  metricId: Scalars['ID']['input'];
  filters?: InputMaybe<Scalars['JSON']['input']>;
}>;


export type GraphMetricEventsQuery = { __typename?: 'Query', metricEventsGraph?: any | null };

export type GraphImpactfulEventsFieldsFragment = { __typename?: 'Entity', id: string, classType: string, happenedAt?: any | null, impact?: ImpactEnum | null, name?: string | null };

export type GraphImpactfulEventsQueryVariables = Exact<{
  filters?: InputMaybe<Scalars['JSON']['input']>;
  metricId: Scalars['ID']['input'];
}>;


export type GraphImpactfulEventsQuery = { __typename?: 'Query', impactfulEntities?: Array<{ __typename?: 'Entity', id: string, classType: string, happenedAt?: any | null, impact?: ImpactEnum | null, name?: string | null }> | null };

export type GraphMetricsFieldsFragment = { __typename?: 'Metric', id: string, classType: string, name?: string | null, displayFormat: DisplayFormatEnum, rollUp: RollUpEnum, compactDisplay: boolean, minimumDisplayPrecision: number, maximumDisplayPrecision: number, positiveDirection: MetricPositiveDirectionsEnum };

export type GraphMetricsQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  range?: InputMaybe<Scalars['String']['input']>;
  interval?: InputMaybe<IntervalEnum>;
  startDate?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['String']['input']>;
  cumulative?: InputMaybe<Scalars['CastableBoolean']['input']>;
  forecast?: InputMaybe<Scalars['CastableBoolean']['input']>;
}>;


export type GraphMetricsQuery = { __typename?: 'Query', metric?: { __typename?: 'Metric', id: string, classType: string, name?: string | null, displayFormat: DisplayFormatEnum, rollUp: RollUpEnum, compactDisplay: boolean, minimumDisplayPrecision: number, maximumDisplayPrecision: number, positiveDirection: MetricPositiveDirectionsEnum, metricDataPoints: Array<{ __typename?: 'MetricDataPoint', date: any, value: number, forecasted: boolean }> } | null };

type IntegrationSubscriptionFields_GoogleIntegration_Fragment = { __typename?: 'GoogleIntegration', id: string, classType: string, activitiesCount: number, configuration?: any | null, createdAt: any, entitiesCount: number, importedHistory: boolean, sourceId?: string | null, sourceName: IntegrationSourceNamesEnum, type?: string | null };

type IntegrationSubscriptionFields_Integration_Fragment = { __typename?: 'Integration', id: string, classType: string, activitiesCount: number, configuration?: any | null, createdAt: any, entitiesCount: number, importedHistory: boolean, sourceId?: string | null, sourceName: IntegrationSourceNamesEnum, type?: string | null };

type IntegrationSubscriptionFields_JiraIntegration_Fragment = { __typename?: 'JiraIntegration', id: string, classType: string, activitiesCount: number, configuration?: any | null, createdAt: any, entitiesCount: number, importedHistory: boolean, sourceId?: string | null, sourceName: IntegrationSourceNamesEnum, type?: string | null };

export type IntegrationSubscriptionFieldsFragment = IntegrationSubscriptionFields_GoogleIntegration_Fragment | IntegrationSubscriptionFields_Integration_Fragment | IntegrationSubscriptionFields_JiraIntegration_Fragment;

export type IntegrationQueryVariables = Exact<{
  sourceName: Scalars['String']['input'];
}>;


export type IntegrationQuery = { __typename?: 'Query', integration?: { __typename?: 'GoogleIntegration', id: string, classType: string, activitiesCount: number, configuration?: any | null, createdAt: any, entitiesCount: number, importedHistory: boolean, sourceId?: string | null, sourceName: IntegrationSourceNamesEnum, type?: string | null, organization: { __typename?: 'Organization', id: string }, creator: { __typename?: 'User', id: string, email: string, name: string, superAdmin: boolean } } | { __typename?: 'Integration', id: string, classType: string, activitiesCount: number, configuration?: any | null, createdAt: any, entitiesCount: number, importedHistory: boolean, sourceId?: string | null, sourceName: IntegrationSourceNamesEnum, type?: string | null, organization: { __typename?: 'Organization', id: string }, creator: { __typename?: 'User', id: string, email: string, name: string, superAdmin: boolean } } | { __typename?: 'JiraIntegration', restrictedProjects: Array<string>, id: string, classType: string, activitiesCount: number, configuration?: any | null, createdAt: any, entitiesCount: number, importedHistory: boolean, sourceId?: string | null, sourceName: IntegrationSourceNamesEnum, type?: string | null, organization: { __typename?: 'Organization', id: string }, creator: { __typename?: 'User', id: string, email: string, name: string, superAdmin: boolean } } | null };

export type IntegrationsQueryVariables = Exact<{ [key: string]: never; }>;


export type IntegrationsQuery = { __typename?: 'Query', integrations?: Array<{ __typename?: 'GoogleIntegration', id: string, classType: string, activitiesCount: number, configuration?: any | null, createdAt: any, entitiesCount: number, importedHistory: boolean, sourceId?: string | null, sourceName: IntegrationSourceNamesEnum, type?: string | null, organization: { __typename?: 'Organization', id: string }, creator: { __typename?: 'User', id: string, email: string, name: string, superAdmin: boolean } } | { __typename?: 'Integration', id: string, classType: string, activitiesCount: number, configuration?: any | null, createdAt: any, entitiesCount: number, importedHistory: boolean, sourceId?: string | null, sourceName: IntegrationSourceNamesEnum, type?: string | null, organization: { __typename?: 'Organization', id: string }, creator: { __typename?: 'User', id: string, email: string, name: string, superAdmin: boolean } } | { __typename?: 'JiraIntegration', id: string, classType: string, activitiesCount: number, configuration?: any | null, createdAt: any, entitiesCount: number, importedHistory: boolean, sourceId?: string | null, sourceName: IntegrationSourceNamesEnum, type?: string | null, organization: { __typename?: 'Organization', id: string }, creator: { __typename?: 'User', id: string, email: string, name: string, superAdmin: boolean } }> | null };

export type GoogleIntegrationQueryVariables = Exact<{ [key: string]: never; }>;


export type GoogleIntegrationQuery = { __typename?: 'Query', googleIntegration?: { __typename?: 'GoogleIntegration', id: string, sourceId?: string | null, sourceName: IntegrationSourceNamesEnum, type?: string | null, classType: string, configuration?: any | null, activitiesCount: number, entitiesCount: number, importedHistory: boolean, createdAt: any, propertiesV4?: any | null, propertyImports?: any | null, organization: { __typename?: 'Organization', id: string }, creator: { __typename?: 'User', id: string, email: string, name: string, superAdmin: boolean } } | null };

export type SharedIntegrationsQueryVariables = Exact<{ [key: string]: never; }>;


export type SharedIntegrationsQuery = { __typename?: 'Query', integrations?: Array<{ __typename?: 'GoogleIntegration', id: string, sourceName: IntegrationSourceNamesEnum, entityTypes: Array<string> } | { __typename?: 'Integration', id: string, sourceName: IntegrationSourceNamesEnum, entityTypes: Array<string> } | { __typename?: 'JiraIntegration', id: string, sourceName: IntegrationSourceNamesEnum, entityTypes: Array<string> }> | null, metricSources?: Array<{ __typename?: 'MetricSource', id: string, sourceName?: string | null }> | null };

export type SourcesQueryVariables = Exact<{ [key: string]: never; }>;


export type SourcesQuery = { __typename?: 'Query', sources?: { __typename?: 'Sources', entity?: Array<{ __typename?: 'Integration', id: string, sourceName: IntegrationSourceNamesEnum, entityTypes: Array<string>, classType: string }> | null, metric?: Array<{ __typename?: 'MetricSource', id: string, sourceName?: string | null, classType: string }> | null } | null };

export type IntegrationCreateMutationVariables = Exact<{
  input: IntegrationCreateInput;
}>;


export type IntegrationCreateMutation = { __typename?: 'Mutation', integrationCreate?: { __typename?: 'IntegrationCreatePayload', integration?: { __typename?: 'Integration', id: string, classType: string, activitiesCount: number, configuration?: any | null, createdAt: any, entitiesCount: number, importedHistory: boolean, sourceId?: string | null, sourceName: IntegrationSourceNamesEnum, type?: string | null, creator: { __typename?: 'User', id: string, email: string, name: string, superAdmin: boolean } } | null, organization: { __typename?: 'Organization', id: string }, errors: Array<{ __typename?: 'Error', message: string, path?: Array<string> | null }> } | null };

export type IntegrationUpdateMutationVariables = Exact<{
  input: IntegrationUpdateInput;
}>;


export type IntegrationUpdateMutation = { __typename?: 'Mutation', integrationUpdate?: { __typename?: 'IntegrationUpdatePayload', integration: { __typename?: 'GoogleIntegration', id: string, classType: string, activitiesCount: number, configuration?: any | null, createdAt: any, entitiesCount: number, importedHistory: boolean, sourceId?: string | null, sourceName: IntegrationSourceNamesEnum, type?: string | null } | { __typename?: 'Integration', id: string, classType: string, activitiesCount: number, configuration?: any | null, createdAt: any, entitiesCount: number, importedHistory: boolean, sourceId?: string | null, sourceName: IntegrationSourceNamesEnum, type?: string | null } | { __typename?: 'JiraIntegration', restrictedProjects: Array<string>, id: string, classType: string, activitiesCount: number, configuration?: any | null, createdAt: any, entitiesCount: number, importedHistory: boolean, sourceId?: string | null, sourceName: IntegrationSourceNamesEnum, type?: string | null }, errors: Array<{ __typename?: 'Error', message: string, path?: Array<string> | null }> } | null };

export type IntegrationImportHistoryMutationVariables = Exact<{
  input: IntegrationImportHistoryInput;
}>;


export type IntegrationImportHistoryMutation = { __typename?: 'Mutation', integrationImportHistory?: { __typename?: 'IntegrationImportHistoryPayload', integration: { __typename?: 'Integration', id: string, classType: string, activitiesCount: number, configuration?: any | null, createdAt: any, entitiesCount: number, importedHistory: boolean, sourceId?: string | null, sourceName: IntegrationSourceNamesEnum, type?: string | null }, errors: Array<{ __typename?: 'Error', message: string, path?: Array<string> | null }> } | null };

export type GoogleAnalyticsPropertyImportMutationVariables = Exact<{
  input: GoogleAnalyticsPropertyImportInput;
}>;


export type GoogleAnalyticsPropertyImportMutation = { __typename?: 'Mutation', googleAnalyticsPropertyImport?: { __typename?: 'GoogleAnalyticsPropertyImportPayload', integration: { __typename?: 'Integration', id: string, classType: string, activitiesCount: number, configuration?: any | null, createdAt: any, entitiesCount: number, importedHistory: boolean, sourceId?: string | null, sourceName: IntegrationSourceNamesEnum, type?: string | null } } | null };

export type InvitationFieldsFragment = { __typename?: 'Invitation', id?: string | null, classType: string, email: string, inviteCode?: string | null, lastSentAt?: any | null, role?: RoleEnum | null };

export type InvitationQueryVariables = Exact<{
  inviteCode: Scalars['String']['input'];
}>;


export type InvitationQuery = { __typename?: 'Query', invitation?: { __typename?: 'Invitation', id?: string | null, classType: string, email: string, inviteCode?: string | null, lastSentAt?: any | null, role?: RoleEnum | null } | null };

export type InvitationsQueryVariables = Exact<{ [key: string]: never; }>;


export type InvitationsQuery = { __typename?: 'Query', invitations?: Array<{ __typename?: 'Invitation', id?: string | null, classType: string, email: string, inviteCode?: string | null, lastSentAt?: any | null, role?: RoleEnum | null }> | null };

export type InvitationCreateMutationVariables = Exact<{
  input: InvitationCreateInput;
}>;


export type InvitationCreateMutation = { __typename?: 'Mutation', invitationCreate?: { __typename?: 'InvitationCreatePayload', invitation?: { __typename?: 'Invitation', id?: string | null, classType: string, email: string, inviteCode?: string | null, lastSentAt?: any | null, role?: RoleEnum | null } | null, errors: Array<{ __typename?: 'Error', message: string, path?: Array<string> | null }> } | null };

export type InvitationDeleteMutationVariables = Exact<{
  input: InvitationDeleteInput;
}>;


export type InvitationDeleteMutation = { __typename?: 'Mutation', crudOperation?: { __typename?: 'InvitationDeletePayload', crudOperation: { __typename?: 'TypesInvitationTypeGraphqlCrudOperation', operation: CrudOperationEnum, data?: { __typename?: 'Invitation', id?: string | null, classType: string, email: string, inviteCode?: string | null, lastSentAt?: any | null, role?: RoleEnum | null } | null }, errors: Array<{ __typename?: 'Error', message: string, path?: Array<string> | null }> } | null };

export type InvitationResendMutationVariables = Exact<{
  input: InvitationResendInput;
}>;


export type InvitationResendMutation = { __typename?: 'Mutation', invitationResend?: { __typename?: 'InvitationResendPayload', invitation?: { __typename?: 'Invitation', id?: string | null, classType: string, email: string, inviteCode?: string | null, lastSentAt?: any | null, role?: RoleEnum | null } | null } | null };

export type LabelRequiredFieldsFragment = { __typename?: 'Label', id: string, classType: string, name: string };

export type LabelsAutocompleteQueryVariables = Exact<{
  query: Scalars['String']['input'];
}>;


export type LabelsAutocompleteQuery = { __typename?: 'Query', labelsAutocomplete?: Array<{ __typename?: 'Label', id: string, classType: string, name: string }> | null };

export type LabelCreateMutationVariables = Exact<{
  input: LabelCreateInput;
}>;


export type LabelCreateMutation = { __typename?: 'Mutation', labelCreate?: { __typename?: 'LabelCreatePayload', label?: { __typename?: 'Label', id: string, classType: string, name: string } | null, domainObject: { __typename?: 'BasicCard', id: string, classType: string, labels?: Array<{ __typename?: 'Label', id: string, classType: string, name: string }> | null } | { __typename?: 'Entity', id: string, classType: string, labels?: Array<{ __typename?: 'Label', id: string, classType: string, name: string }> | null } | { __typename?: 'Metric', id: string, classType: string, labels?: Array<{ __typename?: 'Label', id: string, classType: string, name: string }> | null } | { __typename?: 'Strategy', id: string, classType: string, labels?: Array<{ __typename?: 'Label', id: string, classType: string, name: string }> | null } } | null };

export type LabelDeleteMutationVariables = Exact<{
  input: LabelDeleteInput;
}>;


export type LabelDeleteMutation = { __typename?: 'Mutation', labelDelete?: { __typename?: 'LabelDeletePayload', label?: { __typename?: 'Label', id: string, classType: string, name: string } | null, domainObject: { __typename?: 'BasicCard', id: string, classType: string, labels?: Array<{ __typename?: 'Label', id: string, classType: string, name: string }> | null } | { __typename?: 'Entity', id: string, classType: string, labels?: Array<{ __typename?: 'Label', id: string, classType: string, name: string }> | null } | { __typename?: 'Metric', id: string, classType: string, labels?: Array<{ __typename?: 'Label', id: string, classType: string, name: string }> | null } | { __typename?: 'Strategy', id: string, classType: string, labels?: Array<{ __typename?: 'Label', id: string, classType: string, name: string }> | null } } | null };

export type LookerDashboardSubscriptionFieldsFragment = { __typename?: 'LookerDashboard', id: string, classType: string, dashboardId: string, dashboardUrl: string, lastError?: string | null, lastRunAt?: any | null, title?: string | null };

export type LookerDashboardsQueryVariables = Exact<{ [key: string]: never; }>;


export type LookerDashboardsQuery = { __typename?: 'Query', lookerDashboards?: Array<{ __typename?: 'LookerDashboard', id: string, classType: string, dashboardId: string, dashboardUrl: string, lastError?: string | null, lastRunAt?: any | null, title?: string | null }> | null };

export type LookerDashboardCreateMutationVariables = Exact<{
  input: LookerDashboardCreateInput;
}>;


export type LookerDashboardCreateMutation = { __typename?: 'Mutation', lookerDashboardCreate?: { __typename?: 'LookerDashboardCreatePayload', lookerDashboard?: { __typename?: 'LookerDashboard', id: string, classType: string, dashboardId: string, dashboardUrl: string, lastError?: string | null, lastRunAt?: any | null, title?: string | null } | null, errors: Array<{ __typename?: 'Error', message: string, path?: Array<string> | null }> } | null };

export type LookerDashboardDeleteMutationVariables = Exact<{
  input: LookerDashboardDeleteInput;
}>;


export type LookerDashboardDeleteMutation = { __typename?: 'Mutation', crudOperation?: { __typename?: 'LookerDashboardDeletePayload', crudOperation: { __typename?: 'TypesLookerDashboardTypeGraphqlCrudOperation', operation: CrudOperationEnum, data?: { __typename?: 'LookerDashboard', id: string, classType: string } | null }, errors: Array<{ __typename?: 'Error', message: string, path?: Array<string> | null }> } | null };

export type MetricSubscriptionFieldsFragment = { __typename?: 'Metric', id: string, calculated?: boolean | null, classType: string, compactDisplay: boolean, maximumDisplayPrecision: number, minimumDisplayPrecision: number, redecimalPercentages?: boolean | null, displayFormat: DisplayFormatEnum, commentsCount: number, createdAt: any, description?: string | null, excludeWeekends: boolean, externalUrl?: string | null, externalUrlTitle?: string | null, favoriteId?: string | null, metricDataPointsCount: number, name?: string | null, ownerId?: string | null, periodToDate: boolean, positiveDirection: MetricPositiveDirectionsEnum, recentActivity?: boolean | null, rfId: string, rollUp: RollUpEnum, segmentedDataType: SegmentedDataTypeEnum, showDescription?: boolean | null, showTechnicalDescription?: boolean | null, slackChannelId?: string | null, slug?: string | null, sourceName?: string | null, strategyType?: StrategyTypeEnum | null, technicalDescription?: string | null, updatedAt: any };

export type MetricFieldsFragment = { __typename?: 'Metric', ownerId?: string | null, id: string, calculated?: boolean | null, classType: string, compactDisplay: boolean, maximumDisplayPrecision: number, minimumDisplayPrecision: number, redecimalPercentages?: boolean | null, displayFormat: DisplayFormatEnum, commentsCount: number, createdAt: any, description?: string | null, excludeWeekends: boolean, externalUrl?: string | null, externalUrlTitle?: string | null, favoriteId?: string | null, metricDataPointsCount: number, name?: string | null, periodToDate: boolean, positiveDirection: MetricPositiveDirectionsEnum, recentActivity?: boolean | null, rfId: string, rollUp: RollUpEnum, segmentedDataType: SegmentedDataTypeEnum, showDescription?: boolean | null, showTechnicalDescription?: boolean | null, slackChannelId?: string | null, slug?: string | null, sourceName?: string | null, strategyType?: StrategyTypeEnum | null, technicalDescription?: string | null, updatedAt: any, goals: Array<{ __typename?: 'Goal', id: string, classType: string, currentValue: number, endDate?: any | null, label: string, metricId: string, newestMetricDate?: any | null, oldestMetricDate?: any | null, percentageComplete: number, periodUnit: PeriodUnitEnum, periodNumber?: number | null, periodYear?: number | null, startValue: number, targetValue: number, startDate?: any | null, status: GoalStatusEnum }>, labels?: Array<{ __typename?: 'Label', id: string, classType: string, name: string }> | null, metricSource?: { __typename?: 'MetricSource', id: string, classType: string, errorMessage?: string | null, metricId: string, structuredFormula?: Array<{ __typename?: 'FormulaText', text: string } | { __typename?: 'Metric', id: string, slug?: string | null, name?: string | null }> | null } | null, organization: { __typename?: 'Organization', id: string, classType: string }, owner?: { __typename?: 'User', id: string, classType: string, name: string, email: string } | null, strategyStats: Array<{ __typename?: 'StrategyStat', change?: number | null, classType: string, displayPeriod: string, period: any, total: number }> };

export type MetricQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type MetricQuery = { __typename?: 'Query', metric?: { __typename?: 'Metric', ownerId?: string | null, id: string, calculated?: boolean | null, classType: string, compactDisplay: boolean, maximumDisplayPrecision: number, minimumDisplayPrecision: number, redecimalPercentages?: boolean | null, displayFormat: DisplayFormatEnum, commentsCount: number, createdAt: any, description?: string | null, excludeWeekends: boolean, externalUrl?: string | null, externalUrlTitle?: string | null, favoriteId?: string | null, metricDataPointsCount: number, name?: string | null, periodToDate: boolean, positiveDirection: MetricPositiveDirectionsEnum, recentActivity?: boolean | null, rfId: string, rollUp: RollUpEnum, segmentedDataType: SegmentedDataTypeEnum, showDescription?: boolean | null, showTechnicalDescription?: boolean | null, slackChannelId?: string | null, slug?: string | null, sourceName?: string | null, strategyType?: StrategyTypeEnum | null, technicalDescription?: string | null, updatedAt: any, metricSource?: { __typename?: 'MetricSource', id: string, classType: string, errorMessage?: string | null, metricId: string, structuredFormula?: Array<{ __typename?: 'FormulaText', text: string } | { __typename?: 'Metric', id: string, slug?: string | null, name?: string | null }> | null } | null, goals: Array<{ __typename?: 'Goal', id: string, classType: string, currentValue: number, endDate?: any | null, label: string, metricId: string, newestMetricDate?: any | null, oldestMetricDate?: any | null, percentageComplete: number, periodUnit: PeriodUnitEnum, periodNumber?: number | null, periodYear?: number | null, startValue: number, targetValue: number, startDate?: any | null, status: GoalStatusEnum }>, labels?: Array<{ __typename?: 'Label', id: string, classType: string, name: string }> | null, organization: { __typename?: 'Organization', id: string, classType: string }, owner?: { __typename?: 'User', id: string, classType: string, name: string, email: string } | null, strategyStats: Array<{ __typename?: 'StrategyStat', change?: number | null, classType: string, displayPeriod: string, period: any, total: number }> } | null };

export type MetricsQueryVariables = Exact<{
  unsourced?: InputMaybe<Scalars['CastableBoolean']['input']>;
  showCalculated?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Scalars['String']['input']>;
  strategyId?: InputMaybe<Scalars['ID']['input']>;
  order?: InputMaybe<MetricOrderingInput>;
  page?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type MetricsQuery = { __typename?: 'Query', metrics?: { __typename?: 'MetricCollection', collection: Array<{ __typename?: 'Metric', id: string, classType: string, commentsCount: number, createdAt: any, updatedAt: any, calculated?: boolean | null, metricSourceErrored: boolean, favoriteId?: string | null, rollUp: RollUpEnum, displayFormat: DisplayFormatEnum, metricDataPointsCount: number, sourceName?: string | null, name?: string | null, owner?: { __typename?: 'User', id: string, name: string, email: string, classType: string } | null, credential?: { __typename?: 'Credential', id: string, label?: string | null, classType: string } | null, labels?: Array<{ __typename?: 'Label', id: string, classType: string, name: string }> | null, strategies: Array<{ __typename?: 'Strategy', id: string, name?: string | null, classType: string }> }>, metadata: { __typename?: 'CollectionMetadata', page: number, totalPages: number, limitValue: number, totalCount: number } } | null, organization?: { __typename?: 'Organization', id: string, classType: string } | null };

export type MetricEntitiesQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  workflowState?: InputMaybe<EntityWorkflowStateEnum>;
}>;


export type MetricEntitiesQuery = { __typename?: 'Query', metricEntities?: { __typename?: 'EntityCollection', collection: Array<{ __typename?: 'Entity', id: string, entityAttachmentsCount: number, foreignId?: string | null, foreignType?: string | null, happenedOnWeek?: any | null, sourceName?: string | null, sourceUrl?: string | null, summaryFull?: string | null, summaryShort?: string | null, commentsCount: number, classType: string, displaySummary?: string | null, dueDate?: any | null, entityType?: string | null, foreignState?: string | null, goalHypothesis?: string | null, happenedAt?: any | null, hasEditedHeadline?: boolean | null, impact?: ImpactEnum | null, importance?: ImportanceEnum | null, linkTitle?: string | null, linkUrl?: string | null, name?: string | null, organizationId: string, ownerId?: string | null, results?: string | null, rfId: string, showGoalHypothesis?: boolean | null, showResults?: boolean | null, showSummary?: boolean | null, summary?: string | null, workflowState?: EntityWorkflowStateEnum | null, containerEntityContainments?: Array<{ __typename?: 'EntityContainment', id: string, classType: string, containerId: string, containerClassName: string }> | null, labels?: Array<{ __typename?: 'Label', id: string, classType: string, name: string }> | null, thumbnail?: { __typename?: 'Attachment', id: string, classType: string, entityId: string, url: string } | null, owner?: { __typename?: 'User', id: string, classType: string, name: string, email: string, sourceName: string } | null, classifications?: Array<{ __typename?: 'Classification', id: string, classType: string, category?: string | null, name?: string | null }> | null }>, metadata: { __typename?: 'CollectionMetadata', page: number, totalPages: number, limitValue: number, totalCount: number } } | null };

export type MetricCommentsQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type MetricCommentsQuery = { __typename?: 'Query', metric?: { __typename?: 'Metric', id: string, classType: string, comments?: Array<{ __typename?: 'Comment', id: string, body: string, classType: string, commentableId: string, commentableType: string, createdAt: any, creatorId?: string | null, creator?: { __typename?: 'User', id: string, classType: string, email: string, name: string } | null }> | null } | null };

export type MetricCorrelationsQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  strategyId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type MetricCorrelationsQuery = { __typename?: 'Query', metric?: { __typename?: 'Metric', id: string, classType: string, correlations: Array<{ __typename?: 'CorrelationPair', id: string, classType: string, score?: number | null, sourceMetricId: string, strategyId?: string | null, targetMetric: { __typename?: 'Metric', id: string, name?: string | null, classType: string, positiveDirection: MetricPositiveDirectionsEnum } }> } | null };

export type MetricsAutocompleteQueryVariables = Exact<{
  query: Scalars['String']['input'];
  strategyId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type MetricsAutocompleteQuery = { __typename?: 'Query', metricsAutocomplete?: Array<{ __typename?: 'Metric', id: string, classType: string, slug?: string | null, name?: string | null, calculated?: boolean | null }> | null };

export type MetricCreateMutationVariables = Exact<{
  input: MetricCreateInput;
}>;


export type MetricCreateMutation = { __typename?: 'Mutation', metricCreate?: { __typename?: 'MetricCreatePayload', metric?: { __typename?: 'Metric', ownerId?: string | null, id: string, calculated?: boolean | null, classType: string, compactDisplay: boolean, maximumDisplayPrecision: number, minimumDisplayPrecision: number, redecimalPercentages?: boolean | null, displayFormat: DisplayFormatEnum, commentsCount: number, createdAt: any, description?: string | null, excludeWeekends: boolean, externalUrl?: string | null, externalUrlTitle?: string | null, favoriteId?: string | null, metricDataPointsCount: number, name?: string | null, periodToDate: boolean, positiveDirection: MetricPositiveDirectionsEnum, recentActivity?: boolean | null, rfId: string, rollUp: RollUpEnum, segmentedDataType: SegmentedDataTypeEnum, showDescription?: boolean | null, showTechnicalDescription?: boolean | null, slackChannelId?: string | null, slug?: string | null, sourceName?: string | null, strategyType?: StrategyTypeEnum | null, technicalDescription?: string | null, updatedAt: any, goals: Array<{ __typename?: 'Goal', id: string, classType: string, currentValue: number, endDate?: any | null, label: string, metricId: string, newestMetricDate?: any | null, oldestMetricDate?: any | null, percentageComplete: number, periodUnit: PeriodUnitEnum, periodNumber?: number | null, periodYear?: number | null, startValue: number, targetValue: number, startDate?: any | null, status: GoalStatusEnum }>, labels?: Array<{ __typename?: 'Label', id: string, classType: string, name: string }> | null, metricSource?: { __typename?: 'MetricSource', id: string, classType: string, errorMessage?: string | null, metricId: string, structuredFormula?: Array<{ __typename?: 'FormulaText', text: string } | { __typename?: 'Metric', id: string, slug?: string | null, name?: string | null }> | null } | null, organization: { __typename?: 'Organization', id: string, classType: string }, owner?: { __typename?: 'User', id: string, classType: string, name: string, email: string } | null, strategyStats: Array<{ __typename?: 'StrategyStat', change?: number | null, classType: string, displayPeriod: string, period: any, total: number }> } | null, errors: Array<{ __typename?: 'Error', message: string, path?: Array<string> | null }> } | null };

export type MetricUpdateMutationVariables = Exact<{
  input: MetricUpdateInput;
}>;


export type MetricUpdateMutation = { __typename?: 'Mutation', metricUpdate?: { __typename?: 'MetricUpdatePayload', metric?: { __typename?: 'Metric', ownerId?: string | null, id: string, calculated?: boolean | null, classType: string, compactDisplay: boolean, maximumDisplayPrecision: number, minimumDisplayPrecision: number, redecimalPercentages?: boolean | null, displayFormat: DisplayFormatEnum, commentsCount: number, createdAt: any, description?: string | null, excludeWeekends: boolean, externalUrl?: string | null, externalUrlTitle?: string | null, favoriteId?: string | null, metricDataPointsCount: number, name?: string | null, periodToDate: boolean, positiveDirection: MetricPositiveDirectionsEnum, recentActivity?: boolean | null, rfId: string, rollUp: RollUpEnum, segmentedDataType: SegmentedDataTypeEnum, showDescription?: boolean | null, showTechnicalDescription?: boolean | null, slackChannelId?: string | null, slug?: string | null, sourceName?: string | null, strategyType?: StrategyTypeEnum | null, technicalDescription?: string | null, updatedAt: any, goals: Array<{ __typename?: 'Goal', id: string, classType: string, currentValue: number, endDate?: any | null, label: string, metricId: string, newestMetricDate?: any | null, oldestMetricDate?: any | null, percentageComplete: number, periodUnit: PeriodUnitEnum, periodNumber?: number | null, periodYear?: number | null, startValue: number, targetValue: number, startDate?: any | null, status: GoalStatusEnum }>, labels?: Array<{ __typename?: 'Label', id: string, classType: string, name: string }> | null, metricSource?: { __typename?: 'MetricSource', id: string, classType: string, errorMessage?: string | null, metricId: string, structuredFormula?: Array<{ __typename?: 'FormulaText', text: string } | { __typename?: 'Metric', id: string, slug?: string | null, name?: string | null }> | null } | null, organization: { __typename?: 'Organization', id: string, classType: string }, owner?: { __typename?: 'User', id: string, classType: string, name: string, email: string } | null, strategyStats: Array<{ __typename?: 'StrategyStat', change?: number | null, classType: string, displayPeriod: string, period: any, total: number }> } | null, errors: Array<{ __typename?: 'Error', message: string, path?: Array<string> | null }> } | null };

export type MetricUploadFileMutationVariables = Exact<{
  input: MetricUploadFileInput;
}>;


export type MetricUploadFileMutation = { __typename?: 'Mutation', metricUploadFile?: { __typename?: 'MetricUploadFilePayload', metric?: { __typename?: 'Metric', id: string, classType: string } | null, errors: Array<{ __typename?: 'Error', message: string, path?: Array<string> | null }> } | null };

export type MetricUploadBatchFileMutationVariables = Exact<{
  input: MetricUploadBatchFileInput;
}>;


export type MetricUploadBatchFileMutation = { __typename?: 'Mutation', metricUploadBatchFile?: { __typename?: 'MetricUploadBatchFilePayload', success: boolean } | null };

export type MetricDeleteAllMetricDataPointsMutationVariables = Exact<{
  input: MetricDeleteAllMetricDataPointsInput;
}>;


export type MetricDeleteAllMetricDataPointsMutation = { __typename?: 'Mutation', metricDeleteAllMetricDataPoints?: { __typename?: 'MetricDeleteAllMetricDataPointsPayload', metric: { __typename?: 'Metric', ownerId?: string | null, id: string, calculated?: boolean | null, classType: string, compactDisplay: boolean, maximumDisplayPrecision: number, minimumDisplayPrecision: number, redecimalPercentages?: boolean | null, displayFormat: DisplayFormatEnum, commentsCount: number, createdAt: any, description?: string | null, excludeWeekends: boolean, externalUrl?: string | null, externalUrlTitle?: string | null, favoriteId?: string | null, metricDataPointsCount: number, name?: string | null, periodToDate: boolean, positiveDirection: MetricPositiveDirectionsEnum, recentActivity?: boolean | null, rfId: string, rollUp: RollUpEnum, segmentedDataType: SegmentedDataTypeEnum, showDescription?: boolean | null, showTechnicalDescription?: boolean | null, slackChannelId?: string | null, slug?: string | null, sourceName?: string | null, strategyType?: StrategyTypeEnum | null, technicalDescription?: string | null, updatedAt: any, goals: Array<{ __typename?: 'Goal', id: string, classType: string, currentValue: number, endDate?: any | null, label: string, metricId: string, newestMetricDate?: any | null, oldestMetricDate?: any | null, percentageComplete: number, periodUnit: PeriodUnitEnum, periodNumber?: number | null, periodYear?: number | null, startValue: number, targetValue: number, startDate?: any | null, status: GoalStatusEnum }>, labels?: Array<{ __typename?: 'Label', id: string, classType: string, name: string }> | null, metricSource?: { __typename?: 'MetricSource', id: string, classType: string, errorMessage?: string | null, metricId: string, structuredFormula?: Array<{ __typename?: 'FormulaText', text: string } | { __typename?: 'Metric', id: string, slug?: string | null, name?: string | null }> | null } | null, organization: { __typename?: 'Organization', id: string, classType: string }, owner?: { __typename?: 'User', id: string, classType: string, name: string, email: string } | null, strategyStats: Array<{ __typename?: 'StrategyStat', change?: number | null, classType: string, displayPeriod: string, period: any, total: number }> }, errors: Array<{ __typename?: 'Error', message: string, path?: Array<string> | null }> } | null };

export type MetricPopulateEmptyMutationVariables = Exact<{
  input: MetricPopulateEmptyInput;
}>;


export type MetricPopulateEmptyMutation = { __typename?: 'Mutation', metricPopulateEmpty?: { __typename?: 'MetricPopulateEmptyPayload', metrics?: Array<{ __typename?: 'Metric', ownerId?: string | null, id: string, calculated?: boolean | null, classType: string, compactDisplay: boolean, maximumDisplayPrecision: number, minimumDisplayPrecision: number, redecimalPercentages?: boolean | null, displayFormat: DisplayFormatEnum, commentsCount: number, createdAt: any, description?: string | null, excludeWeekends: boolean, externalUrl?: string | null, externalUrlTitle?: string | null, favoriteId?: string | null, metricDataPointsCount: number, name?: string | null, periodToDate: boolean, positiveDirection: MetricPositiveDirectionsEnum, recentActivity?: boolean | null, rfId: string, rollUp: RollUpEnum, segmentedDataType: SegmentedDataTypeEnum, showDescription?: boolean | null, showTechnicalDescription?: boolean | null, slackChannelId?: string | null, slug?: string | null, sourceName?: string | null, strategyType?: StrategyTypeEnum | null, technicalDescription?: string | null, updatedAt: any, goals: Array<{ __typename?: 'Goal', id: string, classType: string, currentValue: number, endDate?: any | null, label: string, metricId: string, newestMetricDate?: any | null, oldestMetricDate?: any | null, percentageComplete: number, periodUnit: PeriodUnitEnum, periodNumber?: number | null, periodYear?: number | null, startValue: number, targetValue: number, startDate?: any | null, status: GoalStatusEnum }>, labels?: Array<{ __typename?: 'Label', id: string, classType: string, name: string }> | null, metricSource?: { __typename?: 'MetricSource', id: string, classType: string, errorMessage?: string | null, metricId: string, structuredFormula?: Array<{ __typename?: 'FormulaText', text: string } | { __typename?: 'Metric', id: string, slug?: string | null, name?: string | null }> | null } | null, organization: { __typename?: 'Organization', id: string, classType: string }, owner?: { __typename?: 'User', id: string, classType: string, name: string, email: string } | null, strategyStats: Array<{ __typename?: 'StrategyStat', change?: number | null, classType: string, displayPeriod: string, period: any, total: number }> }> | null, errors: Array<{ __typename?: 'Error', message: string, path?: Array<string> | null }> } | null };

export type MetricDataPointQueryVariables = Exact<{
  metricDataPointId: Scalars['ID']['input'];
}>;


export type MetricDataPointQuery = { __typename?: 'Query', metricDataPoint?: { __typename?: 'MetricDataPoint', id: string, classType: string, value: number, date: any } | null };

export type MetricDataPointsQueryVariables = Exact<{
  metricId: Scalars['ID']['input'];
  strategyId?: InputMaybe<Scalars['ID']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type MetricDataPointsQuery = { __typename?: 'Query', metricDataPoints?: { __typename?: 'MetricDataPointCollection', collection: Array<{ __typename?: 'MetricDataPoint', id: string, classType: string, value: number, date: any, filterableId: string, metricId: string, createdAt: any, updatedAt: any, segmentFilters?: Array<{ __typename?: 'SegmentFilter', id: string, segmentName: { __typename?: 'SegmentName', id: string, name: string }, segmentValue: { __typename?: 'SegmentValue', id: string, value: string } }> | null }>, metadata: { __typename?: 'CollectionMetadata', page: number, totalPages: number, limitValue: number, totalCount: number } } | null };

export type SampledMetricDataPointsQueryVariables = Exact<{
  metricId: Scalars['ID']['input'];
  strategyId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type SampledMetricDataPointsQuery = { __typename?: 'Query', sampledMetricDataPoints?: Array<{ __typename?: 'MetricDataPoint', classType: string, date: any, value: number }> | null };

export type MetricDataPointCreateMutationVariables = Exact<{
  input: MetricDataPointCreateInput;
}>;


export type MetricDataPointCreateMutation = { __typename?: 'Mutation', metricDataPointCreate?: { __typename?: 'MetricDataPointCreatePayload', metricDataPoint?: { __typename?: 'MetricDataPoint', id: string, classType: string, date: any, filterableId: string, metricId: string, value: number, segmentFilters?: Array<{ __typename?: 'SegmentFilter', id: string, segmentName: { __typename?: 'SegmentName', id: string, name: string }, segmentValue: { __typename?: 'SegmentValue', id: string, value: string } }> | null } | null, errors: Array<{ __typename?: 'Error', message: string, path?: Array<string> | null }> } | null };

export type MetricDataPointUpdateMutationVariables = Exact<{
  input: MetricDataPointUpdateInput;
}>;


export type MetricDataPointUpdateMutation = { __typename?: 'Mutation', metricDataPointUpdate?: { __typename?: 'MetricDataPointUpdatePayload', metricDataPoint?: { __typename?: 'MetricDataPoint', id: string, classType: string, date: any, filterableId: string, metricId: string, value: number, segmentFilters?: Array<{ __typename?: 'SegmentFilter', id: string, segmentName: { __typename?: 'SegmentName', id: string, name: string }, segmentValue: { __typename?: 'SegmentValue', id: string, value: string } }> | null } | null, errors: Array<{ __typename?: 'Error', message: string, path?: Array<string> | null }> } | null };

export type MetricDataPointDeleteMutationVariables = Exact<{
  input: MetricDataPointDeleteInput;
}>;


export type MetricDataPointDeleteMutation = { __typename?: 'Mutation', crudOperation?: { __typename?: 'MetricDataPointDeletePayload', crudOperation: { __typename?: 'TypesMetricDataPointTypeGraphqlCrudOperation', operation: CrudOperationEnum, data?: { __typename?: 'MetricDataPoint', id: string, classType: string, date: any, filterableId: string, metricId: string, value: number } | null }, errors: Array<{ __typename?: 'Error', message: string, path?: Array<string> | null }> } | null };

export type MetricSourceSubscriptionFieldsFragment = { __typename?: 'MetricSource', id: string, classType: string, configuration?: any | null, credentialId?: string | null, description?: string | null, erroredAt?: any | null, errorMessage?: string | null, lastRunAt?: any | null, metricId: string, name?: string | null, scheduled: boolean, slug?: string | null, sourceName?: string | null, structuredFormula?: Array<{ __typename?: 'FormulaText', text: string } | { __typename?: 'Metric', id: string, slug?: string | null, name?: string | null }> | null };

export type MetricSourceFieldsFragment = { __typename?: 'MetricSource', id: string, classType: string, configuration?: any | null, credentialId?: string | null, description?: string | null, erroredAt?: any | null, errorMessage?: string | null, lastRunAt?: any | null, metricId: string, name?: string | null, scheduled: boolean, slug?: string | null, sourceName?: string | null, structuredFormula?: Array<{ __typename?: 'FormulaText', text: string } | { __typename?: 'Metric', id: string, slug?: string | null, name?: string | null }> | null };

export type MetricSourceQueryVariables = Exact<{
  metricId: Scalars['ID']['input'];
}>;


export type MetricSourceQuery = { __typename?: 'Query', metricSource?: { __typename?: 'MetricSource', id: string, classType: string, configuration?: any | null, credentialId?: string | null, description?: string | null, erroredAt?: any | null, errorMessage?: string | null, lastRunAt?: any | null, metricId: string, name?: string | null, scheduled: boolean, slug?: string | null, sourceName?: string | null, metric: { __typename?: 'Metric', id: string, classType: string, name?: string | null }, googleSheet?: { __typename?: 'GoogleSheet', id: string, classType: string, spreadsheetUrl: string, status: GoogleSheetStatusEnum } | null, metricDataPoints?: Array<{ __typename?: 'MetricDataPoint', date: any, value: number, metric: { __typename?: 'Metric', id: string, classType: string, name?: string | null } }> | null, integration?: { __typename?: 'Integration', id: string, classType: string, sourceName: IntegrationSourceNamesEnum } | null, credential?: { __typename?: 'Credential', id: string, classType: string, displayName?: string | null, label?: string | null, sourceName?: string | null } | null, structuredFormula?: Array<{ __typename?: 'FormulaText', text: string } | { __typename?: 'Metric', id: string, slug?: string | null, name?: string | null }> | null } | null };

export type MetricSourcesQueryVariables = Exact<{ [key: string]: never; }>;


export type MetricSourcesQuery = { __typename?: 'Query', metricSources?: Array<{ __typename?: 'MetricSource', id: string, classType: string, name?: string | null, description?: string | null, erroredAt?: any | null, errorMessage?: string | null, lastRunAt?: any | null, metricId: string, scheduled: boolean, slug?: string | null, sourceName?: string | null }> | null };

export type AmplitudeMetricSourceEventNamesQueryVariables = Exact<{
  credentialId: Scalars['ID']['input'];
}>;


export type AmplitudeMetricSourceEventNamesQuery = { __typename?: 'Query', amplitudeMetricSourceEventNames?: Array<{ __typename?: 'Option', label: string, value: string }> | null };

export type AmplitudeEventTaxonomyQueryVariables = Exact<{
  credentialId: Scalars['ID']['input'];
}>;


export type AmplitudeEventTaxonomyQuery = { __typename?: 'Query', amplitudeEventTaxonomy: Array<{ __typename?: 'AmplitudeEvent', classType: string, name: string, category?: string | null, description?: string | null }> };

export type LookerApiLooksQueryVariables = Exact<{
  credentialId: Scalars['ID']['input'];
}>;


export type LookerApiLooksQuery = { __typename?: 'Query', lookerApiLooks?: Array<{ __typename?: 'Option', label: string, value: string }> | null };

export type LookerApiLookFieldsQueryVariables = Exact<{
  credentialId: Scalars['ID']['input'];
  lookId: Scalars['ID']['input'];
}>;


export type LookerApiLookFieldsQuery = { __typename?: 'Query', lookerApiLookFields?: Array<{ __typename?: 'Option', label: string, value: string }> | null };

export type MetricSourceMutationFieldsFragment = { __typename?: 'MetricSource', id: string, classType: string, configuration?: any | null, credentialId?: string | null, description?: string | null, erroredAt?: any | null, errorMessage?: string | null, lastRunAt?: any | null, metricId: string, name?: string | null, scheduled: boolean, slug?: string | null, sourceName?: string | null, metric: { __typename?: 'Metric', id: string, ownerId?: string | null, calculated?: boolean | null, classType: string, compactDisplay: boolean, maximumDisplayPrecision: number, minimumDisplayPrecision: number, redecimalPercentages?: boolean | null, displayFormat: DisplayFormatEnum, commentsCount: number, createdAt: any, description?: string | null, excludeWeekends: boolean, externalUrl?: string | null, externalUrlTitle?: string | null, favoriteId?: string | null, metricDataPointsCount: number, name?: string | null, periodToDate: boolean, positiveDirection: MetricPositiveDirectionsEnum, recentActivity?: boolean | null, rfId: string, rollUp: RollUpEnum, segmentedDataType: SegmentedDataTypeEnum, showDescription?: boolean | null, showTechnicalDescription?: boolean | null, slackChannelId?: string | null, slug?: string | null, sourceName?: string | null, strategyType?: StrategyTypeEnum | null, technicalDescription?: string | null, updatedAt: any, goals: Array<{ __typename?: 'Goal', id: string, classType: string, currentValue: number, endDate?: any | null, label: string, metricId: string, newestMetricDate?: any | null, oldestMetricDate?: any | null, percentageComplete: number, periodUnit: PeriodUnitEnum, periodNumber?: number | null, periodYear?: number | null, startValue: number, targetValue: number, startDate?: any | null, status: GoalStatusEnum }>, labels?: Array<{ __typename?: 'Label', id: string, classType: string, name: string }> | null, metricSource?: { __typename?: 'MetricSource', id: string, classType: string, errorMessage?: string | null, metricId: string, structuredFormula?: Array<{ __typename?: 'FormulaText', text: string } | { __typename?: 'Metric', id: string, slug?: string | null, name?: string | null }> | null } | null, organization: { __typename?: 'Organization', id: string, classType: string }, owner?: { __typename?: 'User', id: string, classType: string, name: string, email: string } | null, strategyStats: Array<{ __typename?: 'StrategyStat', change?: number | null, classType: string, displayPeriod: string, period: any, total: number }> }, integration?: { __typename?: 'Integration', id: string, classType: string, sourceName: IntegrationSourceNamesEnum } | null, strategies?: Array<{ __typename?: 'Strategy', id: string, classType: string }> | null, structuredFormula?: Array<{ __typename?: 'FormulaText', text: string } | { __typename?: 'Metric', id: string, slug?: string | null, name?: string | null }> | null };

export type MetricSourceCreateMutationVariables = Exact<{
  input: MetricSourceCreateInput;
}>;


export type MetricSourceCreateMutation = { __typename?: 'Mutation', metricSourceCreate?: { __typename?: 'MetricSourceCreatePayload', metricSource?: { __typename?: 'MetricSource', id: string, classType: string, configuration?: any | null, credentialId?: string | null, description?: string | null, erroredAt?: any | null, errorMessage?: string | null, lastRunAt?: any | null, metricId: string, name?: string | null, scheduled: boolean, slug?: string | null, sourceName?: string | null, metric: { __typename?: 'Metric', id: string, ownerId?: string | null, calculated?: boolean | null, classType: string, compactDisplay: boolean, maximumDisplayPrecision: number, minimumDisplayPrecision: number, redecimalPercentages?: boolean | null, displayFormat: DisplayFormatEnum, commentsCount: number, createdAt: any, description?: string | null, excludeWeekends: boolean, externalUrl?: string | null, externalUrlTitle?: string | null, favoriteId?: string | null, metricDataPointsCount: number, name?: string | null, periodToDate: boolean, positiveDirection: MetricPositiveDirectionsEnum, recentActivity?: boolean | null, rfId: string, rollUp: RollUpEnum, segmentedDataType: SegmentedDataTypeEnum, showDescription?: boolean | null, showTechnicalDescription?: boolean | null, slackChannelId?: string | null, slug?: string | null, sourceName?: string | null, strategyType?: StrategyTypeEnum | null, technicalDescription?: string | null, updatedAt: any, goals: Array<{ __typename?: 'Goal', id: string, classType: string, currentValue: number, endDate?: any | null, label: string, metricId: string, newestMetricDate?: any | null, oldestMetricDate?: any | null, percentageComplete: number, periodUnit: PeriodUnitEnum, periodNumber?: number | null, periodYear?: number | null, startValue: number, targetValue: number, startDate?: any | null, status: GoalStatusEnum }>, labels?: Array<{ __typename?: 'Label', id: string, classType: string, name: string }> | null, metricSource?: { __typename?: 'MetricSource', id: string, classType: string, errorMessage?: string | null, metricId: string, structuredFormula?: Array<{ __typename?: 'FormulaText', text: string } | { __typename?: 'Metric', id: string, slug?: string | null, name?: string | null }> | null } | null, organization: { __typename?: 'Organization', id: string, classType: string }, owner?: { __typename?: 'User', id: string, classType: string, name: string, email: string } | null, strategyStats: Array<{ __typename?: 'StrategyStat', change?: number | null, classType: string, displayPeriod: string, period: any, total: number }> }, integration?: { __typename?: 'Integration', id: string, classType: string, sourceName: IntegrationSourceNamesEnum } | null, strategies?: Array<{ __typename?: 'Strategy', id: string, classType: string }> | null, structuredFormula?: Array<{ __typename?: 'FormulaText', text: string } | { __typename?: 'Metric', id: string, slug?: string | null, name?: string | null }> | null } | null, errors: Array<{ __typename?: 'Error', message: string, path?: Array<string> | null }> } | null };

export type MetricSourceUpdateMutationVariables = Exact<{
  input: MetricSourceUpdateInput;
}>;


export type MetricSourceUpdateMutation = { __typename?: 'Mutation', metricSourceUpdate?: { __typename?: 'MetricSourceUpdatePayload', metricSource?: { __typename?: 'MetricSource', id: string, classType: string, configuration?: any | null, credentialId?: string | null, description?: string | null, erroredAt?: any | null, errorMessage?: string | null, lastRunAt?: any | null, metricId: string, name?: string | null, scheduled: boolean, slug?: string | null, sourceName?: string | null, metric: { __typename?: 'Metric', id: string, ownerId?: string | null, calculated?: boolean | null, classType: string, compactDisplay: boolean, maximumDisplayPrecision: number, minimumDisplayPrecision: number, redecimalPercentages?: boolean | null, displayFormat: DisplayFormatEnum, commentsCount: number, createdAt: any, description?: string | null, excludeWeekends: boolean, externalUrl?: string | null, externalUrlTitle?: string | null, favoriteId?: string | null, metricDataPointsCount: number, name?: string | null, periodToDate: boolean, positiveDirection: MetricPositiveDirectionsEnum, recentActivity?: boolean | null, rfId: string, rollUp: RollUpEnum, segmentedDataType: SegmentedDataTypeEnum, showDescription?: boolean | null, showTechnicalDescription?: boolean | null, slackChannelId?: string | null, slug?: string | null, sourceName?: string | null, strategyType?: StrategyTypeEnum | null, technicalDescription?: string | null, updatedAt: any, goals: Array<{ __typename?: 'Goal', id: string, classType: string, currentValue: number, endDate?: any | null, label: string, metricId: string, newestMetricDate?: any | null, oldestMetricDate?: any | null, percentageComplete: number, periodUnit: PeriodUnitEnum, periodNumber?: number | null, periodYear?: number | null, startValue: number, targetValue: number, startDate?: any | null, status: GoalStatusEnum }>, labels?: Array<{ __typename?: 'Label', id: string, classType: string, name: string }> | null, metricSource?: { __typename?: 'MetricSource', id: string, classType: string, errorMessage?: string | null, metricId: string, structuredFormula?: Array<{ __typename?: 'FormulaText', text: string } | { __typename?: 'Metric', id: string, slug?: string | null, name?: string | null }> | null } | null, organization: { __typename?: 'Organization', id: string, classType: string }, owner?: { __typename?: 'User', id: string, classType: string, name: string, email: string } | null, strategyStats: Array<{ __typename?: 'StrategyStat', change?: number | null, classType: string, displayPeriod: string, period: any, total: number }> }, integration?: { __typename?: 'Integration', id: string, classType: string, sourceName: IntegrationSourceNamesEnum } | null, strategies?: Array<{ __typename?: 'Strategy', id: string, classType: string }> | null, structuredFormula?: Array<{ __typename?: 'FormulaText', text: string } | { __typename?: 'Metric', id: string, slug?: string | null, name?: string | null }> | null } | null, errors: Array<{ __typename?: 'Error', message: string, path?: Array<string> | null }> } | null };

export type MetricSourceDeleteMutationVariables = Exact<{
  input: MetricSourceDeleteInput;
}>;


export type MetricSourceDeleteMutation = { __typename?: 'Mutation', crudOperation?: { __typename?: 'MetricSourceDeletePayload', crudOperation: { __typename?: 'TypesMetricSourceTypeGraphqlCrudOperation', operation: CrudOperationEnum, data?: { __typename?: 'MetricSource', id: string, classType: string, name?: string | null, description?: string | null, slug?: string | null, configuration?: any | null, sourceName?: string | null, integration?: { __typename?: 'Integration', id: string, classType: string, sourceName: IntegrationSourceNamesEnum } | null } | null }, errors: Array<{ __typename?: 'Error', message: string, path?: Array<string> | null }> } | null };

export type MetricSourceTestMutationVariables = Exact<{
  input: MetricSourceTestInput;
}>;


export type MetricSourceTestMutation = { __typename?: 'Mutation', metricSourceTest?: { __typename?: 'MetricSourceTestPayload', results: any, metricSource?: { __typename?: 'MetricSource', id: string, classType: string, erroredAt?: any | null, errorMessage?: string | null, lastRunAt?: any | null } | null } | null };

export type MetricSourceTestAttributesMutationVariables = Exact<{
  input: MetricSourceTestAttributesInput;
}>;


export type MetricSourceTestAttributesMutation = { __typename?: 'Mutation', metricSourceTestAttributes?: { __typename?: 'MetricSourceTestAttributesPayload', results: any } | null };

export type MetricSourceRunMutationVariables = Exact<{
  input: MetricSourceRunInput;
}>;


export type MetricSourceRunMutation = { __typename?: 'Mutation', metricSourceRun?: { __typename?: 'MetricSourceRunPayload', success: boolean, status: string, metricSource?: { __typename?: 'MetricSource', id: string, classType: string, erroredAt?: any | null, errorMessage?: string | null, lastRunAt?: any | null } | null, errors: Array<{ __typename?: 'Error', message: string, path?: Array<string> | null }> } | null };

export type MetricSourceActivitiesQueryVariables = Exact<{
  metricSourceId: Scalars['ID']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type MetricSourceActivitiesQuery = { __typename?: 'Query', metricSourceActivities?: { __typename?: 'MetricSourceActivityCollection', collection: Array<{ __typename?: 'MetricSourceActivity', id: string, classType: string, sourceName?: string | null, processedCount: number, processedState?: MetricSourceActivityProcessedStateEnum | null, totalCount: number, createdAt?: any | null, updatedAt?: any | null, metricSource?: { __typename?: 'MetricSource', id: string, classType: string, name?: string | null, metric: { __typename?: 'Metric', id: string, classType: string, name?: string | null } } | null }>, metadata: { __typename?: 'CollectionMetadata', page: number, totalPages: number, limitValue: number, totalCount: number } } | null };

export type MetricSourceActivityQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type MetricSourceActivityQuery = { __typename?: 'Query', metricSourceActivity?: { __typename?: 'MetricSourceActivity', id: string, classType: string, payload?: any | null } | null };

export type OrganizationFieldsFragment = { __typename?: 'Organization', id: string, classType: string, apiToken?: string | null, autoImportGoogleSheet: boolean, defaultImportTime: string, homepageUrl?: string | null, logo?: string | null, metricDefaults?: any | null, name: string, slackable: boolean };

export type OrganizationSamlFieldsFragment = { __typename?: 'Organization', idpEntityId?: string | null, idpSsoServiceUrl?: string | null, idpCert?: string | null, issuer?: string | null, ssoIdentifier?: string | null, ssoProvider?: string | null };

export type OrganizationSubscriptionFieldsFragment = { __typename?: 'Organization', activeSubscription?: { __typename?: 'CustomerSubscription', id: string, startDate?: any | null, endDate?: any | null, trialEndDate?: any | null, status: CustomerSubscriptionStatusEnum } | null };

export type OrganizationQueryVariables = Exact<{ [key: string]: never; }>;


export type OrganizationQuery = { __typename?: 'Query', organization?: { __typename?: 'Organization', id: string, classType: string, apiToken?: string | null, autoImportGoogleSheet: boolean, defaultImportTime: string, homepageUrl?: string | null, logo?: string | null, metricDefaults?: any | null, name: string, slackable: boolean, idpEntityId?: string | null, idpSsoServiceUrl?: string | null, idpCert?: string | null, issuer?: string | null, ssoIdentifier?: string | null, ssoProvider?: string | null, businessContext?: { __typename?: 'BusinessContext', businessName?: string | null, content?: string | null, organizationId: string, parentBusinessContextId?: string | null, parentBusinessContextSlug?: string | null, createdAt: any, data?: any | null, name?: string | null, updatedAt: any, id: string, classType: string, slug?: string | null } | null } | null };

export type OrganizationsQueryVariables = Exact<{ [key: string]: never; }>;


export type OrganizationsQuery = { __typename?: 'Query', organizations?: Array<{ __typename?: 'Organization', id: string, name: string, slug: string }> | null };

export type OrganizationProductStrategyQueryVariables = Exact<{ [key: string]: never; }>;


export type OrganizationProductStrategyQuery = { __typename?: 'Query', organization?: { __typename?: 'Organization', id: string, classType: string } | null };

export type CustomerSubscriptionQueryVariables = Exact<{ [key: string]: never; }>;


export type CustomerSubscriptionQuery = { __typename?: 'Query', organization?: { __typename?: 'Organization', id: string, activeSubscription?: { __typename?: 'CustomerSubscription', id: string, startDate?: any | null, endDate?: any | null, trialEndDate?: any | null, status: CustomerSubscriptionStatusEnum } | null } | null };

export type CreateOrganizationMutationVariables = Exact<{
  input: OrganizationCreateInput;
}>;


export type CreateOrganizationMutation = { __typename?: 'Mutation', organizationCreate?: { __typename?: 'OrganizationCreatePayload', organization?: { __typename?: 'Organization', id: string, classType: string, apiToken?: string | null, autoImportGoogleSheet: boolean, defaultImportTime: string, homepageUrl?: string | null, logo?: string | null, metricDefaults?: any | null, name: string, slackable: boolean } | null, strategy?: { __typename?: 'Strategy', id: string, classType: string } | null, errors: Array<{ __typename?: 'Error', message: string, path?: Array<string> | null }> } | null };

export type CustomerCreateMutationVariables = Exact<{
  input: CustomerCreateInput;
}>;


export type CustomerCreateMutation = { __typename?: 'Mutation', customerCreate?: { __typename?: 'CustomerCreatePayload', organization?: { __typename?: 'Organization', id: string, classType: string, apiToken?: string | null, autoImportGoogleSheet: boolean, defaultImportTime: string, homepageUrl?: string | null, logo?: string | null, metricDefaults?: any | null, name: string, slackable: boolean } | null, strategy?: { __typename?: 'Strategy', id: string, classType: string } | null, errors: Array<{ __typename?: 'Error', message: string, path?: Array<string> | null }> } | null };

export type OrganizationUpdateMutationVariables = Exact<{
  input: OrganizationUpdateInput;
}>;


export type OrganizationUpdateMutation = { __typename?: 'Mutation', organizationUpdate?: { __typename?: 'OrganizationUpdatePayload', organization?: { __typename?: 'Organization', id: string, classType: string, apiToken?: string | null, autoImportGoogleSheet: boolean, defaultImportTime: string, homepageUrl?: string | null, logo?: string | null, metricDefaults?: any | null, name: string, slackable: boolean, idpEntityId?: string | null, idpSsoServiceUrl?: string | null, idpCert?: string | null, issuer?: string | null, ssoIdentifier?: string | null, ssoProvider?: string | null } | null, errors: Array<{ __typename?: 'Error', message: string, path?: Array<string> | null }> } | null };

export type OrganizationDefaultMetricStatIntervalsApplyMutationVariables = Exact<{
  input: OrganizationDefaultMetricStatIntervalsApplyInput;
}>;


export type OrganizationDefaultMetricStatIntervalsApplyMutation = { __typename?: 'Mutation', organizationDefaultMetricStatIntervalsApply?: { __typename?: 'OrganizationDefaultMetricStatIntervalsApplyPayload', organization?: { __typename?: 'Organization', id: string, classType: string, apiToken?: string | null, autoImportGoogleSheet: boolean, defaultImportTime: string, homepageUrl?: string | null, logo?: string | null, metricDefaults?: any | null, name: string, slackable: boolean } | null, errors: Array<{ __typename?: 'Error', message: string, path?: Array<string> | null }> } | null };

export type PaginationAttributesFragment = { __typename?: 'CollectionMetadata', page: number, totalPages: number, limitValue: number, totalCount: number };

export type PlaybookFieldsFragment = { __typename?: 'Playbook', id: string, classType: string, aiBuilderSlug?: string | null, category?: string | null, createdAt?: any | null, description?: string | null, friendlyId?: string | null, hero?: string | null, name: string, publicationState: PublicationStateEnum, rowOrder?: number | null, shortDescription?: string | null, organization?: { __typename?: 'Organization', id: string, classType: string, name: string, logo?: string | null, homepageUrl?: string | null } | null, user?: { __typename?: 'User', id: string, classType: string, name: string } | null };

export type PlaybooksQueryVariables = Exact<{
  aiOnly?: InputMaybe<Scalars['CastableBoolean']['input']>;
}>;


export type PlaybooksQuery = { __typename?: 'Query', playbooks: Array<{ __typename?: 'Playbook', id: string, classType: string, aiBuilderSlug?: string | null, category?: string | null, createdAt?: any | null, description?: string | null, friendlyId?: string | null, hero?: string | null, name: string, publicationState: PublicationStateEnum, rowOrder?: number | null, shortDescription?: string | null, organization?: { __typename?: 'Organization', id: string, classType: string, name: string, logo?: string | null, homepageUrl?: string | null } | null, user?: { __typename?: 'User', id: string, classType: string, name: string } | null }> };

export type PlaybookQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type PlaybookQuery = { __typename?: 'Query', playbook?: { __typename?: 'Playbook', id: string, classType: string, aiBuilderSlug?: string | null, category?: string | null, createdAt?: any | null, description?: string | null, friendlyId?: string | null, hero?: string | null, name: string, publicationState: PublicationStateEnum, rowOrder?: number | null, shortDescription?: string | null, organization?: { __typename?: 'Organization', id: string, classType: string, name: string, logo?: string | null, homepageUrl?: string | null } | null, user?: { __typename?: 'User', id: string, classType: string, name: string } | null } | null };

export type PlaybookApplyWithAiMutationVariables = Exact<{
  input: PlaybookApplyWithAiInput;
}>;


export type PlaybookApplyWithAiMutation = { __typename?: 'Mutation', playbookApplyWithAi?: { __typename?: 'PlaybookApplyWithAiPayload', strategy?: { __typename?: 'Strategy', id: string, businessContextId?: string | null, classType: string, indicatorCounter: number } | null, chat?: { __typename?: 'Chat', id: string } | null, errors: Array<{ __typename?: 'Error', message: string, path?: Array<string> | null }> } | null };

export type PlaybookApplyToStrategyWithAiMutationVariables = Exact<{
  input: PlaybookApplyToStrategyWithAiInput;
}>;


export type PlaybookApplyToStrategyWithAiMutation = { __typename?: 'Mutation', playbookApplyToStrategyWithAi?: { __typename?: 'PlaybookApplyToStrategyWithAiPayload', strategy?: { __typename?: 'Strategy', id: string, businessContextId?: string | null, classType: string, empty: boolean, indicatorCounter: number } | null, chat?: { __typename?: 'Chat', id: string } | null, errors: Array<{ __typename?: 'Error', message: string, path?: Array<string> | null }> } | null };

export type PlaybookCreateFromStrategyMutationVariables = Exact<{
  input: PlaybookCreateFromStrategyInput;
}>;


export type PlaybookCreateFromStrategyMutation = { __typename?: 'Mutation', playbookCreateFromStrategy?: { __typename?: 'PlaybookCreateFromStrategyPayload', playbook?: { __typename?: 'Playbook', id: string, classType: string } | null } | null };

export type PlaybookSubmitForReviewMutationVariables = Exact<{
  input: PlaybookSubmitForReviewInput;
}>;


export type PlaybookSubmitForReviewMutation = { __typename?: 'Mutation', playbookSubmitForReview?: { __typename?: 'PlaybookSubmitForReviewPayload', playbook?: { __typename?: 'Playbook', id: string, classType: string, publicationState: PublicationStateEnum } | null } | null };

export type RecurringReportConfigurationSubscriptionFieldsFragment = { __typename?: 'RecurringReportConfiguration', id: string, classType: string, aiPrompt?: string | null, aiPromptTestResult?: string | null, createdAt: any, emails: string, name?: string | null, position?: number | null, sendToEmail: boolean, sendToSlack: boolean, service: RecurringReportConfigurationServiceEnum, strategyId: string, slackChannelId?: string | null, slackChannel?: { __typename?: 'SlackChannel', id: string, classType: string, name: string, channelId: string, isIm?: boolean | null, value: string, label: string } | null };

export type RecurringReportConfigurationFieldsFragment = { __typename?: 'RecurringReportConfiguration', id: string, classType: string, aiPrompt?: string | null, aiPromptTestResult?: string | null, createdAt: any, emails: string, name?: string | null, position?: number | null, sendToEmail: boolean, sendToSlack: boolean, service: RecurringReportConfigurationServiceEnum, strategyId: string, slackChannelId?: string | null, schedule?: { __typename?: 'Schedule', id: string, schedulableId: string, schedulableType: string, classType: string, rrule?: string | null, humanized: string } | null, slackChannel?: { __typename?: 'SlackChannel', id: string, classType: string, name: string, channelId: string, isIm?: boolean | null, value: string, label: string } | null };

export type RecurringReportConfigurationsQueryVariables = Exact<{
  strategyId: Scalars['ID']['input'];
}>;


export type RecurringReportConfigurationsQuery = { __typename?: 'Query', recurringReportConfigurations?: { __typename?: 'RecurringReportConfigurationCollection', collection: Array<{ __typename?: 'RecurringReportConfiguration', id: string, classType: string, aiPrompt?: string | null, aiPromptTestResult?: string | null, createdAt: any, emails: string, name?: string | null, position?: number | null, sendToEmail: boolean, sendToSlack: boolean, service: RecurringReportConfigurationServiceEnum, strategyId: string, slackChannelId?: string | null, schedule?: { __typename?: 'Schedule', id: string, schedulableId: string, schedulableType: string, classType: string, rrule?: string | null, humanized: string } | null, slackChannel?: { __typename?: 'SlackChannel', id: string, classType: string, name: string, channelId: string, isIm?: boolean | null, value: string, label: string } | null }>, metadata: { __typename?: 'CollectionMetadata', page: number, totalPages: number, limitValue: number, totalCount: number } } | null };

export type RecurringReportConfigurationQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type RecurringReportConfigurationQuery = { __typename?: 'Query', recurringReportConfiguration?: { __typename?: 'RecurringReportConfiguration', id: string, classType: string, aiPrompt?: string | null, aiPromptTestResult?: string | null, createdAt: any, emails: string, name?: string | null, position?: number | null, sendToEmail: boolean, sendToSlack: boolean, service: RecurringReportConfigurationServiceEnum, strategyId: string, slackChannelId?: string | null, reports: Array<{ __typename?: 'Report', id: string, classType: string, createdAt: any, recurringReportConfigurationId?: string | null, strategyId: string, summary?: string | null }>, schedule?: { __typename?: 'Schedule', id: string, schedulableId: string, schedulableType: string, classType: string, rrule?: string | null, humanized: string } | null, slackChannel?: { __typename?: 'SlackChannel', id: string, classType: string, name: string, channelId: string, isIm?: boolean | null, value: string, label: string } | null } | null };

export type RecurringReportConfigurationsByServiceQueryVariables = Exact<{
  strategyId: Scalars['ID']['input'];
  service: RecurringReportConfigurationServiceEnum;
  reportLimit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type RecurringReportConfigurationsByServiceQuery = { __typename?: 'Query', recurringReportConfigurations?: { __typename?: 'RecurringReportConfigurationCollection', collection: Array<{ __typename?: 'RecurringReportConfiguration', id: string, classType: string, aiPrompt?: string | null, aiPromptTestResult?: string | null, createdAt: any, emails: string, name?: string | null, position?: number | null, sendToEmail: boolean, sendToSlack: boolean, service: RecurringReportConfigurationServiceEnum, strategyId: string, slackChannelId?: string | null, reports: Array<{ __typename?: 'Report', id: string, classType: string, createdAt: any, name?: string | null, recurringReportConfigurationId?: string | null, strategyId: string, summary?: string | null }>, schedule?: { __typename?: 'Schedule', id: string, schedulableId: string, schedulableType: string, classType: string, rrule?: string | null, humanized: string } | null, slackChannel?: { __typename?: 'SlackChannel', id: string, classType: string, name: string, channelId: string, isIm?: boolean | null, value: string, label: string } | null }>, metadata: { __typename?: 'CollectionMetadata', page: number, totalPages: number, limitValue: number, totalCount: number } } | null };

export type RecurringReportConfigurationCreateMutationVariables = Exact<{
  input: RecurringReportConfigurationCreateInput;
}>;


export type RecurringReportConfigurationCreateMutation = { __typename?: 'Mutation', recurringReportConfigurationCreate?: { __typename?: 'RecurringReportConfigurationCreatePayload', recurringReportConfiguration?: { __typename?: 'RecurringReportConfiguration', id: string, classType: string, aiPrompt?: string | null, aiPromptTestResult?: string | null, createdAt: any, emails: string, name?: string | null, position?: number | null, sendToEmail: boolean, sendToSlack: boolean, service: RecurringReportConfigurationServiceEnum, strategyId: string, slackChannelId?: string | null, reports: Array<{ __typename?: 'Report', id: string, classType: string, createdAt: any, recurringReportConfigurationId?: string | null, strategyId: string, summary?: string | null }>, schedule?: { __typename?: 'Schedule', id: string, schedulableId: string, schedulableType: string, classType: string, rrule?: string | null, humanized: string } | null, slackChannel?: { __typename?: 'SlackChannel', id: string, classType: string, name: string, channelId: string, isIm?: boolean | null, value: string, label: string } | null } | null, errors: Array<{ __typename?: 'Error', message: string, path?: Array<string> | null }> } | null };

export type RecurringReportConfigurationUpdateMutationVariables = Exact<{
  input: RecurringReportConfigurationUpdateInput;
}>;


export type RecurringReportConfigurationUpdateMutation = { __typename?: 'Mutation', recurringReportConfigurationUpdate?: { __typename?: 'RecurringReportConfigurationUpdatePayload', recurringReportConfiguration?: { __typename?: 'RecurringReportConfiguration', id: string, classType: string, aiPrompt?: string | null, aiPromptTestResult?: string | null, createdAt: any, emails: string, name?: string | null, position?: number | null, sendToEmail: boolean, sendToSlack: boolean, service: RecurringReportConfigurationServiceEnum, strategyId: string, slackChannelId?: string | null, reports: Array<{ __typename?: 'Report', id: string, classType: string, createdAt: any, recurringReportConfigurationId?: string | null, strategyId: string, summary?: string | null }>, schedule?: { __typename?: 'Schedule', id: string, schedulableId: string, schedulableType: string, classType: string, rrule?: string | null, humanized: string } | null, slackChannel?: { __typename?: 'SlackChannel', id: string, classType: string, name: string, channelId: string, isIm?: boolean | null, value: string, label: string } | null } | null, errors: Array<{ __typename?: 'Error', message: string, path?: Array<string> | null }> } | null };

export type RecurringReportConfigurationRunMutationVariables = Exact<{
  input: RecurringReportConfigurationRunInput;
}>;


export type RecurringReportConfigurationRunMutation = { __typename?: 'Mutation', recurringReportConfigurationRun?: { __typename?: 'RecurringReportConfigurationRunPayload', recurringReportConfiguration?: { __typename?: 'RecurringReportConfiguration', id: string, classType: string, aiPrompt?: string | null, aiPromptTestResult?: string | null, createdAt: any, emails: string, name?: string | null, position?: number | null, sendToEmail: boolean, sendToSlack: boolean, service: RecurringReportConfigurationServiceEnum, strategyId: string, slackChannelId?: string | null, reports: Array<{ __typename?: 'Report', id: string, classType: string, createdAt: any, recurringReportConfigurationId?: string | null, strategyId: string, summary?: string | null }>, schedule?: { __typename?: 'Schedule', id: string, schedulableId: string, schedulableType: string, classType: string, rrule?: string | null, humanized: string } | null, slackChannel?: { __typename?: 'SlackChannel', id: string, classType: string, name: string, channelId: string, isIm?: boolean | null, value: string, label: string } | null } | null } | null };

export type RecurringReportConfigurationPromptTestMutationVariables = Exact<{
  input: RecurringReportConfigurationPromptTestInput;
}>;


export type RecurringReportConfigurationPromptTestMutation = { __typename?: 'Mutation', recurringReportConfigurationPromptTest?: { __typename?: 'RecurringReportConfigurationPromptTestPayload', recurringReportConfiguration: { __typename?: 'RecurringReportConfiguration', id: string, classType: string, aiPrompt?: string | null, aiPromptTestResult?: string | null, createdAt: any, emails: string, name?: string | null, position?: number | null, sendToEmail: boolean, sendToSlack: boolean, service: RecurringReportConfigurationServiceEnum, strategyId: string, slackChannelId?: string | null, schedule?: { __typename?: 'Schedule', id: string, schedulableId: string, schedulableType: string, classType: string, rrule?: string | null, humanized: string } | null, slackChannel?: { __typename?: 'SlackChannel', id: string, classType: string, name: string, channelId: string, isIm?: boolean | null, value: string, label: string } | null }, chat?: { __typename?: 'Chat', id: string, classType: string, currentAssistantId?: string | null, errorIsRetryable: boolean, errorMessage?: string | null, organizationId: string, pipelineSlug: string, processedState: ChatProcessedStateEnum, realTimeStatus?: string | null, strategyId?: string | null } | null } | null };

export type RecurringReportConfigurationDeleteMutationVariables = Exact<{
  input: RecurringReportConfigurationDeleteInput;
}>;


export type RecurringReportConfigurationDeleteMutation = { __typename?: 'Mutation', recurringReportConfigurationDelete?: { __typename?: 'RecurringReportConfigurationDeletePayload', crudOperation: { __typename?: 'TypesRecurringReportConfigurationTypeGraphqlCrudOperation', operation: CrudOperationEnum, data?: { __typename?: 'RecurringReportConfiguration', id: string } | null }, errors: Array<{ __typename?: 'Error', message: string, path?: Array<string> | null }> } | null };

export type ReportSubscriptionFieldsFragment = { __typename?: 'Report', id: string, classType: string, createdAt: any, rfId: string, emails: string, endDate?: any | null, name?: string | null, recurringReportConfigurationId?: string | null, sendToEmail: boolean, sendToSlack: boolean, slackChannelId?: string | null, startDate?: any | null, strategyId: string, summary?: string | null, updatedAt: any };

export type ReportFieldsFragment = { __typename?: 'Report', id: string, classType: string, createdAt: any, rfId: string, emails: string, endDate?: any | null, name?: string | null, recurringReportConfigurationId?: string | null, sendToEmail: boolean, sendToSlack: boolean, slackChannelId?: string | null, startDate?: any | null, strategyId: string, summary?: string | null, updatedAt: any, slackChannel?: { __typename?: 'SlackChannel', id: string, classType: string, name: string, channelId: string, type: string, value: string, label: string } | null, strategy: { __typename?: 'Strategy', id: string, classType: string, name?: string | null } };

export type ReportEntityFieldsFragment = { __typename?: 'Entity', id: string, classType: string, confidenceRating?: ConfidenceRatingEnum | null, containeeStats?: any | null, foreignState?: string | null, goalHypothesis?: string | null, name?: string | null, results?: string | null, secondaryForeignId?: string | null, sourceName?: string | null, sourceUrl?: string | null, summary?: string | null, workflowState?: EntityWorkflowStateEnum | null, ownerId?: string | null, labels?: Array<{ __typename?: 'Label', id: string, name: string, classType: string }> | null, owner?: { __typename?: 'User', id: string, name: string, email: string, classType: string } | null };

export type ReportsQueryVariables = Exact<{
  strategyId: Scalars['ID']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type ReportsQuery = { __typename?: 'Query', reports?: { __typename?: 'ReportCollection', collection: Array<{ __typename?: 'Report', id: string, classType: string, createdAt: any, rfId: string, emails: string, endDate?: any | null, name?: string | null, recurringReportConfigurationId?: string | null, sendToEmail: boolean, sendToSlack: boolean, slackChannelId?: string | null, startDate?: any | null, strategyId: string, summary?: string | null, updatedAt: any, slackChannel?: { __typename?: 'SlackChannel', id: string, classType: string, name: string, channelId: string, type: string, value: string, label: string } | null, strategy: { __typename?: 'Strategy', id: string, classType: string, name?: string | null } }>, metadata: { __typename?: 'CollectionMetadata', page: number, totalPages: number, limitValue: number, totalCount: number } } | null };

export type ReportQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type ReportQuery = { __typename?: 'Query', report?: { __typename?: 'Report', id: string, classType: string, createdAt: any, rfId: string, emails: string, endDate?: any | null, name?: string | null, recurringReportConfigurationId?: string | null, sendToEmail: boolean, sendToSlack: boolean, slackChannelId?: string | null, startDate?: any | null, strategyId: string, summary?: string | null, updatedAt: any, slackChannel?: { __typename?: 'SlackChannel', id: string, classType: string, name: string, channelId: string, type: string, value: string, label: string } | null, strategy: { __typename?: 'Strategy', id: string, classType: string, name?: string | null } } | null };

export type ReportCreateMutationVariables = Exact<{
  input: ReportCreateInput;
}>;


export type ReportCreateMutation = { __typename?: 'Mutation', reportCreate?: { __typename?: 'ReportCreatePayload', report?: { __typename?: 'Report', id: string, classType: string, createdAt: any, rfId: string, emails: string, endDate?: any | null, name?: string | null, recurringReportConfigurationId?: string | null, sendToEmail: boolean, sendToSlack: boolean, slackChannelId?: string | null, startDate?: any | null, strategyId: string, summary?: string | null, updatedAt: any, slackChannel?: { __typename?: 'SlackChannel', id: string, classType: string, name: string, channelId: string, type: string, value: string, label: string } | null, strategy: { __typename?: 'Strategy', id: string, classType: string, name?: string | null } } | null, errors: Array<{ __typename?: 'Error', message: string, path?: Array<string> | null }> } | null };

export type ReportUpdateMutationVariables = Exact<{
  input: ReportUpdateInput;
}>;


export type ReportUpdateMutation = { __typename?: 'Mutation', reportUpdate?: { __typename?: 'ReportUpdatePayload', report?: { __typename?: 'Report', id: string, classType: string, createdAt: any, rfId: string, emails: string, endDate?: any | null, name?: string | null, recurringReportConfigurationId?: string | null, sendToEmail: boolean, sendToSlack: boolean, slackChannelId?: string | null, startDate?: any | null, strategyId: string, summary?: string | null, updatedAt: any, slackChannel?: { __typename?: 'SlackChannel', id: string, classType: string, name: string, channelId: string, type: string, value: string, label: string } | null, strategy: { __typename?: 'Strategy', id: string, classType: string, name?: string | null } } | null, errors: Array<{ __typename?: 'Error', message: string, path?: Array<string> | null }> } | null };

export type ReportSendMutationVariables = Exact<{
  input: ReportSendInput;
}>;


export type ReportSendMutation = { __typename?: 'Mutation', reportSend?: { __typename?: 'ReportSendPayload', report?: { __typename?: 'Report', id: string, classType: string, createdAt: any, rfId: string, emails: string, endDate?: any | null, name?: string | null, recurringReportConfigurationId?: string | null, sendToEmail: boolean, sendToSlack: boolean, slackChannelId?: string | null, startDate?: any | null, strategyId: string, summary?: string | null, updatedAt: any, slackChannel?: { __typename?: 'SlackChannel', id: string, classType: string, name: string, channelId: string, type: string, value: string, label: string } | null, strategy: { __typename?: 'Strategy', id: string, classType: string, name?: string | null } } | null, errors: Array<{ __typename?: 'Error', message: string, path?: Array<string> | null }> } | null };

export type ScheduleSubscriptionFieldsFragment = { __typename?: 'Schedule', id: string, classType: string, schedulableId: string, schedulableType: string, rrule?: string | null, humanized: string };

export type ScheduleFieldsFragment = { __typename?: 'Schedule', id: string, classType: string, schedulableId: string, schedulableType: string, rrule?: string | null, humanized: string };

export type SegmentFiltersUpdateMutationVariables = Exact<{
  input: SegmentFiltersUpdateInput;
}>;


export type SegmentFiltersUpdateMutation = { __typename?: 'Mutation', segmentFiltersUpdate?: { __typename?: 'SegmentFiltersUpdatePayload', segmentFilters: Array<{ __typename?: 'SegmentFilter', id: string, segmentName: { __typename?: 'SegmentName', id: string, name: string }, segmentValue: { __typename?: 'SegmentValue', id: string, value: string } }>, filterable: { __typename?: 'MetricDataPoint', id: string } | { __typename?: 'Strategy', id: string }, errors: Array<{ __typename?: 'Error', message: string, path?: Array<string> | null }> } | null };

export type SlackChannelsAutocompleteQueryVariables = Exact<{
  query: Scalars['String']['input'];
}>;


export type SlackChannelsAutocompleteQuery = { __typename?: 'Query', slackChannelsAutocomplete?: Array<{ __typename?: 'SlackChannel', id: string, classType: string, channelId: string, name: string, isArchived?: boolean | null, isIm?: boolean | null, isChannel?: boolean | null, value: string, label: string, type: string }> | null };

export type SlackChannelsQueryVariables = Exact<{ [key: string]: never; }>;


export type SlackChannelsQuery = { __typename?: 'Query', slackChannels?: Array<{ __typename?: 'SlackChannel', id: string, classType: string, channelId: string, name: string, label: string }> | null };

export type NodeFieldsFragment = { __typename?: 'Node', id: string, classType: string, domainObjectId: string, domainObjectType: string, strategyId: string, data: any, nodeId?: string | null, type: string, metadata?: any | null, position: any, parentId?: string | null, width?: number | null, height?: number | null, hidden: boolean, zIndex: number, simBaseline?: number | null, simPercentChange?: number | null, simTarget?: number | null, statsUpdatedAt?: any | null, simImpacts: Array<{ __typename?: 'SimulatorPartialResult', name: string, nodeId: string, nodeRfId: string, deltaR?: number | null, percentR?: number | null }>, simPartials1p: Array<{ __typename?: 'SimulatorPartialResult', name: string, nodeId: string, nodeRfId: string, deltaR?: number | null, percentR?: number | null }>, strategy?: { __typename?: 'Strategy', id: string, filterableId: string } | null, strategyStats: Array<{ __typename?: 'StrategyStat', change?: number | null, classType: string, displayPeriod: string, period: any, total: number }> };

export type EdgeSubscriptionFieldsFragment = { __typename?: 'Edge', id: string, classType: string, color?: string | null, correlationScore?: string | null, correlationScoreUpdatedAt?: any | null, insightsDetailsChatId?: string | null, data: any, edgeId: string, insights?: string | null, insightsDetails?: string | null, rfId: string, source: string, selected?: boolean | null, simImpact?: number | null, sourceId?: string | null, sourceHandle: string, sourceType: string, strategyId: string, target: string, targetId?: string | null, targetHandle: string, targetType: string, type: string, zIndex: number };

export type EdgeFieldsFragment = { __typename?: 'Edge', id: string, classType: string, color?: string | null, correlationScore?: string | null, correlationScoreUpdatedAt?: any | null, insightsDetailsChatId?: string | null, data: any, edgeId: string, insights?: string | null, insightsDetails?: string | null, rfId: string, source: string, selected?: boolean | null, simImpact?: number | null, sourceId?: string | null, sourceHandle: string, sourceType: string, strategyId: string, target: string, targetId?: string | null, targetHandle: string, targetType: string, type: string, zIndex: number, insightsDetailsChat?: { __typename?: 'Chat', id: string, classType: string, processedState: ChatProcessedStateEnum, errorMessage?: string | null, strategyId?: string | null } | null };

export type NoteSubscriptionFieldsFragment = { __typename?: 'Note', id: string, classType: string, createdAt: any, rfId: string, text?: string | null, updatedAt: any };

export type NoteFieldsFragment = { __typename?: 'Note', id: string, classType: string, createdAt: any, rfId: string, text?: string | null, updatedAt: any };

export type SectionSubscriptionFieldsFragment = { __typename?: 'Section', id: string, classType: string, createdAt: any, name?: string | null, rfId: string, updatedAt: any };

export type SectionFieldsFragment = { __typename?: 'Section', id: string, classType: string, createdAt: any, name?: string | null, rfId: string, updatedAt: any };

export type MapImageSubscriptionFieldsFragment = { __typename?: 'MapImage', id: string, classType: string, createdAt: any, rfId: string, updatedAt: any, url: string };

export type MapImageFieldsFragment = { __typename?: 'MapImage', id: string, classType: string, createdAt: any, rfId: string, updatedAt: any, url: string };

export type StrategySubscriptionFieldsFragment = { __typename?: 'Strategy', id: string, rfId: string, classType: string, aiContext?: string | null, backgroundChangeInProgress: boolean, businessContextId?: string | null, confidenceRating?: ConfidenceRatingEnum | null, connected: boolean, createdAt: any, description?: string | null, empty: boolean, indicatorCounter: number, name?: string | null, ownerId?: string | null, recurringReportConfigurationsCount: number, sharing: SharingTypesEnum, showCorrelations: boolean, statsUpdatedAt?: any | null, status: DomainObjectStatusEnum, updatedAt: any };

export type StrategyQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  loadAsAnonymous?: InputMaybe<Scalars['CastableBoolean']['input']>;
}>;


export type StrategyQuery = { __typename?: 'Query', strategy?: { __typename?: 'Strategy', gid: string, commentsCount: number, endDate?: any | null, filterableId: string, favoriteId?: string | null, range?: string | null, showSegmentCreate: boolean, slackChannelId?: string | null, startDate?: any | null, statDisplay?: StatDisplayEnum | null, token?: string | null, id: string, rfId: string, classType: string, aiContext?: string | null, backgroundChangeInProgress: boolean, businessContextId?: string | null, confidenceRating?: ConfidenceRatingEnum | null, connected: boolean, createdAt: any, description?: string | null, empty: boolean, indicatorCounter: number, name?: string | null, ownerId?: string | null, recurringReportConfigurationsCount: number, sharing: SharingTypesEnum, showCorrelations: boolean, statsUpdatedAt?: any | null, status: DomainObjectStatusEnum, updatedAt: any, aiContextVectorStoreFiles?: Array<{ __typename?: 'AiAssistantFile', id: string, classType: string, name: string, remoteId: string, cacheableId: string, cacheableType: string }> | null, slackChannel?: { __typename?: 'SlackChannel', id: string, classType: string, name: string, channelId: string, isIm?: boolean | null } | null, labels?: Array<{ __typename?: 'Label', id: string, name: string }> | null, organization: { __typename?: 'Organization', id: string }, basicCards?: Array<{ __typename?: 'BasicCard', classType: string, commentsCount: number, confidenceRating?: ConfidenceRatingEnum | null, createdAt: any, ownerId?: string | null, recentActivity?: boolean | null, rfId: string, showDescription?: boolean | null, showGoalHypothesis?: boolean | null, showResults?: boolean | null, status: DomainObjectStatusEnum, updatedAt: any, cardTypeId?: string | null, description?: string | null, dueDate?: any | null, externalUrl?: string | null, externalUrlTitle?: string | null, goalHypothesis?: string | null, name?: string | null, results?: string | null, teamType?: TeamTypeEnum | null, id: string, cardType?: { __typename?: 'CardType', id: string, classType: string, name?: string | null, icon?: string | null, color?: string | null, showInMenu: boolean } | null, labels?: Array<{ __typename?: 'Label', id: string, classType: string, name: string }> | null, owner?: { __typename?: 'User', id: string, classType: string, name: string, email: string } | null }> | null, commentThreads?: Array<{ __typename?: 'CommentThread', id: string, classType: string, commentsCount: number, createdAt: any, creatorId: string, rfId: string, sendToSlack?: boolean | null, updatedAt: any, creator: { __typename?: 'User', id: string, classType: string, name: string, email: string } }> | null, metrics?: Array<{ __typename?: 'Metric', ownerId?: string | null, id: string, calculated?: boolean | null, classType: string, compactDisplay: boolean, maximumDisplayPrecision: number, minimumDisplayPrecision: number, redecimalPercentages?: boolean | null, displayFormat: DisplayFormatEnum, commentsCount: number, createdAt: any, description?: string | null, excludeWeekends: boolean, externalUrl?: string | null, externalUrlTitle?: string | null, favoriteId?: string | null, metricDataPointsCount: number, name?: string | null, periodToDate: boolean, positiveDirection: MetricPositiveDirectionsEnum, recentActivity?: boolean | null, rfId: string, rollUp: RollUpEnum, segmentedDataType: SegmentedDataTypeEnum, showDescription?: boolean | null, showTechnicalDescription?: boolean | null, slackChannelId?: string | null, slug?: string | null, sourceName?: string | null, strategyType?: StrategyTypeEnum | null, technicalDescription?: string | null, updatedAt: any, goals: Array<{ __typename?: 'Goal', id: string, classType: string, currentValue: number, endDate?: any | null, label: string, metricId: string, newestMetricDate?: any | null, oldestMetricDate?: any | null, percentageComplete: number, periodUnit: PeriodUnitEnum, periodNumber?: number | null, periodYear?: number | null, startValue: number, targetValue: number, startDate?: any | null, status: GoalStatusEnum }>, labels?: Array<{ __typename?: 'Label', id: string, classType: string, name: string }> | null, metricSource?: { __typename?: 'MetricSource', id: string, classType: string, errorMessage?: string | null, metricId: string, structuredFormula?: Array<{ __typename?: 'FormulaText', text: string } | { __typename?: 'Metric', id: string, slug?: string | null, name?: string | null }> | null } | null, organization: { __typename?: 'Organization', id: string, classType: string }, owner?: { __typename?: 'User', id: string, classType: string, name: string, email: string } | null, strategyStats: Array<{ __typename?: 'StrategyStat', change?: number | null, classType: string, displayPeriod: string, period: any, total: number }> }> | null, entities?: Array<{ __typename?: 'Entity', foreignId?: string | null, linkUrl?: string | null, recentActivity?: boolean | null, rfId: string, workflowState?: EntityWorkflowStateEnum | null, containeeStats?: any | null, entityAttachmentsCount: number, sourceSummary?: string | null, commentsCount: number, classType: string, displaySummary?: string | null, dueDate?: any | null, entityType?: string | null, foreignState?: string | null, foreignType?: string | null, goalHypothesis?: string | null, happenedAt?: any | null, hasEditedHeadline?: boolean | null, id: string, impact?: ImpactEnum | null, importance?: ImportanceEnum | null, linkTitle?: string | null, name?: string | null, organizationId: string, ownerId?: string | null, results?: string | null, showGoalHypothesis?: boolean | null, showResults?: boolean | null, showSummary?: boolean | null, sourceName?: string | null, sourceUrl?: string | null, summary?: string | null, summaryShort?: string | null, summaryFull?: string | null, entityContributions?: Array<{ __typename?: 'EntityContribution', id: string, classType: string, contributor: { __typename?: 'SourceIdentity', id: string, classType: string, name: string, email?: string | null, sourceName: string } | { __typename?: 'User', id: string, classType: string, name: string, email: string, sourceName: string } }> | null, organization: { __typename?: 'Organization', id: string, classType: string, name: string }, owner?: { __typename?: 'User', id: string, classType: string, name: string, email: string, sourceName: string } | null, labels?: Array<{ __typename?: 'Label', id: string, classType: string, name: string }> | null, classifications?: Array<{ __typename?: 'Classification', id: string, classType: string, category?: string | null, name?: string | null }> | null }> | null, strategies?: Array<{ __typename?: 'Strategy', id: string, name?: string | null, description?: string | null, classType: string, rfId: string, backgroundChangeInProgress: boolean, confidenceRating?: ConfidenceRatingEnum | null, commentsCount: number, empty: boolean, endDate?: any | null, ownerId?: string | null, range?: string | null, sharing: SharingTypesEnum, showCorrelations: boolean, showSegmentCreate: boolean, startDate?: any | null, status: DomainObjectStatusEnum, owner?: { __typename?: 'User', id: string, classType: string, name: string, email: string } | null, labels?: Array<{ __typename?: 'Label', id: string, name: string }> | null }> | null, sections?: Array<{ __typename?: 'Section', id: string, classType: string, createdAt: any, name?: string | null, rfId: string, updatedAt: any }> | null, notes?: Array<{ __typename?: 'Note', id: string, classType: string, createdAt: any, rfId: string, text?: string | null, updatedAt: any }> | null, mapImages?: Array<{ __typename?: 'MapImage', id: string, classType: string, createdAt: any, rfId: string, updatedAt: any, url: string }> | null, recurringReportConfigurations?: Array<{ __typename?: 'RecurringReportConfiguration', id: string, classType: string, aiPrompt?: string | null, aiPromptTestResult?: string | null, createdAt: any, emails: string, name?: string | null, position?: number | null, sendToEmail: boolean, sendToSlack: boolean, service: RecurringReportConfigurationServiceEnum, strategyId: string, slackChannelId?: string | null, schedule?: { __typename?: 'Schedule', id: string, schedulableId: string, schedulableType: string, classType: string, rrule?: string | null, humanized: string } | null, slackChannel?: { __typename?: 'SlackChannel', id: string, classType: string, name: string, channelId: string, isIm?: boolean | null, value: string, label: string } | null }> | null, nodes?: Array<{ __typename?: 'Node', id: string, classType: string, domainObjectId: string, domainObjectType: string, strategyId: string, data: any, nodeId?: string | null, type: string, metadata?: any | null, position: any, parentId?: string | null, width?: number | null, height?: number | null, hidden: boolean, zIndex: number, simBaseline?: number | null, simPercentChange?: number | null, simTarget?: number | null, statsUpdatedAt?: any | null, simImpacts: Array<{ __typename?: 'SimulatorPartialResult', name: string, nodeId: string, nodeRfId: string, deltaR?: number | null, percentR?: number | null }>, simPartials1p: Array<{ __typename?: 'SimulatorPartialResult', name: string, nodeId: string, nodeRfId: string, deltaR?: number | null, percentR?: number | null }>, strategy?: { __typename?: 'Strategy', id: string, filterableId: string } | null, strategyStats: Array<{ __typename?: 'StrategyStat', change?: number | null, classType: string, displayPeriod: string, period: any, total: number }> }> | null, edges?: Array<{ __typename?: 'Edge', id: string, classType: string, color?: string | null, correlationScore?: string | null, correlationScoreUpdatedAt?: any | null, insightsDetailsChatId?: string | null, data: any, edgeId: string, insights?: string | null, insightsDetails?: string | null, rfId: string, source: string, selected?: boolean | null, simImpact?: number | null, sourceId?: string | null, sourceHandle: string, sourceType: string, strategyId: string, target: string, targetId?: string | null, targetHandle: string, targetType: string, type: string, zIndex: number, insightsDetailsChat?: { __typename?: 'Chat', id: string, classType: string, processedState: ChatProcessedStateEnum, errorMessage?: string | null, strategyId?: string | null } | null }> | null, segmentFilters?: Array<{ __typename?: 'SegmentFilter', id: string, segmentName: { __typename?: 'SegmentName', id: string, name: string }, segmentValue: { __typename?: 'SegmentValue', id: string, value: string } }> | null } | null };

export type StrategySlackQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type StrategySlackQuery = { __typename?: 'Query', strategy?: { __typename?: 'Strategy', id: string, slackChannelId?: string | null } | null };

export type StrategyEntityQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  entityId: Scalars['ID']['input'];
  metricId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type StrategyEntityQuery = { __typename?: 'Query', strategy?: { __typename?: 'Strategy', entity?: { __typename?: 'Entity', goalHypothesis?: string | null, linkTitle?: string | null, linkUrl?: string | null, results?: string | null, sourceSummary?: string | null, summary?: string | null, summaryFull?: string | null, workflowState?: EntityWorkflowStateEnum | null, entityAttachmentsCount: number, foreignId?: string | null, foreignType?: string | null, happenedOnWeek?: any | null, sourceName?: string | null, sourceUrl?: string | null, summaryShort?: string | null, commentsCount: number, classType: string, displaySummary?: string | null, dueDate?: any | null, entityType?: string | null, foreignState?: string | null, happenedAt?: any | null, hasEditedHeadline?: boolean | null, id: string, impact?: ImpactEnum | null, importance?: ImportanceEnum | null, name?: string | null, organizationId: string, ownerId?: string | null, rfId: string, showGoalHypothesis?: boolean | null, showResults?: boolean | null, showSummary?: boolean | null, entityAttachments?: Array<{ __typename?: 'Attachment', id: string, entityId: string, url: string, classType: string }> | null, containerEntityContainments?: Array<{ __typename?: 'EntityContainment', id: string, classType: string, containerId: string, containerClassName: string }> | null, labels?: Array<{ __typename?: 'Label', id: string, classType: string, name: string }> | null, thumbnail?: { __typename?: 'Attachment', id: string, classType: string, entityId: string, url: string } | null, owner?: { __typename?: 'User', id: string, classType: string, name: string, email: string, sourceName: string } | null, classifications?: Array<{ __typename?: 'Classification', id: string, classType: string, category?: string | null, name?: string | null }> | null } | null } | null };

export type StrategyStrategyEntitiesQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  workflowState?: InputMaybe<EntityWorkflowStateEnum>;
}>;


export type StrategyStrategyEntitiesQuery = { __typename?: 'Query', strategy?: { __typename?: 'Strategy', strategyEntities?: { __typename?: 'EntityCollection', collection: Array<{ __typename?: 'Entity', id: string, entityAttachmentsCount: number, foreignId?: string | null, foreignType?: string | null, happenedOnWeek?: any | null, sourceName?: string | null, sourceUrl?: string | null, summaryFull?: string | null, summaryShort?: string | null, commentsCount: number, classType: string, displaySummary?: string | null, dueDate?: any | null, entityType?: string | null, foreignState?: string | null, goalHypothesis?: string | null, happenedAt?: any | null, hasEditedHeadline?: boolean | null, impact?: ImpactEnum | null, importance?: ImportanceEnum | null, linkTitle?: string | null, linkUrl?: string | null, name?: string | null, organizationId: string, ownerId?: string | null, results?: string | null, rfId: string, showGoalHypothesis?: boolean | null, showResults?: boolean | null, showSummary?: boolean | null, summary?: string | null, workflowState?: EntityWorkflowStateEnum | null, containerEntityContainments?: Array<{ __typename?: 'EntityContainment', id: string, classType: string, containerId: string, containerClassName: string }> | null, labels?: Array<{ __typename?: 'Label', id: string, classType: string, name: string }> | null, thumbnail?: { __typename?: 'Attachment', id: string, classType: string, entityId: string, url: string } | null, owner?: { __typename?: 'User', id: string, classType: string, name: string, email: string, sourceName: string } | null, classifications?: Array<{ __typename?: 'Classification', id: string, classType: string, category?: string | null, name?: string | null }> | null }>, metadata: { __typename?: 'CollectionMetadata', page: number, totalPages: number, limitValue: number, totalCount: number } } | null } | null };

export type StrategyMetricEntitiesQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  metricId: Scalars['ID']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  workflowState?: InputMaybe<EntityWorkflowStateEnum>;
}>;


export type StrategyMetricEntitiesQuery = { __typename?: 'Query', strategy?: { __typename?: 'Strategy', metricEntities?: { __typename?: 'EntityCollection', collection: Array<{ __typename?: 'Entity', id: string, entityAttachmentsCount: number, foreignId?: string | null, foreignType?: string | null, happenedOnWeek?: any | null, sourceName?: string | null, sourceUrl?: string | null, summaryFull?: string | null, summaryShort?: string | null, commentsCount: number, classType: string, displaySummary?: string | null, dueDate?: any | null, entityType?: string | null, foreignState?: string | null, goalHypothesis?: string | null, happenedAt?: any | null, hasEditedHeadline?: boolean | null, impact?: ImpactEnum | null, importance?: ImportanceEnum | null, linkTitle?: string | null, linkUrl?: string | null, name?: string | null, organizationId: string, ownerId?: string | null, results?: string | null, rfId: string, showGoalHypothesis?: boolean | null, showResults?: boolean | null, showSummary?: boolean | null, summary?: string | null, workflowState?: EntityWorkflowStateEnum | null, containerEntityContainments?: Array<{ __typename?: 'EntityContainment', id: string, classType: string, containerId: string, containerClassName: string }> | null, labels?: Array<{ __typename?: 'Label', id: string, classType: string, name: string }> | null, thumbnail?: { __typename?: 'Attachment', id: string, classType: string, entityId: string, url: string } | null, owner?: { __typename?: 'User', id: string, classType: string, name: string, email: string, sourceName: string } | null, classifications?: Array<{ __typename?: 'Classification', id: string, classType: string, category?: string | null, name?: string | null }> | null }>, metadata: { __typename?: 'CollectionMetadata', page: number, totalPages: number, limitValue: number, totalCount: number } } | null } | null };

export type StrategyEntityEntitiesQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  entityId: Scalars['ID']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  workflowState?: InputMaybe<EntityWorkflowStateEnum>;
}>;


export type StrategyEntityEntitiesQuery = { __typename?: 'Query', strategy?: { __typename?: 'Strategy', entityEntities?: { __typename?: 'EntityCollection', collection: Array<{ __typename?: 'Entity', id: string, entityAttachmentsCount: number, foreignId?: string | null, foreignType?: string | null, happenedOnWeek?: any | null, sourceName?: string | null, sourceUrl?: string | null, summaryFull?: string | null, summaryShort?: string | null, commentsCount: number, classType: string, displaySummary?: string | null, dueDate?: any | null, entityType?: string | null, foreignState?: string | null, goalHypothesis?: string | null, happenedAt?: any | null, hasEditedHeadline?: boolean | null, impact?: ImpactEnum | null, importance?: ImportanceEnum | null, linkTitle?: string | null, linkUrl?: string | null, name?: string | null, organizationId: string, ownerId?: string | null, results?: string | null, rfId: string, showGoalHypothesis?: boolean | null, showResults?: boolean | null, showSummary?: boolean | null, summary?: string | null, workflowState?: EntityWorkflowStateEnum | null, containerEntityContainments?: Array<{ __typename?: 'EntityContainment', id: string, classType: string, containerId: string, containerClassName: string }> | null, labels?: Array<{ __typename?: 'Label', id: string, classType: string, name: string }> | null, thumbnail?: { __typename?: 'Attachment', id: string, classType: string, entityId: string, url: string } | null, owner?: { __typename?: 'User', id: string, classType: string, name: string, email: string, sourceName: string } | null, classifications?: Array<{ __typename?: 'Classification', id: string, classType: string, category?: string | null, name?: string | null }> | null }>, metadata: { __typename?: 'CollectionMetadata', page: number, totalPages: number, limitValue: number, totalCount: number } } | null } | null };

export type StrategyBasicCardEntitiesQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  basicCardId: Scalars['ID']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  workflowState?: InputMaybe<EntityWorkflowStateEnum>;
}>;


export type StrategyBasicCardEntitiesQuery = { __typename?: 'Query', strategy?: { __typename?: 'Strategy', basicCardEntities?: { __typename?: 'EntityCollection', collection: Array<{ __typename?: 'Entity', id: string, entityAttachmentsCount: number, foreignId?: string | null, foreignType?: string | null, happenedOnWeek?: any | null, sourceName?: string | null, sourceUrl?: string | null, summaryFull?: string | null, summaryShort?: string | null, commentsCount: number, classType: string, displaySummary?: string | null, dueDate?: any | null, entityType?: string | null, foreignState?: string | null, goalHypothesis?: string | null, happenedAt?: any | null, hasEditedHeadline?: boolean | null, impact?: ImpactEnum | null, importance?: ImportanceEnum | null, linkTitle?: string | null, linkUrl?: string | null, name?: string | null, organizationId: string, ownerId?: string | null, results?: string | null, rfId: string, showGoalHypothesis?: boolean | null, showResults?: boolean | null, showSummary?: boolean | null, summary?: string | null, workflowState?: EntityWorkflowStateEnum | null, containerEntityContainments?: Array<{ __typename?: 'EntityContainment', id: string, classType: string, containerId: string, containerClassName: string }> | null, labels?: Array<{ __typename?: 'Label', id: string, classType: string, name: string }> | null, thumbnail?: { __typename?: 'Attachment', id: string, classType: string, entityId: string, url: string } | null, owner?: { __typename?: 'User', id: string, classType: string, name: string, email: string, sourceName: string } | null, classifications?: Array<{ __typename?: 'Classification', id: string, classType: string, category?: string | null, name?: string | null }> | null }>, metadata: { __typename?: 'CollectionMetadata', page: number, totalPages: number, limitValue: number, totalCount: number } } | null } | null };

export type StrategyGraphMetricsQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  metricId: Scalars['ID']['input'];
  range?: InputMaybe<Scalars['String']['input']>;
  interval?: InputMaybe<IntervalEnum>;
  startDate?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['String']['input']>;
  cumulative?: InputMaybe<Scalars['CastableBoolean']['input']>;
  forecast?: InputMaybe<Scalars['CastableBoolean']['input']>;
}>;


export type StrategyGraphMetricsQuery = { __typename?: 'Query', strategy?: { __typename?: 'Strategy', metric?: { __typename?: 'Metric', id: string, classType: string, name?: string | null, displayFormat: DisplayFormatEnum, rollUp: RollUpEnum, compactDisplay: boolean, minimumDisplayPrecision: number, maximumDisplayPrecision: number, positiveDirection: MetricPositiveDirectionsEnum, metricDataPoints: Array<{ __typename?: 'MetricDataPoint', date: any, value: number, forecasted: boolean }> } | null } | null };

export type StrategyGraphEntityEventsQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  entityId: Scalars['ID']['input'];
  filters?: InputMaybe<Scalars['JSON']['input']>;
}>;


export type StrategyGraphEntityEventsQuery = { __typename?: 'Query', strategy?: { __typename?: 'Strategy', entityEventsGraph?: any | null } | null };

export type StrategyGraphMetricEventsQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  metricId: Scalars['ID']['input'];
  filters?: InputMaybe<Scalars['JSON']['input']>;
}>;


export type StrategyGraphMetricEventsQuery = { __typename?: 'Query', strategy?: { __typename?: 'Strategy', metricEventsGraph?: any | null } | null };

export type StrategiesQueryVariables = Exact<{
  filter?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<StrategyOrderingInput>;
  page?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  businessContextId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type StrategiesQuery = { __typename?: 'Query', strategies?: { __typename?: 'StrategyCollection', collection: Array<{ __typename?: 'Strategy', id: string, classType: string, createdAt: any, name?: string | null, description?: string | null, connected: boolean, favoriteId?: string | null, sharing: SharingTypesEnum, labels?: Array<{ __typename?: 'Label', id: string, name: string }> | null }>, metadata: { __typename?: 'CollectionMetadata', page: number, totalPages: number, limitValue: number, totalCount: number } } | null };

export type StrategyAiConversationMessagesQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type StrategyAiConversationMessagesQuery = { __typename?: 'Query', strategy?: { __typename?: 'Strategy', aiConversation?: { __typename?: 'AiConversation', id: string, aiConversationMessages: Array<{ __typename?: 'AiConversationMessage', id: string, requestContent: string, responseContent: string, success: boolean }> } | null } | null };

export type StrategyFilterSelectOptionsQueryVariables = Exact<{ [key: string]: never; }>;


export type StrategyFilterSelectOptionsQuery = { __typename?: 'Query', strategies?: { __typename?: 'StrategyCollection', collection: Array<{ __typename?: 'Strategy', id: string, classType: string, name?: string | null }> } | null };

export type StrategyMetricDataPointSegmentNamesQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type StrategyMetricDataPointSegmentNamesQuery = { __typename?: 'Query', strategy?: { __typename?: 'Strategy', id: string, classType: string, metricDataPointSegmentNames?: Array<{ __typename?: 'SegmentName', id: string, name: string }> | null } | null };

export type StrategyMetricDataPointSegmentValuesQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  segmentNameId: Scalars['ID']['input'];
}>;


export type StrategyMetricDataPointSegmentValuesQuery = { __typename?: 'Query', strategy?: { __typename?: 'Strategy', id: string, classType: string, metricDataPointSegmentValues?: Array<{ __typename?: 'SegmentValue', id: string, value: string }> | null } | null };

export type StrategySubMapCardFragment = { __typename?: 'Strategy', id: string, name?: string | null, description?: string | null, classType: string, rfId: string, backgroundChangeInProgress: boolean, confidenceRating?: ConfidenceRatingEnum | null, commentsCount: number, empty: boolean, endDate?: any | null, ownerId?: string | null, range?: string | null, sharing: SharingTypesEnum, showCorrelations: boolean, showSegmentCreate: boolean, startDate?: any | null, status: DomainObjectStatusEnum, owner?: { __typename?: 'User', id: string, classType: string, name: string, email: string } | null, labels?: Array<{ __typename?: 'Label', id: string, name: string }> | null };

export type StrategyExistingObjectAutocompleteQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  query: Scalars['String']['input'];
  type?: InputMaybe<Scalars['String']['input']>;
  labels?: InputMaybe<Scalars['String']['input']>;
  scope?: InputMaybe<Scalars['JSON']['input']>;
}>;


export type StrategyExistingObjectAutocompleteQuery = { __typename?: 'Query', strategy?: { __typename?: 'Strategy', existingObjectAutocomplete?: Array<{ __typename?: 'BasicCard', classType: string, commentsCount: number, confidenceRating?: ConfidenceRatingEnum | null, createdAt: any, ownerId?: string | null, recentActivity?: boolean | null, rfId: string, showDescription?: boolean | null, showGoalHypothesis?: boolean | null, showResults?: boolean | null, status: DomainObjectStatusEnum, updatedAt: any, cardTypeId?: string | null, description?: string | null, dueDate?: any | null, externalUrl?: string | null, externalUrlTitle?: string | null, goalHypothesis?: string | null, name?: string | null, results?: string | null, teamType?: TeamTypeEnum | null, id: string, cardType?: { __typename?: 'CardType', id: string, classType: string, name?: string | null, icon?: string | null, color?: string | null, showInMenu: boolean } | null, labels?: Array<{ __typename?: 'Label', id: string, classType: string, name: string }> | null, owner?: { __typename?: 'User', id: string, classType: string, name: string, email: string } | null } | { __typename?: 'Entity', id: string, foreignId?: string | null, linkUrl?: string | null, recentActivity?: boolean | null, rfId: string, workflowState?: EntityWorkflowStateEnum | null, containeeStats?: any | null, entityAttachmentsCount: number, sourceSummary?: string | null, commentsCount: number, classType: string, displaySummary?: string | null, dueDate?: any | null, entityType?: string | null, foreignState?: string | null, foreignType?: string | null, goalHypothesis?: string | null, happenedAt?: any | null, hasEditedHeadline?: boolean | null, impact?: ImpactEnum | null, importance?: ImportanceEnum | null, linkTitle?: string | null, name?: string | null, organizationId: string, ownerId?: string | null, results?: string | null, showGoalHypothesis?: boolean | null, showResults?: boolean | null, showSummary?: boolean | null, sourceName?: string | null, sourceUrl?: string | null, summary?: string | null, summaryShort?: string | null, summaryFull?: string | null, entityContributions?: Array<{ __typename?: 'EntityContribution', id: string, classType: string, contributor: { __typename?: 'SourceIdentity', id: string, classType: string, name: string, email?: string | null, sourceName: string } | { __typename?: 'User', id: string, classType: string, name: string, email: string, sourceName: string } }> | null, organization: { __typename?: 'Organization', id: string, classType: string, name: string }, owner?: { __typename?: 'User', id: string, classType: string, name: string, email: string, sourceName: string } | null, labels?: Array<{ __typename?: 'Label', id: string, classType: string, name: string }> | null, classifications?: Array<{ __typename?: 'Classification', id: string, classType: string, category?: string | null, name?: string | null }> | null } | { __typename?: 'Metric', id: string, ownerId?: string | null, calculated?: boolean | null, classType: string, compactDisplay: boolean, maximumDisplayPrecision: number, minimumDisplayPrecision: number, redecimalPercentages?: boolean | null, displayFormat: DisplayFormatEnum, commentsCount: number, createdAt: any, description?: string | null, excludeWeekends: boolean, externalUrl?: string | null, externalUrlTitle?: string | null, favoriteId?: string | null, metricDataPointsCount: number, name?: string | null, periodToDate: boolean, positiveDirection: MetricPositiveDirectionsEnum, recentActivity?: boolean | null, rfId: string, rollUp: RollUpEnum, segmentedDataType: SegmentedDataTypeEnum, showDescription?: boolean | null, showTechnicalDescription?: boolean | null, slackChannelId?: string | null, slug?: string | null, sourceName?: string | null, strategyType?: StrategyTypeEnum | null, technicalDescription?: string | null, updatedAt: any, goals: Array<{ __typename?: 'Goal', id: string, classType: string, currentValue: number, endDate?: any | null, label: string, metricId: string, newestMetricDate?: any | null, oldestMetricDate?: any | null, percentageComplete: number, periodUnit: PeriodUnitEnum, periodNumber?: number | null, periodYear?: number | null, startValue: number, targetValue: number, startDate?: any | null, status: GoalStatusEnum }>, labels?: Array<{ __typename?: 'Label', id: string, classType: string, name: string }> | null, metricSource?: { __typename?: 'MetricSource', id: string, classType: string, errorMessage?: string | null, metricId: string, structuredFormula?: Array<{ __typename?: 'FormulaText', text: string } | { __typename?: 'Metric', id: string, slug?: string | null, name?: string | null }> | null } | null, organization: { __typename?: 'Organization', id: string, classType: string }, owner?: { __typename?: 'User', id: string, classType: string, name: string, email: string } | null, strategyStats: Array<{ __typename?: 'StrategyStat', change?: number | null, classType: string, displayPeriod: string, period: any, total: number }> } | { __typename?: 'Strategy', id: string, name?: string | null, description?: string | null, classType: string, rfId: string, backgroundChangeInProgress: boolean, confidenceRating?: ConfidenceRatingEnum | null, commentsCount: number, empty: boolean, endDate?: any | null, ownerId?: string | null, range?: string | null, sharing: SharingTypesEnum, showCorrelations: boolean, showSegmentCreate: boolean, startDate?: any | null, status: DomainObjectStatusEnum, owner?: { __typename?: 'User', id: string, classType: string, name: string, email: string } | null, labels?: Array<{ __typename?: 'Label', id: string, name: string }> | null }> | null } | null };

export type StrategyChangelogQueryVariables = Exact<{
  strategyId: Scalars['ID']['input'];
  page: Scalars['Int']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  containerNodeIds?: InputMaybe<Scalars['CommaSeparatedString']['input']>;
}>;


export type StrategyChangelogQuery = { __typename?: 'Query', strategyChangelog?: { __typename?: 'EntityCollection', collection: Array<{ __typename?: 'Entity', id: string, classType: string, dueDate?: any | null, entityAttachmentsCount: number, entityType?: string | null, goalHypothesis?: string | null, happenedAt?: any | null, happenedOnWeek?: any | null, importance?: ImportanceEnum | null, impact?: ImpactEnum | null, linkTitle?: string | null, linkUrl?: string | null, name?: string | null, organizationId: string, results?: string | null, sourceName?: string | null, summary?: string | null, summaryShort?: string | null, summaryFull?: string | null, classifications?: Array<{ __typename?: 'Classification', id: string, classType: string, category?: string | null, name?: string | null }> | null, containerEntityContainments?: Array<{ __typename?: 'EntityContainment', id: string, classType: string, containerId: string, containerClassName: string }> | null, entityContributions?: Array<{ __typename?: 'EntityContribution', id: string, classType: string, contributor: { __typename?: 'SourceIdentity', id: string, name: string, email?: string | null, sourceName: string } | { __typename?: 'User', id: string, name: string, email: string, sourceName: string } }> | null, thumbnail?: { __typename?: 'Attachment', id: string, classType: string, entityId: string, url: string } | null, labels?: Array<{ __typename?: 'Label', id: string, classType: string, name: string }> | null }>, metadata: { __typename?: 'CollectionMetadata', page: number, totalPages: number, limitValue: number, totalCount: number } } | null };

export type StrategyChangelogEntityQueryVariables = Exact<{
  strategyId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
}>;


export type StrategyChangelogEntityQuery = { __typename?: 'Query', strategyChangelogEntity?: { __typename?: 'Entity', id: string, classType: string, dueDate?: any | null, entityAttachmentsCount: number, entityType?: string | null, goalHypothesis?: string | null, happenedAt?: any | null, happenedOnWeek?: any | null, importance?: ImportanceEnum | null, impact?: ImpactEnum | null, linkTitle?: string | null, linkUrl?: string | null, name?: string | null, organizationId: string, results?: string | null, sourceName?: string | null, summary?: string | null, summaryShort?: string | null, summaryFull?: string | null, classifications?: Array<{ __typename?: 'Classification', id: string, classType: string, category?: string | null, name?: string | null }> | null, containerEntityContainments?: Array<{ __typename?: 'EntityContainment', id: string, classType: string, containerId: string, containerClassName: string }> | null, entityContributions?: Array<{ __typename?: 'EntityContribution', id: string, classType: string, contributor: { __typename?: 'SourceIdentity', id: string, name: string, email?: string | null, sourceName: string } | { __typename?: 'User', id: string, name: string, email: string, sourceName: string } }> | null, thumbnail?: { __typename?: 'Attachment', id: string, classType: string, entityId: string, url: string } | null, labels?: Array<{ __typename?: 'Label', id: string, classType: string, name: string }> | null } | null };

export type StrategyCommentThreadCommentsQueryVariables = Exact<{
  strategyId: Scalars['ID']['input'];
  commentThreadId: Scalars['ID']['input'];
}>;


export type StrategyCommentThreadCommentsQuery = { __typename?: 'Query', strategy?: { __typename?: 'Strategy', commentThreadComments?: Array<{ __typename?: 'Comment', id: string, body: string, classType: string, commentableId: string, commentableType: string, createdAt: any, creatorId?: string | null, creator?: { __typename?: 'User', id: string, classType: string, email: string, name: string } | null }> | null } | null };

export type NodeCreateMutationVariables = Exact<{
  input: NodeCreateInput;
}>;


export type NodeCreateMutation = { __typename?: 'Mutation', nodeCreate?: { __typename?: 'NodeCreatePayload', nodeObject?: { __typename?: 'BasicCard', classType: string, commentsCount: number, confidenceRating?: ConfidenceRatingEnum | null, createdAt: any, ownerId?: string | null, recentActivity?: boolean | null, rfId: string, showDescription?: boolean | null, showGoalHypothesis?: boolean | null, showResults?: boolean | null, status: DomainObjectStatusEnum, updatedAt: any, cardTypeId?: string | null, description?: string | null, dueDate?: any | null, externalUrl?: string | null, externalUrlTitle?: string | null, goalHypothesis?: string | null, name?: string | null, results?: string | null, teamType?: TeamTypeEnum | null, id: string, cardType?: { __typename?: 'CardType', id: string, classType: string, name?: string | null, icon?: string | null, color?: string | null, showInMenu: boolean } | null, labels?: Array<{ __typename?: 'Label', id: string, classType: string, name: string }> | null, owner?: { __typename?: 'User', id: string, classType: string, name: string, email: string } | null } | { __typename?: 'CommentThread', id: string, classType: string, commentsCount: number, createdAt: any, creatorId: string, rfId: string, sendToSlack?: boolean | null, updatedAt: any, creator: { __typename?: 'User', id: string, classType: string, name: string, email: string } } | { __typename?: 'Entity', id: string, foreignId?: string | null, linkUrl?: string | null, recentActivity?: boolean | null, rfId: string, workflowState?: EntityWorkflowStateEnum | null, containeeStats?: any | null, entityAttachmentsCount: number, sourceSummary?: string | null, commentsCount: number, classType: string, displaySummary?: string | null, dueDate?: any | null, entityType?: string | null, foreignState?: string | null, foreignType?: string | null, goalHypothesis?: string | null, happenedAt?: any | null, hasEditedHeadline?: boolean | null, impact?: ImpactEnum | null, importance?: ImportanceEnum | null, linkTitle?: string | null, name?: string | null, organizationId: string, ownerId?: string | null, results?: string | null, showGoalHypothesis?: boolean | null, showResults?: boolean | null, showSummary?: boolean | null, sourceName?: string | null, sourceUrl?: string | null, summary?: string | null, summaryShort?: string | null, summaryFull?: string | null, classifications?: Array<{ __typename?: 'Classification', id: string, classType: string, category?: string | null, name?: string | null }> | null, entityContributions?: Array<{ __typename?: 'EntityContribution', id: string, classType: string, contributor: { __typename?: 'SourceIdentity', id: string, classType: string, name: string, email?: string | null, sourceName: string } | { __typename?: 'User', id: string, classType: string, name: string, email: string, sourceName: string } }> | null, organization: { __typename?: 'Organization', id: string, classType: string, name: string }, owner?: { __typename?: 'User', id: string, classType: string, name: string, email: string, sourceName: string } | null, labels?: Array<{ __typename?: 'Label', id: string, classType: string, name: string }> | null } | { __typename?: 'MapImage', id: string, classType: string, createdAt: any, rfId: string, updatedAt: any, url: string } | { __typename?: 'Metric', id: string, ownerId?: string | null, calculated?: boolean | null, classType: string, compactDisplay: boolean, maximumDisplayPrecision: number, minimumDisplayPrecision: number, redecimalPercentages?: boolean | null, displayFormat: DisplayFormatEnum, commentsCount: number, createdAt: any, description?: string | null, excludeWeekends: boolean, externalUrl?: string | null, externalUrlTitle?: string | null, favoriteId?: string | null, metricDataPointsCount: number, name?: string | null, periodToDate: boolean, positiveDirection: MetricPositiveDirectionsEnum, recentActivity?: boolean | null, rfId: string, rollUp: RollUpEnum, segmentedDataType: SegmentedDataTypeEnum, showDescription?: boolean | null, showTechnicalDescription?: boolean | null, slackChannelId?: string | null, slug?: string | null, sourceName?: string | null, strategyType?: StrategyTypeEnum | null, technicalDescription?: string | null, updatedAt: any, goals: Array<{ __typename?: 'Goal', id: string, classType: string, currentValue: number, endDate?: any | null, label: string, metricId: string, newestMetricDate?: any | null, oldestMetricDate?: any | null, percentageComplete: number, periodUnit: PeriodUnitEnum, periodNumber?: number | null, periodYear?: number | null, startValue: number, targetValue: number, startDate?: any | null, status: GoalStatusEnum }>, labels?: Array<{ __typename?: 'Label', id: string, classType: string, name: string }> | null, metricSource?: { __typename?: 'MetricSource', id: string, classType: string, errorMessage?: string | null, metricId: string, structuredFormula?: Array<{ __typename?: 'FormulaText', text: string } | { __typename?: 'Metric', id: string, slug?: string | null, name?: string | null }> | null } | null, organization: { __typename?: 'Organization', id: string, classType: string }, owner?: { __typename?: 'User', id: string, classType: string, name: string, email: string } | null, strategyStats: Array<{ __typename?: 'StrategyStat', change?: number | null, classType: string, displayPeriod: string, period: any, total: number }> } | { __typename?: 'Note', id: string, classType: string, createdAt: any, rfId: string, text?: string | null, updatedAt: any } | { __typename?: 'Section', id: string, classType: string, createdAt: any, name?: string | null, rfId: string, updatedAt: any } | { __typename?: 'Strategy', id: string, name?: string | null, description?: string | null, classType: string, rfId: string, backgroundChangeInProgress: boolean, confidenceRating?: ConfidenceRatingEnum | null, commentsCount: number, empty: boolean, endDate?: any | null, ownerId?: string | null, range?: string | null, sharing: SharingTypesEnum, showCorrelations: boolean, showSegmentCreate: boolean, startDate?: any | null, status: DomainObjectStatusEnum, owner?: { __typename?: 'User', id: string, classType: string, name: string, email: string } | null, labels?: Array<{ __typename?: 'Label', id: string, name: string }> | null } | null, node?: { __typename?: 'Node', id: string, classType: string, domainObjectId: string, domainObjectType: string, strategyId: string, data: any, nodeId?: string | null, type: string, metadata?: any | null, position: any, parentId?: string | null, width?: number | null, height?: number | null, hidden: boolean, zIndex: number, simBaseline?: number | null, simPercentChange?: number | null, simTarget?: number | null, statsUpdatedAt?: any | null, simImpacts: Array<{ __typename?: 'SimulatorPartialResult', name: string, nodeId: string, nodeRfId: string, deltaR?: number | null, percentR?: number | null }>, simPartials1p: Array<{ __typename?: 'SimulatorPartialResult', name: string, nodeId: string, nodeRfId: string, deltaR?: number | null, percentR?: number | null }>, strategy?: { __typename?: 'Strategy', id: string, filterableId: string } | null, strategyStats: Array<{ __typename?: 'StrategyStat', change?: number | null, classType: string, displayPeriod: string, period: any, total: number }> } | null, errors: Array<{ __typename?: 'Error', message: string, path?: Array<string> | null }> } | null };

export type StrategyUpdateMutationVariables = Exact<{
  input: StrategyUpdateInput;
}>;


export type StrategyUpdateMutation = { __typename?: 'Mutation', strategyUpdate?: { __typename?: 'StrategyUpdatePayload', strategy?: { __typename?: 'Strategy', id: string, name?: string | null, classType: string, connected: boolean, sharing: SharingTypesEnum, showCorrelations: boolean, range?: string | null, startDate?: any | null, endDate?: any | null, indicatorCounter: number, slackChannelId?: string | null, labels?: Array<{ __typename?: 'Label', id: string, name: string }> | null, segmentFilters?: Array<{ __typename?: 'SegmentFilter', id: string, segmentName: { __typename?: 'SegmentName', id: string, name: string }, segmentValue: { __typename?: 'SegmentValue', id: string, value: string } }> | null, slackChannel?: { __typename?: 'SlackChannel', id: string, classType: string, name: string, channelId: string, isIm?: boolean | null } | null } | null, errors: Array<{ __typename?: 'Error', message: string, path?: Array<string> | null }> } | null };

export type StrategyNodeUpdateMutationVariables = Exact<{
  input: StrategyNodeUpdateInput;
}>;


export type StrategyNodeUpdateMutation = { __typename?: 'Mutation', strategyNodeUpdate?: { __typename?: 'StrategyNodeUpdatePayload', strategy?: { __typename?: 'Strategy', id: string, classType: string } | null, nodes?: Array<{ __typename?: 'Node', id: string, classType: string, domainObjectId: string, domainObjectType: string, strategyId: string, data: any, nodeId?: string | null, type: string, metadata?: any | null, position: any, parentId?: string | null, width?: number | null, height?: number | null, hidden: boolean, zIndex: number, simBaseline?: number | null, simPercentChange?: number | null, simTarget?: number | null, statsUpdatedAt?: any | null, simImpacts: Array<{ __typename?: 'SimulatorPartialResult', name: string, nodeId: string, nodeRfId: string, deltaR?: number | null, percentR?: number | null }>, simPartials1p: Array<{ __typename?: 'SimulatorPartialResult', name: string, nodeId: string, nodeRfId: string, deltaR?: number | null, percentR?: number | null }>, strategy?: { __typename?: 'Strategy', id: string, filterableId: string } | null, strategyStats: Array<{ __typename?: 'StrategyStat', change?: number | null, classType: string, displayPeriod: string, period: any, total: number }> }> | null, errors: Array<{ __typename?: 'Error', message: string, path?: Array<string> | null }> } | null };

export type DomainObjectUpdateMutationVariables = Exact<{
  input: DomainObjectUpdateInput;
}>;


export type DomainObjectUpdateMutation = { __typename?: 'Mutation', domainObjectUpdate?: { __typename?: 'DomainObjectUpdatePayload', nodeObjects?: Array<{ __typename?: 'AiAssistantFile' } | { __typename?: 'BasicCard', classType: string, commentsCount: number, confidenceRating?: ConfidenceRatingEnum | null, createdAt: any, ownerId?: string | null, recentActivity?: boolean | null, rfId: string, showDescription?: boolean | null, showGoalHypothesis?: boolean | null, showResults?: boolean | null, status: DomainObjectStatusEnum, updatedAt: any, cardTypeId?: string | null, description?: string | null, dueDate?: any | null, externalUrl?: string | null, externalUrlTitle?: string | null, goalHypothesis?: string | null, name?: string | null, results?: string | null, teamType?: TeamTypeEnum | null, id: string, cardType?: { __typename?: 'CardType', id: string, classType: string, name?: string | null, icon?: string | null, color?: string | null, showInMenu: boolean } | null, labels?: Array<{ __typename?: 'Label', id: string, classType: string, name: string }> | null, owner?: { __typename?: 'User', id: string, classType: string, name: string, email: string } | null } | { __typename?: 'BusinessContext', businessName?: string | null, content?: string | null, organizationId: string, parentBusinessContextId?: string | null, parentBusinessContextSlug?: string | null, createdAt: any, data?: any | null, name?: string | null, updatedAt: any, id: string, classType: string, slug?: string | null, businessContexts?: Array<{ __typename?: 'BusinessContext', businessName?: string | null, name?: string | null, organizationId: string, parentBusinessContextId?: string | null, parentBusinessContextSlug?: string | null, id: string, classType: string, slug?: string | null }> | null, parentBusinessContexts?: Array<{ __typename?: 'BusinessContext', businessName?: string | null, name?: string | null, organizationId: string, parentBusinessContextId?: string | null, parentBusinessContextSlug?: string | null, id: string, classType: string, slug?: string | null }> | null, strategies?: Array<{ __typename?: 'Strategy', id: string, classType: string, name?: string | null, businessContextId?: string | null }> | null, cachedAiAssistantFiles?: Array<{ __typename?: 'AiAssistantFile', id: string, classType: string, name: string, remoteId: string, cacheableId: string, cacheableType: string }> | null } | { __typename?: 'CardType' } | { __typename?: 'Chat' } | { __typename?: 'Comment' } | { __typename?: 'CommentThread', id: string, classType: string, commentsCount: number, createdAt: any, creatorId: string, rfId: string, sendToSlack?: boolean | null, updatedAt: any, creator: { __typename?: 'User', id: string, classType: string, name: string, email: string } } | { __typename?: 'Credential' } | { __typename?: 'Edge' } | { __typename?: 'Entity', id: string, foreignId?: string | null, linkUrl?: string | null, recentActivity?: boolean | null, rfId: string, workflowState?: EntityWorkflowStateEnum | null, containeeStats?: any | null, entityAttachmentsCount: number, sourceSummary?: string | null, commentsCount: number, classType: string, displaySummary?: string | null, dueDate?: any | null, entityType?: string | null, foreignState?: string | null, foreignType?: string | null, goalHypothesis?: string | null, happenedAt?: any | null, hasEditedHeadline?: boolean | null, impact?: ImpactEnum | null, importance?: ImportanceEnum | null, linkTitle?: string | null, name?: string | null, organizationId: string, ownerId?: string | null, results?: string | null, showGoalHypothesis?: boolean | null, showResults?: boolean | null, showSummary?: boolean | null, sourceName?: string | null, sourceUrl?: string | null, summary?: string | null, summaryShort?: string | null, summaryFull?: string | null, classifications?: Array<{ __typename?: 'Classification', id: string, classType: string, category?: string | null, name?: string | null }> | null, entityContributions?: Array<{ __typename?: 'EntityContribution', id: string, classType: string, contributor: { __typename?: 'SourceIdentity', id: string, classType: string, name: string, email?: string | null, sourceName: string } | { __typename?: 'User', id: string, classType: string, name: string, email: string, sourceName: string } }> | null, organization: { __typename?: 'Organization', id: string, classType: string, name: string }, owner?: { __typename?: 'User', id: string, classType: string, name: string, email: string, sourceName: string } | null, labels?: Array<{ __typename?: 'Label', id: string, classType: string, name: string }> | null } | { __typename?: 'Favorite' } | { __typename?: 'Goal' } | { __typename?: 'GoogleIntegration' } | { __typename?: 'Integration' } | { __typename?: 'JiraIntegration' } | { __typename?: 'LookerDashboard' } | { __typename?: 'MapImage', id: string, classType: string, createdAt: any, rfId: string, updatedAt: any, url: string } | { __typename?: 'Message' } | { __typename?: 'Metric', id: string, ownerId?: string | null, calculated?: boolean | null, classType: string, compactDisplay: boolean, maximumDisplayPrecision: number, minimumDisplayPrecision: number, redecimalPercentages?: boolean | null, displayFormat: DisplayFormatEnum, commentsCount: number, createdAt: any, description?: string | null, excludeWeekends: boolean, externalUrl?: string | null, externalUrlTitle?: string | null, favoriteId?: string | null, metricDataPointsCount: number, name?: string | null, periodToDate: boolean, positiveDirection: MetricPositiveDirectionsEnum, recentActivity?: boolean | null, rfId: string, rollUp: RollUpEnum, segmentedDataType: SegmentedDataTypeEnum, showDescription?: boolean | null, showTechnicalDescription?: boolean | null, slackChannelId?: string | null, slug?: string | null, sourceName?: string | null, strategyType?: StrategyTypeEnum | null, technicalDescription?: string | null, updatedAt: any, goals: Array<{ __typename?: 'Goal', id: string, classType: string, currentValue: number, endDate?: any | null, label: string, metricId: string, newestMetricDate?: any | null, oldestMetricDate?: any | null, percentageComplete: number, periodUnit: PeriodUnitEnum, periodNumber?: number | null, periodYear?: number | null, startValue: number, targetValue: number, startDate?: any | null, status: GoalStatusEnum }>, labels?: Array<{ __typename?: 'Label', id: string, classType: string, name: string }> | null, metricSource?: { __typename?: 'MetricSource', id: string, classType: string, errorMessage?: string | null, metricId: string, structuredFormula?: Array<{ __typename?: 'FormulaText', text: string } | { __typename?: 'Metric', id: string, slug?: string | null, name?: string | null }> | null } | null, organization: { __typename?: 'Organization', id: string, classType: string }, owner?: { __typename?: 'User', id: string, classType: string, name: string, email: string } | null, strategyStats: Array<{ __typename?: 'StrategyStat', change?: number | null, classType: string, displayPeriod: string, period: any, total: number }> } | { __typename?: 'MetricSource', id: string, classType: string, configuration?: any | null, credentialId?: string | null, description?: string | null, erroredAt?: any | null, errorMessage?: string | null, lastRunAt?: any | null, metricId: string, name?: string | null, scheduled: boolean, slug?: string | null, sourceName?: string | null, structuredFormula?: Array<{ __typename?: 'FormulaText', text: string } | { __typename?: 'Metric', id: string, slug?: string | null, name?: string | null }> | null } | { __typename?: 'Node' } | { __typename?: 'Note', id: string, classType: string, createdAt: any, rfId: string, text?: string | null, updatedAt: any } | { __typename?: 'RecurringReportConfiguration', id: string, classType: string, aiPrompt?: string | null, aiPromptTestResult?: string | null, createdAt: any, emails: string, name?: string | null, position?: number | null, sendToEmail: boolean, sendToSlack: boolean, service: RecurringReportConfigurationServiceEnum, strategyId: string, slackChannelId?: string | null, schedule?: { __typename?: 'Schedule', id: string, schedulableId: string, schedulableType: string, classType: string, rrule?: string | null, humanized: string } | null, slackChannel?: { __typename?: 'SlackChannel', id: string, classType: string, name: string, channelId: string, isIm?: boolean | null, value: string, label: string } | null } | { __typename?: 'Report' } | { __typename?: 'Schedule', id: string, classType: string, schedulableId: string, schedulableType: string, rrule?: string | null, humanized: string } | { __typename?: 'Section', id: string, classType: string, createdAt: any, name?: string | null, rfId: string, updatedAt: any } | { __typename?: 'Strategy', id: string, slackChannelId?: string | null, name?: string | null, description?: string | null, classType: string, rfId: string, backgroundChangeInProgress: boolean, confidenceRating?: ConfidenceRatingEnum | null, commentsCount: number, empty: boolean, endDate?: any | null, ownerId?: string | null, range?: string | null, sharing: SharingTypesEnum, showCorrelations: boolean, showSegmentCreate: boolean, startDate?: any | null, status: DomainObjectStatusEnum, owner?: { __typename?: 'User', id: string, classType: string, name: string, email: string } | null, labels?: Array<{ __typename?: 'Label', id: string, name: string }> | null } | { __typename?: 'Task' } | { __typename?: 'User' }> | null, errors: Array<{ __typename?: 'Error', message: string, path?: Array<string> | null }> } | null };

export type StrategyDeleteMutationVariables = Exact<{
  input: StrategyDeleteInput;
}>;


export type StrategyDeleteMutation = { __typename?: 'Mutation', strategyDelete?: { __typename?: 'StrategyDeletePayload', strategy?: { __typename?: 'Strategy', id: string, classType: string, name?: string | null, connected: boolean, slackChannelId?: string | null } | null, errors: Array<{ __typename?: 'Error', message: string, path?: Array<string> | null }> } | null };

export type EdgeCreateMutationVariables = Exact<{
  input: EdgeCreateInput;
}>;


export type EdgeCreateMutation = { __typename?: 'Mutation', edgeCreate?: { __typename?: 'EdgeCreatePayload', edge: { __typename?: 'Edge', id: string, classType: string, color?: string | null, correlationScore?: string | null, correlationScoreUpdatedAt?: any | null, insightsDetailsChatId?: string | null, data: any, edgeId: string, insights?: string | null, insightsDetails?: string | null, rfId: string, source: string, selected?: boolean | null, simImpact?: number | null, sourceId?: string | null, sourceHandle: string, sourceType: string, strategyId: string, target: string, targetId?: string | null, targetHandle: string, targetType: string, type: string, zIndex: number, insightsDetailsChat?: { __typename?: 'Chat', id: string, classType: string, processedState: ChatProcessedStateEnum, errorMessage?: string | null, strategyId?: string | null } | null }, errors: Array<{ __typename?: 'Error', message: string, path?: Array<string> | null }> } | null };

export type EdgeDeleteMutationVariables = Exact<{
  input: EdgeDeleteInput;
}>;


export type EdgeDeleteMutation = { __typename?: 'Mutation', edgeDelete?: { __typename?: 'EdgeDeletePayload', edge: { __typename?: 'Edge', id: string, rfId: string, classType: string }, errors: Array<{ __typename?: 'Error', message: string, path?: Array<string> | null }> } | null };

export type StrategyReviewSendMutationVariables = Exact<{
  input: StrategyReviewSendInput;
}>;


export type StrategyReviewSendMutation = { __typename?: 'Mutation', strategyReviewSend?: { __typename?: 'StrategyReviewSendPayload', success: boolean, errors: Array<{ __typename?: 'Error', message: string, path?: Array<string> | null }> } | null };

export type StrategyNodeDeleteMutationVariables = Exact<{
  input: StrategyNodeDeleteInput;
}>;


export type StrategyNodeDeleteMutation = { __typename?: 'Mutation', strategyNodeDelete?: { __typename?: 'StrategyNodeDeletePayload', strategy: { __typename?: 'Strategy', id: string, classType: string }, nodes: Array<{ __typename?: 'Node', id: string, classType: string, strategy?: { __typename?: 'Strategy', id: string, classType: string } | null }>, errors: Array<{ __typename?: 'Error', message: string, path?: Array<string> | null }> } | null };

export type MapCloneMutationVariables = Exact<{
  input: MapCloneInput;
}>;


export type MapCloneMutation = { __typename?: 'Mutation', mapClone?: { __typename?: 'MapClonePayload', strategy: { __typename?: 'Strategy', id: string, indicatorCounter: number, classType: string } } | null };

export type MapCloneToOrganizationMutationVariables = Exact<{
  input: MapCloneToOrganizationInput;
}>;


export type MapCloneToOrganizationMutation = { __typename?: 'Mutation', mapCloneToOrganization?: { __typename?: 'MapCloneToOrganizationPayload', strategyId?: string | null, strategyName?: string | null } | null };

export type MapCreateFromExistingMutationVariables = Exact<{
  input: MapCreateFromExistingInput;
}>;


export type MapCreateFromExistingMutation = { __typename?: 'Mutation', mapCreateFromExisting?: { __typename?: 'MapCreateFromExistingPayload', map: { __typename?: 'Strategy', id: string, indicatorCounter: number, name?: string | null, description?: string | null, classType: string, rfId: string, backgroundChangeInProgress: boolean, confidenceRating?: ConfidenceRatingEnum | null, commentsCount: number, empty: boolean, endDate?: any | null, ownerId?: string | null, range?: string | null, sharing: SharingTypesEnum, showCorrelations: boolean, showSegmentCreate: boolean, startDate?: any | null, status: DomainObjectStatusEnum, owner?: { __typename?: 'User', id: string, classType: string, name: string, email: string } | null, labels?: Array<{ __typename?: 'Label', id: string, name: string }> | null }, node: { __typename?: 'Node', id: string, classType: string, domainObjectId: string, domainObjectType: string, strategyId: string, data: any, nodeId?: string | null, type: string, metadata?: any | null, position: any, parentId?: string | null, width?: number | null, height?: number | null, hidden: boolean, zIndex: number, simBaseline?: number | null, simPercentChange?: number | null, simTarget?: number | null, statsUpdatedAt?: any | null, simImpacts: Array<{ __typename?: 'SimulatorPartialResult', name: string, nodeId: string, nodeRfId: string, deltaR?: number | null, percentR?: number | null }>, simPartials1p: Array<{ __typename?: 'SimulatorPartialResult', name: string, nodeId: string, nodeRfId: string, deltaR?: number | null, percentR?: number | null }>, strategy?: { __typename?: 'Strategy', id: string, filterableId: string } | null, strategyStats: Array<{ __typename?: 'StrategyStat', change?: number | null, classType: string, displayPeriod: string, period: any, total: number }> }, errors: Array<{ __typename?: 'Error', message: string, path?: Array<string> | null }> } | null };

export type NodesDuplicateMutationVariables = Exact<{
  input: NodesDuplicateInput;
}>;


export type NodesDuplicateMutation = { __typename?: 'Mutation', nodesDuplicate?: { __typename?: 'NodesDuplicatePayload', nodes?: Array<{ __typename?: 'Node', id: string, classType: string, domainObjectId: string, domainObjectType: string, strategyId: string, data: any, nodeId?: string | null, type: string, metadata?: any | null, position: any, parentId?: string | null, width?: number | null, height?: number | null, hidden: boolean, zIndex: number, simBaseline?: number | null, simPercentChange?: number | null, simTarget?: number | null, statsUpdatedAt?: any | null, simImpacts: Array<{ __typename?: 'SimulatorPartialResult', name: string, nodeId: string, nodeRfId: string, deltaR?: number | null, percentR?: number | null }>, simPartials1p: Array<{ __typename?: 'SimulatorPartialResult', name: string, nodeId: string, nodeRfId: string, deltaR?: number | null, percentR?: number | null }>, strategy?: { __typename?: 'Strategy', id: string, filterableId: string } | null, strategyStats: Array<{ __typename?: 'StrategyStat', change?: number | null, classType: string, displayPeriod: string, period: any, total: number }> }> | null, edges?: Array<{ __typename?: 'Edge', id: string, classType: string, color?: string | null, correlationScore?: string | null, correlationScoreUpdatedAt?: any | null, insightsDetailsChatId?: string | null, data: any, edgeId: string, insights?: string | null, insightsDetails?: string | null, rfId: string, source: string, selected?: boolean | null, simImpact?: number | null, sourceId?: string | null, sourceHandle: string, sourceType: string, strategyId: string, target: string, targetId?: string | null, targetHandle: string, targetType: string, type: string, zIndex: number, insightsDetailsChat?: { __typename?: 'Chat', id: string, classType: string, processedState: ChatProcessedStateEnum, errorMessage?: string | null, strategyId?: string | null } | null }> | null } | null };

export type StrategyPopulateFromPlaybookTemplateMutationVariables = Exact<{
  input: StrategyPopulateFromPlaybookTemplateInput;
}>;


export type StrategyPopulateFromPlaybookTemplateMutation = { __typename?: 'Mutation', strategyPopulateFromPlaybookTemplate?: { __typename?: 'StrategyPopulateFromPlaybookTemplatePayload', strategy?: { __typename?: 'Strategy', id: string, indicatorCounter: number, classType: string, nodes?: Array<{ __typename?: 'Node', id: string, classType: string, domainObjectId: string, domainObjectType: string, strategyId: string, data: any, nodeId?: string | null, type: string, metadata?: any | null, position: any, parentId?: string | null, width?: number | null, height?: number | null, hidden: boolean, zIndex: number, simBaseline?: number | null, simPercentChange?: number | null, simTarget?: number | null, statsUpdatedAt?: any | null, simImpacts: Array<{ __typename?: 'SimulatorPartialResult', name: string, nodeId: string, nodeRfId: string, deltaR?: number | null, percentR?: number | null }>, simPartials1p: Array<{ __typename?: 'SimulatorPartialResult', name: string, nodeId: string, nodeRfId: string, deltaR?: number | null, percentR?: number | null }>, strategy?: { __typename?: 'Strategy', id: string, filterableId: string } | null, strategyStats: Array<{ __typename?: 'StrategyStat', change?: number | null, classType: string, displayPeriod: string, period: any, total: number }> }> | null, edges?: Array<{ __typename?: 'Edge', id: string, classType: string, color?: string | null, correlationScore?: string | null, correlationScoreUpdatedAt?: any | null, insightsDetailsChatId?: string | null, data: any, edgeId: string, insights?: string | null, insightsDetails?: string | null, rfId: string, source: string, selected?: boolean | null, simImpact?: number | null, sourceId?: string | null, sourceHandle: string, sourceType: string, strategyId: string, target: string, targetId?: string | null, targetHandle: string, targetType: string, type: string, zIndex: number, insightsDetailsChat?: { __typename?: 'Chat', id: string, classType: string, processedState: ChatProcessedStateEnum, errorMessage?: string | null, strategyId?: string | null } | null }> | null, basicCards?: Array<{ __typename?: 'BasicCard', classType: string, commentsCount: number, confidenceRating?: ConfidenceRatingEnum | null, createdAt: any, ownerId?: string | null, recentActivity?: boolean | null, rfId: string, showDescription?: boolean | null, showGoalHypothesis?: boolean | null, showResults?: boolean | null, status: DomainObjectStatusEnum, updatedAt: any, cardTypeId?: string | null, description?: string | null, dueDate?: any | null, externalUrl?: string | null, externalUrlTitle?: string | null, goalHypothesis?: string | null, name?: string | null, results?: string | null, teamType?: TeamTypeEnum | null, id: string, cardType?: { __typename?: 'CardType', id: string, classType: string, name?: string | null, icon?: string | null, color?: string | null, showInMenu: boolean } | null, labels?: Array<{ __typename?: 'Label', id: string, classType: string, name: string }> | null, owner?: { __typename?: 'User', id: string, classType: string, name: string, email: string } | null }> | null, metrics?: Array<{ __typename?: 'Metric', ownerId?: string | null, id: string, calculated?: boolean | null, classType: string, compactDisplay: boolean, maximumDisplayPrecision: number, minimumDisplayPrecision: number, redecimalPercentages?: boolean | null, displayFormat: DisplayFormatEnum, commentsCount: number, createdAt: any, description?: string | null, excludeWeekends: boolean, externalUrl?: string | null, externalUrlTitle?: string | null, favoriteId?: string | null, metricDataPointsCount: number, name?: string | null, periodToDate: boolean, positiveDirection: MetricPositiveDirectionsEnum, recentActivity?: boolean | null, rfId: string, rollUp: RollUpEnum, segmentedDataType: SegmentedDataTypeEnum, showDescription?: boolean | null, showTechnicalDescription?: boolean | null, slackChannelId?: string | null, slug?: string | null, sourceName?: string | null, strategyType?: StrategyTypeEnum | null, technicalDescription?: string | null, updatedAt: any, goals: Array<{ __typename?: 'Goal', id: string, classType: string, currentValue: number, endDate?: any | null, label: string, metricId: string, newestMetricDate?: any | null, oldestMetricDate?: any | null, percentageComplete: number, periodUnit: PeriodUnitEnum, periodNumber?: number | null, periodYear?: number | null, startValue: number, targetValue: number, startDate?: any | null, status: GoalStatusEnum }>, labels?: Array<{ __typename?: 'Label', id: string, classType: string, name: string }> | null, metricSource?: { __typename?: 'MetricSource', id: string, classType: string, errorMessage?: string | null, metricId: string, structuredFormula?: Array<{ __typename?: 'FormulaText', text: string } | { __typename?: 'Metric', id: string, slug?: string | null, name?: string | null }> | null } | null, organization: { __typename?: 'Organization', id: string, classType: string }, owner?: { __typename?: 'User', id: string, classType: string, name: string, email: string } | null, strategyStats: Array<{ __typename?: 'StrategyStat', change?: number | null, classType: string, displayPeriod: string, period: any, total: number }> }> | null, entities?: Array<{ __typename?: 'Entity', foreignId?: string | null, linkUrl?: string | null, recentActivity?: boolean | null, rfId: string, workflowState?: EntityWorkflowStateEnum | null, containeeStats?: any | null, entityAttachmentsCount: number, sourceSummary?: string | null, commentsCount: number, classType: string, displaySummary?: string | null, dueDate?: any | null, entityType?: string | null, foreignState?: string | null, foreignType?: string | null, goalHypothesis?: string | null, happenedAt?: any | null, hasEditedHeadline?: boolean | null, id: string, impact?: ImpactEnum | null, importance?: ImportanceEnum | null, linkTitle?: string | null, name?: string | null, organizationId: string, ownerId?: string | null, results?: string | null, showGoalHypothesis?: boolean | null, showResults?: boolean | null, showSummary?: boolean | null, sourceName?: string | null, sourceUrl?: string | null, summary?: string | null, summaryShort?: string | null, summaryFull?: string | null, entityContributions?: Array<{ __typename?: 'EntityContribution', id: string, classType: string, contributor: { __typename?: 'SourceIdentity', id: string, classType: string, name: string, email?: string | null, sourceName: string } | { __typename?: 'User', id: string, classType: string, name: string, email: string, sourceName: string } }> | null, organization: { __typename?: 'Organization', id: string, classType: string, name: string }, owner?: { __typename?: 'User', id: string, classType: string, name: string, email: string, sourceName: string } | null, labels?: Array<{ __typename?: 'Label', id: string, classType: string, name: string }> | null, classifications?: Array<{ __typename?: 'Classification', id: string, classType: string, category?: string | null, name?: string | null }> | null }> | null, strategies?: Array<{ __typename?: 'Strategy', id: string, name?: string | null, description?: string | null, classType: string, rfId: string, backgroundChangeInProgress: boolean, confidenceRating?: ConfidenceRatingEnum | null, commentsCount: number, empty: boolean, endDate?: any | null, ownerId?: string | null, range?: string | null, sharing: SharingTypesEnum, showCorrelations: boolean, showSegmentCreate: boolean, startDate?: any | null, status: DomainObjectStatusEnum, owner?: { __typename?: 'User', id: string, classType: string, name: string, email: string } | null, labels?: Array<{ __typename?: 'Label', id: string, name: string }> | null }> | null, sections?: Array<{ __typename?: 'Section', id: string, classType: string, createdAt: any, name?: string | null, rfId: string, updatedAt: any }> | null, notes?: Array<{ __typename?: 'Note', id: string, classType: string, createdAt: any, rfId: string, text?: string | null, updatedAt: any }> | null, mapImages?: Array<{ __typename?: 'MapImage', id: string, classType: string, createdAt: any, rfId: string, updatedAt: any, url: string }> | null } | null, errors: Array<{ __typename?: 'Error', message: string, path?: Array<string> | null }> } | null };

export type StrategyMetricMultiRegressionMutationVariables = Exact<{
  input: StrategyMetricMultiRegressionInput;
}>;


export type StrategyMetricMultiRegressionMutation = { __typename?: 'Mutation', strategyMetricMultiRegression?: { __typename?: 'StrategyMetricMultiRegressionPayload', r2?: number | null, partials: any, report?: { __typename?: 'Report', id: string, classType: string, name?: string | null } | null } | null };

export type StrategyRegressionScoresClearMutationVariables = Exact<{
  input: StrategyRegressionScoresClearInput;
}>;


export type StrategyRegressionScoresClearMutation = { __typename?: 'Mutation', strategyRegressionScoresClear?: { __typename?: 'StrategyRegressionScoresClearPayload', success: boolean } | null };

export type StrategyBulkAddExistingCardsMutationVariables = Exact<{
  input: StrategyBulkAddExistingCardsInput;
}>;


export type StrategyBulkAddExistingCardsMutation = { __typename?: 'Mutation', strategyBulkAddExistingCards?: { __typename?: 'StrategyBulkAddExistingCardsPayload', strategy?: { __typename?: 'Strategy', id: string } | null, errors: Array<{ __typename?: 'Error', message: string, path?: Array<string> | null }> } | null };

export type StrategyBulkImportUrlsMutationVariables = Exact<{
  input: StrategyBulkImportUrlsInput;
}>;


export type StrategyBulkImportUrlsMutation = { __typename?: 'Mutation', strategyBulkImportUrls?: { __typename?: 'StrategyBulkImportUrlsPayload', strategy?: { __typename?: 'Strategy', id: string } | null, errors: Array<{ __typename?: 'Error', message: string, path?: Array<string> | null }> } | null };

export type MapSimulateMutationVariables = Exact<{
  input: MapSimulateInput;
}>;


export type MapSimulateMutation = { __typename?: 'Mutation', mapSimulate?: { __typename?: 'MapSimulatePayload', errors: Array<{ __typename?: 'Error', message: string, path?: Array<string> | null }> } | null };

export type StrategySimulationPopulateBaselinesMutationVariables = Exact<{
  input: StrategyPopulateSimulationBaselinesInput;
}>;


export type StrategySimulationPopulateBaselinesMutation = { __typename?: 'Mutation', strategyPopulateSimulationBaselines?: { __typename?: 'StrategyPopulateSimulationBaselinesPayload', error?: string | null, result?: Array<{ __typename?: 'Node', id: string, classType: string, simBaseline?: number | null }> | null } | null };

export type MapRunStatsMutationVariables = Exact<{
  input: MapRunStatsInput;
}>;


export type MapRunStatsMutation = { __typename?: 'Mutation', mapRunStats?: { __typename?: 'MapRunStatsPayload', strategy: { __typename?: 'Strategy', id: string, classType: string, statsUpdatedAt?: any | null } } | null };

export type StrategiesBulkReassignBusinessContextMutationVariables = Exact<{
  input: StrategiesBulkReassignBusinessContextInput;
}>;


export type StrategiesBulkReassignBusinessContextMutation = { __typename?: 'Mutation', strategiesBulkReassignBusinessContext?: { __typename?: 'StrategiesBulkReassignBusinessContextPayload', strategies?: Array<{ __typename?: 'Strategy', id: string, classType: string, name?: string | null, businessContextId?: string | null }> | null, errors: Array<{ __typename?: 'Error', message: string, path?: Array<string> | null }> } | null };

export type MapStructureUpdatedSubscriptionVariables = Exact<{
  strategyId: Scalars['ID']['input'];
}>;


export type MapStructureUpdatedSubscription = { __typename?: 'Subscription', crudOperation: { __typename?: 'MapStructureChangedPayload', operation: CrudOperationEnum, data: Array<{ __typename?: 'Edge', id: string, classType: string, color?: string | null, correlationScore?: string | null, correlationScoreUpdatedAt?: any | null, insightsDetailsChatId?: string | null, data: any, edgeId: string, insights?: string | null, insightsDetails?: string | null, rfId: string, source: string, selected?: boolean | null, simImpact?: number | null, sourceId?: string | null, sourceHandle: string, sourceType: string, strategyId: string, target: string, targetId?: string | null, targetHandle: string, targetType: string, type: string, zIndex: number } | { __typename?: 'Node', id: string, classType: string, domainObjectId: string, domainObjectType: string, strategyId: string, data: any, nodeId?: string | null, type: string, metadata?: any | null, position: any, parentId?: string | null, width?: number | null, height?: number | null, hidden: boolean, zIndex: number, simBaseline?: number | null, simPercentChange?: number | null, simTarget?: number | null, statsUpdatedAt?: any | null, simImpacts: Array<{ __typename?: 'SimulatorPartialResult', name: string, nodeId: string, nodeRfId: string, deltaR?: number | null, percentR?: number | null }>, simPartials1p: Array<{ __typename?: 'SimulatorPartialResult', name: string, nodeId: string, nodeRfId: string, deltaR?: number | null, percentR?: number | null }>, strategy?: { __typename?: 'Strategy', id: string, filterableId: string } | null, strategyStats: Array<{ __typename?: 'StrategyStat', change?: number | null, classType: string, displayPeriod: string, period: any, total: number }> }> } };

export type OrganizationCrudSubscriptionVariables = Exact<{
  organizationId: Scalars['ID']['input'];
}>;


export type OrganizationCrudSubscription = { __typename?: 'Subscription', crudOperation: { __typename?: 'OrganizationCrudPayload', operation: CrudOperationEnum, data: Array<{ __typename?: 'AiAssistantFile', id: string, classType: string, name: string, remoteId: string, cacheableId: string, cacheableType: string } | { __typename?: 'BasicCard', classType: string, commentsCount: number, confidenceRating?: ConfidenceRatingEnum | null, createdAt: any, ownerId?: string | null, recentActivity?: boolean | null, rfId: string, showDescription?: boolean | null, showGoalHypothesis?: boolean | null, showResults?: boolean | null, status: DomainObjectStatusEnum, updatedAt: any, cardTypeId?: string | null, description?: string | null, dueDate?: any | null, externalUrl?: string | null, externalUrlTitle?: string | null, goalHypothesis?: string | null, name?: string | null, results?: string | null, teamType?: TeamTypeEnum | null, id: string } | { __typename?: 'BusinessContext', businessName?: string | null, content?: string | null, organizationId: string, parentBusinessContextId?: string | null, parentBusinessContextSlug?: string | null, createdAt: any, data?: any | null, name?: string | null, updatedAt: any, id: string, classType: string, slug?: string | null } | { __typename?: 'CardType', id: string, classType: string, name?: string | null, icon?: string | null, color?: string | null, showInMenu: boolean } | { __typename?: 'Chat', id: string, classType: string, currentAssistantId?: string | null, errorIsRetryable: boolean, errorMessage?: string | null, organizationId: string, pipelineSlug: string, processedState: ChatProcessedStateEnum, realTimeStatus?: string | null, strategyId?: string | null } | { __typename?: 'Comment', id: string, body: string, classType: string, commentableId: string, commentableType: string, createdAt: any, creatorId?: string | null } | { __typename?: 'CommentThread', id: string, classType: string, commentsCount: number, createdAt: any, creatorId: string, rfId: string, sendToSlack?: boolean | null, updatedAt: any } | { __typename?: 'Credential' } | { __typename?: 'Edge' } | { __typename?: 'Entity', commentsCount: number, classType: string, displaySummary?: string | null, dueDate?: any | null, entityType?: string | null, foreignState?: string | null, foreignType?: string | null, goalHypothesis?: string | null, happenedAt?: any | null, hasEditedHeadline?: boolean | null, id: string, impact?: ImpactEnum | null, importance?: ImportanceEnum | null, linkTitle?: string | null, linkUrl?: string | null, name?: string | null, organizationId: string, ownerId?: string | null, results?: string | null, rfId: string, showGoalHypothesis?: boolean | null, showResults?: boolean | null, showSummary?: boolean | null, sourceName?: string | null, sourceUrl?: string | null, summary?: string | null, summaryShort?: string | null, summaryFull?: string | null, workflowState?: EntityWorkflowStateEnum | null } | { __typename?: 'Favorite' } | { __typename?: 'Goal', id: string, classType: string, currentValue: number, endDate?: any | null, label: string, metricId: string, newestMetricDate?: any | null, oldestMetricDate?: any | null, percentageComplete: number, periodUnit: PeriodUnitEnum, periodNumber?: number | null, periodYear?: number | null, startValue: number, targetValue: number, startDate?: any | null, status: GoalStatusEnum } | { __typename?: 'GoogleIntegration', id: string, classType: string, activitiesCount: number, configuration?: any | null, createdAt: any, entitiesCount: number, importedHistory: boolean, sourceId?: string | null, sourceName: IntegrationSourceNamesEnum, type?: string | null } | { __typename?: 'Integration', id: string, classType: string, activitiesCount: number, configuration?: any | null, createdAt: any, entitiesCount: number, importedHistory: boolean, sourceId?: string | null, sourceName: IntegrationSourceNamesEnum, type?: string | null } | { __typename?: 'JiraIntegration', id: string, classType: string, activitiesCount: number, configuration?: any | null, createdAt: any, entitiesCount: number, importedHistory: boolean, sourceId?: string | null, sourceName: IntegrationSourceNamesEnum, type?: string | null } | { __typename?: 'LookerDashboard', id: string, classType: string, dashboardId: string, dashboardUrl: string, lastError?: string | null, lastRunAt?: any | null, title?: string | null } | { __typename?: 'MapImage', id: string, classType: string, createdAt: any, rfId: string, updatedAt: any, url: string } | { __typename?: 'Message', id: string, chatId: string, classType: string, content: string, createdAt: any, role: AiAssistantRoleEnum, updatedAt: any, userId?: string | null, assistantId?: string | null, assistant?: { __typename?: 'AiAssistant', id: string, name: string } | null, user?: { __typename?: 'User', id: string, name: string, email: string } | null } | { __typename?: 'Metric', id: string, calculated?: boolean | null, classType: string, compactDisplay: boolean, maximumDisplayPrecision: number, minimumDisplayPrecision: number, redecimalPercentages?: boolean | null, displayFormat: DisplayFormatEnum, commentsCount: number, createdAt: any, description?: string | null, excludeWeekends: boolean, externalUrl?: string | null, externalUrlTitle?: string | null, favoriteId?: string | null, metricDataPointsCount: number, name?: string | null, ownerId?: string | null, periodToDate: boolean, positiveDirection: MetricPositiveDirectionsEnum, recentActivity?: boolean | null, rfId: string, rollUp: RollUpEnum, segmentedDataType: SegmentedDataTypeEnum, showDescription?: boolean | null, showTechnicalDescription?: boolean | null, slackChannelId?: string | null, slug?: string | null, sourceName?: string | null, strategyType?: StrategyTypeEnum | null, technicalDescription?: string | null, updatedAt: any } | { __typename?: 'MetricSource', id: string, classType: string, configuration?: any | null, credentialId?: string | null, description?: string | null, erroredAt?: any | null, errorMessage?: string | null, lastRunAt?: any | null, metricId: string, name?: string | null, scheduled: boolean, slug?: string | null, sourceName?: string | null, structuredFormula?: Array<{ __typename?: 'FormulaText', text: string } | { __typename?: 'Metric', id: string, slug?: string | null, name?: string | null }> | null } | { __typename?: 'Node' } | { __typename?: 'Note', id: string, classType: string, createdAt: any, rfId: string, text?: string | null, updatedAt: any } | { __typename?: 'RecurringReportConfiguration', id: string, classType: string, aiPrompt?: string | null, aiPromptTestResult?: string | null, createdAt: any, emails: string, name?: string | null, position?: number | null, sendToEmail: boolean, sendToSlack: boolean, service: RecurringReportConfigurationServiceEnum, strategyId: string, slackChannelId?: string | null, slackChannel?: { __typename?: 'SlackChannel', id: string, classType: string, name: string, channelId: string, isIm?: boolean | null, value: string, label: string } | null } | { __typename?: 'Report', id: string, classType: string, createdAt: any, rfId: string, emails: string, endDate?: any | null, name?: string | null, recurringReportConfigurationId?: string | null, sendToEmail: boolean, sendToSlack: boolean, slackChannelId?: string | null, startDate?: any | null, strategyId: string, summary?: string | null, updatedAt: any } | { __typename?: 'Schedule', id: string, classType: string, schedulableId: string, schedulableType: string, rrule?: string | null, humanized: string } | { __typename?: 'Section', id: string, classType: string, createdAt: any, name?: string | null, rfId: string, updatedAt: any } | { __typename?: 'Strategy', id: string, rfId: string, classType: string, aiContext?: string | null, backgroundChangeInProgress: boolean, businessContextId?: string | null, confidenceRating?: ConfidenceRatingEnum | null, connected: boolean, createdAt: any, description?: string | null, empty: boolean, indicatorCounter: number, name?: string | null, ownerId?: string | null, recurringReportConfigurationsCount: number, sharing: SharingTypesEnum, showCorrelations: boolean, statsUpdatedAt?: any | null, status: DomainObjectStatusEnum, updatedAt: any } | { __typename?: 'Task', createdAt?: any | null, description?: string | null, domainObjectId: string, domainObjectType: string, jobId?: string | null, progress?: number | null, status: TaskStatusesEnum, summary?: string | null, taskType: TaskTypesEnum, updatedAt?: any | null, id: string, classType: string } | { __typename?: 'User', id: string, classType: string, name: string, email: string, role?: RoleEnum | null }> } };

export type MapEventsSubscriptionVariables = Exact<{
  strategyId: Scalars['ID']['input'];
}>;


export type MapEventsSubscription = { __typename?: 'Subscription', mapEvents: { __typename?: 'MapEventsPayload', event: MapEventsEnum, data: any } };

export type TaskRequiredFieldsFragment = { __typename?: 'Task', id: string, classType: string };

export type TaskSubscriptionFieldsFragment = { __typename?: 'Task', createdAt?: any | null, description?: string | null, domainObjectId: string, domainObjectType: string, jobId?: string | null, progress?: number | null, status: TaskStatusesEnum, summary?: string | null, taskType: TaskTypesEnum, updatedAt?: any | null, id: string, classType: string };

export type TasksQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  domainObjectId?: InputMaybe<Scalars['ID']['input']>;
  domainObjectType?: InputMaybe<Scalars['String']['input']>;
}>;


export type TasksQuery = { __typename?: 'Query', tasks?: { __typename?: 'TaskCollection', collection: Array<{ __typename?: 'Task', createdAt?: any | null, description?: string | null, domainObjectId: string, domainObjectType: string, jobId?: string | null, progress?: number | null, status: TaskStatusesEnum, summary?: string | null, taskType: TaskTypesEnum, updatedAt?: any | null, id: string, classType: string }>, metadata: { __typename?: 'CollectionMetadata', page: number, totalPages: number, limitValue: number, totalCount: number } } | null };

export type UserSubscriptionFieldsFragment = { __typename?: 'User', id: string, classType: string, name: string, email: string, role?: RoleEnum | null };

export type UserRequiredFieldsFragment = { __typename?: 'User', id: string, classType: string, name: string, email: string };

export type UserFieldsFragment = { __typename?: 'User', timeZone: string, role?: RoleEnum | null, createdAt?: any | null, updatedAt?: any | null, confirmedAt?: any | null, superAdmin: boolean, optedInToAnalytics?: boolean | null, jobTitle?: string | null, id: string, classType: string, name: string, email: string };

export type CurrentUserQueryVariables = Exact<{ [key: string]: never; }>;


export type CurrentUserQuery = { __typename?: 'Query', identityId?: string | null, me?: { __typename?: 'User', abilities?: any | null, accountsCount: number, timeZone: string, role?: RoleEnum | null, createdAt?: any | null, updatedAt?: any | null, confirmedAt?: any | null, superAdmin: boolean, optedInToAnalytics?: boolean | null, jobTitle?: string | null, id: string, classType: string, name: string, email: string, organization?: { __typename?: 'Organization', id: string, classType: string, apiToken?: string | null, autoImportGoogleSheet: boolean, defaultImportTime: string, homepageUrl?: string | null, logo?: string | null, metricDefaults?: any | null, name: string, slackable: boolean } | null } | null };

export type UserAccountsQueryVariables = Exact<{ [key: string]: never; }>;


export type UserAccountsQuery = { __typename?: 'Query', userAccounts?: Array<{ __typename?: 'Account', id: string, classType: string, disabledAt?: any | null, organizationId: string, organizationLogoUrl?: string | null, organizationName: string, role: RoleEnum, userId: string }> | null };

export type UserCreateMutationVariables = Exact<{
  input: UserCreateInput;
}>;


export type UserCreateMutation = { __typename?: 'Mutation', userCreate?: { __typename?: 'UserCreatePayload', user?: { __typename?: 'User', timeZone: string, role?: RoleEnum | null, createdAt?: any | null, updatedAt?: any | null, confirmedAt?: any | null, superAdmin: boolean, optedInToAnalytics?: boolean | null, jobTitle?: string | null, id: string, classType: string, name: string, email: string } | null, errors: Array<{ __typename?: 'Error', message: string, path?: Array<string> | null }> } | null };

export type UserUpdateMutationVariables = Exact<{
  input: UserUpdateInput;
}>;


export type UserUpdateMutation = { __typename?: 'Mutation', userUpdate?: { __typename?: 'UserUpdatePayload', user?: { __typename?: 'User', timeZone: string, role?: RoleEnum | null, createdAt?: any | null, updatedAt?: any | null, confirmedAt?: any | null, superAdmin: boolean, optedInToAnalytics?: boolean | null, jobTitle?: string | null, id: string, classType: string, name: string, email: string } | null, errors: Array<{ __typename?: 'Error', message: string, path?: Array<string> | null }> } | null };

export type UserAuthenticateMutationVariables = Exact<{
  input: UserAuthenticateInput;
}>;


export type UserAuthenticateMutation = { __typename?: 'Mutation', userAuthenticate?: { __typename?: 'UserAuthenticatePayload', redirect?: string | null, errors: Array<{ __typename?: 'Error', message: string, path?: Array<string> | null }> } | null };

export type UserResetPasswordRequestMutationVariables = Exact<{
  input: UserResetPasswordRequestInput;
}>;


export type UserResetPasswordRequestMutation = { __typename?: 'Mutation', userResetPasswordRequest?: { __typename?: 'UserResetPasswordRequestPayload', success: boolean } | null };

export type UserResetPasswordMutationVariables = Exact<{
  input: UserResetPasswordInput;
}>;


export type UserResetPasswordMutation = { __typename?: 'Mutation', userResetPassword?: { __typename?: 'UserResetPasswordPayload', success?: boolean | null, errors: Array<{ __typename?: 'Error', message: string, path?: Array<string> | null }> } | null };

export type CaptureEmailMutationVariables = Exact<{
  input: UserEmailCaptureInput;
}>;


export type CaptureEmailMutation = { __typename?: 'Mutation', userEmailCapture?: { __typename?: 'UserEmailCapturePayload', success: boolean, errors: Array<{ __typename?: 'Error', message: string }> } | null };

export type ConfirmEmailMutationVariables = Exact<{
  input: UserConfirmEmailInput;
}>;


export type ConfirmEmailMutation = { __typename?: 'Mutation', userConfirmEmail?: { __typename?: 'UserConfirmEmailPayload', success: boolean } | null };

export const AccountSubscriptionFieldsFragmentDoc = gql`
    fragment AccountSubscriptionFields on Account {
  id
  classType
  organizationName
  organizationLogoUrl
  name
  role
  disabledAt
}
    `;
export const AccountRequiredFieldsFragmentDoc = gql`
    fragment AccountRequiredFields on Account {
  id
  classType
  name
  organizationId
  organizationLogoUrl
  organizationName
  role
  userId
  disabledAt
}
    `;
export const ChatSubscriptionFieldsFragmentDoc = gql`
    fragment ChatSubscriptionFields on Chat {
  id
  classType
  currentAssistantId
  errorIsRetryable
  errorMessage
  organizationId
  pipelineSlug
  processedState
  realTimeStatus
  strategyId
}
    `;
export const ChatFieldsFragmentDoc = gql`
    fragment ChatFields on Chat {
  ...ChatSubscriptionFields
  chattables {
    chattableId
    chattableType
  }
}
    ${ChatSubscriptionFieldsFragmentDoc}`;
export const MessageSubscriptionFieldsFragmentDoc = gql`
    fragment MessageSubscriptionFields on Message {
  id
  chatId
  classType
  content
  createdAt
  role
  updatedAt
  userId
  assistantId
  assistant {
    id
    name
  }
  user {
    id
    name
    email
  }
}
    `;
export const BasicCardRequiredFieldsFragmentDoc = gql`
    fragment BasicCardRequiredFields on BasicCard {
  id
  classType
}
    `;
export const BasicCardIndexFieldsFragmentDoc = gql`
    fragment BasicCardIndexFields on BasicCard {
  ...BasicCardRequiredFields
  cardTypeId
  createdAt
  description
  dueDate
  externalUrl
  externalUrlTitle
  goalHypothesis
  name
  results
  teamType
}
    ${BasicCardRequiredFieldsFragmentDoc}`;
export const BasicCardSubscriptionFieldsFragmentDoc = gql`
    fragment BasicCardSubscriptionFields on BasicCard {
  ...BasicCardIndexFields
  classType
  commentsCount
  confidenceRating
  createdAt
  ownerId
  recentActivity
  rfId
  showDescription
  showGoalHypothesis
  showResults
  status
  updatedAt
}
    ${BasicCardIndexFieldsFragmentDoc}`;
export const BasicCardPrivateFieldsFragmentDoc = gql`
    fragment BasicCardPrivateFields on BasicCard {
  ownerId
  owner {
    id
    classType
    name
    email
  }
}
    `;
export const CommonCardTypeFieldsFragmentDoc = gql`
    fragment CommonCardTypeFields on CardType {
  id
  classType
  name
  icon
  color
  showInMenu
}
    `;
export const LabelRequiredFieldsFragmentDoc = gql`
    fragment LabelRequiredFields on Label {
  id
  classType
  name
}
    `;
export const BasicCardFieldsFragmentDoc = gql`
    fragment BasicCardFields on BasicCard {
  ...BasicCardSubscriptionFields
  ...BasicCardPrivateFields
  cardType {
    ...CommonCardTypeFields
  }
  labels {
    ...LabelRequiredFields
  }
}
    ${BasicCardSubscriptionFieldsFragmentDoc}
${BasicCardPrivateFieldsFragmentDoc}
${CommonCardTypeFieldsFragmentDoc}
${LabelRequiredFieldsFragmentDoc}`;
export const BusinessContextRequiredFieldsFragmentDoc = gql`
    fragment BusinessContextRequiredFields on BusinessContext {
  id
  classType
  slug
}
    `;
export const BusinessContextSubscriptionFieldsFragmentDoc = gql`
    fragment BusinessContextSubscriptionFields on BusinessContext {
  ...BusinessContextRequiredFields
  businessName
  content
  organizationId
  parentBusinessContextId
  parentBusinessContextSlug
  createdAt
  data
  name
  updatedAt
}
    ${BusinessContextRequiredFieldsFragmentDoc}`;
export const AiAssistantFilesSubscriptionFieldsFragmentDoc = gql`
    fragment AiAssistantFilesSubscriptionFields on AiAssistantFile {
  id
  classType
  name
  remoteId
  cacheableId
  cacheableType
}
    `;
export const BusinessContextFieldsFragmentDoc = gql`
    fragment BusinessContextFields on BusinessContext {
  ...BusinessContextSubscriptionFields
  businessContexts {
    ...BusinessContextRequiredFields
    businessName
    name
    organizationId
    parentBusinessContextId
    parentBusinessContextSlug
  }
  parentBusinessContexts {
    ...BusinessContextRequiredFields
    businessName
    name
    organizationId
    parentBusinessContextId
    parentBusinessContextSlug
  }
  strategies {
    id
    classType
    name
    businessContextId
  }
  cachedAiAssistantFiles {
    ...AiAssistantFilesSubscriptionFields
  }
}
    ${BusinessContextSubscriptionFieldsFragmentDoc}
${BusinessContextRequiredFieldsFragmentDoc}
${AiAssistantFilesSubscriptionFieldsFragmentDoc}`;
export const CardTypeSubscriptionFieldsFragmentDoc = gql`
    fragment CardTypeSubscriptionFields on CardType {
  id
  classType
  name
  icon
  color
  showInMenu
}
    `;
export const ChangelogEntityFieldsFragmentDoc = gql`
    fragment ChangelogEntityFields on Entity {
  id
  classifications {
    id
    classType
    category
    name
  }
  classType
  containerEntityContainments {
    id
    classType
    containerId
    containerClassName
  }
  dueDate
  entityAttachmentsCount
  entityContributions {
    id
    contributor {
      ... on User {
        id
        name
        email
        sourceName
      }
      ... on SourceIdentity {
        id
        name
        email
        sourceName
      }
    }
    classType
  }
  entityType
  goalHypothesis
  happenedAt
  happenedOnWeek
  importance
  impact
  linkTitle
  linkUrl
  name
  organizationId
  results
  sourceName
  summary
  summaryShort
  summaryFull
  thumbnail {
    id
    classType
    entityId
    url
  }
  labels {
    ...LabelRequiredFields
  }
}
    ${LabelRequiredFieldsFragmentDoc}`;
export const CommentSubscriptionFieldsFragmentDoc = gql`
    fragment CommentSubscriptionFields on Comment {
  id
  body
  classType
  commentableId
  commentableType
  createdAt
  creatorId
}
    `;
export const CommentFieldsFragmentDoc = gql`
    fragment CommentFields on Comment {
  ...CommentSubscriptionFields
  creator {
    id
    classType
    email
    name
  }
}
    ${CommentSubscriptionFieldsFragmentDoc}`;
export const CommentThreadSubscriptionFieldsFragmentDoc = gql`
    fragment CommentThreadSubscriptionFields on CommentThread {
  id
  classType
  commentsCount
  createdAt
  creatorId
  rfId
  sendToSlack
  updatedAt
}
    `;
export const CommentThreadFieldsFragmentDoc = gql`
    fragment CommentThreadFields on CommentThread {
  ...CommentThreadSubscriptionFields
  creator {
    id
    classType
    name
    email
  }
}
    ${CommentThreadSubscriptionFieldsFragmentDoc}`;
export const CredentialFieldsFragmentDoc = gql`
    fragment CredentialFields on Credential {
  id
  classType
  displayName
  createdAt
  sourceName
  updatedAt
  apiKey
  clientId
  database
  file {
    id
    metadata {
      filename
    }
  }
  fileData
  host
  label
  port
  projectId
  region
  role
  schema
  username
  warehouse
  workspaceId
}
    `;
export const EntitySubscriptionFieldsFragmentDoc = gql`
    fragment EntitySubscriptionFields on Entity {
  commentsCount
  classType
  displaySummary
  dueDate
  entityType
  foreignState
  foreignType
  goalHypothesis
  happenedAt
  hasEditedHeadline
  id
  impact
  importance
  linkTitle
  linkUrl
  name
  organizationId
  ownerId
  results
  rfId
  showGoalHypothesis
  showResults
  showSummary
  sourceName
  sourceUrl
  summary
  summaryShort
  summaryFull
  workflowState
}
    `;
export const EntityFieldsFragmentDoc = gql`
    fragment EntityFields on Entity {
  ...EntitySubscriptionFields
  classifications {
    id
    classType
    category
    name
  }
}
    ${EntitySubscriptionFieldsFragmentDoc}`;
export const EntityStrategyCardFragmentDoc = gql`
    fragment EntityStrategyCard on Entity {
  ...EntityFields
  foreignId
  linkUrl
  recentActivity
  rfId
  workflowState
  containeeStats
  entityAttachmentsCount
  sourceSummary
  entityContributions {
    id
    contributor {
      ... on User {
        id
        classType
        name
        email
        sourceName
      }
      ... on SourceIdentity {
        id
        classType
        name
        email
        sourceName
      }
    }
    classType
  }
  organization {
    id
    classType
    name
  }
  owner {
    id
    classType
    name
    email
    sourceName
  }
  labels {
    ...LabelRequiredFields
  }
}
    ${EntityFieldsFragmentDoc}
${LabelRequiredFieldsFragmentDoc}`;
export const EntitiesFormAttributesFragmentDoc = gql`
    fragment EntitiesFormAttributes on Entity {
  ...EntityFields
  createdAt
  goalHypothesis
  linkTitle
  linkUrl
  results
  summary
  sourceSummary
  updatedAt
  entityAttachments {
    id
    classType
    entityId
    url
  }
}
    ${EntityFieldsFragmentDoc}`;
export const EntityPrivateFieldsFragmentDoc = gql`
    fragment EntityPrivateFields on Entity {
  entityContributions {
    id
    contributor {
      ... on User {
        id
        classType
        name
        email
        sourceName
      }
      ... on SourceIdentity {
        id
        classType
        name
        email
        sourceName
      }
    }
  }
}
    `;
export const EntityBasicsFragmentDoc = gql`
    fragment EntityBasics on Entity {
  ...EntityFields
  containerEntityContainments {
    id
    classType
    containerId
    containerClassName
  }
  entityAttachmentsCount
  foreignId
  foreignType
  happenedOnWeek
  labels {
    ...LabelRequiredFields
  }
  sourceName
  sourceUrl
  summaryFull
  summaryShort
  thumbnail {
    id
    classType
    entityId
    url
  }
  owner {
    id
    classType
    name
    email
    sourceName
  }
}
    ${EntityFieldsFragmentDoc}
${LabelRequiredFieldsFragmentDoc}`;
export const EntityDetailsFragmentDoc = gql`
    fragment EntityDetails on Entity {
  ...EntityBasics
  goalHypothesis
  linkTitle
  linkUrl
  results
  sourceSummary
  summary
  summaryFull
  workflowState
  entityAttachments {
    id
    entityId
    url
    classType
  }
}
    ${EntityBasicsFragmentDoc}`;
export const CommonFavoriteFieldsFragmentDoc = gql`
    fragment CommonFavoriteFields on Favorite {
  id
  classType
  favoritableId
  favoritableType
  favoritable {
    id
    classType
    name
    favoriteId
  }
}
    `;
export const GoogleSheetFieldsFragmentDoc = gql`
    fragment GoogleSheetFields on GoogleSheet {
  id
  classType
  organizationLevel
  spreadsheetUrl
  status
}
    `;
export const GraphImpactfulEventsFieldsFragmentDoc = gql`
    fragment GraphImpactfulEventsFields on Entity {
  id
  classType
  happenedAt
  impact
  name
}
    `;
export const GraphMetricsFieldsFragmentDoc = gql`
    fragment GraphMetricsFields on Metric {
  id
  classType
  name
  displayFormat
  rollUp
  compactDisplay
  minimumDisplayPrecision
  maximumDisplayPrecision
  positiveDirection
}
    `;
export const IntegrationSubscriptionFieldsFragmentDoc = gql`
    fragment IntegrationSubscriptionFields on IntegrationInterface {
  id
  classType
  activitiesCount
  configuration
  createdAt
  entitiesCount
  importedHistory
  sourceId
  sourceName
  type
}
    `;
export const InvitationFieldsFragmentDoc = gql`
    fragment InvitationFields on Invitation {
  id
  classType
  email
  inviteCode
  lastSentAt
  role
}
    `;
export const LookerDashboardSubscriptionFieldsFragmentDoc = gql`
    fragment LookerDashboardSubscriptionFields on LookerDashboard {
  id
  classType
  dashboardId
  dashboardUrl
  lastError
  lastRunAt
  title
}
    `;
export const MetricSourceSubscriptionFieldsFragmentDoc = gql`
    fragment MetricSourceSubscriptionFields on MetricSource {
  id
  classType
  configuration
  credentialId
  description
  erroredAt
  errorMessage
  lastRunAt
  metricId
  name
  scheduled
  slug
  sourceName
  structuredFormula {
    ... on FormulaText {
      text
    }
    ... on Metric {
      id
      slug
      name
    }
  }
}
    `;
export const MetricSourceFieldsFragmentDoc = gql`
    fragment MetricSourceFields on MetricSource {
  ...MetricSourceSubscriptionFields
}
    ${MetricSourceSubscriptionFieldsFragmentDoc}`;
export const MetricDisplayFormatFieldsFragmentDoc = gql`
    fragment MetricDisplayFormatFields on Metric {
  compactDisplay
  displayFormat
  maximumDisplayPrecision
  minimumDisplayPrecision
  redecimalPercentages
}
    `;
export const MetricSubscriptionFieldsFragmentDoc = gql`
    fragment MetricSubscriptionFields on Metric {
  id
  calculated
  classType
  compactDisplay
  maximumDisplayPrecision
  minimumDisplayPrecision
  redecimalPercentages
  displayFormat
  commentsCount
  createdAt
  description
  excludeWeekends
  externalUrl
  externalUrlTitle
  favoriteId
  metricDataPointsCount
  name
  ownerId
  periodToDate
  positiveDirection
  recentActivity
  rfId
  rollUp
  segmentedDataType
  showDescription
  showTechnicalDescription
  slackChannelId
  slug
  sourceName
  strategyType
  technicalDescription
  updatedAt
  ...MetricDisplayFormatFields
}
    ${MetricDisplayFormatFieldsFragmentDoc}`;
export const GoalSubscriptionFieldsFragmentDoc = gql`
    fragment GoalSubscriptionFields on Goal {
  id
  classType
  currentValue
  endDate
  label
  metricId
  newestMetricDate
  oldestMetricDate
  percentageComplete
  periodUnit
  periodNumber
  periodYear
  startValue
  targetValue
  startDate
  status
}
    `;
export const GoalFieldsFragmentDoc = gql`
    fragment GoalFields on Goal {
  ...GoalSubscriptionFields
}
    ${GoalSubscriptionFieldsFragmentDoc}`;
export const MetricFieldsFragmentDoc = gql`
    fragment MetricFields on Metric {
  ...MetricSubscriptionFields
  goals {
    ...GoalFields
  }
  labels {
    ...LabelRequiredFields
  }
  metricSource {
    id
    classType
    errorMessage
    metricId
    structuredFormula {
      ... on FormulaText {
        text
      }
      ... on Metric {
        id
        slug
        name
      }
    }
  }
  organization {
    id
    classType
  }
  ownerId
  owner {
    id
    classType
    name
    email
  }
  strategyStats {
    change
    classType
    displayPeriod
    period
    total
  }
}
    ${MetricSubscriptionFieldsFragmentDoc}
${GoalFieldsFragmentDoc}
${LabelRequiredFieldsFragmentDoc}`;
export const MetricSourceMutationFieldsFragmentDoc = gql`
    fragment MetricSourceMutationFields on MetricSource {
  ...MetricSourceSubscriptionFields
  metric {
    id
    ...MetricFields
  }
  integration {
    id
    classType
    sourceName
  }
  strategies {
    id
    classType
  }
}
    ${MetricSourceSubscriptionFieldsFragmentDoc}
${MetricFieldsFragmentDoc}`;
export const OrganizationFieldsFragmentDoc = gql`
    fragment OrganizationFields on Organization {
  id
  classType
  apiToken
  autoImportGoogleSheet
  defaultImportTime
  homepageUrl
  logo
  metricDefaults
  name
  slackable
}
    `;
export const OrganizationSamlFieldsFragmentDoc = gql`
    fragment OrganizationSAMLFields on Organization {
  idpEntityId
  idpSsoServiceUrl
  idpCert
  issuer
  ssoIdentifier
  ssoProvider
}
    `;
export const OrganizationSubscriptionFieldsFragmentDoc = gql`
    fragment OrganizationSubscriptionFields on Organization {
  activeSubscription {
    id
    startDate
    endDate
    trialEndDate
    status
  }
}
    `;
export const PaginationAttributesFragmentDoc = gql`
    fragment PaginationAttributes on CollectionMetadata {
  page
  totalPages
  limitValue
  totalCount
}
    `;
export const PlaybookFieldsFragmentDoc = gql`
    fragment PlaybookFields on Playbook {
  id
  classType
  aiBuilderSlug
  category
  createdAt
  description
  friendlyId
  hero
  name
  publicationState
  rowOrder
  shortDescription
  organization {
    id
    classType
    name
    logo
    homepageUrl
  }
  user {
    id
    classType
    name
  }
}
    `;
export const RecurringReportConfigurationSubscriptionFieldsFragmentDoc = gql`
    fragment RecurringReportConfigurationSubscriptionFields on RecurringReportConfiguration {
  id
  classType
  aiPrompt
  aiPromptTestResult
  createdAt
  emails
  name
  position
  sendToEmail
  sendToSlack
  service
  strategyId
  slackChannelId
  slackChannel {
    id
    classType
    name
    channelId
    isIm
    value
    label
  }
}
    `;
export const RecurringReportConfigurationFieldsFragmentDoc = gql`
    fragment RecurringReportConfigurationFields on RecurringReportConfiguration {
  id
  classType
  aiPrompt
  aiPromptTestResult
  createdAt
  emails
  name
  position
  sendToEmail
  sendToSlack
  service
  strategyId
  schedule {
    id
    schedulableId
    schedulableType
    classType
    rrule
    humanized
  }
  slackChannel {
    id
    classType
    name
    channelId
    isIm
    value
    label
  }
  slackChannelId
}
    `;
export const ReportSubscriptionFieldsFragmentDoc = gql`
    fragment ReportSubscriptionFields on Report {
  id
  classType
  createdAt
  rfId
  emails
  endDate
  name
  recurringReportConfigurationId
  sendToEmail
  sendToSlack
  slackChannelId
  startDate
  strategyId
  summary
  updatedAt
}
    `;
export const ReportFieldsFragmentDoc = gql`
    fragment ReportFields on Report {
  ...ReportSubscriptionFields
  slackChannel {
    id
    classType
    name
    channelId
    type
    value
    label
  }
  strategy {
    id
    classType
    name
  }
}
    ${ReportSubscriptionFieldsFragmentDoc}`;
export const ReportEntityFieldsFragmentDoc = gql`
    fragment ReportEntityFields on Entity {
  id
  classType
  confidenceRating
  containeeStats
  foreignState
  goalHypothesis
  name
  results
  secondaryForeignId
  sourceName
  sourceUrl
  summary
  workflowState
  ownerId
  labels {
    id
    name
    classType
  }
  owner {
    id
    name
    email
    classType
  }
}
    `;
export const ScheduleSubscriptionFieldsFragmentDoc = gql`
    fragment ScheduleSubscriptionFields on Schedule {
  id
  classType
  schedulableId
  schedulableType
  rrule
  humanized
}
    `;
export const ScheduleFieldsFragmentDoc = gql`
    fragment ScheduleFields on Schedule {
  ...ScheduleSubscriptionFields
}
    ${ScheduleSubscriptionFieldsFragmentDoc}`;
export const NodeFieldsFragmentDoc = gql`
    fragment NodeFields on Node {
  id
  classType
  domainObjectId
  domainObjectType
  strategyId
  data
  nodeId
  type
  metadata
  position
  parentId
  width
  height
  hidden
  zIndex
  simBaseline
  simImpacts {
    name
    nodeId
    nodeRfId
    deltaR
    percentR
  }
  simPartials1p {
    name
    nodeId
    nodeRfId
    deltaR
    percentR
  }
  simPercentChange
  simTarget
  statsUpdatedAt
  strategy {
    id
    filterableId
  }
  strategyStats {
    change
    classType
    displayPeriod
    period
    total
  }
}
    `;
export const EdgeSubscriptionFieldsFragmentDoc = gql`
    fragment EdgeSubscriptionFields on Edge {
  id
  classType
  color
  correlationScore
  correlationScoreUpdatedAt
  insightsDetailsChatId
  data
  edgeId
  insights
  insightsDetails
  rfId
  source
  selected
  simImpact
  sourceId
  sourceHandle
  sourceType
  strategyId
  target
  targetId
  targetHandle
  targetType
  type
  zIndex
}
    `;
export const EdgeFieldsFragmentDoc = gql`
    fragment EdgeFields on Edge {
  ...EdgeSubscriptionFields
  insightsDetailsChat {
    id
    classType
    processedState
    errorMessage
    strategyId
  }
}
    ${EdgeSubscriptionFieldsFragmentDoc}`;
export const NoteSubscriptionFieldsFragmentDoc = gql`
    fragment NoteSubscriptionFields on Note {
  id
  classType
  createdAt
  rfId
  text
  updatedAt
}
    `;
export const NoteFieldsFragmentDoc = gql`
    fragment NoteFields on Note {
  ...NoteSubscriptionFields
}
    ${NoteSubscriptionFieldsFragmentDoc}`;
export const SectionSubscriptionFieldsFragmentDoc = gql`
    fragment SectionSubscriptionFields on Section {
  id
  classType
  createdAt
  name
  rfId
  updatedAt
}
    `;
export const SectionFieldsFragmentDoc = gql`
    fragment SectionFields on Section {
  ...SectionSubscriptionFields
}
    ${SectionSubscriptionFieldsFragmentDoc}`;
export const MapImageSubscriptionFieldsFragmentDoc = gql`
    fragment MapImageSubscriptionFields on MapImage {
  id
  classType
  createdAt
  rfId
  updatedAt
  url
}
    `;
export const MapImageFieldsFragmentDoc = gql`
    fragment MapImageFields on MapImage {
  ...MapImageSubscriptionFields
}
    ${MapImageSubscriptionFieldsFragmentDoc}`;
export const StrategySubscriptionFieldsFragmentDoc = gql`
    fragment StrategySubscriptionFields on Strategy {
  id
  rfId
  classType
  aiContext
  backgroundChangeInProgress
  businessContextId
  confidenceRating
  connected
  createdAt
  description
  empty
  indicatorCounter
  name
  ownerId
  recurringReportConfigurationsCount
  rfId
  sharing
  showCorrelations
  statsUpdatedAt
  status
  updatedAt
}
    `;
export const StrategySubMapCardFragmentDoc = gql`
    fragment StrategySubMapCard on Strategy {
  id
  name
  description
  classType
  rfId
  backgroundChangeInProgress
  confidenceRating
  commentsCount
  empty
  endDate
  ownerId
  range
  sharing
  showCorrelations
  showSegmentCreate
  startDate
  status
  owner {
    id
    classType
    name
    email
  }
  labels {
    id
    name
  }
}
    `;
export const TaskRequiredFieldsFragmentDoc = gql`
    fragment TaskRequiredFields on Task {
  id
  classType
}
    `;
export const TaskSubscriptionFieldsFragmentDoc = gql`
    fragment TaskSubscriptionFields on Task {
  ...TaskRequiredFields
  createdAt
  description
  domainObjectId
  domainObjectType
  jobId
  progress
  status
  summary
  taskType
  updatedAt
}
    ${TaskRequiredFieldsFragmentDoc}`;
export const UserSubscriptionFieldsFragmentDoc = gql`
    fragment UserSubscriptionFields on User {
  id
  classType
  name
  email
  role
}
    `;
export const UserRequiredFieldsFragmentDoc = gql`
    fragment UserRequiredFields on User {
  id
  classType
  name
  email
}
    `;
export const UserFieldsFragmentDoc = gql`
    fragment UserFields on User {
  ...UserRequiredFields
  timeZone
  role
  createdAt
  updatedAt
  confirmedAt
  superAdmin
  optedInToAnalytics
  jobTitle
}
    ${UserRequiredFieldsFragmentDoc}`;
export const AccountsDocument = gql`
    query Accounts($includeDisabled: CastableBoolean) {
  accounts(includeDisabled: $includeDisabled) {
    ...AccountRequiredFields
    createdAt
    updatedAt
    user {
      id
      classType
      name
      email
      superAdmin
      createdAt
    }
  }
}
    ${AccountRequiredFieldsFragmentDoc}`;

export function useAccountsQuery(options?: Omit<Urql.UseQueryArgs<AccountsQueryVariables>, 'query'>) {
  return Urql.useQuery<AccountsQuery, AccountsQueryVariables>({ query: AccountsDocument, ...options });
};
export const MembersAutocompleteDocument = gql`
    query MembersAutocomplete($query: String!) {
  membersAutocomplete(query: $query) {
    id
    classType
    name
    email
  }
}
    `;

export function useMembersAutocompleteQuery(options: Omit<Urql.UseQueryArgs<MembersAutocompleteQueryVariables>, 'query'>) {
  return Urql.useQuery<MembersAutocompleteQuery, MembersAutocompleteQueryVariables>({ query: MembersAutocompleteDocument, ...options });
};
export const AccountUpdateDocument = gql`
    mutation AccountUpdate($input: AccountUpdateInput!) {
  accountUpdate(input: $input) {
    account {
      ...AccountRequiredFields
      createdAt
      updatedAt
    }
    user {
      id
      classType
      name
      email
      createdAt
      superAdmin
    }
  }
}
    ${AccountRequiredFieldsFragmentDoc}`;

export function useAccountUpdateMutation() {
  return Urql.useMutation<AccountUpdateMutation, AccountUpdateMutationVariables>(AccountUpdateDocument);
};
export const AccountDeleteDocument = gql`
    mutation AccountDelete($input: AccountDeleteInput!) {
  crudOperation: accountDelete(input: $input) {
    crudOperation {
      operation
      data {
        id
        classType
        name
        role
        disabledAt
        createdAt
        updatedAt
      }
    }
    errors {
      message
      path
    }
  }
}
    `;

export function useAccountDeleteMutation() {
  return Urql.useMutation<AccountDeleteMutation, AccountDeleteMutationVariables>(AccountDeleteDocument);
};
export const AccountSwitchDocument = gql`
    mutation AccountSwitch($input: AccountSwitchInput!) {
  accountSwitch(input: $input) {
    account {
      ...AccountRequiredFields
      createdAt
      updatedAt
    }
    user {
      id
      classType
      name
      email
    }
  }
}
    ${AccountRequiredFieldsFragmentDoc}`;

export function useAccountSwitchMutation() {
  return Urql.useMutation<AccountSwitchMutation, AccountSwitchMutationVariables>(AccountSwitchDocument);
};
export const StrategyMetricsSuggestDocument = gql`
    mutation StrategyMetricsSuggest($input: StrategyMetricsSuggestInput!) {
  strategyMetricsSuggest(input: $input) {
    result
    error
  }
}
    `;

export function useStrategyMetricsSuggestMutation() {
  return Urql.useMutation<StrategyMetricsSuggestMutation, StrategyMetricsSuggestMutationVariables>(StrategyMetricsSuggestDocument);
};
export const MetricDescriptionSuggestDocument = gql`
    mutation MetricDescriptionSuggest($input: MetricDescriptionSuggestInput!) {
  metricDescriptionSuggest(input: $input) {
    result
  }
}
    `;

export function useMetricDescriptionSuggestMutation() {
  return Urql.useMutation<MetricDescriptionSuggestMutation, MetricDescriptionSuggestMutationVariables>(MetricDescriptionSuggestDocument);
};
export const StrategyDescriptionSuggestDocument = gql`
    mutation StrategyDescriptionSuggest($input: StrategyDescriptionSuggestInput!) {
  strategyDescriptionSuggest(input: $input) {
    result
  }
}
    `;

export function useStrategyDescriptionSuggestMutation() {
  return Urql.useMutation<StrategyDescriptionSuggestMutation, StrategyDescriptionSuggestMutationVariables>(StrategyDescriptionSuggestDocument);
};
export const StrategyNameSuggestDocument = gql`
    mutation StrategyNameSuggest($input: StrategyNameSuggestInput!) {
  strategyNameSuggest(input: $input) {
    result
  }
}
    `;

export function useStrategyNameSuggestMutation() {
  return Urql.useMutation<StrategyNameSuggestMutation, StrategyNameSuggestMutationVariables>(StrategyNameSuggestDocument);
};
export const MetricTechnicalDescriptionSuggestDocument = gql`
    mutation MetricTechnicalDescriptionSuggest($input: MetricTechnicalDescriptionSuggestInput!) {
  metricTechnicalDescriptionSuggest(input: $input) {
    result
  }
}
    `;

export function useMetricTechnicalDescriptionSuggestMutation() {
  return Urql.useMutation<MetricTechnicalDescriptionSuggestMutation, MetricTechnicalDescriptionSuggestMutationVariables>(MetricTechnicalDescriptionSuggestDocument);
};
export const ProductInitiativesSuggestDocument = gql`
    mutation ProductInitiativesSuggest($input: ProductInitiativesSuggestInput!) {
  productInitiativesSuggest(input: $input) {
    result
  }
}
    `;

export function useProductInitiativesSuggestMutation() {
  return Urql.useMutation<ProductInitiativesSuggestMutation, ProductInitiativesSuggestMutationVariables>(ProductInitiativesSuggestDocument);
};
export const OpenAiFileDeleteDocument = gql`
    mutation OpenAiFileDelete($input: OpenAiFileDeleteInput!) {
  openAiFileDelete(input: $input) {
    success
  }
}
    `;

export function useOpenAiFileDeleteMutation() {
  return Urql.useMutation<OpenAiFileDeleteMutation, OpenAiFileDeleteMutationVariables>(OpenAiFileDeleteDocument);
};
export const MetricFormulasSuggestDocument = gql`
    mutation MetricFormulasSuggest($input: MetricFormulasSuggestInput!) {
  metricFormulasSuggest(input: $input) {
    result
    error
  }
}
    `;

export function useMetricFormulasSuggestMutation() {
  return Urql.useMutation<MetricFormulasSuggestMutation, MetricFormulasSuggestMutationVariables>(MetricFormulasSuggestDocument);
};
export const OrganizationChatsDocument = gql`
    query OrganizationChats($chattableType: String!, $chattableId: ID!) {
  organization {
    id
    chats(chattableType: $chattableType, chattableId: $chattableId) {
      ...ChatFields
      mostRecentPrompt {
        ...MessageSubscriptionFields
        user {
          id
          classType
          name
          email
        }
        assistant {
          id
          name
        }
      }
    }
  }
}
    ${ChatFieldsFragmentDoc}
${MessageSubscriptionFieldsFragmentDoc}`;

export function useOrganizationChatsQuery(options: Omit<Urql.UseQueryArgs<OrganizationChatsQueryVariables>, 'query'>) {
  return Urql.useQuery<OrganizationChatsQuery, OrganizationChatsQueryVariables>({ query: OrganizationChatsDocument, ...options });
};
export const PipelineDocument = gql`
    query Pipeline($id: PipelineEnum!) {
  pipeline(id: $id) {
    id
    name
    slug
    classType
    assistants {
      id
      name
    }
  }
}
    `;

export function usePipelineQuery(options: Omit<Urql.UseQueryArgs<PipelineQueryVariables>, 'query'>) {
  return Urql.useQuery<PipelineQuery, PipelineQueryVariables>({ query: PipelineDocument, ...options });
};
export const ChatDocument = gql`
    query Chat($id: ID!) {
  chat(id: $id) {
    ...ChatFields
    messages {
      ...MessageSubscriptionFields
      user {
        id
        name
        email
      }
      assistant {
        id
        name
      }
    }
  }
}
    ${ChatFieldsFragmentDoc}
${MessageSubscriptionFieldsFragmentDoc}`;

export function useChatQuery(options: Omit<Urql.UseQueryArgs<ChatQueryVariables>, 'query'>) {
  return Urql.useQuery<ChatQuery, ChatQueryVariables>({ query: ChatDocument, ...options });
};
export const PipelineRunDocument = gql`
    mutation PipelineRun($input: PipelineRunInput!) {
  pipelineRun(input: $input) {
    chat {
      ...ChatSubscriptionFields
    }
    errors {
      message
    }
  }
}
    ${ChatSubscriptionFieldsFragmentDoc}`;

export function usePipelineRunMutation() {
  return Urql.useMutation<PipelineRunMutation, PipelineRunMutationVariables>(PipelineRunDocument);
};
export const ChatCancelDocument = gql`
    mutation ChatCancel($input: ChatCancelInput!) {
  chatCancel(input: $input) {
    chat {
      ...ChatSubscriptionFields
    }
  }
}
    ${ChatSubscriptionFieldsFragmentDoc}`;

export function useChatCancelMutation() {
  return Urql.useMutation<ChatCancelMutation, ChatCancelMutationVariables>(ChatCancelDocument);
};
export const ChatUpdateDocument = gql`
    mutation ChatUpdate($input: ChatUpdateInput!) {
  chatUpdate(input: $input) {
    chat {
      ...ChatSubscriptionFields
    }
  }
}
    ${ChatSubscriptionFieldsFragmentDoc}`;

export function useChatUpdateMutation() {
  return Urql.useMutation<ChatUpdateMutation, ChatUpdateMutationVariables>(ChatUpdateDocument);
};
export const UploadTicketGenerateDocument = gql`
    mutation UploadTicketGenerate($input: UploadTicketGenerateInput!) {
  uploadTicketGenerate(input: $input) {
    ticket
  }
}
    `;

export function useUploadTicketGenerateMutation() {
  return Urql.useMutation<UploadTicketGenerateMutation, UploadTicketGenerateMutationVariables>(UploadTicketGenerateDocument);
};
export const AiAssistantFileCacheFilesAddDocument = gql`
    mutation AiAssistantFileCacheFilesAdd($input: AiAssistantFileCacheFilesAddInput!) {
  aiAssistantFileCacheFilesAdd(input: $input) {
    success
  }
}
    `;

export function useAiAssistantFileCacheFilesAddMutation() {
  return Urql.useMutation<AiAssistantFileCacheFilesAddMutation, AiAssistantFileCacheFilesAddMutationVariables>(AiAssistantFileCacheFilesAddDocument);
};
export const AiAssistantFileCacheFilesRemoveDocument = gql`
    mutation AiAssistantFileCacheFilesRemove($input: AiAssistantFileCacheFilesRemoveInput!) {
  aiAssistantFileCacheFilesRemove(input: $input) {
    success
  }
}
    `;

export function useAiAssistantFileCacheFilesRemoveMutation() {
  return Urql.useMutation<AiAssistantFileCacheFilesRemoveMutation, AiAssistantFileCacheFilesRemoveMutationVariables>(AiAssistantFileCacheFilesRemoveDocument);
};
export const AiAssistantEvalResultsDocument = gql`
    query AiAssistantEvalResults($states: [String!]) {
  aiAssistantEvalResults(states: $states) {
    id
    eval {
      id
      name
      retryBelow
      live
    }
    score
    model
    processedState
    assistantFingerprint
    assistantName
    contextSnapshot
  }
}
    `;

export function useAiAssistantEvalResultsQuery(options?: Omit<Urql.UseQueryArgs<AiAssistantEvalResultsQueryVariables>, 'query'>) {
  return Urql.useQuery<AiAssistantEvalResultsQuery, AiAssistantEvalResultsQueryVariables>({ query: AiAssistantEvalResultsDocument, ...options });
};
export const AiNodesGenerateDocument = gql`
    mutation AiNodesGenerate($input: AiNodesGenerateInput!) {
  aiNodesGenerate(input: $input) {
    success
  }
}
    `;

export function useAiNodesGenerateMutation() {
  return Urql.useMutation<AiNodesGenerateMutation, AiNodesGenerateMutationVariables>(AiNodesGenerateDocument);
};
export const MetricsGenerateFromFormulaDocument = gql`
    mutation MetricsGenerateFromFormula($input: MetricsGenerateFromFormulaInput!) {
  metricsGenerateFromFormula(input: $input) {
    success
  }
}
    `;

export function useMetricsGenerateFromFormulaMutation() {
  return Urql.useMutation<MetricsGenerateFromFormulaMutation, MetricsGenerateFromFormulaMutationVariables>(MetricsGenerateFromFormulaDocument);
};
export const StrategyAiConversationDocument = gql`
    query StrategyAiConversation($strategyId: ID!) {
  strategy(id: $strategyId) {
    id
    aiConversation {
      id
      aiConversationMessages {
        id
        requestRole
        requestContent
        responseRole
        responseContent
      }
    }
  }
}
    `;

export function useStrategyAiConversationQuery(options: Omit<Urql.UseQueryArgs<StrategyAiConversationQueryVariables>, 'query'>) {
  return Urql.useQuery<StrategyAiConversationQuery, StrategyAiConversationQueryVariables>({ query: StrategyAiConversationDocument, ...options });
};
export const BasicCardDocument = gql`
    query BasicCard($id: ID!) {
  basicCard(id: $id) {
    ...BasicCardFields
  }
}
    ${BasicCardFieldsFragmentDoc}`;

export function useBasicCardQuery(options: Omit<Urql.UseQueryArgs<BasicCardQueryVariables>, 'query'>) {
  return Urql.useQuery<BasicCardQuery, BasicCardQueryVariables>({ query: BasicCardDocument, ...options });
};
export const BasicCardsDocument = gql`
    query BasicCards($filter: String, $strategyId: ID, $order: BasicCardOrderingInput, $page: Int, $limit: Int) {
  basicCards(
    filter: $filter
    strategyId: $strategyId
    order: $order
    page: $page
    limit: $limit
  ) {
    collection {
      id
      ...BasicCardFields
      cardTypeName
      containeeCount
      strategies {
        id
        name
        classType
      }
    }
    metadata {
      ...PaginationAttributes
    }
  }
  organization {
    id
    classType
  }
}
    ${BasicCardFieldsFragmentDoc}
${PaginationAttributesFragmentDoc}`;

export function useBasicCardsQuery(options?: Omit<Urql.UseQueryArgs<BasicCardsQueryVariables>, 'query'>) {
  return Urql.useQuery<BasicCardsQuery, BasicCardsQueryVariables>({ query: BasicCardsDocument, ...options });
};
export const BasicCardEntitiesDocument = gql`
    query BasicCardEntities($id: ID!, $page: Int, $limit: Int, $workflowState: EntityWorkflowStateEnum) {
  basicCardEntities(
    basicCardId: $id
    workflowState: $workflowState
    page: $page
    limit: $limit
  ) {
    collection {
      id
      classType
      ...EntityBasics
    }
    metadata {
      ...PaginationAttributes
    }
  }
}
    ${EntityBasicsFragmentDoc}
${PaginationAttributesFragmentDoc}`;

export function useBasicCardEntitiesQuery(options: Omit<Urql.UseQueryArgs<BasicCardEntitiesQueryVariables>, 'query'>) {
  return Urql.useQuery<BasicCardEntitiesQuery, BasicCardEntitiesQueryVariables>({ query: BasicCardEntitiesDocument, ...options });
};
export const BasicCardCommentsDocument = gql`
    query BasicCardComments($id: ID!) {
  basicCard(id: $id) {
    ...BasicCardRequiredFields
    comments {
      id
      ...CommentFields
    }
  }
}
    ${BasicCardRequiredFieldsFragmentDoc}
${CommentFieldsFragmentDoc}`;

export function useBasicCardCommentsQuery(options: Omit<Urql.UseQueryArgs<BasicCardCommentsQueryVariables>, 'query'>) {
  return Urql.useQuery<BasicCardCommentsQuery, BasicCardCommentsQueryVariables>({ query: BasicCardCommentsDocument, ...options });
};
export const BasicCardCreateDocument = gql`
    mutation BasicCardCreate($input: BasicCardCreateInput!) {
  basicCardCreate(input: $input) {
    basicCard {
      ...BasicCardFields
    }
    errors {
      message
      path
    }
  }
}
    ${BasicCardFieldsFragmentDoc}`;

export function useBasicCardCreateMutation() {
  return Urql.useMutation<BasicCardCreateMutation, BasicCardCreateMutationVariables>(BasicCardCreateDocument);
};
export const BasicCardDeleteDocument = gql`
    mutation BasicCardDelete($input: BasicCardDeleteInput!) {
  basicCardDelete(input: $input) {
    basicCard {
      ...BasicCardFields
    }
    errors {
      message
      path
    }
  }
}
    ${BasicCardFieldsFragmentDoc}`;

export function useBasicCardDeleteMutation() {
  return Urql.useMutation<BasicCardDeleteMutation, BasicCardDeleteMutationVariables>(BasicCardDeleteDocument);
};
export const BillingCreateSubscriptionDocument = gql`
    mutation BillingCreateSubscription($input: BillingCreateSubscriptionInput!) {
  billingCreateSubscription(input: $input) {
    response
  }
}
    `;

export function useBillingCreateSubscriptionMutation() {
  return Urql.useMutation<BillingCreateSubscriptionMutation, BillingCreateSubscriptionMutationVariables>(BillingCreateSubscriptionDocument);
};
export const BillingProvisionSubscriptionDocument = gql`
    mutation BillingProvisionSubscription($input: BillingProvisionSubscriptionInput!) {
  billingProvisionSubscription(input: $input) {
    response
  }
}
    `;

export function useBillingProvisionSubscriptionMutation() {
  return Urql.useMutation<BillingProvisionSubscriptionMutation, BillingProvisionSubscriptionMutationVariables>(BillingProvisionSubscriptionDocument);
};
export const BusinessContextDocument = gql`
    query BusinessContext($id: ID) {
  businessContext(id: $id) {
    ...BusinessContextFields
    parentBusinessContext {
      ...BusinessContextFields
      name
      parentBusinessContextId
      parentBusinessContextSlug
    }
  }
}
    ${BusinessContextFieldsFragmentDoc}`;

export function useBusinessContextQuery(options?: Omit<Urql.UseQueryArgs<BusinessContextQueryVariables>, 'query'>) {
  return Urql.useQuery<BusinessContextQuery, BusinessContextQueryVariables>({ query: BusinessContextDocument, ...options });
};
export const BusinessContextsDocument = gql`
    query BusinessContexts($parentBusinessContextId: ID) {
  businessContexts(parentBusinessContextId: $parentBusinessContextId) {
    ...BusinessContextFields
  }
}
    ${BusinessContextFieldsFragmentDoc}`;

export function useBusinessContextsQuery(options?: Omit<Urql.UseQueryArgs<BusinessContextsQueryVariables>, 'query'>) {
  return Urql.useQuery<BusinessContextsQuery, BusinessContextsQueryVariables>({ query: BusinessContextsDocument, ...options });
};
export const BusinessContextCreateDocument = gql`
    mutation BusinessContextCreate($input: BusinessContextCreateInput!) {
  businessContextCreate(input: $input) {
    businessContext {
      ...BusinessContextSubscriptionFields
    }
    errors {
      message
      path
    }
  }
}
    ${BusinessContextSubscriptionFieldsFragmentDoc}`;

export function useBusinessContextCreateMutation() {
  return Urql.useMutation<BusinessContextCreateMutation, BusinessContextCreateMutationVariables>(BusinessContextCreateDocument);
};
export const BusinessContextGenerateDocument = gql`
    mutation BusinessContextGenerate($input: BusinessContextGenerateInput!) {
  businessContextGenerate(input: $input) {
    errors {
      message
      path
    }
  }
}
    `;

export function useBusinessContextGenerateMutation() {
  return Urql.useMutation<BusinessContextGenerateMutation, BusinessContextGenerateMutationVariables>(BusinessContextGenerateDocument);
};
export const BusinessContextEmptyDocument = gql`
    mutation BusinessContextEmpty($input: BusinessContextEmptyInput!) {
  businessContextEmpty(input: $input) {
    businessContext {
      ...BusinessContextFields
    }
    errors {
      message
      path
    }
  }
}
    ${BusinessContextFieldsFragmentDoc}`;

export function useBusinessContextEmptyMutation() {
  return Urql.useMutation<BusinessContextEmptyMutation, BusinessContextEmptyMutationVariables>(BusinessContextEmptyDocument);
};
export const BusinessContextDeleteDocument = gql`
    mutation BusinessContextDelete($input: BusinessContextDeleteInput!) {
  businessContextDelete(input: $input) {
    crudOperation {
      data {
        id
      }
      operation
    }
    errors {
      message
      path
    }
  }
}
    `;

export function useBusinessContextDeleteMutation() {
  return Urql.useMutation<BusinessContextDeleteMutation, BusinessContextDeleteMutationVariables>(BusinessContextDeleteDocument);
};
export const CardTypesDocument = gql`
    query CardTypes {
  cardTypes {
    ...CommonCardTypeFields
  }
}
    ${CommonCardTypeFieldsFragmentDoc}`;

export function useCardTypesQuery(options?: Omit<Urql.UseQueryArgs<CardTypesQueryVariables>, 'query'>) {
  return Urql.useQuery<CardTypesQuery, CardTypesQueryVariables>({ query: CardTypesDocument, ...options });
};
export const CardTypeCreateDocument = gql`
    mutation CardTypeCreate($input: CardTypeCreateInput!) {
  cardTypeCreate(input: $input) {
    cardType {
      ...CommonCardTypeFields
    }
    errors {
      message
      path
    }
  }
}
    ${CommonCardTypeFieldsFragmentDoc}`;

export function useCardTypeCreateMutation() {
  return Urql.useMutation<CardTypeCreateMutation, CardTypeCreateMutationVariables>(CardTypeCreateDocument);
};
export const CardTypeUpdateDocument = gql`
    mutation CardTypeUpdate($input: CardTypeUpdateInput!) {
  cardTypeUpdate(input: $input) {
    cardType {
      ...CommonCardTypeFields
    }
    errors {
      message
      path
    }
  }
}
    ${CommonCardTypeFieldsFragmentDoc}`;

export function useCardTypeUpdateMutation() {
  return Urql.useMutation<CardTypeUpdateMutation, CardTypeUpdateMutationVariables>(CardTypeUpdateDocument);
};
export const CardTypeDeleteDocument = gql`
    mutation CardTypeDelete($input: CardTypeDeleteInput!) {
  crudOperation: cardTypeDelete(input: $input) {
    crudOperation {
      operation
      data {
        id
        classType
      }
    }
    errors {
      message
      path
    }
  }
}
    `;

export function useCardTypeDeleteMutation() {
  return Urql.useMutation<CardTypeDeleteMutation, CardTypeDeleteMutationVariables>(CardTypeDeleteDocument);
};
export const CommentCreateDocument = gql`
    mutation CommentCreate($input: CommentCreateInput!) {
  commentCreate(input: $input) {
    comment {
      ...CommentFields
    }
  }
}
    ${CommentFieldsFragmentDoc}`;

export function useCommentCreateMutation() {
  return Urql.useMutation<CommentCreateMutation, CommentCreateMutationVariables>(CommentCreateDocument);
};
export const CommentDeleteDocument = gql`
    mutation CommentDelete($input: CommentDeleteInput!) {
  commentDelete(input: $input) {
    comment {
      ...CommentFields
    }
  }
}
    ${CommentFieldsFragmentDoc}`;

export function useCommentDeleteMutation() {
  return Urql.useMutation<CommentDeleteMutation, CommentDeleteMutationVariables>(CommentDeleteDocument);
};
export const ContributorDocument = gql`
    query Contributor($id: String!) {
  contributor(id: $id) {
    ... on User {
      id
      classType
      name
      sourceName
      searchableContributorId
    }
    ... on SourceIdentity {
      id
      classType
      name
      sourceName
      searchableContributorId
    }
  }
}
    `;

export function useContributorQuery(options: Omit<Urql.UseQueryArgs<ContributorQueryVariables>, 'query'>) {
  return Urql.useQuery<ContributorQuery, ContributorQueryVariables>({ query: ContributorDocument, ...options });
};
export const ContributorsAutocompleteDocument = gql`
    query ContributorsAutocomplete($query: String!) {
  contributorsAutocomplete(query: $query) {
    ... on User {
      id
      classType
      name
      sourceName
      searchableContributorId
    }
    ... on SourceIdentity {
      id
      classType
      name
      sourceName
      searchableContributorId
    }
  }
}
    `;

export function useContributorsAutocompleteQuery(options: Omit<Urql.UseQueryArgs<ContributorsAutocompleteQueryVariables>, 'query'>) {
  return Urql.useQuery<ContributorsAutocompleteQuery, ContributorsAutocompleteQueryVariables>({ query: ContributorsAutocompleteDocument, ...options });
};
export const EmailAutocompleteDocument = gql`
    query EmailAutocomplete($query: String!, $requireEmail: CastableBoolean) {
  contributorsAutocomplete(query: $query, requireEmail: $requireEmail) {
    ... on User {
      id
      classType
      name
      email
    }
    ... on SourceIdentity {
      id
      classType
      name
      email
    }
  }
}
    `;

export function useEmailAutocompleteQuery(options: Omit<Urql.UseQueryArgs<EmailAutocompleteQueryVariables>, 'query'>) {
  return Urql.useQuery<EmailAutocompleteQuery, EmailAutocompleteQueryVariables>({ query: EmailAutocompleteDocument, ...options });
};
export const EntityCreateContributorDocument = gql`
    mutation EntityCreateContributor($input: EntityCreateContributorInput!) {
  entityCreateContributor(input: $input) {
    entity {
      id
      classType
      entityContributions {
        id
        classType
        contributor {
          ... on User {
            id
            name
            email
            sourceName
          }
          ... on SourceIdentity {
            id
            name
            email
            sourceName
          }
        }
      }
    }
  }
}
    `;

export function useEntityCreateContributorMutation() {
  return Urql.useMutation<EntityCreateContributorMutation, EntityCreateContributorMutationVariables>(EntityCreateContributorDocument);
};
export const EntityDeleteContributorDocument = gql`
    mutation EntityDeleteContributor($input: EntityDeleteContributorInput!) {
  entityDeleteContributor(input: $input) {
    entity {
      id
      classType
      entityContributions {
        id
        contributor {
          ... on User {
            id
            classType
            name
            email
            sourceName
          }
          ... on SourceIdentity {
            id
            classType
            name
            email
            sourceName
          }
        }
      }
    }
  }
}
    `;

export function useEntityDeleteContributorMutation() {
  return Urql.useMutation<EntityDeleteContributorMutation, EntityDeleteContributorMutationVariables>(EntityDeleteContributorDocument);
};
export const CorrelationPairDocument = gql`
    query CorrelationPair($sourceId: ID!, $targetId: ID!, $range: String, $startDate: String, $endDate: String) {
  organization {
    id
    classType
    correlate(
      sourceId: $sourceId
      targetId: $targetId
      range: $range
      startDate: $startDate
      endDate: $endDate
    ) {
      id
      classType
      score
      sourceLagDays
      targetLagDays
      range
      startDate
      endDate
      sourceMetric {
        id
        classType
        name
        positiveDirection
      }
      targetMetric {
        id
        classType
        name
        positiveDirection
      }
    }
  }
}
    `;

export function useCorrelationPairQuery(options: Omit<Urql.UseQueryArgs<CorrelationPairQueryVariables>, 'query'>) {
  return Urql.useQuery<CorrelationPairQuery, CorrelationPairQueryVariables>({ query: CorrelationPairDocument, ...options });
};
export const CorrelationPairMetricsDocument = gql`
    query CorrelationPairMetrics($sourceId: ID!, $targetId: ID!, $range: String, $interval: IntervalEnum, $startDate: String, $endDate: String, $cumulative: CastableBoolean, $sourceLagDays: Int, $targetLagDays: Int) {
  organization {
    id
    classType
    correlate(
      sourceId: $sourceId
      targetId: $targetId
      range: $range
      startDate: $startDate
      endDate: $endDate
    ) {
      id
      classType
      sourceMetric {
        id
        classType
        name
        positiveDirection
        metricDataPoints(
          range: $range
          interval: $interval
          startDate: $startDate
          endDate: $endDate
          cumulative: $cumulative
          lagDays: $sourceLagDays
        ) {
          date
          value
        }
      }
      targetMetric {
        id
        classType
        name
        positiveDirection
        metricDataPoints(
          range: $range
          interval: $interval
          startDate: $startDate
          endDate: $endDate
          cumulative: $cumulative
          lagDays: $targetLagDays
        ) {
          date
          value
        }
      }
    }
  }
}
    `;

export function useCorrelationPairMetricsQuery(options: Omit<Urql.UseQueryArgs<CorrelationPairMetricsQueryVariables>, 'query'>) {
  return Urql.useQuery<CorrelationPairMetricsQuery, CorrelationPairMetricsQueryVariables>({ query: CorrelationPairMetricsDocument, ...options });
};
export const CorrelationPairUpdateDocument = gql`
    mutation CorrelationPairUpdate($input: CorrelationPairUpdateInput!) {
  correlationPairUpdate(input: $input) {
    correlationPair {
      id
      classType
      sourceLagDays
      targetLagDays
      range
      startDate
      endDate
    }
    errors {
      message
      path
    }
  }
}
    `;

export function useCorrelationPairUpdateMutation() {
  return Urql.useMutation<CorrelationPairUpdateMutation, CorrelationPairUpdateMutationVariables>(CorrelationPairUpdateDocument);
};
export const CredentialDocument = gql`
    query Credential($id: ID!) {
  credential(id: $id) {
    ...CredentialFields
  }
}
    ${CredentialFieldsFragmentDoc}`;

export function useCredentialQuery(options: Omit<Urql.UseQueryArgs<CredentialQueryVariables>, 'query'>) {
  return Urql.useQuery<CredentialQuery, CredentialQueryVariables>({ query: CredentialDocument, ...options });
};
export const CredentialsDocument = gql`
    query Credentials($sourceName: String) {
  credentials(sourceName: $sourceName) {
    ...CredentialFields
  }
}
    ${CredentialFieldsFragmentDoc}`;

export function useCredentialsQuery(options?: Omit<Urql.UseQueryArgs<CredentialsQueryVariables>, 'query'>) {
  return Urql.useQuery<CredentialsQuery, CredentialsQueryVariables>({ query: CredentialsDocument, ...options });
};
export const SuperAdminCredentialsDocument = gql`
    query SuperAdminCredentials($sourceName: String) {
  superAdminCredentials(sourceName: $sourceName) {
    id
    displayName
  }
}
    `;

export function useSuperAdminCredentialsQuery(options?: Omit<Urql.UseQueryArgs<SuperAdminCredentialsQueryVariables>, 'query'>) {
  return Urql.useQuery<SuperAdminCredentialsQuery, SuperAdminCredentialsQueryVariables>({ query: SuperAdminCredentialsDocument, ...options });
};
export const CredentialMetricNamesDocument = gql`
    query CredentialMetricNames($id: ID!) {
  credential(id: $id) {
    id
    metrics {
      id
      classType
      name
    }
  }
}
    `;

export function useCredentialMetricNamesQuery(options: Omit<Urql.UseQueryArgs<CredentialMetricNamesQueryVariables>, 'query'>) {
  return Urql.useQuery<CredentialMetricNamesQuery, CredentialMetricNamesQueryVariables>({ query: CredentialMetricNamesDocument, ...options });
};
export const CredentialCreateDocument = gql`
    mutation CredentialCreate($input: CredentialCreateInput!) {
  credentialCreate(input: $input) {
    credential {
      ...CredentialFields
    }
    errors {
      message
      path
    }
  }
}
    ${CredentialFieldsFragmentDoc}`;

export function useCredentialCreateMutation() {
  return Urql.useMutation<CredentialCreateMutation, CredentialCreateMutationVariables>(CredentialCreateDocument);
};
export const CredentialTestDocument = gql`
    mutation CredentialTest($input: CredentialTestInput!) {
  credentialTest(input: $input) {
    credential {
      ...CredentialFields
    }
    success
    errors {
      message
      path
    }
  }
}
    ${CredentialFieldsFragmentDoc}`;

export function useCredentialTestMutation() {
  return Urql.useMutation<CredentialTestMutation, CredentialTestMutationVariables>(CredentialTestDocument);
};
export const CredentialAttributesTestDocument = gql`
    mutation CredentialAttributesTest($input: CredentialAttributesTestInput!) {
  credentialAttributesTest(input: $input) {
    success
    errors {
      message
      path
    }
  }
}
    `;

export function useCredentialAttributesTestMutation() {
  return Urql.useMutation<CredentialAttributesTestMutation, CredentialAttributesTestMutationVariables>(CredentialAttributesTestDocument);
};
export const DomainObjectsDeleteDocument = gql`
    mutation DomainObjectsDelete($input: DomainObjectsDeleteInput!) {
  crudOperation: domainObjectsDelete(input: $input) {
    crudOperation {
      operation
      data {
        ... on BasicCard {
          id
          classType
        }
        ... on CardType {
          id
          classType
        }
        ... on Entity {
          id
          classType
        }
        ... on Integration {
          id
          classType
        }
        ... on MapImage {
          id
          classType
        }
        ... on Metric {
          id
          classType
        }
        ... on Note {
          id
          classType
        }
        ... on Section {
          id
          classType
        }
        ... on Strategy {
          id
          classType
        }
      }
    }
    errors {
      message
      path
    }
  }
}
    `;

export function useDomainObjectsDeleteMutation() {
  return Urql.useMutation<DomainObjectsDeleteMutation, DomainObjectsDeleteMutationVariables>(DomainObjectsDeleteDocument);
};
export const DomainObjectsBulkLabelDocument = gql`
    mutation DomainObjectsBulkLabel($input: DomainObjectsBulkLabelInput!) {
  domainObjectsBulkLabel(input: $input) {
    domainObjects {
      ... on Entity {
        id
        rfId
        classType
        labels {
          id
          name
        }
      }
      ... on Metric {
        id
        rfId
        classType
        labels {
          id
          name
        }
      }
      ... on Strategy {
        id
        rfId
        classType
        labels {
          id
          name
        }
      }
    }
  }
}
    `;

export function useDomainObjectsBulkLabelMutation() {
  return Urql.useMutation<DomainObjectsBulkLabelMutation, DomainObjectsBulkLabelMutationVariables>(DomainObjectsBulkLabelDocument);
};
export const EntityDocument = gql`
    query Entity($id: ID!) {
  entity(id: $id) {
    ...EntityDetails
    ...EntityPrivateFields
  }
}
    ${EntityDetailsFragmentDoc}
${EntityPrivateFieldsFragmentDoc}`;

export function useEntityQuery(options: Omit<Urql.UseQueryArgs<EntityQueryVariables>, 'query'>) {
  return Urql.useQuery<EntityQuery, EntityQueryVariables>({ query: EntityDocument, ...options });
};
export const EntityFormDocument = gql`
    query EntityForm($id: ID!) {
  entity(id: $id) {
    id
    labels {
      ...LabelRequiredFields
    }
    entityContributions {
      id
      contributor {
        ... on User {
          id
          classType
          name
          email
          sourceName
        }
        ... on SourceIdentity {
          id
          classType
          name
          email
          sourceName
        }
      }
    }
    ...EntitiesFormAttributes
  }
}
    ${LabelRequiredFieldsFragmentDoc}
${EntitiesFormAttributesFragmentDoc}`;

export function useEntityFormQuery(options: Omit<Urql.UseQueryArgs<EntityFormQueryVariables>, 'query'>) {
  return Urql.useQuery<EntityFormQuery, EntityFormQueryVariables>({ query: EntityFormDocument, ...options });
};
export const EntitiesDocument = gql`
    query Entities($filter: String, $strategyId: ID, $order: EntityOrderingInput, $page: Int, $limit: Int) {
  entities(
    filter: $filter
    strategyId: $strategyId
    order: $order
    page: $page
    limit: $limit
  ) {
    collection {
      id
      classType
      foreignType
      name
      sourceName
      containeeCount
      labels {
        ...LabelRequiredFields
      }
      strategies {
        id
        name
        classType
      }
    }
    metadata {
      ...PaginationAttributes
    }
  }
}
    ${LabelRequiredFieldsFragmentDoc}
${PaginationAttributesFragmentDoc}`;

export function useEntitiesQuery(options?: Omit<Urql.UseQueryArgs<EntitiesQueryVariables>, 'query'>) {
  return Urql.useQuery<EntitiesQuery, EntitiesQueryVariables>({ query: EntitiesDocument, ...options });
};
export const EntityEntitiesDocument = gql`
    query EntityEntities($id: ID!, $page: Int!, $limit: Int, $workflowState: EntityWorkflowStateEnum) {
  entityEntities(
    entityId: $id
    workflowState: $workflowState
    page: $page
    limit: $limit
  ) {
    collection {
      ...EntityBasics
    }
    metadata {
      ...PaginationAttributes
    }
  }
}
    ${EntityBasicsFragmentDoc}
${PaginationAttributesFragmentDoc}`;

export function useEntityEntitiesQuery(options: Omit<Urql.UseQueryArgs<EntityEntitiesQueryVariables>, 'query'>) {
  return Urql.useQuery<EntityEntitiesQuery, EntityEntitiesQueryVariables>({ query: EntityEntitiesDocument, ...options });
};
export const EntityCommentsDocument = gql`
    query EntityComments($id: ID!) {
  entity(id: $id) {
    ...EntityBasics
    comments {
      id
      ...CommentFields
    }
  }
}
    ${EntityBasicsFragmentDoc}
${CommentFieldsFragmentDoc}`;

export function useEntityCommentsQuery(options: Omit<Urql.UseQueryArgs<EntityCommentsQueryVariables>, 'query'>) {
  return Urql.useQuery<EntityCommentsQuery, EntityCommentsQueryVariables>({ query: EntityCommentsDocument, ...options });
};
export const EntityCreateDocument = gql`
    mutation EntityCreate($input: EntityCreateInput!) {
  entityCreate(input: $input) {
    entity {
      ...EntityBasics
    }
    errors {
      message
      path
    }
  }
}
    ${EntityBasicsFragmentDoc}`;

export function useEntityCreateMutation() {
  return Urql.useMutation<EntityCreateMutation, EntityCreateMutationVariables>(EntityCreateDocument);
};
export const EntityUpdateDocument = gql`
    mutation EntityUpdate($input: EntityUpdateInput!) {
  entityUpdate(input: $input) {
    entity {
      ...EntityBasics
      labels {
        ...LabelRequiredFields
      }
      entityContributions {
        id
        classType
        contributor {
          ... on User {
            id
            classType
            name
            email
            sourceName
          }
          ... on SourceIdentity {
            id
            classType
            name
            email
            sourceName
          }
        }
      }
      ...EntitiesFormAttributes
    }
    errors {
      message
      path
    }
  }
}
    ${EntityBasicsFragmentDoc}
${LabelRequiredFieldsFragmentDoc}
${EntitiesFormAttributesFragmentDoc}`;

export function useEntityUpdateMutation() {
  return Urql.useMutation<EntityUpdateMutation, EntityUpdateMutationVariables>(EntityUpdateDocument);
};
export const EntitySlackDocument = gql`
    mutation EntitySlack($input: EntitySlackInput!) {
  entitySlack(input: $input) {
    success
    errors {
      message
      path
    }
  }
}
    `;

export function useEntitySlackMutation() {
  return Urql.useMutation<EntitySlackMutation, EntitySlackMutationVariables>(EntitySlackDocument);
};
export const EntityCreateAttachmentDocument = gql`
    mutation EntityCreateAttachment($input: EntityCreateAttachmentInput!) {
  entityCreateAttachment(input: $input) {
    entity {
      id
      classType
      entityAttachmentsCount
      entityAttachments {
        id
        classType
        entityId
        url
      }
      thumbnail {
        id
        classType
        entityId
        url
      }
    }
    errors {
      message
      path
    }
  }
}
    `;

export function useEntityCreateAttachmentMutation() {
  return Urql.useMutation<EntityCreateAttachmentMutation, EntityCreateAttachmentMutationVariables>(EntityCreateAttachmentDocument);
};
export const EntityDeleteAttachmentDocument = gql`
    mutation EntityDeleteAttachment($input: EntityDeleteAttachmentInput!) {
  entityDeleteAttachment(input: $input) {
    entity {
      id
      classType
      entityAttachmentsCount
      entityAttachments {
        id
        classType
        entityId
        url
      }
      thumbnail {
        id
        classType
        entityId
        url
      }
    }
    errors {
      message
      path
    }
  }
}
    `;

export function useEntityDeleteAttachmentMutation() {
  return Urql.useMutation<EntityDeleteAttachmentMutation, EntityDeleteAttachmentMutationVariables>(EntityDeleteAttachmentDocument);
};
export const EntityContainmentCreateDocument = gql`
    mutation EntityContainmentCreate($input: EntityContainmentCreateInput!) {
  entityContainmentCreate(input: $input) {
    entity {
      id
      classType
    }
    errors {
      message
      path
    }
  }
}
    `;

export function useEntityContainmentCreateMutation() {
  return Urql.useMutation<EntityContainmentCreateMutation, EntityContainmentCreateMutationVariables>(EntityContainmentCreateDocument);
};
export const EntityContainmentDeleteDocument = gql`
    mutation EntityContainmentDelete($input: EntityContainmentDeleteInput!) {
  entityContainmentDelete(input: $input) {
    entity {
      id
      classType
    }
    errors {
      message
      path
    }
  }
}
    `;

export function useEntityContainmentDeleteMutation() {
  return Urql.useMutation<EntityContainmentDeleteMutation, EntityContainmentDeleteMutationVariables>(EntityContainmentDeleteDocument);
};
export const FavoritesDocument = gql`
    query Favorites {
  favorites {
    ...CommonFavoriteFields
  }
}
    ${CommonFavoriteFieldsFragmentDoc}`;

export function useFavoritesQuery(options?: Omit<Urql.UseQueryArgs<FavoritesQueryVariables>, 'query'>) {
  return Urql.useQuery<FavoritesQuery, FavoritesQueryVariables>({ query: FavoritesDocument, ...options });
};
export const FavoriteCreateDocument = gql`
    mutation FavoriteCreate($input: FavoriteCreateInput!) {
  favoriteCreate(input: $input) {
    favorite {
      ...CommonFavoriteFields
    }
    errors {
      message
      path
    }
  }
}
    ${CommonFavoriteFieldsFragmentDoc}`;

export function useFavoriteCreateMutation() {
  return Urql.useMutation<FavoriteCreateMutation, FavoriteCreateMutationVariables>(FavoriteCreateDocument);
};
export const FavoriteDeleteDocument = gql`
    mutation FavoriteDelete($input: FavoriteDeleteInput!) {
  favoriteDelete(input: $input) {
    favorite {
      ...CommonFavoriteFields
    }
  }
}
    ${CommonFavoriteFieldsFragmentDoc}`;

export function useFavoriteDeleteMutation() {
  return Urql.useMutation<FavoriteDeleteMutation, FavoriteDeleteMutationVariables>(FavoriteDeleteDocument);
};
export const GoalsDocument = gql`
    query Goals($metricId: ID!) {
  metric(id: $metricId) {
    id
    classType
    ...MetricDisplayFormatFields
    goals {
      ...GoalFields
    }
  }
}
    ${MetricDisplayFormatFieldsFragmentDoc}
${GoalFieldsFragmentDoc}`;

export function useGoalsQuery(options: Omit<Urql.UseQueryArgs<GoalsQueryVariables>, 'query'>) {
  return Urql.useQuery<GoalsQuery, GoalsQueryVariables>({ query: GoalsDocument, ...options });
};
export const GoalDocument = gql`
    query Goal($id: ID!) {
  goal(id: $id) {
    ...GoalFields
  }
}
    ${GoalFieldsFragmentDoc}`;

export function useGoalQuery(options: Omit<Urql.UseQueryArgs<GoalQueryVariables>, 'query'>) {
  return Urql.useQuery<GoalQuery, GoalQueryVariables>({ query: GoalDocument, ...options });
};
export const GoalCreateDocument = gql`
    mutation GoalCreate($input: GoalCreateInput!) {
  goalCreate(input: $input) {
    goal {
      ...GoalFields
    }
    errors {
      message
      path
    }
  }
}
    ${GoalFieldsFragmentDoc}`;

export function useGoalCreateMutation() {
  return Urql.useMutation<GoalCreateMutation, GoalCreateMutationVariables>(GoalCreateDocument);
};
export const GoogleSheetDocument = gql`
    query GoogleSheet($id: ID!) {
  googleSheet(id: $id) {
    ...GoogleSheetFields
  }
}
    ${GoogleSheetFieldsFragmentDoc}`;

export function useGoogleSheetQuery(options: Omit<Urql.UseQueryArgs<GoogleSheetQueryVariables>, 'query'>) {
  return Urql.useQuery<GoogleSheetQuery, GoogleSheetQueryVariables>({ query: GoogleSheetDocument, ...options });
};
export const OrganizationGoogleSheetDocument = gql`
    query OrganizationGoogleSheet {
  organization {
    id
    googleSheet {
      ...GoogleSheetFields
    }
  }
}
    ${GoogleSheetFieldsFragmentDoc}`;

export function useOrganizationGoogleSheetQuery(options?: Omit<Urql.UseQueryArgs<OrganizationGoogleSheetQueryVariables>, 'query'>) {
  return Urql.useQuery<OrganizationGoogleSheetQuery, OrganizationGoogleSheetQueryVariables>({ query: OrganizationGoogleSheetDocument, ...options });
};
export const GoogleSheetDeleteDocument = gql`
    mutation GoogleSheetDelete($input: GoogleSheetDeleteInput!) {
  googleSheetDelete(input: $input) {
    googleSheet {
      id
    }
  }
}
    `;

export function useGoogleSheetDeleteMutation() {
  return Urql.useMutation<GoogleSheetDeleteMutation, GoogleSheetDeleteMutationVariables>(GoogleSheetDeleteDocument);
};
export const GoogleSheetImportDocument = gql`
    mutation GoogleSheetImport($input: GoogleSheetImportInput!) {
  googleSheetImport(input: $input) {
    googleSheet {
      id
    }
  }
}
    `;

export function useGoogleSheetImportMutation() {
  return Urql.useMutation<GoogleSheetImportMutation, GoogleSheetImportMutationVariables>(GoogleSheetImportDocument);
};
export const GraphEventsDocument = gql`
    query GraphEvents($filters: JSON) {
  eventsGraph(filters: $filters)
}
    `;

export function useGraphEventsQuery(options?: Omit<Urql.UseQueryArgs<GraphEventsQueryVariables>, 'query'>) {
  return Urql.useQuery<GraphEventsQuery, GraphEventsQueryVariables>({ query: GraphEventsDocument, ...options });
};
export const GraphMetricEventsDocument = gql`
    query GraphMetricEvents($metricId: ID!, $filters: JSON) {
  metricEventsGraph(metricId: $metricId, filters: $filters)
}
    `;

export function useGraphMetricEventsQuery(options: Omit<Urql.UseQueryArgs<GraphMetricEventsQueryVariables>, 'query'>) {
  return Urql.useQuery<GraphMetricEventsQuery, GraphMetricEventsQueryVariables>({ query: GraphMetricEventsDocument, ...options });
};
export const GraphImpactfulEventsDocument = gql`
    query GraphImpactfulEvents($filters: JSON, $metricId: ID!) {
  impactfulEntities(filters: $filters, metricId: $metricId) {
    id
    classType
    ...GraphImpactfulEventsFields
  }
}
    ${GraphImpactfulEventsFieldsFragmentDoc}`;

export function useGraphImpactfulEventsQuery(options: Omit<Urql.UseQueryArgs<GraphImpactfulEventsQueryVariables>, 'query'>) {
  return Urql.useQuery<GraphImpactfulEventsQuery, GraphImpactfulEventsQueryVariables>({ query: GraphImpactfulEventsDocument, ...options });
};
export const GraphMetricsDocument = gql`
    query GraphMetrics($id: ID!, $range: String, $interval: IntervalEnum, $startDate: String, $endDate: String, $cumulative: CastableBoolean, $forecast: CastableBoolean) {
  metric(id: $id) {
    id
    classType
    metricDataPoints(
      range: $range
      interval: $interval
      startDate: $startDate
      endDate: $endDate
      cumulative: $cumulative
      forecast: $forecast
    ) {
      date
      value
      forecasted
    }
    ...GraphMetricsFields
  }
}
    ${GraphMetricsFieldsFragmentDoc}`;

export function useGraphMetricsQuery(options: Omit<Urql.UseQueryArgs<GraphMetricsQueryVariables>, 'query'>) {
  return Urql.useQuery<GraphMetricsQuery, GraphMetricsQueryVariables>({ query: GraphMetricsDocument, ...options });
};
export const IntegrationDocument = gql`
    query Integration($sourceName: String!) {
  integration(sourceName: $sourceName) {
    ...IntegrationSubscriptionFields
    ... on IntegrationInterface {
      organization {
        id
      }
      creator {
        id
        email
        name
        superAdmin
      }
    }
    ... on JiraIntegration {
      restrictedProjects
    }
  }
}
    ${IntegrationSubscriptionFieldsFragmentDoc}`;

export function useIntegrationQuery(options: Omit<Urql.UseQueryArgs<IntegrationQueryVariables>, 'query'>) {
  return Urql.useQuery<IntegrationQuery, IntegrationQueryVariables>({ query: IntegrationDocument, ...options });
};
export const IntegrationsDocument = gql`
    query Integrations {
  integrations {
    ...IntegrationSubscriptionFields
    ... on IntegrationInterface {
      organization {
        id
      }
      creator {
        id
        email
        name
        superAdmin
      }
    }
  }
}
    ${IntegrationSubscriptionFieldsFragmentDoc}`;

export function useIntegrationsQuery(options?: Omit<Urql.UseQueryArgs<IntegrationsQueryVariables>, 'query'>) {
  return Urql.useQuery<IntegrationsQuery, IntegrationsQueryVariables>({ query: IntegrationsDocument, ...options });
};
export const GoogleIntegrationDocument = gql`
    query GoogleIntegration {
  googleIntegration {
    id
    sourceId
    sourceName
    type
    classType
    configuration
    activitiesCount
    entitiesCount
    importedHistory
    createdAt
    propertiesV4
    propertyImports
    organization {
      id
    }
    creator {
      id
      email
      name
      superAdmin
    }
  }
}
    `;

export function useGoogleIntegrationQuery(options?: Omit<Urql.UseQueryArgs<GoogleIntegrationQueryVariables>, 'query'>) {
  return Urql.useQuery<GoogleIntegrationQuery, GoogleIntegrationQueryVariables>({ query: GoogleIntegrationDocument, ...options });
};
export const SharedIntegrationsDocument = gql`
    query SharedIntegrations {
  integrations {
    ... on IntegrationInterface {
      id
      sourceName
      entityTypes
    }
  }
  metricSources {
    id
    sourceName
  }
}
    `;

export function useSharedIntegrationsQuery(options?: Omit<Urql.UseQueryArgs<SharedIntegrationsQueryVariables>, 'query'>) {
  return Urql.useQuery<SharedIntegrationsQuery, SharedIntegrationsQueryVariables>({ query: SharedIntegrationsDocument, ...options });
};
export const SourcesDocument = gql`
    query Sources {
  sources {
    entity {
      id
      sourceName
      entityTypes
      classType
    }
    metric {
      id
      sourceName
      classType
    }
  }
}
    `;

export function useSourcesQuery(options?: Omit<Urql.UseQueryArgs<SourcesQueryVariables>, 'query'>) {
  return Urql.useQuery<SourcesQuery, SourcesQueryVariables>({ query: SourcesDocument, ...options });
};
export const IntegrationCreateDocument = gql`
    mutation IntegrationCreate($input: IntegrationCreateInput!) {
  integrationCreate(input: $input) {
    integration {
      ...IntegrationSubscriptionFields
      creator {
        id
        email
        name
        superAdmin
      }
    }
    organization {
      id
    }
    errors {
      message
      path
    }
  }
}
    ${IntegrationSubscriptionFieldsFragmentDoc}`;

export function useIntegrationCreateMutation() {
  return Urql.useMutation<IntegrationCreateMutation, IntegrationCreateMutationVariables>(IntegrationCreateDocument);
};
export const IntegrationUpdateDocument = gql`
    mutation IntegrationUpdate($input: IntegrationUpdateInput!) {
  integrationUpdate(input: $input) {
    integration {
      ... on IntegrationInterface {
        ...IntegrationSubscriptionFields
      }
      ... on JiraIntegration {
        restrictedProjects
      }
    }
    errors {
      message
      path
    }
  }
}
    ${IntegrationSubscriptionFieldsFragmentDoc}`;

export function useIntegrationUpdateMutation() {
  return Urql.useMutation<IntegrationUpdateMutation, IntegrationUpdateMutationVariables>(IntegrationUpdateDocument);
};
export const IntegrationImportHistoryDocument = gql`
    mutation IntegrationImportHistory($input: IntegrationImportHistoryInput!) {
  integrationImportHistory(input: $input) {
    integration {
      ...IntegrationSubscriptionFields
    }
    errors {
      message
      path
    }
  }
}
    ${IntegrationSubscriptionFieldsFragmentDoc}`;

export function useIntegrationImportHistoryMutation() {
  return Urql.useMutation<IntegrationImportHistoryMutation, IntegrationImportHistoryMutationVariables>(IntegrationImportHistoryDocument);
};
export const GoogleAnalyticsPropertyImportDocument = gql`
    mutation GoogleAnalyticsPropertyImport($input: GoogleAnalyticsPropertyImportInput!) {
  googleAnalyticsPropertyImport(input: $input) {
    integration {
      ...IntegrationSubscriptionFields
    }
  }
}
    ${IntegrationSubscriptionFieldsFragmentDoc}`;

export function useGoogleAnalyticsPropertyImportMutation() {
  return Urql.useMutation<GoogleAnalyticsPropertyImportMutation, GoogleAnalyticsPropertyImportMutationVariables>(GoogleAnalyticsPropertyImportDocument);
};
export const InvitationDocument = gql`
    query Invitation($inviteCode: String!) {
  invitation(inviteCode: $inviteCode) {
    ...InvitationFields
  }
}
    ${InvitationFieldsFragmentDoc}`;

export function useInvitationQuery(options: Omit<Urql.UseQueryArgs<InvitationQueryVariables>, 'query'>) {
  return Urql.useQuery<InvitationQuery, InvitationQueryVariables>({ query: InvitationDocument, ...options });
};
export const InvitationsDocument = gql`
    query Invitations {
  invitations {
    ...InvitationFields
  }
}
    ${InvitationFieldsFragmentDoc}`;

export function useInvitationsQuery(options?: Omit<Urql.UseQueryArgs<InvitationsQueryVariables>, 'query'>) {
  return Urql.useQuery<InvitationsQuery, InvitationsQueryVariables>({ query: InvitationsDocument, ...options });
};
export const InvitationCreateDocument = gql`
    mutation InvitationCreate($input: InvitationCreateInput!) {
  invitationCreate(input: $input) {
    invitation {
      ...InvitationFields
    }
    errors {
      message
      path
    }
  }
}
    ${InvitationFieldsFragmentDoc}`;

export function useInvitationCreateMutation() {
  return Urql.useMutation<InvitationCreateMutation, InvitationCreateMutationVariables>(InvitationCreateDocument);
};
export const InvitationDeleteDocument = gql`
    mutation InvitationDelete($input: InvitationDeleteInput!) {
  crudOperation: invitationDelete(input: $input) {
    crudOperation {
      operation
      data {
        id
        classType
        email
        inviteCode
        lastSentAt
        role
      }
    }
    errors {
      message
      path
    }
  }
}
    `;

export function useInvitationDeleteMutation() {
  return Urql.useMutation<InvitationDeleteMutation, InvitationDeleteMutationVariables>(InvitationDeleteDocument);
};
export const InvitationResendDocument = gql`
    mutation InvitationResend($input: InvitationResendInput!) {
  invitationResend(input: $input) {
    invitation {
      ...InvitationFields
    }
  }
}
    ${InvitationFieldsFragmentDoc}`;

export function useInvitationResendMutation() {
  return Urql.useMutation<InvitationResendMutation, InvitationResendMutationVariables>(InvitationResendDocument);
};
export const LabelsAutocompleteDocument = gql`
    query LabelsAutocomplete($query: String!) {
  labelsAutocomplete(query: $query) {
    ...LabelRequiredFields
  }
}
    ${LabelRequiredFieldsFragmentDoc}`;

export function useLabelsAutocompleteQuery(options: Omit<Urql.UseQueryArgs<LabelsAutocompleteQueryVariables>, 'query'>) {
  return Urql.useQuery<LabelsAutocompleteQuery, LabelsAutocompleteQueryVariables>({ query: LabelsAutocompleteDocument, ...options });
};
export const LabelCreateDocument = gql`
    mutation LabelCreate($input: LabelCreateInput!) {
  labelCreate(input: $input) {
    label {
      ...LabelRequiredFields
    }
    domainObject {
      ... on BasicCard {
        id
        classType
        labels {
          ...LabelRequiredFields
        }
      }
      ... on Entity {
        id
        classType
        labels {
          ...LabelRequiredFields
        }
      }
      ... on Metric {
        id
        classType
        labels {
          ...LabelRequiredFields
        }
      }
      ... on Strategy {
        id
        classType
        labels {
          ...LabelRequiredFields
        }
      }
    }
  }
}
    ${LabelRequiredFieldsFragmentDoc}`;

export function useLabelCreateMutation() {
  return Urql.useMutation<LabelCreateMutation, LabelCreateMutationVariables>(LabelCreateDocument);
};
export const LabelDeleteDocument = gql`
    mutation LabelDelete($input: LabelDeleteInput!) {
  labelDelete(input: $input) {
    label {
      ...LabelRequiredFields
    }
    domainObject {
      ... on BasicCard {
        id
        classType
        labels {
          ...LabelRequiredFields
        }
      }
      ... on Entity {
        id
        classType
        labels {
          ...LabelRequiredFields
        }
      }
      ... on Metric {
        id
        classType
        labels {
          ...LabelRequiredFields
        }
      }
      ... on Strategy {
        id
        classType
        labels {
          ...LabelRequiredFields
        }
      }
    }
  }
}
    ${LabelRequiredFieldsFragmentDoc}`;

export function useLabelDeleteMutation() {
  return Urql.useMutation<LabelDeleteMutation, LabelDeleteMutationVariables>(LabelDeleteDocument);
};
export const LookerDashboardsDocument = gql`
    query LookerDashboards {
  lookerDashboards {
    ...LookerDashboardSubscriptionFields
  }
}
    ${LookerDashboardSubscriptionFieldsFragmentDoc}`;

export function useLookerDashboardsQuery(options?: Omit<Urql.UseQueryArgs<LookerDashboardsQueryVariables>, 'query'>) {
  return Urql.useQuery<LookerDashboardsQuery, LookerDashboardsQueryVariables>({ query: LookerDashboardsDocument, ...options });
};
export const LookerDashboardCreateDocument = gql`
    mutation LookerDashboardCreate($input: LookerDashboardCreateInput!) {
  lookerDashboardCreate(input: $input) {
    lookerDashboard {
      ...LookerDashboardSubscriptionFields
    }
    errors {
      message
      path
    }
  }
}
    ${LookerDashboardSubscriptionFieldsFragmentDoc}`;

export function useLookerDashboardCreateMutation() {
  return Urql.useMutation<LookerDashboardCreateMutation, LookerDashboardCreateMutationVariables>(LookerDashboardCreateDocument);
};
export const LookerDashboardDeleteDocument = gql`
    mutation LookerDashboardDelete($input: LookerDashboardDeleteInput!) {
  crudOperation: lookerDashboardDelete(input: $input) {
    crudOperation {
      operation
      data {
        id
        classType
      }
    }
    errors {
      message
      path
    }
  }
}
    `;

export function useLookerDashboardDeleteMutation() {
  return Urql.useMutation<LookerDashboardDeleteMutation, LookerDashboardDeleteMutationVariables>(LookerDashboardDeleteDocument);
};
export const MetricDocument = gql`
    query Metric($id: ID!) {
  metric(id: $id) {
    ...MetricFields
    metricSource {
      id
      classType
    }
  }
}
    ${MetricFieldsFragmentDoc}`;

export function useMetricQuery(options: Omit<Urql.UseQueryArgs<MetricQueryVariables>, 'query'>) {
  return Urql.useQuery<MetricQuery, MetricQueryVariables>({ query: MetricDocument, ...options });
};
export const MetricsDocument = gql`
    query Metrics($unsourced: CastableBoolean, $showCalculated: Boolean = false, $filter: String, $strategyId: ID, $order: MetricOrderingInput, $page: Int, $limit: Int) {
  metrics(
    unsourced: $unsourced
    filter: $filter
    strategyId: $strategyId
    order: $order
    page: $page
    limit: $limit
  ) {
    collection {
      id
      classType
      commentsCount
      createdAt
      updatedAt
      calculated @include(if: $showCalculated)
      metricSourceErrored
      favoriteId
      rollUp
      displayFormat
      metricDataPointsCount
      sourceName
      name
      owner {
        id
        name
        email
        classType
      }
      credential {
        id
        label
        classType
      }
      labels {
        ...LabelRequiredFields
      }
      strategies {
        id
        name
        classType
      }
    }
    metadata {
      ...PaginationAttributes
    }
  }
  organization {
    id
    classType
  }
}
    ${LabelRequiredFieldsFragmentDoc}
${PaginationAttributesFragmentDoc}`;

export function useMetricsQuery(options?: Omit<Urql.UseQueryArgs<MetricsQueryVariables>, 'query'>) {
  return Urql.useQuery<MetricsQuery, MetricsQueryVariables>({ query: MetricsDocument, ...options });
};
export const MetricEntitiesDocument = gql`
    query MetricEntities($id: ID!, $page: Int, $limit: Int, $workflowState: EntityWorkflowStateEnum) {
  metricEntities(
    metricId: $id
    workflowState: $workflowState
    page: $page
    limit: $limit
  ) {
    collection {
      id
      ...EntityBasics
    }
    metadata {
      ...PaginationAttributes
    }
  }
}
    ${EntityBasicsFragmentDoc}
${PaginationAttributesFragmentDoc}`;

export function useMetricEntitiesQuery(options: Omit<Urql.UseQueryArgs<MetricEntitiesQueryVariables>, 'query'>) {
  return Urql.useQuery<MetricEntitiesQuery, MetricEntitiesQueryVariables>({ query: MetricEntitiesDocument, ...options });
};
export const MetricCommentsDocument = gql`
    query MetricComments($id: ID!) {
  metric(id: $id) {
    id
    classType
    comments {
      id
      ...CommentFields
    }
  }
}
    ${CommentFieldsFragmentDoc}`;

export function useMetricCommentsQuery(options: Omit<Urql.UseQueryArgs<MetricCommentsQueryVariables>, 'query'>) {
  return Urql.useQuery<MetricCommentsQuery, MetricCommentsQueryVariables>({ query: MetricCommentsDocument, ...options });
};
export const MetricCorrelationsDocument = gql`
    query MetricCorrelations($id: ID!, $strategyId: ID) {
  metric(id: $id) {
    id
    classType
    correlations(strategyId: $strategyId) {
      id
      classType
      score
      sourceMetricId
      strategyId
      targetMetric {
        id
        name
        classType
        positiveDirection
      }
    }
  }
}
    `;

export function useMetricCorrelationsQuery(options: Omit<Urql.UseQueryArgs<MetricCorrelationsQueryVariables>, 'query'>) {
  return Urql.useQuery<MetricCorrelationsQuery, MetricCorrelationsQueryVariables>({ query: MetricCorrelationsDocument, ...options });
};
export const MetricsAutocompleteDocument = gql`
    query MetricsAutocomplete($query: String!, $strategyId: ID) {
  metricsAutocomplete(query: $query, strategyId: $strategyId) {
    id
    classType
    slug
    name
    calculated
  }
}
    `;

export function useMetricsAutocompleteQuery(options: Omit<Urql.UseQueryArgs<MetricsAutocompleteQueryVariables>, 'query'>) {
  return Urql.useQuery<MetricsAutocompleteQuery, MetricsAutocompleteQueryVariables>({ query: MetricsAutocompleteDocument, ...options });
};
export const MetricCreateDocument = gql`
    mutation MetricCreate($input: MetricCreateInput!) {
  metricCreate(input: $input) {
    metric {
      ...MetricFields
    }
    errors {
      message
      path
    }
  }
}
    ${MetricFieldsFragmentDoc}`;

export function useMetricCreateMutation() {
  return Urql.useMutation<MetricCreateMutation, MetricCreateMutationVariables>(MetricCreateDocument);
};
export const MetricUpdateDocument = gql`
    mutation MetricUpdate($input: MetricUpdateInput!) {
  metricUpdate(input: $input) {
    metric {
      ...MetricFields
    }
    errors {
      message
      path
    }
  }
}
    ${MetricFieldsFragmentDoc}`;

export function useMetricUpdateMutation() {
  return Urql.useMutation<MetricUpdateMutation, MetricUpdateMutationVariables>(MetricUpdateDocument);
};
export const MetricUploadFileDocument = gql`
    mutation MetricUploadFile($input: MetricUploadFileInput!) {
  metricUploadFile(input: $input) {
    metric {
      id
      classType
    }
    errors {
      message
      path
    }
  }
}
    `;

export function useMetricUploadFileMutation() {
  return Urql.useMutation<MetricUploadFileMutation, MetricUploadFileMutationVariables>(MetricUploadFileDocument);
};
export const MetricUploadBatchFileDocument = gql`
    mutation MetricUploadBatchFile($input: MetricUploadBatchFileInput!) {
  metricUploadBatchFile(input: $input) {
    success
  }
}
    `;

export function useMetricUploadBatchFileMutation() {
  return Urql.useMutation<MetricUploadBatchFileMutation, MetricUploadBatchFileMutationVariables>(MetricUploadBatchFileDocument);
};
export const MetricDeleteAllMetricDataPointsDocument = gql`
    mutation MetricDeleteAllMetricDataPoints($input: MetricDeleteAllMetricDataPointsInput!) {
  metricDeleteAllMetricDataPoints(input: $input) {
    metric {
      ...MetricFields
    }
    errors {
      message
      path
    }
  }
}
    ${MetricFieldsFragmentDoc}`;

export function useMetricDeleteAllMetricDataPointsMutation() {
  return Urql.useMutation<MetricDeleteAllMetricDataPointsMutation, MetricDeleteAllMetricDataPointsMutationVariables>(MetricDeleteAllMetricDataPointsDocument);
};
export const MetricPopulateEmptyDocument = gql`
    mutation MetricPopulateEmpty($input: MetricPopulateEmptyInput!) {
  metricPopulateEmpty(input: $input) {
    metrics {
      ...MetricFields
    }
    errors {
      message
      path
    }
  }
}
    ${MetricFieldsFragmentDoc}`;

export function useMetricPopulateEmptyMutation() {
  return Urql.useMutation<MetricPopulateEmptyMutation, MetricPopulateEmptyMutationVariables>(MetricPopulateEmptyDocument);
};
export const MetricDataPointDocument = gql`
    query MetricDataPoint($metricDataPointId: ID!) {
  metricDataPoint(metricDataPointId: $metricDataPointId) {
    id
    classType
    value
    date
  }
}
    `;

export function useMetricDataPointQuery(options: Omit<Urql.UseQueryArgs<MetricDataPointQueryVariables>, 'query'>) {
  return Urql.useQuery<MetricDataPointQuery, MetricDataPointQueryVariables>({ query: MetricDataPointDocument, ...options });
};
export const MetricDataPointsDocument = gql`
    query MetricDataPoints($metricId: ID!, $strategyId: ID, $page: Int, $limit: Int) {
  metricDataPoints(
    metricId: $metricId
    strategyId: $strategyId
    page: $page
    limit: $limit
  ) {
    collection {
      id
      classType
      value
      date
      filterableId
      segmentFilters {
        id
        segmentName {
          id
          name
        }
        segmentValue {
          id
          value
        }
      }
      metricId
      createdAt
      updatedAt
    }
    metadata {
      ...PaginationAttributes
    }
  }
}
    ${PaginationAttributesFragmentDoc}`;

export function useMetricDataPointsQuery(options: Omit<Urql.UseQueryArgs<MetricDataPointsQueryVariables>, 'query'>) {
  return Urql.useQuery<MetricDataPointsQuery, MetricDataPointsQueryVariables>({ query: MetricDataPointsDocument, ...options });
};
export const SampledMetricDataPointsDocument = gql`
    query SampledMetricDataPoints($metricId: ID!, $strategyId: ID) {
  sampledMetricDataPoints(metricId: $metricId, strategyId: $strategyId) {
    classType
    date
    value
  }
}
    `;

export function useSampledMetricDataPointsQuery(options: Omit<Urql.UseQueryArgs<SampledMetricDataPointsQueryVariables>, 'query'>) {
  return Urql.useQuery<SampledMetricDataPointsQuery, SampledMetricDataPointsQueryVariables>({ query: SampledMetricDataPointsDocument, ...options });
};
export const MetricDataPointCreateDocument = gql`
    mutation MetricDataPointCreate($input: MetricDataPointCreateInput!) {
  metricDataPointCreate(input: $input) {
    metricDataPoint {
      id
      classType
      date
      filterableId
      metricId
      segmentFilters {
        id
        segmentName {
          id
          name
        }
        segmentValue {
          id
          value
        }
      }
      value
    }
    errors {
      message
      path
    }
  }
}
    `;

export function useMetricDataPointCreateMutation() {
  return Urql.useMutation<MetricDataPointCreateMutation, MetricDataPointCreateMutationVariables>(MetricDataPointCreateDocument);
};
export const MetricDataPointUpdateDocument = gql`
    mutation MetricDataPointUpdate($input: MetricDataPointUpdateInput!) {
  metricDataPointUpdate(input: $input) {
    metricDataPoint {
      id
      classType
      date
      filterableId
      metricId
      segmentFilters {
        id
        segmentName {
          id
          name
        }
        segmentValue {
          id
          value
        }
      }
      value
    }
    errors {
      message
      path
    }
  }
}
    `;

export function useMetricDataPointUpdateMutation() {
  return Urql.useMutation<MetricDataPointUpdateMutation, MetricDataPointUpdateMutationVariables>(MetricDataPointUpdateDocument);
};
export const MetricDataPointDeleteDocument = gql`
    mutation MetricDataPointDelete($input: MetricDataPointDeleteInput!) {
  crudOperation: metricDataPointDelete(input: $input) {
    crudOperation {
      operation
      data {
        id
        classType
        date
        filterableId
        metricId
        value
      }
    }
    errors {
      message
      path
    }
  }
}
    `;

export function useMetricDataPointDeleteMutation() {
  return Urql.useMutation<MetricDataPointDeleteMutation, MetricDataPointDeleteMutationVariables>(MetricDataPointDeleteDocument);
};
export const MetricSourceDocument = gql`
    query MetricSource($metricId: ID!) {
  metricSource(metricId: $metricId) {
    ...MetricSourceSubscriptionFields
    metric {
      id
      classType
      name
    }
    googleSheet {
      id
      classType
      spreadsheetUrl
      status
    }
    metricDataPoints {
      date
      value
      metric {
        id
        classType
        name
      }
    }
    integration {
      id
      classType
      sourceName
    }
    credential {
      id
      classType
      displayName
      label
      sourceName
    }
  }
}
    ${MetricSourceSubscriptionFieldsFragmentDoc}`;

export function useMetricSourceQuery(options: Omit<Urql.UseQueryArgs<MetricSourceQueryVariables>, 'query'>) {
  return Urql.useQuery<MetricSourceQuery, MetricSourceQueryVariables>({ query: MetricSourceDocument, ...options });
};
export const MetricSourcesDocument = gql`
    query MetricSources {
  metricSources {
    id
    classType
    name
    description
    erroredAt
    errorMessage
    lastRunAt
    metricId
    scheduled
    slug
    sourceName
  }
}
    `;

export function useMetricSourcesQuery(options?: Omit<Urql.UseQueryArgs<MetricSourcesQueryVariables>, 'query'>) {
  return Urql.useQuery<MetricSourcesQuery, MetricSourcesQueryVariables>({ query: MetricSourcesDocument, ...options });
};
export const AmplitudeMetricSourceEventNamesDocument = gql`
    query AmplitudeMetricSourceEventNames($credentialId: ID!) {
  amplitudeMetricSourceEventNames(credentialId: $credentialId) {
    label
    value
  }
}
    `;

export function useAmplitudeMetricSourceEventNamesQuery(options: Omit<Urql.UseQueryArgs<AmplitudeMetricSourceEventNamesQueryVariables>, 'query'>) {
  return Urql.useQuery<AmplitudeMetricSourceEventNamesQuery, AmplitudeMetricSourceEventNamesQueryVariables>({ query: AmplitudeMetricSourceEventNamesDocument, ...options });
};
export const AmplitudeEventTaxonomyDocument = gql`
    query AmplitudeEventTaxonomy($credentialId: ID!) {
  amplitudeEventTaxonomy(credentialId: $credentialId) {
    classType
    name
    category
    description
  }
}
    `;

export function useAmplitudeEventTaxonomyQuery(options: Omit<Urql.UseQueryArgs<AmplitudeEventTaxonomyQueryVariables>, 'query'>) {
  return Urql.useQuery<AmplitudeEventTaxonomyQuery, AmplitudeEventTaxonomyQueryVariables>({ query: AmplitudeEventTaxonomyDocument, ...options });
};
export const LookerApiLooksDocument = gql`
    query LookerApiLooks($credentialId: ID!) {
  lookerApiLooks(credentialId: $credentialId) {
    label
    value
  }
}
    `;

export function useLookerApiLooksQuery(options: Omit<Urql.UseQueryArgs<LookerApiLooksQueryVariables>, 'query'>) {
  return Urql.useQuery<LookerApiLooksQuery, LookerApiLooksQueryVariables>({ query: LookerApiLooksDocument, ...options });
};
export const LookerApiLookFieldsDocument = gql`
    query LookerApiLookFields($credentialId: ID!, $lookId: ID!) {
  lookerApiLookFields(credentialId: $credentialId, lookId: $lookId) {
    label
    value
  }
}
    `;

export function useLookerApiLookFieldsQuery(options: Omit<Urql.UseQueryArgs<LookerApiLookFieldsQueryVariables>, 'query'>) {
  return Urql.useQuery<LookerApiLookFieldsQuery, LookerApiLookFieldsQueryVariables>({ query: LookerApiLookFieldsDocument, ...options });
};
export const MetricSourceCreateDocument = gql`
    mutation MetricSourceCreate($input: MetricSourceCreateInput!) {
  metricSourceCreate(input: $input) {
    metricSource {
      ...MetricSourceMutationFields
    }
    errors {
      message
      path
    }
  }
}
    ${MetricSourceMutationFieldsFragmentDoc}`;

export function useMetricSourceCreateMutation() {
  return Urql.useMutation<MetricSourceCreateMutation, MetricSourceCreateMutationVariables>(MetricSourceCreateDocument);
};
export const MetricSourceUpdateDocument = gql`
    mutation MetricSourceUpdate($input: MetricSourceUpdateInput!) {
  metricSourceUpdate(input: $input) {
    metricSource {
      ...MetricSourceMutationFields
    }
    errors {
      message
      path
    }
  }
}
    ${MetricSourceMutationFieldsFragmentDoc}`;

export function useMetricSourceUpdateMutation() {
  return Urql.useMutation<MetricSourceUpdateMutation, MetricSourceUpdateMutationVariables>(MetricSourceUpdateDocument);
};
export const MetricSourceDeleteDocument = gql`
    mutation MetricSourceDelete($input: MetricSourceDeleteInput!) {
  crudOperation: metricSourceDelete(input: $input) {
    crudOperation {
      operation
      data {
        id
        classType
        name
        description
        slug
        configuration
        sourceName
        integration {
          id
          classType
          sourceName
        }
      }
    }
    errors {
      message
      path
    }
  }
}
    `;

export function useMetricSourceDeleteMutation() {
  return Urql.useMutation<MetricSourceDeleteMutation, MetricSourceDeleteMutationVariables>(MetricSourceDeleteDocument);
};
export const MetricSourceTestDocument = gql`
    mutation MetricSourceTest($input: MetricSourceTestInput!) {
  metricSourceTest(input: $input) {
    metricSource {
      id
      classType
      erroredAt
      errorMessage
      lastRunAt
    }
    results
  }
}
    `;

export function useMetricSourceTestMutation() {
  return Urql.useMutation<MetricSourceTestMutation, MetricSourceTestMutationVariables>(MetricSourceTestDocument);
};
export const MetricSourceTestAttributesDocument = gql`
    mutation MetricSourceTestAttributes($input: MetricSourceTestAttributesInput!) {
  metricSourceTestAttributes(input: $input) {
    results
  }
}
    `;

export function useMetricSourceTestAttributesMutation() {
  return Urql.useMutation<MetricSourceTestAttributesMutation, MetricSourceTestAttributesMutationVariables>(MetricSourceTestAttributesDocument);
};
export const MetricSourceRunDocument = gql`
    mutation MetricSourceRun($input: MetricSourceRunInput!) {
  metricSourceRun(input: $input) {
    success
    status
    metricSource {
      id
      classType
      erroredAt
      errorMessage
      lastRunAt
    }
    errors {
      message
      path
    }
  }
}
    `;

export function useMetricSourceRunMutation() {
  return Urql.useMutation<MetricSourceRunMutation, MetricSourceRunMutationVariables>(MetricSourceRunDocument);
};
export const MetricSourceActivitiesDocument = gql`
    query MetricSourceActivities($metricSourceId: ID!, $page: Int, $limit: Int) {
  metricSourceActivities(
    metricSourceId: $metricSourceId
    page: $page
    limit: $limit
  ) {
    collection {
      id
      classType
      sourceName
      processedCount
      processedState
      totalCount
      metricSource {
        id
        classType
        name
        metric {
          id
          classType
          name
        }
      }
      createdAt
      updatedAt
    }
    metadata {
      ...PaginationAttributes
    }
  }
}
    ${PaginationAttributesFragmentDoc}`;

export function useMetricSourceActivitiesQuery(options: Omit<Urql.UseQueryArgs<MetricSourceActivitiesQueryVariables>, 'query'>) {
  return Urql.useQuery<MetricSourceActivitiesQuery, MetricSourceActivitiesQueryVariables>({ query: MetricSourceActivitiesDocument, ...options });
};
export const MetricSourceActivityDocument = gql`
    query MetricSourceActivity($id: ID!) {
  metricSourceActivity(id: $id) {
    id
    classType
    payload
  }
}
    `;

export function useMetricSourceActivityQuery(options: Omit<Urql.UseQueryArgs<MetricSourceActivityQueryVariables>, 'query'>) {
  return Urql.useQuery<MetricSourceActivityQuery, MetricSourceActivityQueryVariables>({ query: MetricSourceActivityDocument, ...options });
};
export const OrganizationDocument = gql`
    query Organization {
  organization {
    ...OrganizationFields
    ...OrganizationSAMLFields
    businessContext {
      ...BusinessContextSubscriptionFields
    }
  }
}
    ${OrganizationFieldsFragmentDoc}
${OrganizationSamlFieldsFragmentDoc}
${BusinessContextSubscriptionFieldsFragmentDoc}`;

export function useOrganizationQuery(options?: Omit<Urql.UseQueryArgs<OrganizationQueryVariables>, 'query'>) {
  return Urql.useQuery<OrganizationQuery, OrganizationQueryVariables>({ query: OrganizationDocument, ...options });
};
export const OrganizationsDocument = gql`
    query Organizations {
  organizations {
    id
    name
    slug
  }
}
    `;

export function useOrganizationsQuery(options?: Omit<Urql.UseQueryArgs<OrganizationsQueryVariables>, 'query'>) {
  return Urql.useQuery<OrganizationsQuery, OrganizationsQueryVariables>({ query: OrganizationsDocument, ...options });
};
export const OrganizationProductStrategyDocument = gql`
    query OrganizationProductStrategy {
  organization {
    id
    classType
  }
}
    `;

export function useOrganizationProductStrategyQuery(options?: Omit<Urql.UseQueryArgs<OrganizationProductStrategyQueryVariables>, 'query'>) {
  return Urql.useQuery<OrganizationProductStrategyQuery, OrganizationProductStrategyQueryVariables>({ query: OrganizationProductStrategyDocument, ...options });
};
export const CustomerSubscriptionDocument = gql`
    query CustomerSubscription {
  organization {
    id
    ...OrganizationSubscriptionFields
  }
}
    ${OrganizationSubscriptionFieldsFragmentDoc}`;

export function useCustomerSubscriptionQuery(options?: Omit<Urql.UseQueryArgs<CustomerSubscriptionQueryVariables>, 'query'>) {
  return Urql.useQuery<CustomerSubscriptionQuery, CustomerSubscriptionQueryVariables>({ query: CustomerSubscriptionDocument, ...options });
};
export const CreateOrganizationDocument = gql`
    mutation CreateOrganization($input: OrganizationCreateInput!) {
  organizationCreate(input: $input) {
    organization {
      ...OrganizationFields
    }
    strategy {
      id
      classType
    }
    errors {
      message
      path
    }
  }
}
    ${OrganizationFieldsFragmentDoc}`;

export function useCreateOrganizationMutation() {
  return Urql.useMutation<CreateOrganizationMutation, CreateOrganizationMutationVariables>(CreateOrganizationDocument);
};
export const CustomerCreateDocument = gql`
    mutation CustomerCreate($input: CustomerCreateInput!) {
  customerCreate(input: $input) {
    organization {
      ...OrganizationFields
    }
    strategy {
      id
      classType
    }
    errors {
      message
      path
    }
  }
}
    ${OrganizationFieldsFragmentDoc}`;

export function useCustomerCreateMutation() {
  return Urql.useMutation<CustomerCreateMutation, CustomerCreateMutationVariables>(CustomerCreateDocument);
};
export const OrganizationUpdateDocument = gql`
    mutation OrganizationUpdate($input: OrganizationUpdateInput!) {
  organizationUpdate(input: $input) {
    organization {
      ...OrganizationFields
      ...OrganizationSAMLFields
    }
    errors {
      message
      path
    }
  }
}
    ${OrganizationFieldsFragmentDoc}
${OrganizationSamlFieldsFragmentDoc}`;

export function useOrganizationUpdateMutation() {
  return Urql.useMutation<OrganizationUpdateMutation, OrganizationUpdateMutationVariables>(OrganizationUpdateDocument);
};
export const OrganizationDefaultMetricStatIntervalsApplyDocument = gql`
    mutation OrganizationDefaultMetricStatIntervalsApply($input: OrganizationDefaultMetricStatIntervalsApplyInput!) {
  organizationDefaultMetricStatIntervalsApply(input: $input) {
    organization {
      ...OrganizationFields
    }
    errors {
      message
      path
    }
  }
}
    ${OrganizationFieldsFragmentDoc}`;

export function useOrganizationDefaultMetricStatIntervalsApplyMutation() {
  return Urql.useMutation<OrganizationDefaultMetricStatIntervalsApplyMutation, OrganizationDefaultMetricStatIntervalsApplyMutationVariables>(OrganizationDefaultMetricStatIntervalsApplyDocument);
};
export const PlaybooksDocument = gql`
    query Playbooks($aiOnly: CastableBoolean) {
  playbooks(aiOnly: $aiOnly) {
    ...PlaybookFields
  }
}
    ${PlaybookFieldsFragmentDoc}`;

export function usePlaybooksQuery(options?: Omit<Urql.UseQueryArgs<PlaybooksQueryVariables>, 'query'>) {
  return Urql.useQuery<PlaybooksQuery, PlaybooksQueryVariables>({ query: PlaybooksDocument, ...options });
};
export const PlaybookDocument = gql`
    query Playbook($id: ID!) {
  playbook(id: $id) {
    ...PlaybookFields
  }
}
    ${PlaybookFieldsFragmentDoc}`;

export function usePlaybookQuery(options: Omit<Urql.UseQueryArgs<PlaybookQueryVariables>, 'query'>) {
  return Urql.useQuery<PlaybookQuery, PlaybookQueryVariables>({ query: PlaybookDocument, ...options });
};
export const PlaybookApplyWithAiDocument = gql`
    mutation PlaybookApplyWithAi($input: PlaybookApplyWithAiInput!) {
  playbookApplyWithAi(input: $input) {
    strategy {
      id
      businessContextId
      classType
      indicatorCounter
    }
    chat {
      id
    }
    errors {
      message
      path
    }
  }
}
    `;

export function usePlaybookApplyWithAiMutation() {
  return Urql.useMutation<PlaybookApplyWithAiMutation, PlaybookApplyWithAiMutationVariables>(PlaybookApplyWithAiDocument);
};
export const PlaybookApplyToStrategyWithAiDocument = gql`
    mutation PlaybookApplyToStrategyWithAi($input: PlaybookApplyToStrategyWithAiInput!) {
  playbookApplyToStrategyWithAi(input: $input) {
    strategy {
      id
      businessContextId
      classType
      empty
      indicatorCounter
    }
    chat {
      id
    }
    errors {
      message
      path
    }
  }
}
    `;

export function usePlaybookApplyToStrategyWithAiMutation() {
  return Urql.useMutation<PlaybookApplyToStrategyWithAiMutation, PlaybookApplyToStrategyWithAiMutationVariables>(PlaybookApplyToStrategyWithAiDocument);
};
export const PlaybookCreateFromStrategyDocument = gql`
    mutation PlaybookCreateFromStrategy($input: PlaybookCreateFromStrategyInput!) {
  playbookCreateFromStrategy(input: $input) {
    playbook {
      id
      classType
    }
  }
}
    `;

export function usePlaybookCreateFromStrategyMutation() {
  return Urql.useMutation<PlaybookCreateFromStrategyMutation, PlaybookCreateFromStrategyMutationVariables>(PlaybookCreateFromStrategyDocument);
};
export const PlaybookSubmitForReviewDocument = gql`
    mutation PlaybookSubmitForReview($input: PlaybookSubmitForReviewInput!) {
  playbookSubmitForReview(input: $input) {
    playbook {
      id
      classType
      publicationState
    }
  }
}
    `;

export function usePlaybookSubmitForReviewMutation() {
  return Urql.useMutation<PlaybookSubmitForReviewMutation, PlaybookSubmitForReviewMutationVariables>(PlaybookSubmitForReviewDocument);
};
export const RecurringReportConfigurationsDocument = gql`
    query RecurringReportConfigurations($strategyId: ID!) {
  recurringReportConfigurations(strategyId: $strategyId) {
    collection {
      ...RecurringReportConfigurationFields
    }
    metadata {
      ...PaginationAttributes
    }
  }
}
    ${RecurringReportConfigurationFieldsFragmentDoc}
${PaginationAttributesFragmentDoc}`;

export function useRecurringReportConfigurationsQuery(options: Omit<Urql.UseQueryArgs<RecurringReportConfigurationsQueryVariables>, 'query'>) {
  return Urql.useQuery<RecurringReportConfigurationsQuery, RecurringReportConfigurationsQueryVariables>({ query: RecurringReportConfigurationsDocument, ...options });
};
export const RecurringReportConfigurationDocument = gql`
    query RecurringReportConfiguration($id: ID!) {
  recurringReportConfiguration(id: $id) {
    ...RecurringReportConfigurationFields
    reports(limit: 1) {
      id
      classType
      createdAt
      recurringReportConfigurationId
      strategyId
      summary
    }
  }
}
    ${RecurringReportConfigurationFieldsFragmentDoc}`;

export function useRecurringReportConfigurationQuery(options: Omit<Urql.UseQueryArgs<RecurringReportConfigurationQueryVariables>, 'query'>) {
  return Urql.useQuery<RecurringReportConfigurationQuery, RecurringReportConfigurationQueryVariables>({ query: RecurringReportConfigurationDocument, ...options });
};
export const RecurringReportConfigurationsByServiceDocument = gql`
    query RecurringReportConfigurationsByService($strategyId: ID!, $service: RecurringReportConfigurationServiceEnum!, $reportLimit: Int) {
  recurringReportConfigurations(strategyId: $strategyId, service: $service) {
    collection {
      ...RecurringReportConfigurationFields
      reports(limit: $reportLimit) {
        id
        classType
        createdAt
        name
        recurringReportConfigurationId
        strategyId
        summary
      }
    }
    metadata {
      ...PaginationAttributes
    }
  }
}
    ${RecurringReportConfigurationFieldsFragmentDoc}
${PaginationAttributesFragmentDoc}`;

export function useRecurringReportConfigurationsByServiceQuery(options: Omit<Urql.UseQueryArgs<RecurringReportConfigurationsByServiceQueryVariables>, 'query'>) {
  return Urql.useQuery<RecurringReportConfigurationsByServiceQuery, RecurringReportConfigurationsByServiceQueryVariables>({ query: RecurringReportConfigurationsByServiceDocument, ...options });
};
export const RecurringReportConfigurationCreateDocument = gql`
    mutation RecurringReportConfigurationCreate($input: RecurringReportConfigurationCreateInput!) {
  recurringReportConfigurationCreate(input: $input) {
    recurringReportConfiguration {
      ...RecurringReportConfigurationFields
      reports(limit: 1) {
        id
        classType
        createdAt
        recurringReportConfigurationId
        strategyId
        summary
      }
    }
    errors {
      message
      path
    }
  }
}
    ${RecurringReportConfigurationFieldsFragmentDoc}`;

export function useRecurringReportConfigurationCreateMutation() {
  return Urql.useMutation<RecurringReportConfigurationCreateMutation, RecurringReportConfigurationCreateMutationVariables>(RecurringReportConfigurationCreateDocument);
};
export const RecurringReportConfigurationUpdateDocument = gql`
    mutation RecurringReportConfigurationUpdate($input: RecurringReportConfigurationUpdateInput!) {
  recurringReportConfigurationUpdate(input: $input) {
    recurringReportConfiguration {
      ...RecurringReportConfigurationFields
      reports(limit: 1) {
        id
        classType
        createdAt
        recurringReportConfigurationId
        strategyId
        summary
      }
    }
    errors {
      message
      path
    }
  }
}
    ${RecurringReportConfigurationFieldsFragmentDoc}`;

export function useRecurringReportConfigurationUpdateMutation() {
  return Urql.useMutation<RecurringReportConfigurationUpdateMutation, RecurringReportConfigurationUpdateMutationVariables>(RecurringReportConfigurationUpdateDocument);
};
export const RecurringReportConfigurationRunDocument = gql`
    mutation RecurringReportConfigurationRun($input: RecurringReportConfigurationRunInput!) {
  recurringReportConfigurationRun(input: $input) {
    recurringReportConfiguration {
      ...RecurringReportConfigurationFields
      reports(limit: 1) {
        id
        classType
        createdAt
        recurringReportConfigurationId
        strategyId
        summary
      }
    }
  }
}
    ${RecurringReportConfigurationFieldsFragmentDoc}`;

export function useRecurringReportConfigurationRunMutation() {
  return Urql.useMutation<RecurringReportConfigurationRunMutation, RecurringReportConfigurationRunMutationVariables>(RecurringReportConfigurationRunDocument);
};
export const RecurringReportConfigurationPromptTestDocument = gql`
    mutation RecurringReportConfigurationPromptTest($input: RecurringReportConfigurationPromptTestInput!) {
  recurringReportConfigurationPromptTest(input: $input) {
    recurringReportConfiguration {
      ...RecurringReportConfigurationFields
    }
    chat {
      ...ChatSubscriptionFields
    }
  }
}
    ${RecurringReportConfigurationFieldsFragmentDoc}
${ChatSubscriptionFieldsFragmentDoc}`;

export function useRecurringReportConfigurationPromptTestMutation() {
  return Urql.useMutation<RecurringReportConfigurationPromptTestMutation, RecurringReportConfigurationPromptTestMutationVariables>(RecurringReportConfigurationPromptTestDocument);
};
export const RecurringReportConfigurationDeleteDocument = gql`
    mutation RecurringReportConfigurationDelete($input: RecurringReportConfigurationDeleteInput!) {
  recurringReportConfigurationDelete(input: $input) {
    crudOperation {
      data {
        id
      }
      operation
    }
    errors {
      message
      path
    }
  }
}
    `;

export function useRecurringReportConfigurationDeleteMutation() {
  return Urql.useMutation<RecurringReportConfigurationDeleteMutation, RecurringReportConfigurationDeleteMutationVariables>(RecurringReportConfigurationDeleteDocument);
};
export const ReportsDocument = gql`
    query Reports($strategyId: ID!, $page: Int, $limit: Int) {
  reports(strategyId: $strategyId, page: $page, limit: $limit) {
    collection {
      ...ReportFields
    }
    metadata {
      ...PaginationAttributes
    }
  }
}
    ${ReportFieldsFragmentDoc}
${PaginationAttributesFragmentDoc}`;

export function useReportsQuery(options: Omit<Urql.UseQueryArgs<ReportsQueryVariables>, 'query'>) {
  return Urql.useQuery<ReportsQuery, ReportsQueryVariables>({ query: ReportsDocument, ...options });
};
export const ReportDocument = gql`
    query Report($id: ID!) {
  report(id: $id) {
    ...ReportFields
  }
}
    ${ReportFieldsFragmentDoc}`;

export function useReportQuery(options: Omit<Urql.UseQueryArgs<ReportQueryVariables>, 'query'>) {
  return Urql.useQuery<ReportQuery, ReportQueryVariables>({ query: ReportDocument, ...options });
};
export const ReportCreateDocument = gql`
    mutation ReportCreate($input: ReportCreateInput!) {
  reportCreate(input: $input) {
    report {
      ...ReportFields
    }
    errors {
      message
      path
    }
  }
}
    ${ReportFieldsFragmentDoc}`;

export function useReportCreateMutation() {
  return Urql.useMutation<ReportCreateMutation, ReportCreateMutationVariables>(ReportCreateDocument);
};
export const ReportUpdateDocument = gql`
    mutation ReportUpdate($input: ReportUpdateInput!) {
  reportUpdate(input: $input) {
    report {
      ...ReportFields
    }
    errors {
      message
      path
    }
  }
}
    ${ReportFieldsFragmentDoc}`;

export function useReportUpdateMutation() {
  return Urql.useMutation<ReportUpdateMutation, ReportUpdateMutationVariables>(ReportUpdateDocument);
};
export const ReportSendDocument = gql`
    mutation ReportSend($input: ReportSendInput!) {
  reportSend(input: $input) {
    report {
      ...ReportFields
    }
    errors {
      message
      path
    }
  }
}
    ${ReportFieldsFragmentDoc}`;

export function useReportSendMutation() {
  return Urql.useMutation<ReportSendMutation, ReportSendMutationVariables>(ReportSendDocument);
};
export const SegmentFiltersUpdateDocument = gql`
    mutation SegmentFiltersUpdate($input: SegmentFiltersUpdateInput!) {
  segmentFiltersUpdate(input: $input) {
    segmentFilters {
      id
      segmentName {
        id
        name
      }
      segmentValue {
        id
        value
      }
    }
    filterable {
      id: filterableId
    }
    errors {
      message
      path
    }
  }
}
    `;

export function useSegmentFiltersUpdateMutation() {
  return Urql.useMutation<SegmentFiltersUpdateMutation, SegmentFiltersUpdateMutationVariables>(SegmentFiltersUpdateDocument);
};
export const SlackChannelsAutocompleteDocument = gql`
    query SlackChannelsAutocomplete($query: String!) {
  slackChannelsAutocomplete(query: $query) {
    id
    classType
    channelId
    name
    isArchived
    isIm
    isChannel
    value
    label
    type
  }
}
    `;

export function useSlackChannelsAutocompleteQuery(options: Omit<Urql.UseQueryArgs<SlackChannelsAutocompleteQueryVariables>, 'query'>) {
  return Urql.useQuery<SlackChannelsAutocompleteQuery, SlackChannelsAutocompleteQueryVariables>({ query: SlackChannelsAutocompleteDocument, ...options });
};
export const SlackChannelsDocument = gql`
    query SlackChannels {
  slackChannels {
    id
    classType
    channelId
    name
    label
  }
}
    `;

export function useSlackChannelsQuery(options?: Omit<Urql.UseQueryArgs<SlackChannelsQueryVariables>, 'query'>) {
  return Urql.useQuery<SlackChannelsQuery, SlackChannelsQueryVariables>({ query: SlackChannelsDocument, ...options });
};
export const StrategyDocument = gql`
    query Strategy($id: ID!, $loadAsAnonymous: CastableBoolean) {
  strategy(id: $id, loadAsAnonymous: $loadAsAnonymous) {
    ...StrategySubscriptionFields
    gid
    aiContextVectorStoreFiles {
      ...AiAssistantFilesSubscriptionFields
    }
    commentsCount
    endDate
    filterableId
    favoriteId
    filterableId
    range
    showSegmentCreate
    slackChannel {
      id
      classType
      name
      channelId
      isIm
    }
    slackChannelId
    startDate
    statDisplay
    token
    labels {
      id
      name
    }
    organization {
      id
    }
    basicCards {
      ...BasicCardFields
    }
    commentThreads {
      ...CommentThreadFields
    }
    metrics {
      ...MetricFields
    }
    entities {
      ...EntityStrategyCard
    }
    strategies {
      ...StrategySubMapCard
    }
    sections {
      ...SectionFields
    }
    notes {
      ...NoteFields
    }
    mapImages {
      ...MapImageFields
    }
    recurringReportConfigurations {
      ...RecurringReportConfigurationFields
    }
    nodes {
      ...NodeFields
    }
    edges {
      ...EdgeFields
    }
    segmentFilters {
      id
      segmentName {
        id
        name
      }
      segmentValue {
        id
        value
      }
    }
  }
}
    ${StrategySubscriptionFieldsFragmentDoc}
${AiAssistantFilesSubscriptionFieldsFragmentDoc}
${BasicCardFieldsFragmentDoc}
${CommentThreadFieldsFragmentDoc}
${MetricFieldsFragmentDoc}
${EntityStrategyCardFragmentDoc}
${StrategySubMapCardFragmentDoc}
${SectionFieldsFragmentDoc}
${NoteFieldsFragmentDoc}
${MapImageFieldsFragmentDoc}
${RecurringReportConfigurationFieldsFragmentDoc}
${NodeFieldsFragmentDoc}
${EdgeFieldsFragmentDoc}`;

export function useStrategyQuery(options: Omit<Urql.UseQueryArgs<StrategyQueryVariables>, 'query'>) {
  return Urql.useQuery<StrategyQuery, StrategyQueryVariables>({ query: StrategyDocument, ...options });
};
export const StrategySlackDocument = gql`
    query StrategySlack($id: ID!) {
  strategy(id: $id) {
    id
    slackChannelId
  }
}
    `;

export function useStrategySlackQuery(options: Omit<Urql.UseQueryArgs<StrategySlackQueryVariables>, 'query'>) {
  return Urql.useQuery<StrategySlackQuery, StrategySlackQueryVariables>({ query: StrategySlackDocument, ...options });
};
export const StrategyEntityDocument = gql`
    query StrategyEntity($id: ID!, $entityId: ID!, $metricId: ID) {
  strategy(id: $id) {
    entity(id: $entityId, metricId: $metricId) {
      ...EntityDetails
    }
  }
}
    ${EntityDetailsFragmentDoc}`;

export function useStrategyEntityQuery(options: Omit<Urql.UseQueryArgs<StrategyEntityQueryVariables>, 'query'>) {
  return Urql.useQuery<StrategyEntityQuery, StrategyEntityQueryVariables>({ query: StrategyEntityDocument, ...options });
};
export const StrategyStrategyEntitiesDocument = gql`
    query StrategyStrategyEntities($id: ID!, $page: Int, $limit: Int, $workflowState: EntityWorkflowStateEnum) {
  strategy(id: $id) {
    strategyEntities(workflowState: $workflowState, page: $page, limit: $limit) {
      collection {
        id
        ...EntityBasics
      }
      metadata {
        ...PaginationAttributes
      }
    }
  }
}
    ${EntityBasicsFragmentDoc}
${PaginationAttributesFragmentDoc}`;

export function useStrategyStrategyEntitiesQuery(options: Omit<Urql.UseQueryArgs<StrategyStrategyEntitiesQueryVariables>, 'query'>) {
  return Urql.useQuery<StrategyStrategyEntitiesQuery, StrategyStrategyEntitiesQueryVariables>({ query: StrategyStrategyEntitiesDocument, ...options });
};
export const StrategyMetricEntitiesDocument = gql`
    query StrategyMetricEntities($id: ID!, $metricId: ID!, $page: Int, $limit: Int, $workflowState: EntityWorkflowStateEnum) {
  strategy(id: $id) {
    metricEntities(
      metricId: $metricId
      workflowState: $workflowState
      page: $page
      limit: $limit
    ) {
      collection {
        id
        ...EntityBasics
      }
      metadata {
        ...PaginationAttributes
      }
    }
  }
}
    ${EntityBasicsFragmentDoc}
${PaginationAttributesFragmentDoc}`;

export function useStrategyMetricEntitiesQuery(options: Omit<Urql.UseQueryArgs<StrategyMetricEntitiesQueryVariables>, 'query'>) {
  return Urql.useQuery<StrategyMetricEntitiesQuery, StrategyMetricEntitiesQueryVariables>({ query: StrategyMetricEntitiesDocument, ...options });
};
export const StrategyEntityEntitiesDocument = gql`
    query StrategyEntityEntities($id: ID!, $entityId: ID!, $page: Int, $limit: Int, $workflowState: EntityWorkflowStateEnum) {
  strategy(id: $id) {
    entityEntities(
      entityId: $entityId
      workflowState: $workflowState
      page: $page
      limit: $limit
    ) {
      collection {
        id
        ...EntityBasics
      }
      metadata {
        ...PaginationAttributes
      }
    }
  }
}
    ${EntityBasicsFragmentDoc}
${PaginationAttributesFragmentDoc}`;

export function useStrategyEntityEntitiesQuery(options: Omit<Urql.UseQueryArgs<StrategyEntityEntitiesQueryVariables>, 'query'>) {
  return Urql.useQuery<StrategyEntityEntitiesQuery, StrategyEntityEntitiesQueryVariables>({ query: StrategyEntityEntitiesDocument, ...options });
};
export const StrategyBasicCardEntitiesDocument = gql`
    query StrategyBasicCardEntities($id: ID!, $basicCardId: ID!, $page: Int, $limit: Int, $workflowState: EntityWorkflowStateEnum) {
  strategy(id: $id) {
    basicCardEntities(
      basicCardId: $basicCardId
      workflowState: $workflowState
      page: $page
      limit: $limit
    ) {
      collection {
        id
        ...EntityBasics
      }
      metadata {
        ...PaginationAttributes
      }
    }
  }
}
    ${EntityBasicsFragmentDoc}
${PaginationAttributesFragmentDoc}`;

export function useStrategyBasicCardEntitiesQuery(options: Omit<Urql.UseQueryArgs<StrategyBasicCardEntitiesQueryVariables>, 'query'>) {
  return Urql.useQuery<StrategyBasicCardEntitiesQuery, StrategyBasicCardEntitiesQueryVariables>({ query: StrategyBasicCardEntitiesDocument, ...options });
};
export const StrategyGraphMetricsDocument = gql`
    query StrategyGraphMetrics($id: ID!, $metricId: ID!, $range: String, $interval: IntervalEnum, $startDate: String, $endDate: String, $cumulative: CastableBoolean, $forecast: CastableBoolean) {
  strategy(id: $id) {
    metric(id: $metricId) {
      id
      metricDataPoints(
        range: $range
        interval: $interval
        startDate: $startDate
        endDate: $endDate
        cumulative: $cumulative
        forecast: $forecast
        strategyId: $id
      ) {
        date
        value
        forecasted
      }
      ...GraphMetricsFields
    }
  }
}
    ${GraphMetricsFieldsFragmentDoc}`;

export function useStrategyGraphMetricsQuery(options: Omit<Urql.UseQueryArgs<StrategyGraphMetricsQueryVariables>, 'query'>) {
  return Urql.useQuery<StrategyGraphMetricsQuery, StrategyGraphMetricsQueryVariables>({ query: StrategyGraphMetricsDocument, ...options });
};
export const StrategyGraphEntityEventsDocument = gql`
    query StrategyGraphEntityEvents($id: ID!, $entityId: ID!, $filters: JSON) {
  strategy(id: $id) {
    entityEventsGraph(entityId: $entityId, filters: $filters)
  }
}
    `;

export function useStrategyGraphEntityEventsQuery(options: Omit<Urql.UseQueryArgs<StrategyGraphEntityEventsQueryVariables>, 'query'>) {
  return Urql.useQuery<StrategyGraphEntityEventsQuery, StrategyGraphEntityEventsQueryVariables>({ query: StrategyGraphEntityEventsDocument, ...options });
};
export const StrategyGraphMetricEventsDocument = gql`
    query StrategyGraphMetricEvents($id: ID!, $metricId: ID!, $filters: JSON) {
  strategy(id: $id) {
    metricEventsGraph(metricId: $metricId, filters: $filters)
  }
}
    `;

export function useStrategyGraphMetricEventsQuery(options: Omit<Urql.UseQueryArgs<StrategyGraphMetricEventsQueryVariables>, 'query'>) {
  return Urql.useQuery<StrategyGraphMetricEventsQuery, StrategyGraphMetricEventsQueryVariables>({ query: StrategyGraphMetricEventsDocument, ...options });
};
export const StrategiesDocument = gql`
    query Strategies($filter: String, $order: StrategyOrderingInput, $page: Int, $limit: Int, $businessContextId: ID) {
  strategies(
    filter: $filter
    order: $order
    page: $page
    limit: $limit
    businessContextId: $businessContextId
  ) {
    collection {
      id
      classType
      createdAt
      name
      description
      connected
      favoriteId
      sharing
      labels {
        id
        name
      }
    }
    metadata {
      ...PaginationAttributes
    }
  }
}
    ${PaginationAttributesFragmentDoc}`;

export function useStrategiesQuery(options?: Omit<Urql.UseQueryArgs<StrategiesQueryVariables>, 'query'>) {
  return Urql.useQuery<StrategiesQuery, StrategiesQueryVariables>({ query: StrategiesDocument, ...options });
};
export const StrategyAiConversationMessagesDocument = gql`
    query StrategyAiConversationMessages($id: ID!) {
  strategy(id: $id) {
    aiConversation {
      id
      aiConversationMessages {
        id
        requestContent
        responseContent
        success
      }
    }
  }
}
    `;

export function useStrategyAiConversationMessagesQuery(options: Omit<Urql.UseQueryArgs<StrategyAiConversationMessagesQueryVariables>, 'query'>) {
  return Urql.useQuery<StrategyAiConversationMessagesQuery, StrategyAiConversationMessagesQueryVariables>({ query: StrategyAiConversationMessagesDocument, ...options });
};
export const StrategyFilterSelectOptionsDocument = gql`
    query StrategyFilterSelectOptions {
  strategies(limit: 10000) {
    collection {
      id
      classType
      name
    }
  }
}
    `;

export function useStrategyFilterSelectOptionsQuery(options?: Omit<Urql.UseQueryArgs<StrategyFilterSelectOptionsQueryVariables>, 'query'>) {
  return Urql.useQuery<StrategyFilterSelectOptionsQuery, StrategyFilterSelectOptionsQueryVariables>({ query: StrategyFilterSelectOptionsDocument, ...options });
};
export const StrategyMetricDataPointSegmentNamesDocument = gql`
    query StrategyMetricDataPointSegmentNames($id: ID!) {
  strategy(id: $id) {
    id
    classType
    metricDataPointSegmentNames {
      id
      name
    }
  }
}
    `;

export function useStrategyMetricDataPointSegmentNamesQuery(options: Omit<Urql.UseQueryArgs<StrategyMetricDataPointSegmentNamesQueryVariables>, 'query'>) {
  return Urql.useQuery<StrategyMetricDataPointSegmentNamesQuery, StrategyMetricDataPointSegmentNamesQueryVariables>({ query: StrategyMetricDataPointSegmentNamesDocument, ...options });
};
export const StrategyMetricDataPointSegmentValuesDocument = gql`
    query StrategyMetricDataPointSegmentValues($id: ID!, $segmentNameId: ID!) {
  strategy(id: $id) {
    id
    classType
    metricDataPointSegmentValues(segmentNameId: $segmentNameId) {
      id
      value
    }
  }
}
    `;

export function useStrategyMetricDataPointSegmentValuesQuery(options: Omit<Urql.UseQueryArgs<StrategyMetricDataPointSegmentValuesQueryVariables>, 'query'>) {
  return Urql.useQuery<StrategyMetricDataPointSegmentValuesQuery, StrategyMetricDataPointSegmentValuesQueryVariables>({ query: StrategyMetricDataPointSegmentValuesDocument, ...options });
};
export const StrategyExistingObjectAutocompleteDocument = gql`
    query StrategyExistingObjectAutocomplete($id: ID!, $query: String!, $type: String, $labels: String, $scope: JSON) {
  strategy(id: $id) {
    existingObjectAutocomplete(
      query: $query
      type: $type
      scope: $scope
      labels: $labels
    ) {
      ... on Metric {
        id
        ...MetricFields
      }
      ... on Entity {
        id
        ...EntityStrategyCard
      }
      ... on Strategy {
        ...StrategySubMapCard
      }
      ... on BasicCard {
        ...BasicCardFields
      }
    }
  }
}
    ${MetricFieldsFragmentDoc}
${EntityStrategyCardFragmentDoc}
${StrategySubMapCardFragmentDoc}
${BasicCardFieldsFragmentDoc}`;

export function useStrategyExistingObjectAutocompleteQuery(options: Omit<Urql.UseQueryArgs<StrategyExistingObjectAutocompleteQueryVariables>, 'query'>) {
  return Urql.useQuery<StrategyExistingObjectAutocompleteQuery, StrategyExistingObjectAutocompleteQueryVariables>({ query: StrategyExistingObjectAutocompleteDocument, ...options });
};
export const StrategyChangelogDocument = gql`
    query StrategyChangelog($strategyId: ID!, $page: Int!, $limit: Int, $containerNodeIds: CommaSeparatedString) {
  strategyChangelog(
    strategyId: $strategyId
    page: $page
    limit: $limit
    containerNodeIds: $containerNodeIds
  ) {
    collection {
      id
      ...ChangelogEntityFields
    }
    metadata {
      ...PaginationAttributes
    }
  }
}
    ${ChangelogEntityFieldsFragmentDoc}
${PaginationAttributesFragmentDoc}`;

export function useStrategyChangelogQuery(options: Omit<Urql.UseQueryArgs<StrategyChangelogQueryVariables>, 'query'>) {
  return Urql.useQuery<StrategyChangelogQuery, StrategyChangelogQueryVariables>({ query: StrategyChangelogDocument, ...options });
};
export const StrategyChangelogEntityDocument = gql`
    query StrategyChangelogEntity($strategyId: ID!, $id: ID!) {
  strategyChangelogEntity(strategyId: $strategyId, id: $id) {
    id
    ...ChangelogEntityFields
  }
}
    ${ChangelogEntityFieldsFragmentDoc}`;

export function useStrategyChangelogEntityQuery(options: Omit<Urql.UseQueryArgs<StrategyChangelogEntityQueryVariables>, 'query'>) {
  return Urql.useQuery<StrategyChangelogEntityQuery, StrategyChangelogEntityQueryVariables>({ query: StrategyChangelogEntityDocument, ...options });
};
export const StrategyCommentThreadCommentsDocument = gql`
    query StrategyCommentThreadComments($strategyId: ID!, $commentThreadId: ID!) {
  strategy(id: $strategyId) {
    commentThreadComments(commentThreadId: $commentThreadId) {
      id
      ...CommentFields
    }
  }
}
    ${CommentFieldsFragmentDoc}`;

export function useStrategyCommentThreadCommentsQuery(options: Omit<Urql.UseQueryArgs<StrategyCommentThreadCommentsQueryVariables>, 'query'>) {
  return Urql.useQuery<StrategyCommentThreadCommentsQuery, StrategyCommentThreadCommentsQueryVariables>({ query: StrategyCommentThreadCommentsDocument, ...options });
};
export const NodeCreateDocument = gql`
    mutation NodeCreate($input: NodeCreateInput!) {
  nodeCreate(input: $input) {
    nodeObject {
      ... on BasicCard {
        ...BasicCardFields
      }
      ... on CommentThread {
        ...CommentThreadFields
      }
      ... on Entity {
        id
        ...EntityFields
        ...EntityPrivateFields
        ...EntityStrategyCard
      }
      ... on MapImage {
        id
        ...MapImageFields
      }
      ... on Metric {
        id
        ...MetricFields
      }
      ... on Note {
        id
        ...NoteFields
      }
      ... on Section {
        id
        ...SectionFields
      }
      ... on Strategy {
        id
        ...StrategySubMapCard
      }
    }
    node {
      id
      ...NodeFields
    }
    errors {
      message
      path
    }
  }
}
    ${BasicCardFieldsFragmentDoc}
${CommentThreadFieldsFragmentDoc}
${EntityFieldsFragmentDoc}
${EntityPrivateFieldsFragmentDoc}
${EntityStrategyCardFragmentDoc}
${MapImageFieldsFragmentDoc}
${MetricFieldsFragmentDoc}
${NoteFieldsFragmentDoc}
${SectionFieldsFragmentDoc}
${StrategySubMapCardFragmentDoc}
${NodeFieldsFragmentDoc}`;

export function useNodeCreateMutation() {
  return Urql.useMutation<NodeCreateMutation, NodeCreateMutationVariables>(NodeCreateDocument);
};
export const StrategyUpdateDocument = gql`
    mutation StrategyUpdate($input: StrategyUpdateInput!) {
  strategyUpdate(input: $input) {
    strategy {
      id
      name
      classType
      connected
      sharing
      showCorrelations
      range
      startDate
      endDate
      indicatorCounter
      labels {
        id
        name
      }
      segmentFilters {
        id
        segmentName {
          id
          name
        }
        segmentValue {
          id
          value
        }
      }
      slackChannelId
      slackChannel {
        id
        classType
        name
        channelId
        isIm
      }
    }
    errors {
      message
      path
    }
  }
}
    `;

export function useStrategyUpdateMutation() {
  return Urql.useMutation<StrategyUpdateMutation, StrategyUpdateMutationVariables>(StrategyUpdateDocument);
};
export const StrategyNodeUpdateDocument = gql`
    mutation StrategyNodeUpdate($input: StrategyNodeUpdateInput!) {
  strategyNodeUpdate(input: $input) {
    strategy {
      id
      classType
    }
    nodes {
      id
      ...NodeFields
    }
    errors {
      message
      path
    }
  }
}
    ${NodeFieldsFragmentDoc}`;

export function useStrategyNodeUpdateMutation() {
  return Urql.useMutation<StrategyNodeUpdateMutation, StrategyNodeUpdateMutationVariables>(StrategyNodeUpdateDocument);
};
export const DomainObjectUpdateDocument = gql`
    mutation DomainObjectUpdate($input: DomainObjectUpdateInput!) {
  domainObjectUpdate(input: $input) {
    nodeObjects {
      ... on BasicCard {
        ...BasicCardFields
      }
      ... on BusinessContext {
        ...BusinessContextFields
      }
      ... on CommentThread {
        ...CommentThreadFields
      }
      ... on Entity {
        id
        ...EntityFields
        ...EntityPrivateFields
        ...EntityStrategyCard
      }
      ... on MapImage {
        id
        ...MapImageFields
      }
      ... on Metric {
        id
        ...MetricFields
      }
      ... on MetricSource {
        id
        ...MetricSourceFields
      }
      ... on Note {
        id
        ...NoteFields
      }
      ... on RecurringReportConfiguration {
        id
        ...RecurringReportConfigurationFields
      }
      ... on Schedule {
        ...ScheduleFields
      }
      ... on Section {
        id
        ...SectionFields
      }
      ... on Strategy {
        id
        slackChannelId
        ...StrategySubMapCard
      }
    }
    errors {
      message
      path
    }
  }
}
    ${BasicCardFieldsFragmentDoc}
${BusinessContextFieldsFragmentDoc}
${CommentThreadFieldsFragmentDoc}
${EntityFieldsFragmentDoc}
${EntityPrivateFieldsFragmentDoc}
${EntityStrategyCardFragmentDoc}
${MapImageFieldsFragmentDoc}
${MetricFieldsFragmentDoc}
${MetricSourceFieldsFragmentDoc}
${NoteFieldsFragmentDoc}
${RecurringReportConfigurationFieldsFragmentDoc}
${ScheduleFieldsFragmentDoc}
${SectionFieldsFragmentDoc}
${StrategySubMapCardFragmentDoc}`;

export function useDomainObjectUpdateMutation() {
  return Urql.useMutation<DomainObjectUpdateMutation, DomainObjectUpdateMutationVariables>(DomainObjectUpdateDocument);
};
export const StrategyDeleteDocument = gql`
    mutation StrategyDelete($input: StrategyDeleteInput!) {
  strategyDelete(input: $input) {
    strategy {
      id
      classType
      name
      connected
      slackChannelId
    }
    errors {
      message
      path
    }
  }
}
    `;

export function useStrategyDeleteMutation() {
  return Urql.useMutation<StrategyDeleteMutation, StrategyDeleteMutationVariables>(StrategyDeleteDocument);
};
export const EdgeCreateDocument = gql`
    mutation EdgeCreate($input: EdgeCreateInput!) {
  edgeCreate(input: $input) {
    edge {
      ...EdgeFields
    }
    errors {
      message
      path
    }
  }
}
    ${EdgeFieldsFragmentDoc}`;

export function useEdgeCreateMutation() {
  return Urql.useMutation<EdgeCreateMutation, EdgeCreateMutationVariables>(EdgeCreateDocument);
};
export const EdgeDeleteDocument = gql`
    mutation EdgeDelete($input: EdgeDeleteInput!) {
  edgeDelete(input: $input) {
    edge {
      id
      rfId
      classType
    }
    errors {
      message
      path
    }
  }
}
    `;

export function useEdgeDeleteMutation() {
  return Urql.useMutation<EdgeDeleteMutation, EdgeDeleteMutationVariables>(EdgeDeleteDocument);
};
export const StrategyReviewSendDocument = gql`
    mutation StrategyReviewSend($input: StrategyReviewSendInput!) {
  strategyReviewSend(input: $input) {
    success
    errors {
      message
      path
    }
  }
}
    `;

export function useStrategyReviewSendMutation() {
  return Urql.useMutation<StrategyReviewSendMutation, StrategyReviewSendMutationVariables>(StrategyReviewSendDocument);
};
export const StrategyNodeDeleteDocument = gql`
    mutation StrategyNodeDelete($input: StrategyNodeDeleteInput!) {
  strategyNodeDelete(input: $input) {
    strategy {
      id
      classType
    }
    nodes {
      id
      classType
      strategy {
        id
        classType
      }
    }
    errors {
      message
      path
    }
  }
}
    `;

export function useStrategyNodeDeleteMutation() {
  return Urql.useMutation<StrategyNodeDeleteMutation, StrategyNodeDeleteMutationVariables>(StrategyNodeDeleteDocument);
};
export const MapCloneDocument = gql`
    mutation MapClone($input: MapCloneInput!) {
  mapClone(input: $input) {
    strategy {
      id
      indicatorCounter
      classType
    }
  }
}
    `;

export function useMapCloneMutation() {
  return Urql.useMutation<MapCloneMutation, MapCloneMutationVariables>(MapCloneDocument);
};
export const MapCloneToOrganizationDocument = gql`
    mutation MapCloneToOrganization($input: MapCloneToOrganizationInput!) {
  mapCloneToOrganization(input: $input) {
    strategyId
    strategyName
  }
}
    `;

export function useMapCloneToOrganizationMutation() {
  return Urql.useMutation<MapCloneToOrganizationMutation, MapCloneToOrganizationMutationVariables>(MapCloneToOrganizationDocument);
};
export const MapCreateFromExistingDocument = gql`
    mutation MapCreateFromExisting($input: MapCreateFromExistingInput!) {
  mapCreateFromExisting(input: $input) {
    map {
      id
      indicatorCounter
      ...StrategySubMapCard
    }
    node {
      id
      ...NodeFields
    }
    errors {
      message
      path
    }
  }
}
    ${StrategySubMapCardFragmentDoc}
${NodeFieldsFragmentDoc}`;

export function useMapCreateFromExistingMutation() {
  return Urql.useMutation<MapCreateFromExistingMutation, MapCreateFromExistingMutationVariables>(MapCreateFromExistingDocument);
};
export const NodesDuplicateDocument = gql`
    mutation NodesDuplicate($input: NodesDuplicateInput!) {
  nodesDuplicate(input: $input) {
    nodes {
      id
      ...NodeFields
    }
    edges {
      id
      ...EdgeFields
    }
  }
}
    ${NodeFieldsFragmentDoc}
${EdgeFieldsFragmentDoc}`;

export function useNodesDuplicateMutation() {
  return Urql.useMutation<NodesDuplicateMutation, NodesDuplicateMutationVariables>(NodesDuplicateDocument);
};
export const StrategyPopulateFromPlaybookTemplateDocument = gql`
    mutation StrategyPopulateFromPlaybookTemplate($input: StrategyPopulateFromPlaybookTemplateInput!) {
  strategyPopulateFromPlaybookTemplate(input: $input) {
    strategy {
      id
      indicatorCounter
      classType
      nodes {
        ...NodeFields
      }
      edges {
        ...EdgeFields
      }
      basicCards {
        ...BasicCardFields
      }
      metrics {
        ...MetricFields
      }
      entities {
        ...EntityStrategyCard
      }
      strategies {
        ...StrategySubMapCard
      }
      sections {
        ...SectionFields
      }
      notes {
        ...NoteFields
      }
      mapImages {
        ...MapImageFields
      }
    }
    errors {
      message
      path
    }
  }
}
    ${NodeFieldsFragmentDoc}
${EdgeFieldsFragmentDoc}
${BasicCardFieldsFragmentDoc}
${MetricFieldsFragmentDoc}
${EntityStrategyCardFragmentDoc}
${StrategySubMapCardFragmentDoc}
${SectionFieldsFragmentDoc}
${NoteFieldsFragmentDoc}
${MapImageFieldsFragmentDoc}`;

export function useStrategyPopulateFromPlaybookTemplateMutation() {
  return Urql.useMutation<StrategyPopulateFromPlaybookTemplateMutation, StrategyPopulateFromPlaybookTemplateMutationVariables>(StrategyPopulateFromPlaybookTemplateDocument);
};
export const StrategyMetricMultiRegressionDocument = gql`
    mutation StrategyMetricMultiRegression($input: StrategyMetricMultiRegressionInput!) {
  strategyMetricMultiRegression(input: $input) {
    r2
    partials
    report {
      id
      classType
      name
    }
  }
}
    `;

export function useStrategyMetricMultiRegressionMutation() {
  return Urql.useMutation<StrategyMetricMultiRegressionMutation, StrategyMetricMultiRegressionMutationVariables>(StrategyMetricMultiRegressionDocument);
};
export const StrategyRegressionScoresClearDocument = gql`
    mutation StrategyRegressionScoresClear($input: StrategyRegressionScoresClearInput!) {
  strategyRegressionScoresClear(input: $input) {
    success
  }
}
    `;

export function useStrategyRegressionScoresClearMutation() {
  return Urql.useMutation<StrategyRegressionScoresClearMutation, StrategyRegressionScoresClearMutationVariables>(StrategyRegressionScoresClearDocument);
};
export const StrategyBulkAddExistingCardsDocument = gql`
    mutation StrategyBulkAddExistingCards($input: StrategyBulkAddExistingCardsInput!) {
  strategyBulkAddExistingCards(input: $input) {
    strategy {
      id
    }
    errors {
      message
      path
    }
  }
}
    `;

export function useStrategyBulkAddExistingCardsMutation() {
  return Urql.useMutation<StrategyBulkAddExistingCardsMutation, StrategyBulkAddExistingCardsMutationVariables>(StrategyBulkAddExistingCardsDocument);
};
export const StrategyBulkImportUrlsDocument = gql`
    mutation StrategyBulkImportUrls($input: StrategyBulkImportUrlsInput!) {
  strategyBulkImportUrls(input: $input) {
    strategy {
      id
    }
    errors {
      message
      path
    }
  }
}
    `;

export function useStrategyBulkImportUrlsMutation() {
  return Urql.useMutation<StrategyBulkImportUrlsMutation, StrategyBulkImportUrlsMutationVariables>(StrategyBulkImportUrlsDocument);
};
export const MapSimulateDocument = gql`
    mutation MapSimulate($input: MapSimulateInput!) {
  mapSimulate(input: $input) {
    errors {
      message
      path
    }
  }
}
    `;

export function useMapSimulateMutation() {
  return Urql.useMutation<MapSimulateMutation, MapSimulateMutationVariables>(MapSimulateDocument);
};
export const StrategySimulationPopulateBaselinesDocument = gql`
    mutation StrategySimulationPopulateBaselines($input: StrategyPopulateSimulationBaselinesInput!) {
  strategyPopulateSimulationBaselines(input: $input) {
    result {
      id
      classType
      simBaseline
    }
    error
  }
}
    `;

export function useStrategySimulationPopulateBaselinesMutation() {
  return Urql.useMutation<StrategySimulationPopulateBaselinesMutation, StrategySimulationPopulateBaselinesMutationVariables>(StrategySimulationPopulateBaselinesDocument);
};
export const MapRunStatsDocument = gql`
    mutation MapRunStats($input: MapRunStatsInput!) {
  mapRunStats(input: $input) {
    strategy {
      id
      classType
      statsUpdatedAt
    }
  }
}
    `;

export function useMapRunStatsMutation() {
  return Urql.useMutation<MapRunStatsMutation, MapRunStatsMutationVariables>(MapRunStatsDocument);
};
export const StrategiesBulkReassignBusinessContextDocument = gql`
    mutation StrategiesBulkReassignBusinessContext($input: StrategiesBulkReassignBusinessContextInput!) {
  strategiesBulkReassignBusinessContext(input: $input) {
    strategies {
      id
      classType
      name
      businessContextId
    }
    errors {
      message
      path
    }
  }
}
    `;

export function useStrategiesBulkReassignBusinessContextMutation() {
  return Urql.useMutation<StrategiesBulkReassignBusinessContextMutation, StrategiesBulkReassignBusinessContextMutationVariables>(StrategiesBulkReassignBusinessContextDocument);
};
export const MapStructureUpdatedDocument = gql`
    subscription MapStructureUpdated($strategyId: ID!) {
  crudOperation: mapStructureChanged(strategyId: $strategyId) {
    operation
    data {
      ... on Node {
        id
        ...NodeFields
      }
      ... on Edge {
        id
        ...EdgeSubscriptionFields
      }
    }
  }
}
    ${NodeFieldsFragmentDoc}
${EdgeSubscriptionFieldsFragmentDoc}`;

export function useMapStructureUpdatedSubscription<TData = MapStructureUpdatedSubscription>(options: Omit<Urql.UseSubscriptionArgs<MapStructureUpdatedSubscriptionVariables>, 'query'>, handler?: Urql.SubscriptionHandler<MapStructureUpdatedSubscription, TData>) {
  return Urql.useSubscription<MapStructureUpdatedSubscription, TData, MapStructureUpdatedSubscriptionVariables>({ query: MapStructureUpdatedDocument, ...options }, handler);
};
export const OrganizationCrudDocument = gql`
    subscription OrganizationCrud($organizationId: ID!) {
  crudOperation: organizationCrud(organizationId: $organizationId) {
    operation
    data {
      ... on AiAssistantFile {
        ...AiAssistantFilesSubscriptionFields
      }
      ... on BasicCard {
        ...BasicCardSubscriptionFields
      }
      ... on BusinessContext {
        ...BusinessContextSubscriptionFields
      }
      ... on Chat {
        ...ChatSubscriptionFields
      }
      ... on Entity {
        ...EntitySubscriptionFields
      }
      ... on CardType {
        ...CardTypeSubscriptionFields
      }
      ... on Comment {
        ...CommentSubscriptionFields
      }
      ... on CommentThread {
        ...CommentThreadSubscriptionFields
      }
      ... on Goal {
        ...GoalSubscriptionFields
      }
      ... on IntegrationInterface {
        ...IntegrationSubscriptionFields
      }
      ... on LookerDashboard {
        ...LookerDashboardSubscriptionFields
      }
      ... on MapImage {
        ...MapImageSubscriptionFields
      }
      ... on Message {
        ...MessageSubscriptionFields
      }
      ... on Metric {
        ...MetricSubscriptionFields
      }
      ... on MetricSource {
        ...MetricSourceSubscriptionFields
      }
      ... on Note {
        ...NoteSubscriptionFields
      }
      ... on RecurringReportConfiguration {
        ...RecurringReportConfigurationSubscriptionFields
      }
      ... on Report {
        ...ReportSubscriptionFields
      }
      ... on Schedule {
        ...ScheduleSubscriptionFields
      }
      ... on Section {
        ...SectionSubscriptionFields
      }
      ... on Strategy {
        ...StrategySubscriptionFields
      }
      ... on Task {
        ...TaskSubscriptionFields
      }
      ... on User {
        ...UserSubscriptionFields
      }
    }
  }
}
    ${AiAssistantFilesSubscriptionFieldsFragmentDoc}
${BasicCardSubscriptionFieldsFragmentDoc}
${BusinessContextSubscriptionFieldsFragmentDoc}
${ChatSubscriptionFieldsFragmentDoc}
${EntitySubscriptionFieldsFragmentDoc}
${CardTypeSubscriptionFieldsFragmentDoc}
${CommentSubscriptionFieldsFragmentDoc}
${CommentThreadSubscriptionFieldsFragmentDoc}
${GoalSubscriptionFieldsFragmentDoc}
${IntegrationSubscriptionFieldsFragmentDoc}
${LookerDashboardSubscriptionFieldsFragmentDoc}
${MapImageSubscriptionFieldsFragmentDoc}
${MessageSubscriptionFieldsFragmentDoc}
${MetricSubscriptionFieldsFragmentDoc}
${MetricSourceSubscriptionFieldsFragmentDoc}
${NoteSubscriptionFieldsFragmentDoc}
${RecurringReportConfigurationSubscriptionFieldsFragmentDoc}
${ReportSubscriptionFieldsFragmentDoc}
${ScheduleSubscriptionFieldsFragmentDoc}
${SectionSubscriptionFieldsFragmentDoc}
${StrategySubscriptionFieldsFragmentDoc}
${TaskSubscriptionFieldsFragmentDoc}
${UserSubscriptionFieldsFragmentDoc}`;

export function useOrganizationCrudSubscription<TData = OrganizationCrudSubscription>(options: Omit<Urql.UseSubscriptionArgs<OrganizationCrudSubscriptionVariables>, 'query'>, handler?: Urql.SubscriptionHandler<OrganizationCrudSubscription, TData>) {
  return Urql.useSubscription<OrganizationCrudSubscription, TData, OrganizationCrudSubscriptionVariables>({ query: OrganizationCrudDocument, ...options }, handler);
};
export const MapEventsDocument = gql`
    subscription MapEvents($strategyId: ID!) {
  mapEvents(strategyId: $strategyId) {
    event
    data
  }
}
    `;

export function useMapEventsSubscription<TData = MapEventsSubscription>(options: Omit<Urql.UseSubscriptionArgs<MapEventsSubscriptionVariables>, 'query'>, handler?: Urql.SubscriptionHandler<MapEventsSubscription, TData>) {
  return Urql.useSubscription<MapEventsSubscription, TData, MapEventsSubscriptionVariables>({ query: MapEventsDocument, ...options }, handler);
};
export const TasksDocument = gql`
    query Tasks($page: Int, $limit: Int, $domainObjectId: ID, $domainObjectType: String) {
  tasks(
    page: $page
    limit: $limit
    domainObjectId: $domainObjectId
    domainObjectType: $domainObjectType
  ) {
    collection {
      ...TaskSubscriptionFields
    }
    metadata {
      ...PaginationAttributes
    }
  }
}
    ${TaskSubscriptionFieldsFragmentDoc}
${PaginationAttributesFragmentDoc}`;

export function useTasksQuery(options?: Omit<Urql.UseQueryArgs<TasksQueryVariables>, 'query'>) {
  return Urql.useQuery<TasksQuery, TasksQueryVariables>({ query: TasksDocument, ...options });
};
export const CurrentUserDocument = gql`
    query CurrentUser {
  me {
    abilities
    accountsCount
    ...UserFields
    organization {
      ...OrganizationFields
    }
  }
  identityId
}
    ${UserFieldsFragmentDoc}
${OrganizationFieldsFragmentDoc}`;

export function useCurrentUserQuery(options?: Omit<Urql.UseQueryArgs<CurrentUserQueryVariables>, 'query'>) {
  return Urql.useQuery<CurrentUserQuery, CurrentUserQueryVariables>({ query: CurrentUserDocument, ...options });
};
export const UserAccountsDocument = gql`
    query UserAccounts {
  userAccounts {
    id
    classType
    disabledAt
    organizationId
    organizationLogoUrl
    organizationName
    role
    userId
  }
}
    `;

export function useUserAccountsQuery(options?: Omit<Urql.UseQueryArgs<UserAccountsQueryVariables>, 'query'>) {
  return Urql.useQuery<UserAccountsQuery, UserAccountsQueryVariables>({ query: UserAccountsDocument, ...options });
};
export const UserCreateDocument = gql`
    mutation UserCreate($input: UserCreateInput!) {
  userCreate(input: $input) {
    user {
      ...UserFields
    }
    errors {
      message
      path
    }
  }
}
    ${UserFieldsFragmentDoc}`;

export function useUserCreateMutation() {
  return Urql.useMutation<UserCreateMutation, UserCreateMutationVariables>(UserCreateDocument);
};
export const UserUpdateDocument = gql`
    mutation UserUpdate($input: UserUpdateInput!) {
  userUpdate(input: $input) {
    user {
      ...UserFields
    }
    errors {
      message
      path
    }
  }
}
    ${UserFieldsFragmentDoc}`;

export function useUserUpdateMutation() {
  return Urql.useMutation<UserUpdateMutation, UserUpdateMutationVariables>(UserUpdateDocument);
};
export const UserAuthenticateDocument = gql`
    mutation UserAuthenticate($input: UserAuthenticateInput!) {
  userAuthenticate(input: $input) {
    redirect
    errors {
      message
      path
    }
  }
}
    `;

export function useUserAuthenticateMutation() {
  return Urql.useMutation<UserAuthenticateMutation, UserAuthenticateMutationVariables>(UserAuthenticateDocument);
};
export const UserResetPasswordRequestDocument = gql`
    mutation UserResetPasswordRequest($input: UserResetPasswordRequestInput!) {
  userResetPasswordRequest(input: $input) {
    success
  }
}
    `;

export function useUserResetPasswordRequestMutation() {
  return Urql.useMutation<UserResetPasswordRequestMutation, UserResetPasswordRequestMutationVariables>(UserResetPasswordRequestDocument);
};
export const UserResetPasswordDocument = gql`
    mutation UserResetPassword($input: UserResetPasswordInput!) {
  userResetPassword(input: $input) {
    success
    errors {
      message
      path
    }
  }
}
    `;

export function useUserResetPasswordMutation() {
  return Urql.useMutation<UserResetPasswordMutation, UserResetPasswordMutationVariables>(UserResetPasswordDocument);
};
export const CaptureEmailDocument = gql`
    mutation CaptureEmail($input: UserEmailCaptureInput!) {
  userEmailCapture(input: $input) {
    success
    errors {
      message
    }
  }
}
    `;

export function useCaptureEmailMutation() {
  return Urql.useMutation<CaptureEmailMutation, CaptureEmailMutationVariables>(CaptureEmailDocument);
};
export const ConfirmEmailDocument = gql`
    mutation ConfirmEmail($input: UserConfirmEmailInput!) {
  userConfirmEmail(input: $input) {
    success
  }
}
    `;

export function useConfirmEmailMutation() {
  return Urql.useMutation<ConfirmEmailMutation, ConfirmEmailMutationVariables>(ConfirmEmailDocument);
};